import _get2 from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e20) { function e(_x584) { return _e20.apply(this, arguments); } e.toString = function () { return _e20.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e21) { function e(_x585) { return _e21.apply(this, arguments); } e.toString = function () { return _e21.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.reduce.js";
import { v4 as t } from "uuid";
import e from "decimal.js";
import i from "web3";
import r from "fs";
import n from "save-file";
import s from "node-abort-controller";
import o from "buffer";
import a from "crypto";
import { fetch as h } from "cross-fetch";
import u from "@oceanprotocol/contracts/artifacts/Metadata.json";
import { LZMA as l } from "lzma/src/lzma-c";
import c from "@oceanprotocol/contracts/artifacts/DTFactory.json";
import d from "@oceanprotocol/contracts/artifacts/DataTokenTemplate.json";
import { lookup as f } from "@ethereum-navigator/navigator";
import { SHA256 as m } from "crypto-js";
import g from "@oceanprotocol/contracts/artifacts/BPool.json";
import p from "@oceanprotocol/contracts/artifacts/BFactory.json";
import w from "@oceanprotocol/contracts/artifacts/FixedRateExchange.json";
import v from "@oceanprotocol/contracts/artifacts/Dispenser.json";
import { homedir as y } from "os";
import M from "@oceanprotocol/contracts/artifacts/address.json";

var b = function b() {
  _classCallCheck(this, b);

  this.nodeUri = void 0, this.providerAddress = void 0, this.metadataCacheUri = void 0, this.providerUri = void 0, this.rbacUri = void 0, this.web3Provider = void 0, this.oceanTokenAddress = void 0, this.factoryAddress = void 0, this.factoryABI = void 0, this.datatokensABI = void 0, this.poolFactoryAddress = void 0, this.poolFactoryABI = void 0, this.poolABI = void 0, this.fixedRateExchangeAddress = void 0, this.fixedRateExchangeAddressABI = void 0, this.dispenserAddress = void 0, this.dispenserABI = void 0, this.metadataContractAddress = void 0, this.metadataContractABI = void 0, this.startBlock = void 0, this.verbose = void 0, this.authMessage = void 0, this.authTokenExpiration = void 0, this.parityUri = void 0, this.threshold = void 0;
};

function A() {
  return (A = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];

      for (var r in i) {
        Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var x;
!function (t) {
  t[t.None = -1] = "None", t[t.Error = 0] = "Error", t[t.Warn = 1] = "Warn", t[t.Log = 2] = "Log", t[t.Verbose = 3] = "Verbose";
}(x || (x = {}));

var E = /*#__PURE__*/function () {
  function E() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : x.Error;

    _classCallCheck(this, E);

    this.logLevel = void 0, this.logLevel = t;
  }

  _createClass(E, [{
    key: "setLevel",
    value: function setLevel(t) {
      this.logLevel = t;
    }
  }, {
    key: "bypass",
    value: function bypass() {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      this.dispatch.apply(this, ["log", -Infinity].concat(t));
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      this.dispatch.apply(this, ["debug", x.Verbose].concat(t));
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        t[_key3] = arguments[_key3];
      }

      this.dispatch.apply(this, ["log", x.Log].concat(t));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        t[_key4] = arguments[_key4];
      }

      this.dispatch.apply(this, ["warn", x.Warn].concat(t));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        t[_key5] = arguments[_key5];
      }

      this.dispatch.apply(this, ["error", x.Error].concat(t));
    }
  }, {
    key: "dispatch",
    value: function dispatch(t, e) {
      var _console;

      for (var _len6 = arguments.length, i = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        i[_key6 - 2] = arguments[_key6];
      }

      this.logLevel >= e && (_console = console)[t].apply(_console, i);
    }
  }]);

  return E;
}();

var R = new E(),
    k = function k(t) {
  return I(t, !0);
},
    S = function S(t) {
  return I(t, !1);
};

function I() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = arguments.length > 1 ? arguments[1] : undefined;

  var _ref = _(t, /^(?:0x)*([a-f0-9]+)$/i, "zeroXTransformer"),
      i = _ref.valid,
      r = _ref.output;

  return (e && i ? "0x" : "") + r;
}

var T = function T(t) {
  return O(t, !0);
};

function O() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = arguments.length > 1 ? arguments[1] : undefined;

  var _ref2 = _(t, /^(?:0x|did:op:)*([a-f0-9]{40})$/i, "didTransformer"),
      i = _ref2.valid,
      r = _ref2.output;

  return (e && i ? "did:op:" : "") + r;
}

var B = function B(t) {
  return k(O(t, !1));
},
    C = function C(t) {
  return S(O(t, !1));
};

function _(t, e, i) {
  if ("string" != typeof t) throw R.debug("Not input string:"), R.debug(t), new Error("[".concat(i, "] Expected string, input type: ").concat(typeof t));
  var r = t.match(e);
  return r ? {
    valid: !0,
    output: r[1]
  } : (R.warn("[".concat(i, "] Input transformation failed.")), {
    valid: !1,
    output: t
  });
}

var D = /*#__PURE__*/function () {
  function D() {
    _classCallCheck(this, D);

    this.completed = !1, this.subscriptions = new Set();
  }

  _createClass(D, [{
    key: "subscribe",
    value: function subscribe(t, e, i) {
      var _this = this;

      if (this.completed) throw new Error("Observer completed.");
      var r = {
        onNext: t,
        onComplete: e,
        onError: i
      };
      return this.subscriptions.add(r), {
        unsubscribe: function unsubscribe() {
          return _this.subscriptions.delete(r);
        }
      };
    }
  }, {
    key: "next",
    value: function next(t) {
      this.emit("onNext", t);
    }
  }, {
    key: "complete",
    value: function complete(t) {
      this.emit("onComplete", t), this.unsubscribe();
    }
  }, {
    key: "error",
    value: function error(t) {
      this.emit("onError", t), this.unsubscribe();
    }
  }, {
    key: "emit",
    value: function emit(t, e) {
      Array.from(this.subscriptions).map(function (e) {
        return e[t];
      }).filter(function (t) {
        return t && "function" == typeof t;
      }).forEach(function (t) {
        return t(e);
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.completed = !0, this.subscriptions.clear();
    }
  }]);

  return D;
}();

var P = /*#__PURE__*/function () {
  function P(t) {
    var _this2 = this;

    _classCallCheck(this, P);

    this.observer = new D(), this.promise = Object.assign(new Promise(function (t, e) {
      setTimeout(function () {
        _this2.observer.subscribe(void 0, t, e);
      }, 0);
    }), this), setTimeout(function () {
      return _this2.init(t);
    }, 1);
  }

  _createClass(P, [{
    key: "subscribe",
    value: function subscribe(t) {
      return this.observer.subscribe(t);
    }
  }, {
    key: "next",
    value: function next(t) {
      return this.observer.subscribe(t), this;
    }
  }, {
    key: "then",
    value: function then(t, e) {
      return Object.assign(this.promise.then(t, e), this);
    }
  }, {
    key: "catch",
    value: function _catch(t) {
      return Object.assign(this.promise.catch(t), this);
    }
  }, {
    key: "finally",
    value: function _finally(t) {
      return Object.assign(this.promise.finally(t), this);
    }
  }, {
    key: "init",
    value: function init(t) {
      var _this3 = this;

      var e = t(this.observer);
      Promise.resolve(e).then(function (t) {
        "function" == typeof e.then && _this3.observer.complete(t);
      }).catch(function (t) {
        "function" == typeof e.then && _this3.observer.error(t);
      });
    }
  }]);

  return P;
}();

var N = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
    L = Math.ceil,
    W = Math.floor,
    F = "[BigNumber Error] ",
    U = F + "Number primitive has more than 15 significant digits: ",
    $ = 1e14,
    j = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
    q = 1e9;

function G(t) {
  var e = 0 | t;
  return t > 0 || t === e ? e : e - 1;
}

function z(t) {
  for (var e, i, r = 1, n = t.length, s = t[0] + ""; r < n;) {
    for (i = 14 - (e = t[r++] + "").length; i--; e = "0" + e) {
      ;
    }

    s += e;
  }

  for (n = s.length; 48 === s.charCodeAt(--n);) {
    ;
  }

  return s.slice(0, n + 1 || 1);
}

function H(t, e) {
  var i,
      r,
      n = t.c,
      s = e.c,
      o = t.s,
      a = e.s,
      h = t.e,
      u = e.e;
  if (!o || !a) return null;
  if (r = s && !s[0], (i = n && !n[0]) || r) return i ? r ? 0 : -a : o;
  if (o != a) return o;
  if (i = o < 0, r = h == u, !n || !s) return r ? 0 : !n ^ i ? 1 : -1;
  if (!r) return h > u ^ i ? 1 : -1;

  for (a = (h = n.length) < (u = s.length) ? h : u, o = 0; o < a; o++) {
    if (n[o] != s[o]) return n[o] > s[o] ^ i ? 1 : -1;
  }

  return h == u ? 0 : h > u ^ i ? 1 : -1;
}

function Z(t, e, i, r) {
  if (t < e || t > i || t !== W(t)) throw Error(F + (r || "Argument") + ("number" == typeof t ? t < e || t > i ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
}

function V(t) {
  var e = t.c.length - 1;
  return G(t.e / 14) == e && t.c[e] % 2 != 0;
}

function J(t, e) {
  return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (e < 0 ? "e" : "e+") + e;
}

function K(t, e, i) {
  var r, n;

  if (e < 0) {
    for (n = i + "."; ++e; n += i) {
      ;
    }

    t = n + t;
  } else if (++e > (r = t.length)) {
    for (n = i, e -= r; --e; n += i) {
      ;
    }

    t += n;
  } else e < r && (t = t.slice(0, e) + "." + t.slice(e));

  return t;
}

var X = function t(e) {
  var i,
      r,
      n,
      s,
      o,
      a,
      h,
      u,
      l,
      c,
      d = R.prototype = {
    constructor: R,
    toString: null,
    valueOf: null
  },
      f = new R(1),
      m = 20,
      g = 4,
      p = -7,
      w = 21,
      v = -1e7,
      y = 1e7,
      M = !1,
      b = 1,
      A = 0,
      x = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    suffix: ""
  },
      E = "0123456789abcdefghijklmnopqrstuvwxyz";

  function R(t, e) {
    var i,
        s,
        o,
        a,
        h,
        u,
        l,
        c,
        d = this;
    if (!(d instanceof R)) return new R(t, e);

    if (null == e) {
      if (t && !0 === t._isBigNumber) return d.s = t.s, void (!t.c || t.e > y ? d.c = d.e = null : t.e < v ? d.c = [d.e = 0] : (d.e = t.e, d.c = t.c.slice()));

      if ((u = "number" == typeof t) && 0 * t == 0) {
        if (d.s = 1 / t < 0 ? (t = -t, -1) : 1, t === ~~t) {
          for (a = 0, h = t; h >= 10; h /= 10, a++) {
            ;
          }

          return void (a > y ? d.c = d.e = null : (d.e = a, d.c = [t]));
        }

        c = String(t);
      } else {
        if (!N.test(c = String(t))) return n(d, c, u);
        d.s = 45 == c.charCodeAt(0) ? (c = c.slice(1), -1) : 1;
      }

      (a = c.indexOf(".")) > -1 && (c = c.replace(".", "")), (h = c.search(/e/i)) > 0 ? (a < 0 && (a = h), a += +c.slice(h + 1), c = c.substring(0, h)) : a < 0 && (a = c.length);
    } else {
      if (Z(e, 2, E.length, "Base"), 10 == e) return T(d = new R(t), m + d.e + 1, g);

      if (c = String(t), u = "number" == typeof t) {
        if (0 * t != 0) return n(d, c, u, e);
        if (d.s = 1 / t < 0 ? (c = c.slice(1), -1) : 1, R.DEBUG && c.replace(/^0\.0*|\./, "").length > 15) throw Error(U + t);
      } else d.s = 45 === c.charCodeAt(0) ? (c = c.slice(1), -1) : 1;

      for (i = E.slice(0, e), a = h = 0, l = c.length; h < l; h++) {
        if (i.indexOf(s = c.charAt(h)) < 0) {
          if ("." == s) {
            if (h > a) {
              a = l;
              continue;
            }
          } else if (!o && (c == c.toUpperCase() && (c = c.toLowerCase()) || c == c.toLowerCase() && (c = c.toUpperCase()))) {
            o = !0, h = -1, a = 0;
            continue;
          }

          return n(d, String(t), u, e);
        }
      }

      u = !1, (a = (c = r(c, e, 10, d.s)).indexOf(".")) > -1 ? c = c.replace(".", "") : a = c.length;
    }

    for (h = 0; 48 === c.charCodeAt(h); h++) {
      ;
    }

    for (l = c.length; 48 === c.charCodeAt(--l);) {
      ;
    }

    if (c = c.slice(h, ++l)) {
      if (l -= h, u && R.DEBUG && l > 15 && (t > 9007199254740991 || t !== W(t))) throw Error(U + d.s * t);
      if ((a = a - h - 1) > y) d.c = d.e = null;else if (a < v) d.c = [d.e = 0];else {
        if (d.e = a, d.c = [], h = (a + 1) % 14, a < 0 && (h += 14), h < l) {
          for (h && d.c.push(+c.slice(0, h)), l -= 14; h < l;) {
            d.c.push(+c.slice(h, h += 14));
          }

          h = 14 - (c = c.slice(h)).length;
        } else h -= l;

        for (; h--; c += "0") {
          ;
        }

        d.c.push(+c);
      }
    } else d.c = [d.e = 0];
  }

  function k(t, e, i, r) {
    var n, s, o, a, h;
    if (null == i ? i = g : Z(i, 0, 8), !t.c) return t.toString();
    if (n = t.c[0], o = t.e, null == e) h = z(t.c), h = 1 == r || 2 == r && (o <= p || o >= w) ? J(h, o) : K(h, o, "0");else if (s = (t = T(new R(t), e, i)).e, a = (h = z(t.c)).length, 1 == r || 2 == r && (e <= s || s <= p)) {
      for (; a < e; h += "0", a++) {
        ;
      }

      h = J(h, s);
    } else if (e -= o, h = K(h, s, "0"), s + 1 > a) {
      if (--e > 0) for (h += "."; e--; h += "0") {
        ;
      }
    } else if ((e += s - a) > 0) for (s + 1 == a && (h += "."); e--; h += "0") {
      ;
    }
    return t.s < 0 && n ? "-" + h : h;
  }

  function S(t, e) {
    for (var i, r = 1, n = new R(t[0]); r < t.length; r++) {
      if (!(i = new R(t[r])).s) {
        n = i;
        break;
      }

      e.call(n, i) && (n = i);
    }

    return n;
  }

  function I(t, e, i) {
    for (var r = 1, n = e.length; !e[--n]; e.pop()) {
      ;
    }

    for (n = e[0]; n >= 10; n /= 10, r++) {
      ;
    }

    return (i = r + 14 * i - 1) > y ? t.c = t.e = null : i < v ? t.c = [t.e = 0] : (t.e = i, t.c = e), t;
  }

  function T(t, e, i, r) {
    var n,
        s,
        o,
        a,
        h,
        u,
        l,
        c = t.c,
        d = j;

    if (c) {
      t: {
        for (n = 1, a = c[0]; a >= 10; a /= 10, n++) {
          ;
        }

        if ((s = e - n) < 0) s += 14, l = (h = c[u = 0]) / d[n - (o = e) - 1] % 10 | 0;else if ((u = L((s + 1) / 14)) >= c.length) {
          if (!r) break t;

          for (; c.length <= u; c.push(0)) {
            ;
          }

          h = l = 0, n = 1, o = (s %= 14) - 14 + 1;
        } else {
          for (h = a = c[u], n = 1; a >= 10; a /= 10, n++) {
            ;
          }

          l = (o = (s %= 14) - 14 + n) < 0 ? 0 : h / d[n - o - 1] % 10 | 0;
        }
        if (r = r || e < 0 || null != c[u + 1] || (o < 0 ? h : h % d[n - o - 1]), r = i < 4 ? (l || r) && (0 == i || i == (t.s < 0 ? 3 : 2)) : l > 5 || 5 == l && (4 == i || r || 6 == i && (s > 0 ? o > 0 ? h / d[n - o] : 0 : c[u - 1]) % 10 & 1 || i == (t.s < 0 ? 8 : 7)), e < 1 || !c[0]) return c.length = 0, r ? (c[0] = d[(14 - (e -= t.e + 1) % 14) % 14], t.e = -e || 0) : c[0] = t.e = 0, t;
        if (0 == s ? (c.length = u, a = 1, u--) : (c.length = u + 1, a = d[14 - s], c[u] = o > 0 ? W(h / d[n - o] % d[o]) * a : 0), r) for (;;) {
          if (0 == u) {
            for (s = 1, o = c[0]; o >= 10; o /= 10, s++) {
              ;
            }

            for (o = c[0] += a, a = 1; o >= 10; o /= 10, a++) {
              ;
            }

            s != a && (t.e++, c[0] == $ && (c[0] = 1));
            break;
          }

          if (c[u] += a, c[u] != $) break;
          c[u--] = 0, a = 1;
        }

        for (s = c.length; 0 === c[--s]; c.pop()) {
          ;
        }
      }

      t.e > y ? t.c = t.e = null : t.e < v && (t.c = [t.e = 0]);
    }

    return t;
  }

  function O(t) {
    var e,
        i = t.e;
    return null === i ? t.toString() : (e = z(t.c), e = i <= p || i >= w ? J(e, i) : K(e, i, "0"), t.s < 0 ? "-" + e : e);
  }

  return R.clone = t, R.ROUND_UP = 0, R.ROUND_DOWN = 1, R.ROUND_CEIL = 2, R.ROUND_FLOOR = 3, R.ROUND_HALF_UP = 4, R.ROUND_HALF_DOWN = 5, R.ROUND_HALF_EVEN = 6, R.ROUND_HALF_CEIL = 7, R.ROUND_HALF_FLOOR = 8, R.EUCLID = 9, R.config = R.set = function (t) {
    var e, i;

    if (null != t) {
      if ("object" != typeof t) throw Error(F + "Object expected: " + t);
      if (t.hasOwnProperty(e = "DECIMAL_PLACES") && (Z(i = t[e], 0, q, e), m = i), t.hasOwnProperty(e = "ROUNDING_MODE") && (Z(i = t[e], 0, 8, e), g = i), t.hasOwnProperty(e = "EXPONENTIAL_AT") && ((i = t[e]) && i.pop ? (Z(i[0], -q, 0, e), Z(i[1], 0, q, e), p = i[0], w = i[1]) : (Z(i, -q, q, e), p = -(w = i < 0 ? -i : i))), t.hasOwnProperty(e = "RANGE")) if ((i = t[e]) && i.pop) Z(i[0], -q, -1, e), Z(i[1], 1, q, e), v = i[0], y = i[1];else {
        if (Z(i, -q, q, e), !i) throw Error(F + e + " cannot be zero: " + i);
        v = -(y = i < 0 ? -i : i);
      }

      if (t.hasOwnProperty(e = "CRYPTO")) {
        if ((i = t[e]) !== !!i) throw Error(F + e + " not true or false: " + i);

        if (i) {
          if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw M = !i, Error(F + "crypto unavailable");
          M = i;
        } else M = i;
      }

      if (t.hasOwnProperty(e = "MODULO_MODE") && (Z(i = t[e], 0, 9, e), b = i), t.hasOwnProperty(e = "POW_PRECISION") && (Z(i = t[e], 0, q, e), A = i), t.hasOwnProperty(e = "FORMAT")) {
        if ("object" != typeof (i = t[e])) throw Error(F + e + " not an object: " + i);
        x = i;
      }

      if (t.hasOwnProperty(e = "ALPHABET")) {
        if ("string" != typeof (i = t[e]) || /^.$|[+-.\s]|(.).*\1/.test(i)) throw Error(F + e + " invalid: " + i);
        E = i;
      }
    }

    return {
      DECIMAL_PLACES: m,
      ROUNDING_MODE: g,
      EXPONENTIAL_AT: [p, w],
      RANGE: [v, y],
      CRYPTO: M,
      MODULO_MODE: b,
      POW_PRECISION: A,
      FORMAT: x,
      ALPHABET: E
    };
  }, R.isBigNumber = function (t) {
    if (!t || !0 !== t._isBigNumber) return !1;
    if (!R.DEBUG) return !0;
    var e,
        i,
        r = t.c,
        n = t.e,
        s = t.s;

    t: if ("[object Array]" == {}.toString.call(r)) {
      if ((1 === s || -1 === s) && n >= -q && n <= q && n === W(n)) {
        if (0 === r[0]) {
          if (0 === n && 1 === r.length) return !0;
          break t;
        }

        if ((e = (n + 1) % 14) < 1 && (e += 14), String(r[0]).length == e) {
          for (e = 0; e < r.length; e++) {
            if ((i = r[e]) < 0 || i >= $ || i !== W(i)) break t;
          }

          if (0 !== i) return !0;
        }
      }
    } else if (null === r && null === n && (null === s || 1 === s || -1 === s)) return !0;

    throw Error(F + "Invalid BigNumber: " + t);
  }, R.maximum = R.max = function () {
    return S(arguments, d.lt);
  }, R.minimum = R.min = function () {
    return S(arguments, d.gt);
  }, R.random = (s = 9007199254740992, o = Math.random() * s & 2097151 ? function () {
    return W(Math.random() * s);
  } : function () {
    return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
  }, function (t) {
    var e,
        i,
        r,
        n,
        s,
        a = 0,
        h = [],
        u = new R(f);
    if (null == t ? t = m : Z(t, 0, q), n = L(t / 14), M) if (crypto.getRandomValues) {
      for (e = crypto.getRandomValues(new Uint32Array(n *= 2)); a < n;) {
        (s = 131072 * e[a] + (e[a + 1] >>> 11)) >= 9e15 ? (i = crypto.getRandomValues(new Uint32Array(2)), e[a] = i[0], e[a + 1] = i[1]) : (h.push(s % 1e14), a += 2);
      }

      a = n / 2;
    } else {
      if (!crypto.randomBytes) throw M = !1, Error(F + "crypto unavailable");

      for (e = crypto.randomBytes(n *= 7); a < n;) {
        (s = 281474976710656 * (31 & e[a]) + 1099511627776 * e[a + 1] + 4294967296 * e[a + 2] + 16777216 * e[a + 3] + (e[a + 4] << 16) + (e[a + 5] << 8) + e[a + 6]) >= 9e15 ? crypto.randomBytes(7).copy(e, a) : (h.push(s % 1e14), a += 7);
      }

      a = n / 7;
    }
    if (!M) for (; a < n;) {
      (s = o()) < 9e15 && (h[a++] = s % 1e14);
    }

    for (t %= 14, (n = h[--a]) && t && (h[a] = W(n / (s = j[14 - t])) * s); 0 === h[a]; h.pop(), a--) {
      ;
    }

    if (a < 0) h = [r = 0];else {
      for (r = -1; 0 === h[0]; h.splice(0, 1), r -= 14) {
        ;
      }

      for (a = 1, s = h[0]; s >= 10; s /= 10, a++) {
        ;
      }

      a < 14 && (r -= 14 - a);
    }
    return u.e = r, u.c = h, u;
  }), R.sum = function () {
    for (var t = 1, e = arguments, i = new R(e[0]); t < e.length;) {
      i = i.plus(e[t++]);
    }

    return i;
  }, r = function () {
    var t = "0123456789";

    function e(t, e, i, r) {
      for (var n, s, o = [0], a = 0, h = t.length; a < h;) {
        for (s = o.length; s--; o[s] *= e) {
          ;
        }

        for (o[0] += r.indexOf(t.charAt(a++)), n = 0; n < o.length; n++) {
          o[n] > i - 1 && (null == o[n + 1] && (o[n + 1] = 0), o[n + 1] += o[n] / i | 0, o[n] %= i);
        }
      }

      return o.reverse();
    }

    return function (r, n, s, o, a) {
      var h,
          u,
          l,
          c,
          d,
          f,
          p,
          w,
          v = r.indexOf("."),
          y = m,
          M = g;

      for (v >= 0 && (c = A, A = 0, r = r.replace(".", ""), f = (w = new R(n)).pow(r.length - v), A = c, w.c = e(K(z(f.c), f.e, "0"), 10, s, t), w.e = w.c.length), l = c = (p = e(r, n, s, a ? (h = E, t) : (h = t, E))).length; 0 == p[--c]; p.pop()) {
        ;
      }

      if (!p[0]) return h.charAt(0);
      if (v < 0 ? --l : (f.c = p, f.e = l, f.s = o, p = (f = i(f, w, y, M, s)).c, d = f.r, l = f.e), v = p[u = l + y + 1], c = s / 2, d = d || u < 0 || null != p[u + 1], d = M < 4 ? (null != v || d) && (0 == M || M == (f.s < 0 ? 3 : 2)) : v > c || v == c && (4 == M || d || 6 == M && 1 & p[u - 1] || M == (f.s < 0 ? 8 : 7)), u < 1 || !p[0]) r = d ? K(h.charAt(1), -y, h.charAt(0)) : h.charAt(0);else {
        if (p.length = u, d) for (--s; ++p[--u] > s;) {
          p[u] = 0, u || (++l, p = [1].concat(p));
        }

        for (c = p.length; !p[--c];) {
          ;
        }

        for (v = 0, r = ""; v <= c; r += h.charAt(p[v++])) {
          ;
        }

        r = K(r, l, h.charAt(0));
      }
      return r;
    };
  }(), i = function () {
    function t(t, e, i) {
      var r,
          n,
          s,
          o,
          a = 0,
          h = t.length,
          u = e % 1e7,
          l = e / 1e7 | 0;

      for (t = t.slice(); h--;) {
        a = ((n = u * (s = t[h] % 1e7) + (r = l * s + (o = t[h] / 1e7 | 0) * u) % 1e7 * 1e7 + a) / i | 0) + (r / 1e7 | 0) + l * o, t[h] = n % i;
      }

      return a && (t = [a].concat(t)), t;
    }

    function e(t, e, i, r) {
      var n, s;
      if (i != r) s = i > r ? 1 : -1;else for (n = s = 0; n < i; n++) {
        if (t[n] != e[n]) {
          s = t[n] > e[n] ? 1 : -1;
          break;
        }
      }
      return s;
    }

    function i(t, e, i, r) {
      for (var n = 0; i--;) {
        t[i] -= n, t[i] = (n = t[i] < e[i] ? 1 : 0) * r + t[i] - e[i];
      }

      for (; !t[0] && t.length > 1; t.splice(0, 1)) {
        ;
      }
    }

    return function (r, n, s, o, a) {
      var h,
          u,
          l,
          c,
          d,
          f,
          m,
          g,
          p,
          w,
          v,
          y,
          M,
          b,
          A,
          x,
          E,
          k = r.s == n.s ? 1 : -1,
          S = r.c,
          I = n.c;
      if (!(S && S[0] && I && I[0])) return new R(r.s && n.s && (S ? !I || S[0] != I[0] : I) ? S && 0 == S[0] || !I ? 0 * k : k / 0 : NaN);

      for (p = (g = new R(k)).c = [], k = s + (u = r.e - n.e) + 1, a || (a = $, u = G(r.e / 14) - G(n.e / 14), k = k / 14 | 0), l = 0; I[l] == (S[l] || 0); l++) {
        ;
      }

      if (I[l] > (S[l] || 0) && u--, k < 0) p.push(1), c = !0;else {
        for (b = S.length, x = I.length, l = 0, k += 2, (d = W(a / (I[0] + 1))) > 1 && (I = t(I, d, a), S = t(S, d, a), x = I.length, b = S.length), M = x, v = (w = S.slice(0, x)).length; v < x; w[v++] = 0) {
          ;
        }

        E = I.slice(), E = [0].concat(E), A = I[0], I[1] >= a / 2 && A++;

        do {
          if (d = 0, (h = e(I, w, x, v)) < 0) {
            if (y = w[0], x != v && (y = y * a + (w[1] || 0)), (d = W(y / A)) > 1) for (d >= a && (d = a - 1), m = (f = t(I, d, a)).length, v = w.length; 1 == e(f, w, m, v);) {
              d--, i(f, x < m ? E : I, m, a), m = f.length, h = 1;
            } else 0 == d && (h = d = 1), m = (f = I.slice()).length;
            if (m < v && (f = [0].concat(f)), i(w, f, v, a), v = w.length, -1 == h) for (; e(I, w, x, v) < 1;) {
              d++, i(w, x < v ? E : I, v, a), v = w.length;
            }
          } else 0 === h && (d++, w = [0]);

          p[l++] = d, w[0] ? w[v++] = S[M] || 0 : (w = [S[M]], v = 1);
        } while ((M++ < b || null != w[0]) && k--);

        c = null != w[0], p[0] || p.splice(0, 1);
      }

      if (a == $) {
        for (l = 1, k = p[0]; k >= 10; k /= 10, l++) {
          ;
        }

        T(g, s + (g.e = l + 14 * u - 1) + 1, o, c);
      } else g.e = u, g.r = +c;

      return g;
    };
  }(), a = /^(-?)0([xbo])(?=\w[\w.]*$)/i, h = /^([^.]+)\.$/, u = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, c = /^\s*\+(?=[\w.])|^\s+|\s+$/g, n = function n(t, e, i, r) {
    var n,
        s = i ? e : e.replace(c, "");
    if (l.test(s)) t.s = isNaN(s) ? null : s < 0 ? -1 : 1;else {
      if (!i && (s = s.replace(a, function (t, e, i) {
        return n = "x" == (i = i.toLowerCase()) ? 16 : "b" == i ? 2 : 8, r && r != n ? t : e;
      }), r && (n = r, s = s.replace(h, "$1").replace(u, "0.$1")), e != s)) return new R(s, n);
      if (R.DEBUG) throw Error(F + "Not a" + (r ? " base " + r : "") + " number: " + e);
      t.s = null;
    }
    t.c = t.e = null;
  }, d.absoluteValue = d.abs = function () {
    var t = new R(this);
    return t.s < 0 && (t.s = 1), t;
  }, d.comparedTo = function (t, e) {
    return H(this, new R(t, e));
  }, d.decimalPlaces = d.dp = function (t, e) {
    var i,
        r,
        n,
        s = this;
    if (null != t) return Z(t, 0, q), null == e ? e = g : Z(e, 0, 8), T(new R(s), t + s.e + 1, e);
    if (!(i = s.c)) return null;
    if (r = 14 * ((n = i.length - 1) - G(this.e / 14)), n = i[n]) for (; n % 10 == 0; n /= 10, r--) {
      ;
    }
    return r < 0 && (r = 0), r;
  }, d.dividedBy = d.div = function (t, e) {
    return i(this, new R(t, e), m, g);
  }, d.dividedToIntegerBy = d.idiv = function (t, e) {
    return i(this, new R(t, e), 0, 1);
  }, d.exponentiatedBy = d.pow = function (t, e) {
    var i,
        r,
        n,
        s,
        o,
        a,
        h,
        u,
        l = this;
    if ((t = new R(t)).c && !t.isInteger()) throw Error(F + "Exponent not an integer: " + O(t));
    if (null != e && (e = new R(e)), o = t.e > 14, !l.c || !l.c[0] || 1 == l.c[0] && !l.e && 1 == l.c.length || !t.c || !t.c[0]) return u = new R(Math.pow(+O(l), o ? 2 - V(t) : +O(t))), e ? u.mod(e) : u;

    if (a = t.s < 0, e) {
      if (e.c ? !e.c[0] : !e.s) return new R(NaN);
      (r = !a && l.isInteger() && e.isInteger()) && (l = l.mod(e));
    } else {
      if (t.e > 9 && (l.e > 0 || l.e < -1 || (0 == l.e ? l.c[0] > 1 || o && l.c[1] >= 24e7 : l.c[0] < 8e13 || o && l.c[0] <= 9999975e7))) return s = l.s < 0 && V(t) ? -0 : 0, l.e > -1 && (s = 1 / s), new R(a ? 1 / s : s);
      A && (s = L(A / 14 + 2));
    }

    for (o ? (i = new R(.5), a && (t.s = 1), h = V(t)) : h = (n = Math.abs(+O(t))) % 2, u = new R(f);;) {
      if (h) {
        if (!(u = u.times(l)).c) break;
        s ? u.c.length > s && (u.c.length = s) : r && (u = u.mod(e));
      }

      if (n) {
        if (0 === (n = W(n / 2))) break;
        h = n % 2;
      } else if (T(t = t.times(i), t.e + 1, 1), t.e > 14) h = V(t);else {
        if (0 == (n = +O(t))) break;
        h = n % 2;
      }

      l = l.times(l), s ? l.c && l.c.length > s && (l.c.length = s) : r && (l = l.mod(e));
    }

    return r ? u : (a && (u = f.div(u)), e ? u.mod(e) : s ? T(u, A, g, void 0) : u);
  }, d.integerValue = function (t) {
    var e = new R(this);
    return null == t ? t = g : Z(t, 0, 8), T(e, e.e + 1, t);
  }, d.isEqualTo = d.eq = function (t, e) {
    return 0 === H(this, new R(t, e));
  }, d.isFinite = function () {
    return !!this.c;
  }, d.isGreaterThan = d.gt = function (t, e) {
    return H(this, new R(t, e)) > 0;
  }, d.isGreaterThanOrEqualTo = d.gte = function (t, e) {
    return 1 === (e = H(this, new R(t, e))) || 0 === e;
  }, d.isInteger = function () {
    return !!this.c && G(this.e / 14) > this.c.length - 2;
  }, d.isLessThan = d.lt = function (t, e) {
    return H(this, new R(t, e)) < 0;
  }, d.isLessThanOrEqualTo = d.lte = function (t, e) {
    return -1 === (e = H(this, new R(t, e))) || 0 === e;
  }, d.isNaN = function () {
    return !this.s;
  }, d.isNegative = function () {
    return this.s < 0;
  }, d.isPositive = function () {
    return this.s > 0;
  }, d.isZero = function () {
    return !!this.c && 0 == this.c[0];
  }, d.minus = function (t, e) {
    var i,
        r,
        n,
        s,
        o = this,
        a = o.s;
    if (e = (t = new R(t, e)).s, !a || !e) return new R(NaN);
    if (a != e) return t.s = -e, o.plus(t);
    var h = o.e / 14,
        u = t.e / 14,
        l = o.c,
        c = t.c;

    if (!h || !u) {
      if (!l || !c) return l ? (t.s = -e, t) : new R(c ? o : NaN);
      if (!l[0] || !c[0]) return c[0] ? (t.s = -e, t) : new R(l[0] ? o : 3 == g ? -0 : 0);
    }

    if (h = G(h), u = G(u), l = l.slice(), a = h - u) {
      for ((s = a < 0) ? (a = -a, n = l) : (u = h, n = c), n.reverse(), e = a; e--; n.push(0)) {
        ;
      }

      n.reverse();
    } else for (r = (s = (a = l.length) < (e = c.length)) ? a : e, a = e = 0; e < r; e++) {
      if (l[e] != c[e]) {
        s = l[e] < c[e];
        break;
      }
    }

    if (s && (n = l, l = c, c = n, t.s = -t.s), (e = (r = c.length) - (i = l.length)) > 0) for (; e--; l[i++] = 0) {
      ;
    }

    for (e = $ - 1; r > a;) {
      if (l[--r] < c[r]) {
        for (i = r; i && !l[--i]; l[i] = e) {
          ;
        }

        --l[i], l[r] += $;
      }

      l[r] -= c[r];
    }

    for (; 0 == l[0]; l.splice(0, 1), --u) {
      ;
    }

    return l[0] ? I(t, l, u) : (t.s = 3 == g ? -1 : 1, t.c = [t.e = 0], t);
  }, d.modulo = d.mod = function (t, e) {
    var r,
        n,
        s = this;
    return t = new R(t, e), !s.c || !t.s || t.c && !t.c[0] ? new R(NaN) : !t.c || s.c && !s.c[0] ? new R(s) : (9 == b ? (n = t.s, t.s = 1, r = i(s, t, 0, 3), t.s = n, r.s *= n) : r = i(s, t, 0, b), (t = s.minus(r.times(t))).c[0] || 1 != b || (t.s = s.s), t);
  }, d.multipliedBy = d.times = function (t, e) {
    var i,
        r,
        n,
        s,
        o,
        a,
        h,
        u,
        l,
        c,
        d,
        f,
        m,
        g,
        p,
        w = this,
        v = w.c,
        y = (t = new R(t, e)).c;
    if (!(v && y && v[0] && y[0])) return !w.s || !t.s || v && !v[0] && !y || y && !y[0] && !v ? t.c = t.e = t.s = null : (t.s *= w.s, v && y ? (t.c = [0], t.e = 0) : t.c = t.e = null), t;

    for (r = G(w.e / 14) + G(t.e / 14), t.s *= w.s, (h = v.length) < (c = y.length) && (m = v, v = y, y = m, n = h, h = c, c = n), n = h + c, m = []; n--; m.push(0)) {
      ;
    }

    for (g = $, p = 1e7, n = c; --n >= 0;) {
      for (i = 0, d = y[n] % p, f = y[n] / p | 0, s = n + (o = h); s > n;) {
        i = ((u = d * (u = v[--o] % p) + (a = f * u + (l = v[o] / p | 0) * d) % p * p + m[s] + i) / g | 0) + (a / p | 0) + f * l, m[s--] = u % g;
      }

      m[s] = i;
    }

    return i ? ++r : m.splice(0, 1), I(t, m, r);
  }, d.negated = function () {
    var t = new R(this);
    return t.s = -t.s || null, t;
  }, d.plus = function (t, e) {
    var i,
        r = this,
        n = r.s;
    if (e = (t = new R(t, e)).s, !n || !e) return new R(NaN);
    if (n != e) return t.s = -e, r.minus(t);
    var s = r.e / 14,
        o = t.e / 14,
        a = r.c,
        h = t.c;

    if (!s || !o) {
      if (!a || !h) return new R(n / 0);
      if (!a[0] || !h[0]) return h[0] ? t : new R(a[0] ? r : 0 * n);
    }

    if (s = G(s), o = G(o), a = a.slice(), n = s - o) {
      for (n > 0 ? (o = s, i = h) : (n = -n, i = a), i.reverse(); n--; i.push(0)) {
        ;
      }

      i.reverse();
    }

    for ((n = a.length) - (e = h.length) < 0 && (i = h, h = a, a = i, e = n), n = 0; e;) {
      n = (a[--e] = a[e] + h[e] + n) / $ | 0, a[e] = $ === a[e] ? 0 : a[e] % $;
    }

    return n && (a = [n].concat(a), ++o), I(t, a, o);
  }, d.precision = d.sd = function (t, e) {
    var i,
        r,
        n,
        s = this;
    if (null != t && t !== !!t) return Z(t, 1, q), null == e ? e = g : Z(e, 0, 8), T(new R(s), t, e);
    if (!(i = s.c)) return null;

    if (r = 14 * (n = i.length - 1) + 1, n = i[n]) {
      for (; n % 10 == 0; n /= 10, r--) {
        ;
      }

      for (n = i[0]; n >= 10; n /= 10, r++) {
        ;
      }
    }

    return t && s.e + 1 > r && (r = s.e + 1), r;
  }, d.shiftedBy = function (t) {
    return Z(t, -9007199254740991, 9007199254740991), this.times("1e" + t);
  }, d.squareRoot = d.sqrt = function () {
    var t,
        e,
        r,
        n,
        s,
        o = this,
        a = o.c,
        h = o.s,
        u = o.e,
        l = m + 4,
        c = new R("0.5");
    if (1 !== h || !a || !a[0]) return new R(!h || h < 0 && (!a || a[0]) ? NaN : a ? o : 1 / 0);
    if (0 == (h = Math.sqrt(+O(o))) || h == 1 / 0 ? (((e = z(a)).length + u) % 2 == 0 && (e += "0"), h = Math.sqrt(+e), u = G((u + 1) / 2) - (u < 0 || u % 2), r = new R(e = h == 1 / 0 ? "5e" + u : (e = h.toExponential()).slice(0, e.indexOf("e") + 1) + u)) : r = new R(h + ""), r.c[0]) for ((h = (u = r.e) + l) < 3 && (h = 0);;) {
      if (r = c.times((s = r).plus(i(o, s, l, 1))), z(s.c).slice(0, h) === (e = z(r.c)).slice(0, h)) {
        if (r.e < u && --h, "9999" != (e = e.slice(h - 3, h + 1)) && (n || "4999" != e)) {
          +e && (+e.slice(1) || "5" != e.charAt(0)) || (T(r, r.e + m + 2, 1), t = !r.times(r).eq(o));
          break;
        }

        if (!n && (T(s, s.e + m + 2, 0), s.times(s).eq(o))) {
          r = s;
          break;
        }

        l += 4, h += 4, n = 1;
      }
    }
    return T(r, r.e + m + 1, g, t);
  }, d.toExponential = function (t, e) {
    return null != t && (Z(t, 0, q), t++), k(this, t, e, 1);
  }, d.toFixed = function (t, e) {
    return null != t && (Z(t, 0, q), t = t + this.e + 1), k(this, t, e);
  }, d.toFormat = function (t, e, i) {
    var r,
        n = this;
    if (null == i) null != t && e && "object" == typeof e ? (i = e, e = null) : t && "object" == typeof t ? (i = t, t = e = null) : i = x;else if ("object" != typeof i) throw Error(F + "Argument not an object: " + i);

    if (r = n.toFixed(t, e), n.c) {
      var s,
          o = r.split("."),
          a = +i.groupSize,
          h = +i.secondaryGroupSize,
          u = i.groupSeparator || "",
          l = o[0],
          c = o[1],
          d = n.s < 0,
          f = d ? l.slice(1) : l,
          m = f.length;

      if (h && (s = a, a = h, h = s, m -= s), a > 0 && m > 0) {
        for (l = f.substr(0, s = m % a || a); s < m; s += a) {
          l += u + f.substr(s, a);
        }

        h > 0 && (l += u + f.slice(s)), d && (l = "-" + l);
      }

      r = c ? l + (i.decimalSeparator || "") + ((h = +i.fractionGroupSize) ? c.replace(new RegExp("\\d{" + h + "}\\B", "g"), "$&" + (i.fractionGroupSeparator || "")) : c) : l;
    }

    return (i.prefix || "") + r + (i.suffix || "");
  }, d.toFraction = function (t) {
    var e,
        r,
        n,
        s,
        o,
        a,
        h,
        u,
        l,
        c,
        d,
        m,
        p = this,
        w = p.c;
    if (null != t && (!(h = new R(t)).isInteger() && (h.c || 1 !== h.s) || h.lt(f))) throw Error(F + "Argument " + (h.isInteger() ? "out of range: " : "not an integer: ") + O(h));
    if (!w) return new R(p);

    for (e = new R(f), l = r = new R(f), n = u = new R(f), m = z(w), o = e.e = m.length - p.e - 1, e.c[0] = j[(a = o % 14) < 0 ? 14 + a : a], t = !t || h.comparedTo(e) > 0 ? o > 0 ? e : l : h, a = y, y = 1 / 0, h = new R(m), u.c[0] = 0; c = i(h, e, 0, 1), 1 != (s = r.plus(c.times(n))).comparedTo(t);) {
      r = n, n = s, l = u.plus(c.times(s = l)), u = s, e = h.minus(c.times(s = e)), h = s;
    }

    return s = i(t.minus(r), n, 0, 1), u = u.plus(s.times(l)), r = r.plus(s.times(n)), u.s = l.s = p.s, d = i(l, n, o *= 2, g).minus(p).abs().comparedTo(i(u, r, o, g).minus(p).abs()) < 1 ? [l, n] : [u, r], y = a, d;
  }, d.toNumber = function () {
    return +O(this);
  }, d.toPrecision = function (t, e) {
    return null != t && Z(t, 1, q), k(this, t, e, 2);
  }, d.toString = function (t) {
    var e,
        i = this,
        n = i.s,
        s = i.e;
    return null === s ? n ? (e = "Infinity", n < 0 && (e = "-" + e)) : e = "NaN" : (null == t ? e = s <= p || s >= w ? J(z(i.c), s) : K(z(i.c), s, "0") : 10 === t ? e = K(z((i = T(new R(i), m + s + 1, g)).c), i.e, "0") : (Z(t, 2, E.length, "Base"), e = r(K(z(i.c), s, "0"), 10, t, n, !0)), n < 0 && i.c[0] && (e = "-" + e)), e;
  }, d.valueOf = d.toJSON = function () {
    return O(this);
  }, d._isBigNumber = !0, d[Symbol.toStringTag] = "BigNumber", d[Symbol.for("nodejs.util.inspect.custom")] = d.valueOf, null != e && R.set(e), R;
}();

function Q(_x, _x2) {
  return _Q.apply(this, arguments);
}

function _Q() {
  _Q = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee229(t, e) {
    var i;
    return _regeneratorRuntime.wrap(function _callee229$(_context229) {
      while (1) {
        switch (_context229.prev = _context229.next) {
          case 0:
            _context229.t0 = X;
            _context229.next = 3;
            return t.eth.getGasPrice();

          case 3:
            _context229.t1 = _context229.sent;
            i = new _context229.t0(_context229.t1);
            return _context229.abrupt("return", e && e.gasFeeMultiplier ? i.multipliedBy(e.gasFeeMultiplier).integerValue(X.ROUND_DOWN).toString(10) : i.toString(10));

          case 6:
          case "end":
            return _context229.stop();
        }
      }
    }, _callee229);
  }));
  return _Q.apply(this, arguments);
}

function Y(t, e) {
  return e && (t.transactionBlockTimeout = e.transactionBlockTimeout, t.transactionConfirmationBlocks = e.transactionConfirmationBlocks, t.transactionPollingTimeout = e.transactionPollingTimeout), t;
}

function tt(t) {
  return void 0 !== t.id;
}

function et(_x3, _x4) {
  return _et.apply(this, arguments);
}

function _et() {
  _et = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee230(t, e) {
    var i;
    return _regeneratorRuntime.wrap(function _callee230$(_context230) {
      while (1) {
        switch (_context230.prev = _context230.next) {
          case 0:
            if (!tt(t)) {
              _context230.next = 2;
              break;
            }

            return _context230.abrupt("return", {
              did: t.id,
              ddo: t
            });

          case 2:
            _context230.next = 4;
            return e.assets.resolve(t);

          case 4:
            i = _context230.sent;
            return _context230.abrupt("return", {
              did: i.id,
              ddo: i
            });

          case 6:
          case "end":
            return _context230.stop();
        }
      }
    }, _callee230);
  }));
  return _et.apply(this, arguments);
}

var it = {
  nouns: ["Crab", "Fish", "Seal", "Octopus", "Shark", "Seahorse", "Walrus", "Starfish", "Whale", "Orca", "Penguin", "Jellyfish", "Squid", "Lobster", "Pelican", "Shrimp", "Oyster", "Clam", "Seagull", "Dolphin", "Shell", "Cormorant", "Otter", "Anemone", "Turtle", "Coral", "Ray", "Barracuda", "Krill", "Anchovy", "Angelfish", "Barnacle", "Clownfish", "Cod", "Cuttlefish", "Eel", "Fugu", "Herring", "Haddock", "Ling", "Mackerel", "Manatee", "Narwhal", "Nautilus", "Plankton", "Porpoise", "Prawn", "Pufferfish", "Swordfish", "Tuna"],
  adjectives: ["adamant", "adroit", "amatory", "ambitious", "amused", "animistic", "antic", "arcadian", "artistic", "astonishing", "astounding", "baleful", "bellicose", "bilious", "blissful", "boorish", "brave", "breathtaking", "brilliant", "calamitous", "caustic", "cerulean", "clever", "charming", "comely", "competent", "concomitant", "confident", "contumacious", "corpulent", "crapulous", "creative", "dazzling", "dedicated", "defamatory", "delighted", "delightful", "determined", "didactic", "dilatory", "dowdy", "efficacious", "effulgent", "egregious", "empowered", "endemic", "enthusiastic", "equanimous", "exceptional", "execrable", "fabulous", "fantastic", "fastidious", "feckless", "fecund", "friable", "fulsome", "garrulous", "generous", "gentle", "guileless", "gustatory", "heuristic", "histrionic", "hubristic", "incendiary", "incredible", "insidious", "insolent", "inspired", "intransigent", "inveterate", "invidious", "invigorated", "irksome", "jejune", "juicy", "jocular", "joyful", "judicious", "kind", "lachrymose", "limpid", "loquacious", "lovely", "luminous", "mannered", "marvelous", "mendacious", "meretricious", "minatory", "mordant", "motivated", "munificent", "nefarious", "noxious", "obtuse", "optimistic", "parsimonious", "pendulous", "pernicious", "pervasive", "petulant", "passionate", "phenomenal", "platitudinous", "pleasant", "powerful", "precipitate", "propitious", "puckish", "querulous", "quiescent", "rebarbative", "recalcitant", "redolent", "rhadamanthine", "risible", "ruminative", "sagacious", "salubrious", "sartorial", "sclerotic", "serpentine", "smart", "spasmodic", "strident", "stunning", "stupendous", "taciturn", "tactful", "tasty", "tenacious", "tremendous", "tremulous", "trenchant", "turbulent", "turgid", "ubiquitous", "uxorious", "verdant", "vibrant", "voluble", "voracious", "wheedling", "withering", "wonderful", "zealous"]
};

function rt(t) {
  var e = t || it,
      i = Math.floor(Math.random() * e.adjectives.length),
      r = Math.floor(Math.random() * e.nouns.length),
      n = Math.floor(100 * Math.random()),
      s = e.adjectives[i].replace(/^\w/, function (t) {
    return t.toUpperCase();
  }),
      o = e.nouns[r].replace(/^\w/, function (t) {
    return t.toUpperCase();
  });
  return {
    name: "".concat(s, " ").concat(o, " Token"),
    symbol: "".concat((s.substring(0, 3) + o.substring(0, 3)).toUpperCase(), "-").concat(n)
  };
}

var nt = {
  __proto__: null,
  objectPromiseAll: function () {
    var _objectPromiseAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = function () {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return t.reduce(function (t, i, r) {
                  return A({}, t, _defineProperty({}, i, e[r]));
                }, {});
              };

              _context.t1 = Object.keys(t);
              _context.next = 4;
              return Promise.all(Object.values(t));

            case 4:
              _context.t2 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function objectPromiseAll(_x5) {
      return _objectPromiseAll.apply(this, arguments);
    }

    return objectPromiseAll;
  }(),

  get LogLevel() {
    return x;
  },

  Logger: E,
  LoggerInstance: R,
  zeroX: k,
  noZeroX: S,
  zeroXTransformer: I,
  didPrefixed: T,
  noDidPrefixed: function noDidPrefixed(t) {
    return O(t, !1);
  },
  didTransformer: O,
  didZeroX: B,
  didNoZeroX: C,
  generateId: function generateId() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 64;
    var i = "";

    for (; i.length < e;) {
      i += t().replace(/-/g, "");
    }

    return i.substr(0, e);
  },
  SubscribablePromise: P,
  SubscribableObserver: D,
  getFairGasPrice: Q,
  setContractDefaults: Y,
  isDdo: tt,
  assetResolve: et,
  generateDatatokenName: rt
};

var st = /*#__PURE__*/function () {
  function st() {
    _classCallCheck(this, st);

    this._ocean = void 0, this._web3 = void 0, this._config = void 0, this._logger = void 0;
  }

  _createClass(st, [{
    key: "ocean",
    get: function get() {
      return this._ocean || R.error("Ocean instance is not defined."), this._ocean;
    }
  }, {
    key: "web3",
    get: function get() {
      return this._web3 || R.error("Web3 instance is not defined."), this._web3;
    }
  }, {
    key: "config",
    get: function get() {
      return this._config || R.error("Config instance is not defined."), this._config;
    }
  }, {
    key: "logger",
    get: function get() {
      return R;
    }
  }, {
    key: "instanceConfig",
    get: function get() {
      var t = this.ocean,
          e = this.web3,
          i = this.config,
          r = this.logger;
      return {
        ocean: t,
        web3: e,
        config: i,
        logger: r
      };
    }
  }, {
    key: "setInstanceConfig",
    value: function setInstanceConfig(t) {
      st.setInstanceConfig(this, t);
    }
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                R.warn("getInstance() methods has needs to be added to child class.");

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getInstance(_x6) {
        return _getInstance.apply(this, arguments);
      }

      return getInstance;
    }()
  }, {
    key: "setInstanceConfig",
    value: function setInstanceConfig(t, _ref3) {
      var e = _ref3.ocean,
          i = _ref3.config,
          r = _ref3.web3,
          n = _ref3.logger;
      t._ocean = e, t._config = i, t._web3 = r, t._logger = n;
    }
  }]);

  return st;
}();

var ot = /*#__PURE__*/function (_st) {
  _inherits(ot, _st);

  var _super = _createSuper(ot);

  function ot() {
    var _this4;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0x0";
    var e = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, ot);

    _this4 = _super.call(this), _this4.id = void 0, _this4.password = void 0, _this4.token = void 0, _this4.id = t, e && _this4.setInstanceConfig(e);
    return _this4;
  }

  _createClass(ot, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "setId",
    value: function setId(t) {
      this.id = t;
    }
  }, {
    key: "setPassword",
    value: function setPassword(t) {
      this.password = t;
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.password;
    }
  }, {
    key: "getTokenBalance",
    value: function () {
      var _getTokenBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
        var i, r, n, _s, _o;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(null === t)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", null);

              case 2:
                i = [{
                  constant: !0,
                  inputs: [{
                    name: "_owner",
                    type: "address"
                  }],
                  name: "balanceOf",
                  outputs: [{
                    name: "balance",
                    type: "uint256"
                  }],
                  payable: !1,
                  stateMutability: "view",
                  type: "function"
                }];
                r = null;
                _context3.next = 6;
                return this.getTokenDecimals(t);

              case 6:
                n = _context3.sent;
                _context3.prev = 7;
                _s = new this.web3.eth.Contract(i, t, {
                  from: this.id
                });
                _context3.next = 11;
                return _s.methods.balanceOf(this.id).call();

              case 11:
                _o = _context3.sent;
                r = new e(_o).div(Math.pow(10, n)).toString();
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](7);
                this.logger.error("ERROR: Failed to get the balance: ".concat(_context3.t0.message));

              case 18:
                return _context3.abrupt("return", r);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 15]]);
      }));

      function getTokenBalance(_x7) {
        return _getTokenBalance.apply(this, arguments);
      }

      return getTokenBalance;
    }()
  }, {
    key: "getTokenDecimals",
    value: function () {
      var _getTokenDecimals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
        var e, i, _r;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = 18;

                if (!(null === t)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", e);

              case 3:
                i = [{
                  constant: !0,
                  inputs: [],
                  name: "decimals",
                  outputs: [{
                    name: "",
                    type: "uint8"
                  }],
                  type: "function"
                }];
                _context4.prev = 4;
                _r = new this.web3.eth.Contract(i, t, {
                  from: this.id
                });
                _context4.next = 8;
                return _r.methods.decimals().call();

              case 8:
                e = _context4.sent;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](4);
                this.logger.error("ERROR: Failed to get decimals : ".concat(_context4.t0.message));

              case 14:
                return _context4.abrupt("return", e);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 11]]);
      }));

      function getTokenDecimals(_x8) {
        return _getTokenDecimals.apply(this, arguments);
      }

      return getTokenDecimals;
    }()
  }, {
    key: "getOceanBalance",
    value: function () {
      var _getOceanBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.getTokenBalance(this.config.oceanTokenAddress));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getOceanBalance() {
        return _getOceanBalance.apply(this, arguments);
      }

      return getOceanBalance;
    }()
  }, {
    key: "getTokenSymbol",
    value: function () {
      var _getTokenSymbol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", "");

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getTokenSymbol(_x9) {
        return _getTokenSymbol.apply(this, arguments);
      }

      return getTokenSymbol;
    }()
  }, {
    key: "getEtherBalance",
    value: function () {
      var _getEtherBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var t;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.web3.eth.getBalance(this.id, "latest");

              case 2:
                t = _context7.sent;
                return _context7.abrupt("return", this.web3.utils.fromWei(t));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getEtherBalance() {
        return _getEtherBalance.apply(this, arguments);
      }

      return getEtherBalance;
    }()
  }]);

  return ot;
}(st);

var at = /*#__PURE__*/function () {
  function at(t) {
    _classCallCheck(this, at);

    this.id = void 0, this.id = t;
  }

  _createClass(at, [{
    key: "getDid",
    value: function getDid() {
      return "did:op:".concat(this.id);
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      var e;
      t instanceof at && (t = t.getDid());
      var i = t.match(/^did:op:([a-f0-9]{40})$/i);
      if (i && (e = new at(i[1])), !e) throw new Error("Parsing DID failed, ".concat(t));
      return e;
    }
  }, {
    key: "generate",
    value: function generate(t) {
      return new at(S(t));
    }
  }]);

  return at;
}();

var ht = /*#__PURE__*/function (_st2) {
  _inherits(ht, _st2);

  var _super2 = _createSuper(ht);

  function ht() {
    _classCallCheck(this, ht);

    return _super2.apply(this, arguments);
  }

  _createClass(ht, [{
    key: "list",
    value: function () {
      var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this5 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.web3.eth.getAccounts();

              case 2:
                t = _context8.sent.map(function (t) {
                  return new ot(t, _this5.instanceConfig);
                });
                return _context8.abrupt("return", Promise.all(t));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function list() {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "getTokenBalance",
    value: function getTokenBalance(t, e) {
      return e.getTokenBalance(t);
    }
  }, {
    key: "getOceanBalance",
    value: function getOceanBalance(t) {
      return t.getOceanBalance();
    }
  }, {
    key: "getEtherBalance",
    value: function getEtherBalance(t) {
      return t.getEtherBalance();
    }
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                e = new ht();
                return _context9.abrupt("return", (e.setInstanceConfig(t), e));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getInstance(_x10) {
        return _getInstance2.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return ht;
}(st);

var ut = /*#__PURE__*/function () {
  function ut() {
    _classCallCheck(this, ut);
  }

  _createClass(ut, null, [{
    key: "getWeb3",
    value: function getWeb3() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new i(t.web3Provider || i.givenProvider || new i.providers.HttpProvider(t.nodeUri));
    }
  }]);

  return ut;
}();

var lt = /*#__PURE__*/function () {
  function lt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, lt);

    this["@context"] = "https://w3id.org/did/v1", this.id = null, this.created = void 0, this.updated = void 0, this.dataToken = void 0, this.publicKey = [], this.authentication = [], this.service = [], this.proof = void 0, this.price = void 0, this.isInPurgatory = void 0, this.purgatoryData = void 0, this.dataTokenInfo = void 0, this.credentials = void 0, this.chainId = void 0, this.event = void 0, Object.assign(this, t, {
      created: t && t.created || new Date().toISOString().replace(/\.[0-9]{3}/, "")
    });
  }

  _createClass(lt, [{
    key: "shortId",
    value: function shortId() {
      return this.id.replace("did:op:", "");
    }
  }, {
    key: "findServiceById",
    value: function findServiceById(t) {
      if (isNaN(t)) throw new Error("index is not set");
      return this.service.find(function (e) {
        return e.index === t;
      });
    }
  }, {
    key: "findServiceByType",
    value: function findServiceByType(t) {
      if (!t) throw new Error("serviceType not set");
      return this.service.find(function (e) {
        return e.type === t;
      });
    }
  }, {
    key: "getChecksum",
    value: function getChecksum() {
      var _this$findServiceByTy = this.findServiceByType("metadata"),
          t = _this$findServiceByTy.attributes,
          _t$main = t.main,
          e = _t$main.files,
          i = _t$main.name,
          r = _t$main.author,
          n = _t$main.license,
          s = [].concat(_toConsumableArray((e || []).map(function (_ref4) {
        var t = _ref4.checksum;
        return t;
      }).filter(function (t) {
        return !!t;
      })), [i, r, n, this.id]);

      return ut.getWeb3().utils.sha3(s.join("")).replace(/^0x([a-f0-9]{64})(:!.+)?$/i, "0x$1");
    }
  }, {
    key: "addProof",
    value: function () {
      var _addProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!this.proof) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("Proof already exists");

              case 2:
                this.proof = {
                  created: new Date().toISOString().replace(/\.[0-9]{3}/, ""),
                  creator: e,
                  type: "AddressHash",
                  signatureValue: ut.getWeb3().utils.sha3(e).replace(/^0x([a-f0-9]{64})(:!.+)?$/i, "0x$1")
                };

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function addProof(_x11, _x12, _x13) {
        return _addProof.apply(this, arguments);
      }

      return addProof;
    }()
  }], [{
    key: "serialize",
    value: function serialize(t) {
      return JSON.stringify(t, null, 2);
    }
  }, {
    key: "deserialize",
    value: function deserialize(t) {
      var e = JSON.parse(t);
      return new lt(e);
    }
  }]);

  return lt;
}();

function ct(t) {
  if (!Number.isInteger(t)) throw new TypeError("Expected an integer, got " + typeof t);
  var e = new WeakMap(),
      i = new s(),
      r = setTimeout(function () {
    i.abort();
  }, t);
  return e.set(i.signal, r), i.signal;
}

var dt = require("cross-fetch");

var ft = /*#__PURE__*/function () {
  function ft(t) {
    _classCallCheck(this, ft);

    this.logger = void 0, this.logger = t;
  }

  _createClass(ft, [{
    key: "post",
    value: function post(t, e) {
      return this.postWithHeaders(t, e, {
        "Content-type": "application/json"
      });
    }
  }, {
    key: "postWithOctet",
    value: function postWithOctet(t, e) {
      return this.postWithHeaders(t, e, {
        "Content-type": "application/octet-stream"
      });
    }
  }, {
    key: "postWithHeaders",
    value: function postWithHeaders(t, e, i) {
      return this.fetch(t, null != e ? {
        method: "POST",
        body: e,
        headers: i,
        signal: ct(5e3)
      } : {
        method: "POST",
        signal: ct(5e3)
      });
    }
  }, {
    key: "get",
    value: function get(t) {
      return this.fetch(t, {
        method: "GET",
        headers: {
          "Content-type": "application/json"
        },
        signal: ct(5e3)
      });
    }
  }, {
    key: "put",
    value: function put(t, e) {
      return this.fetch(t, null != e ? {
        method: "PUT",
        body: e,
        headers: {
          "Content-type": "application/json"
        },
        signal: ct(5e3)
      } : {
        method: "PUT",
        headers: {
          "Content-type": "application/json"
        },
        signal: ct(5e3)
      });
    }
  }, {
    key: "delete",
    value: function _delete(t, e) {
      return this.fetch(t, null != e ? {
        method: "DELETE",
        body: e,
        headers: {
          "Content-type": "application/json"
        },
        signal: ct(5e3)
      } : {
        method: "DELETE",
        headers: {
          "Content-type": "application/json"
        },
        signal: ct(5e3)
      });
    }
  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t, e, i) {
        var s, o;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.get(t);

              case 2:
                s = _context12.sent;

                if (s.ok) {
                  _context12.next = 5;
                  break;
                }

                throw new Error("Response error.");

              case 5:
                try {
                  o = s.headers.get("content-disposition").match(/attachment;filename=(.+)/)[1];
                } catch (e) {
                  try {
                    o = t.split("/").pop();
                  } catch (t) {
                    o = "file".concat(i);
                  }
                }

                if (!e) {
                  _context12.next = 10;
                  break;
                }

                _context12.next = 9;
                return new Promise( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, i) {
                    var n;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            r.mkdirSync(e, {
                              recursive: !0
                            });
                            n = r.createWriteStream("".concat(e).concat(o));
                            s.body.pipe(n), s.body.on("error", i), n.on("finish", t);

                          case 3:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));

                  return function (_x17, _x18) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 9:
                return _context12.abrupt("return", e);

              case 10:
                _context12.t0 = n;
                _context12.next = 13;
                return s.arrayBuffer();

              case 13:
                _context12.t1 = _context12.sent;
                _context12.t2 = o;
                (0, _context12.t0)(_context12.t1, _context12.t2);

              case 16:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function downloadFile(_x14, _x15, _x16) {
        return _downloadFile.apply(this, arguments);
      }

      return downloadFile;
    }()
  }, {
    key: "downloadFileBrowser",
    value: function () {
      var _downloadFileBrowser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                e = document.createElement("a");
                e.download = "", e.href = t, e.click();

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function downloadFileBrowser(_x19) {
        return _downloadFileBrowser.apply(this, arguments);
      }

      return downloadFileBrowser;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return dt(t, e);

              case 2:
                i = _context14.sent;

                if (i.ok) {
                  _context14.next = 13;
                  break;
                }

                this.logger.error("Error requesting [".concat(e.method, "] ").concat(t));
                _context14.t0 = this.logger;
                _context14.t1 = "Response message: \n";
                _context14.next = 9;
                return i.text();

              case 9:
                _context14.t2 = _context14.sent;
                _context14.t3 = _context14.t1.concat.call(_context14.t1, _context14.t2);

                _context14.t0.error.call(_context14.t0, _context14.t3);

                throw i;

              case 13:
                return _context14.abrupt("return", i);

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetch(_x20, _x21) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }]);

  return ft;
}();

var mt = /*#__PURE__*/function (_st3) {
  _inherits(mt, _st3);

  var _super3 = _createSuper(mt);

  function mt() {
    var _this6;

    _classCallCheck(this, mt);

    for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      t[_key7] = arguments[_key7];
    }

    _this6 = _super3.call.apply(_super3, [this].concat(t)), _this6.nonce = void 0, _this6.baseUrl = void 0, _this6.servicesEndpoints = void 0, _this6.computeAddress = void 0, _this6.providerAddress = void 0, _this6.providerVersion = void 0, _this6.computeLimits = void 0;
    return _this6;
  }

  _createClass(mt, [{
    key: "setBaseUrl",
    value: function () {
      var _setBaseUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.baseUrl = t;
                _context15.next = 3;
                return this.getServiceEndpoints();

              case 3:
                this.servicesEndpoints = _context15.sent;
                return _context15.abrupt("return", !0);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setBaseUrl(_x22) {
        return _setBaseUrl.apply(this, arguments);
      }

      return setBaseUrl;
    }()
  }, {
    key: "url",
    get: function get() {
      return this.baseUrl;
    }
  }, {
    key: "getServiceEndpoints",
    value: function () {
      var _getServiceEndpoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var t, _e2, _i;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                t = [];
                _context16.prev = 1;
                _context16.next = 4;
                return this.ocean.utils.fetch.get(this.url);

              case 4:
                _context16.next = 6;
                return _context16.sent.json();

              case 6:
                _e2 = _context16.sent;
                this.providerAddress = _e2.providerAddress, "computeAddress" in _e2 && (this.computeAddress = _e2.computeAddress), "version" in _e2 && (this.providerVersion = _e2.version), "computeLimits" in _e2 && (this.computeLimits = _e2.computeLimits);

                for (_i in _e2.serviceEndpoints) {
                  t.push({
                    serviceName: _i,
                    method: _e2.serviceEndpoints[_i][0],
                    urlPath: this.url + _e2.serviceEndpoints[_i][1]
                  });
                }

                return _context16.abrupt("return", t);

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16["catch"](1);
                return _context16.abrupt("return", (this.logger.error("Finding the service endpoints failed:", _context16.t0), null));

              case 15:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[1, 12]]);
      }));

      function getServiceEndpoints() {
        return _getServiceEndpoints.apply(this, arguments);
      }

      return getServiceEndpoints;
    }()
  }, {
    key: "getEndpointURL",
    value: function getEndpointURL(t) {
      return this.servicesEndpoints ? this.servicesEndpoints.find(function (e) {
        return e.serviceName === t;
      }) : null;
    }
  }, {
    key: "createSignature",
    value: function () {
      var _createSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t, e) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.ocean.utils.signature.signText(S(e), t.getId());

              case 2:
                return _context17.abrupt("return", _context17.sent);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function createSignature(_x23, _x24) {
        return _createSignature.apply(this, arguments);
      }

      return createSignature;
    }()
  }, {
    key: "createHashSignature",
    value: function () {
      var _createHashSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t, e) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.ocean.utils.signature.signWithHash(e, t.getId());

              case 2:
                return _context18.abrupt("return", _context18.sent);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function createHashSignature(_x25, _x26) {
        return _createHashSignature.apply(this, arguments);
      }

      return createHashSignature;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(t, e, i) {
        var r, n, _t2;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getNonce(i.getId());

              case 2:
                r = {
                  documentId: t,
                  document: JSON.stringify(e),
                  publisherAddress: i.getId()
                }, n = this.getEncryptEndpoint() ? this.getEncryptEndpoint().urlPath : null;

                if (n) {
                  _context19.next = 5;
                  break;
                }

                return _context19.abrupt("return", null);

              case 5:
                _context19.prev = 5;
                _context19.next = 8;
                return this.ocean.utils.fetch.post(n, decodeURI(JSON.stringify(r)));

              case 8:
                _t2 = _context19.sent;
                _context19.next = 11;
                return _t2.json();

              case 11:
                return _context19.abrupt("return", _context19.sent.encryptedDocument);

              case 14:
                _context19.prev = 14;
                _context19.t0 = _context19["catch"](5);
                throw this.logger.error(_context19.t0), new Error("HTTP request failed");

              case 17:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[5, 14]]);
      }));

      function encrypt(_x27, _x28, _x29) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "fileinfo",
    value: function () {
      var _fileinfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
        var e, i, r, _t3, _n, _iterator, _step, _t4;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                e = {
                  url: t
                }, i = [], r = this.getFileinfoEndpoint() ? this.getFileinfoEndpoint().urlPath : null;

                if (r) {
                  _context20.next = 3;
                  break;
                }

                return _context20.abrupt("return", null);

              case 3:
                _context20.prev = 3;
                _context20.next = 6;
                return this.ocean.utils.fetch.post(r, JSON.stringify(e));

              case 6:
                _t3 = _context20.sent;
                _context20.next = 9;
                return _t3.json();

              case 9:
                _n = _context20.sent;
                _iterator = _createForOfIteratorHelper(_n);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _t4 = _step.value;
                    i.push(_t4);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context20.abrupt("return", i);

              case 15:
                _context20.prev = 15;
                _context20.t0 = _context20["catch"](3);
                return _context20.abrupt("return", null);

              case 18:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[3, 15]]);
      }));

      function fileinfo(_x30) {
        return _fileinfo.apply(this, arguments);
      }

      return fileinfo;
    }()
  }, {
    key: "isFileConsumable",
    value: function () {
      var _isFileConsumable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(t, e) {
        var i, r, n, s, _t5;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                i = {
                  did: t.getDid()
                };
                _context21.next = 3;
                return this.ocean.metadataCache.retrieveDDO(t);

              case 3:
                r = _context21.sent;

                if (r) {
                  _context21.next = 6;
                  break;
                }

                return _context21.abrupt("return", !1);

              case 6:
                n = r.findServiceById(e);

                if (n) {
                  _context21.next = 9;
                  break;
                }

                return _context21.abrupt("return", !1);

              case 9:
                s = n.serviceEndpoint + "/api/v1/services/fileinfo";
                _context21.prev = 10;
                _context21.next = 13;
                return this.ocean.utils.fetch.post(s, JSON.stringify(i));

              case 13:
                _t5 = _context21.sent;
                _context21.next = 16;
                return _t5.json();

              case 16:
                return _context21.abrupt("return", _context21.sent[0].valid);

              case 19:
                _context21.prev = 19;
                _context21.t0 = _context21["catch"](10);
                return _context21.abrupt("return", !1);

              case 22:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[10, 19]]);
      }));

      function isFileConsumable(_x31, _x32) {
        return _isFileConsumable.apply(this, arguments);
      }

      return isFileConsumable;
    }()
  }, {
    key: "getNonce",
    value: function () {
      var _getNonce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t) {
        var e, _i2;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                e = this.getNonceEndpoint() ? this.getNonceEndpoint().urlPath : null;

                if (e) {
                  _context22.next = 3;
                  break;
                }

                return _context22.abrupt("return", null);

              case 3:
                _context22.prev = 3;
                _context22.next = 6;
                return this.ocean.utils.fetch.get(e + "?userAddress=".concat(t));

              case 6:
                _i2 = _context22.sent;
                _context22.t0 = String;
                _context22.next = 10;
                return _i2.json();

              case 10:
                _context22.t1 = _context22.sent.nonce;
                this.nonce = (0, _context22.t0)(_context22.t1);
                return _context22.abrupt("return", this.nonce);

              case 15:
                _context22.prev = 15;
                _context22.t2 = _context22["catch"](3);
                throw this.logger.error(_context22.t2), new Error("HTTP request failed");

              case 18:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[3, 15]]);
      }));

      function getNonce(_x33) {
        return _getNonce.apply(this, arguments);
      }

      return getNonce;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t, e, i, r, n) {
        var _yield$et, s, o, a, _t6;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return et(t, this.ocean);

              case 2:
                _yield$et = _context23.sent;
                s = _yield$et.did;
                o = _yield$et.ddo;
                a = this.getInitializeEndpoint() ? this.getInitializeEndpoint().urlPath : null;

                if (a) {
                  _context23.next = 8;
                  break;
                }

                return _context23.abrupt("return", null);

              case 8:
                a += "?documentId=".concat(s), a += "&serviceId=".concat(e), a += "&serviceType=".concat(i), a += "&dataToken=".concat(o.dataToken), a += "&consumerAddress=".concat(r), n && (a += "&userdata=" + encodeURI(JSON.stringify(n)));
                _context23.prev = 9;
                _context23.next = 12;
                return this.ocean.utils.fetch.get(a);

              case 12:
                _t6 = _context23.sent;
                _context23.next = 15;
                return _t6.text();

              case 15:
                return _context23.abrupt("return", _context23.sent);

              case 18:
                _context23.prev = 18;
                _context23.t0 = _context23["catch"](9);
                throw this.logger.error(_context23.t0), new Error("Asset URL not found or not available.");

              case 21:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[9, 18]]);
      }));

      function initialize(_x34, _x35, _x36, _x37, _x38) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "download",
    value: function () {
      var _download = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t, e, i, r, n, s, o, a) {
        var _this7 = this;

        var h,
            u,
            l,
            c,
            d,
            _args25 = arguments;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                h = _args25.length > 8 && _args25[8] !== undefined ? _args25[8] : -1;
                u = _args25.length > 9 ? _args25[9] : undefined;
                _context25.next = 4;
                return this.getNonce(o.getId());

              case 4:
                _context25.next = 6;
                return this.createSignature(o, t + this.nonce);

              case 6:
                l = _context25.sent;
                c = this.getDownloadEndpoint() ? this.getDownloadEndpoint().urlPath : null;

                if (c) {
                  _context25.next = 10;
                  break;
                }

                return _context25.abrupt("return", null);

              case 10:
                d = a.filter(function (t, e) {
                  return -1 === h || e === h;
                }).map( /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref6) {
                    var a, h;
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            a = _ref6.index;
                            h = c;
                            h += "?fileIndex=".concat(a), h += "&documentId=".concat(t), h += "&serviceId=".concat(n), h += "&serviceType=".concat(r), h += "&dataToken=".concat(i), h += "&transferTxId=".concat(e), h += "&consumerAddress=".concat(o.getId()), h += "&signature=".concat(l), u && (h += "&userdata=" + encodeURI(JSON.stringify(u)));
                            _context24.prev = 3;

                            if (!s) {
                              _context24.next = 9;
                              break;
                            }

                            _context24.next = 7;
                            return _this7.ocean.utils.fetch.downloadFile(h, s, a);

                          case 7:
                            _context24.next = 11;
                            break;

                          case 9:
                            _context24.next = 11;
                            return _this7.ocean.utils.fetch.downloadFileBrowser(h);

                          case 11:
                            _context24.next = 16;
                            break;

                          case 13:
                            _context24.prev = 13;
                            _context24.t0 = _context24["catch"](3);
                            throw _this7.logger.error("Error consuming assets"), _this7.logger.error(_context24.t0), _context24.t0;

                          case 16:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24, null, [[3, 13]]);
                  }));

                  return function (_x47) {
                    return _ref7.apply(this, arguments);
                  };
                }());
                _context25.next = 13;
                return Promise.all(d);

              case 13:
                return _context25.abrupt("return", s);

              case 14:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function download(_x39, _x40, _x41, _x42, _x43, _x44, _x45, _x46) {
        return _download.apply(this, arguments);
      }

      return download;
    }()
  }, {
    key: "computeStart",
    value: function () {
      var _computeStart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t, e, i, r, n, s, o, a, h, u) {
        var l, c, d, f, m, _t7;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                l = e.getId();
                _context26.next = 3;
                return this.getNonce(e.getId());

              case 3:
                c = Object();
                c.documentId = S(t);
                d = l;
                d += t && "".concat(S(t)) || "", d += this.nonce;
                _context26.next = 9;
                return this.createHashSignature(e, d);

              case 9:
                f = _context26.sent;
                c.signature = f, r && (c.output = r), i.did && (c.algorithmDid = i.did), i.meta && (c.algorithmMeta = i.meta), c.consumerAddress = l, n && (c.transferTxId = n), i.transferTxId && (c.algorithmTransferTxId = i.transferTxId), i.dataToken && (c.algorithmDataToken = i.dataToken), s && (c.serviceId = s), o && (c.serviceType = o), a && (c.dataToken = a), h && (c.additionalInputs = h), u && (c.userData = u), i.algoCustomParameters && (c.algouserdata = i.algoCustomParameters);
                m = this.getComputeStartEndpoint() ? this.getComputeStartEndpoint().urlPath : null;

                if (m) {
                  _context26.next = 14;
                  break;
                }

                return _context26.abrupt("return", null);

              case 14:
                _context26.prev = 14;
                _context26.next = 17;
                return this.ocean.utils.fetch.post(m, JSON.stringify(c));

              case 17:
                _t7 = _context26.sent;

                if (!(null != _t7 && _t7.ok)) {
                  _context26.next = 24;
                  break;
                }

                _context26.next = 21;
                return _t7.json();

              case 21:
                _context26.t0 = _context26.sent;
                _context26.next = 25;
                break;

              case 24:
                _context26.t0 = (console.error("Compute start failed:", _t7.status, _t7.statusText), this.logger.error("Payload was:", c), null);

              case 25:
                return _context26.abrupt("return", _context26.t0);

              case 28:
                _context26.prev = 28;
                _context26.t1 = _context26["catch"](14);
                return _context26.abrupt("return", (this.logger.error("Compute start failed:"), this.logger.error(_context26.t1), this.logger.error("Payload was:", c), null));

              case 31:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[14, 28]]);
      }));

      function computeStart(_x48, _x49, _x50, _x51, _x52, _x53, _x54, _x55, _x56, _x57) {
        return _computeStart.apply(this, arguments);
      }

      return computeStart;
    }()
  }, {
    key: "computeStop",
    value: function () {
      var _computeStop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t, e, i) {
        var r, n, s, o, a, _t8;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                r = e.getId();
                _context27.next = 3;
                return this.getNonce(e.getId());

              case 3:
                n = Object();
                n.documentId = S(t);
                s = r;
                s += i || "", s += t && "".concat(S(t)) || "", s += this.nonce;
                _context27.next = 9;
                return this.createHashSignature(e, s);

              case 9:
                o = _context27.sent;
                n.signature = o, n.jobId = i, n.consumerAddress = r;
                a = this.getComputeStopEndpoint() ? this.getComputeStopEndpoint().urlPath : null;

                if (a) {
                  _context27.next = 14;
                  break;
                }

                return _context27.abrupt("return", null);

              case 14:
                _context27.prev = 14;
                _context27.next = 17;
                return this.ocean.utils.fetch.put(a, JSON.stringify(n));

              case 17:
                _t8 = _context27.sent;

                if (!(null != _t8 && _t8.ok)) {
                  _context27.next = 24;
                  break;
                }

                _context27.next = 21;
                return _t8.json();

              case 21:
                _context27.t0 = _context27.sent;
                _context27.next = 25;
                break;

              case 24:
                _context27.t0 = (this.logger.error("Compute stop failed:", _t8.status, _t8.statusText), this.logger.error("Payload was:", n), null);

              case 25:
                return _context27.abrupt("return", _context27.t0);

              case 28:
                _context27.prev = 28;
                _context27.t1 = _context27["catch"](14);
                return _context27.abrupt("return", (this.logger.error("Compute stop failed:"), this.logger.error(_context27.t1), this.logger.error("Payload was:", n), null));

              case 31:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[14, 28]]);
      }));

      function computeStop(_x58, _x59, _x60) {
        return _computeStop.apply(this, arguments);
      }

      return computeStop;
    }()
  }, {
    key: "computeDelete",
    value: function () {
      var _computeDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t, e, i) {
        var r, n, s, o, a, _t9;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                r = e.getId();
                _context28.next = 3;
                return this.getNonce(e.getId());

              case 3:
                n = Object();
                n.documentId = S(t);
                s = r;
                s += i || "", s += t && "".concat(S(t)) || "", s += this.nonce;
                _context28.next = 9;
                return this.createHashSignature(e, s);

              case 9:
                o = _context28.sent;
                n.signature = o, n.jobId = i, n.consumerAddress = r;
                a = this.getComputeDeleteEndpoint() ? this.getComputeDeleteEndpoint().urlPath : null;

                if (a) {
                  _context28.next = 14;
                  break;
                }

                return _context28.abrupt("return", null);

              case 14:
                _context28.prev = 14;
                _context28.next = 17;
                return this.ocean.utils.fetch.delete(a, JSON.stringify(n));

              case 17:
                _t9 = _context28.sent;

                if (!(null != _t9 && _t9.ok)) {
                  _context28.next = 24;
                  break;
                }

                _context28.next = 21;
                return _t9.json();

              case 21:
                _context28.t0 = _context28.sent;
                _context28.next = 25;
                break;

              case 24:
                _context28.t0 = (this.logger.error("Delete compute job failed:", _t9.status, _t9.statusText), this.logger.error("Payload was:", n), null);

              case 25:
                return _context28.abrupt("return", _context28.t0);

              case 28:
                _context28.prev = 28;
                _context28.t1 = _context28["catch"](14);
                return _context28.abrupt("return", (this.logger.error("Delete compute job failed:"), this.logger.error(_context28.t1), this.logger.error("Payload was:", n), null));

              case 31:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this, [[14, 28]]);
      }));

      function computeDelete(_x61, _x62, _x63) {
        return _computeDelete.apply(this, arguments);
      }

      return computeDelete;
    }()
  }, {
    key: "computeStatus",
    value: function () {
      var _computeStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t, e, i, r) {
        var n, s, o, _t10;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                n = e.getId();
                _context29.next = 3;
                return this.getNonce(e.getId());

              case 3:
                s = "?documentId=" + S(t);
                s += i && "&jobId=".concat(i) || "", s += "&consumerAddress=".concat(n), s += r && "&transferTxId=".concat(r) || "";
                o = this.getComputeStatusEndpoint() ? this.getComputeStatusEndpoint().urlPath : null;

                if (o) {
                  _context29.next = 8;
                  break;
                }

                return _context29.abrupt("return", null);

              case 8:
                _context29.prev = 8;
                _context29.next = 11;
                return this.ocean.utils.fetch.get(o + s);

              case 11:
                _t10 = _context29.sent;

                if (!(null != _t10 && _t10.ok)) {
                  _context29.next = 18;
                  break;
                }

                _context29.next = 15;
                return _t10.json();

              case 15:
                _context29.t0 = _context29.sent;
                _context29.next = 19;
                break;

              case 18:
                _context29.t0 = (this.logger.error("Get compute status failed:", _t10.status, _t10.statusText), null);

              case 19:
                return _context29.abrupt("return", _context29.t0);

              case 22:
                _context29.prev = 22;
                _context29.t1 = _context29["catch"](8);
                return _context29.abrupt("return", (this.logger.error("Get compute status failed"), this.logger.error(_context29.t1), null));

              case 25:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this, [[8, 22]]);
      }));

      function computeStatus(_x64, _x65, _x66, _x67) {
        return _computeStatus.apply(this, arguments);
      }

      return computeStatus;
    }()
  }, {
    key: "computeResult",
    value: function () {
      var _computeResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t, e, i, r) {
        var n, s, o, a;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.getNonce(r.getId());

              case 2:
                n = r.getId();
                n += t, n += String(e), n += this.nonce;
                _context30.next = 6;
                return this.createHashSignature(r, n);

              case 6:
                s = _context30.sent;
                o = this.getComputeResultEndpoint() ? this.getComputeResultEndpoint().urlPath : null;

                if (o) {
                  _context30.next = 10;
                  break;
                }

                return _context30.abrupt("return", null);

              case 10:
                a = o;
                a += "?jobId=".concat(t), a += "&index=".concat(String(e)), a += "&signature=".concat(s), a += "&consumerAddress=".concat(r.getId());
                _context30.prev = 12;

                if (!i) {
                  _context30.next = 18;
                  break;
                }

                _context30.next = 16;
                return this.ocean.utils.fetch.downloadFile(a, i, e);

              case 16:
                _context30.next = 20;
                break;

              case 18:
                _context30.next = 20;
                return this.ocean.utils.fetch.downloadFileBrowser(a);

              case 20:
                _context30.next = 25;
                break;

              case 22:
                _context30.prev = 22;
                _context30.t0 = _context30["catch"](12);
                throw this.logger.error("Error getting job result"), this.logger.error(_context30.t0), _context30.t0;

              case 25:
                return _context30.abrupt("return", i);

              case 26:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this, [[12, 22]]);
      }));

      function computeResult(_x68, _x69, _x70, _x71) {
        return _computeResult.apply(this, arguments);
      }

      return computeResult;
    }()
  }, {
    key: "getInitializeEndpoint",
    value: function getInitializeEndpoint() {
      return this.getEndpointURL("initialize");
    }
  }, {
    key: "getNonceEndpoint",
    value: function getNonceEndpoint() {
      return this.getEndpointURL("nonce");
    }
  }, {
    key: "getEncryptEndpoint",
    value: function getEncryptEndpoint() {
      return this.getEndpointURL("encrypt");
    }
  }, {
    key: "getFileinfoEndpoint",
    value: function getFileinfoEndpoint() {
      return this.getEndpointURL("fileinfo");
    }
  }, {
    key: "getComputeStartEndpoint",
    value: function getComputeStartEndpoint() {
      return this.getEndpointURL("computeStart");
    }
  }, {
    key: "getComputeStopEndpoint",
    value: function getComputeStopEndpoint() {
      return this.getEndpointURL("computeStop");
    }
  }, {
    key: "getComputeStatusEndpoint",
    value: function getComputeStatusEndpoint() {
      return this.getEndpointURL("computeStatus");
    }
  }, {
    key: "getComputeDeleteEndpoint",
    value: function getComputeDeleteEndpoint() {
      return this.getEndpointURL("computeDelete");
    }
  }, {
    key: "getComputeResultEndpoint",
    value: function getComputeResultEndpoint() {
      return this.getEndpointURL("computeResult");
    }
  }, {
    key: "getDownloadEndpoint",
    value: function getDownloadEndpoint() {
      return this.getEndpointURL("download");
    }
  }, {
    key: "isValidProvider",
    value: function () {
      var _isValidProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(t) {
        var _e3, _t11;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                _context31.next = 3;
                return this.ocean.utils.fetch.get(t);

              case 3:
                _e3 = _context31.sent;

                if (!(null != _e3 && _e3.ok)) {
                  _context31.next = 10;
                  break;
                }

                _context31.next = 7;
                return _e3.json();

              case 7:
                _t11 = _context31.sent;

                if (!(_t11 && _t11.providerAddress)) {
                  _context31.next = 10;
                  break;
                }

                return _context31.abrupt("return", !0);

              case 10:
                return _context31.abrupt("return", !1);

              case 13:
                _context31.prev = 13;
                _context31.t0 = _context31["catch"](0);
                return _context31.abrupt("return", (this.logger.error("Error validating provider: ".concat(_context31.t0.message)), !1));

              case 16:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 13]]);
      }));

      function isValidProvider(_x72) {
        return _isValidProvider.apply(this, arguments);
      }

      return isValidProvider;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                e = new mt();
                e.setInstanceConfig(t);
                e.nonce = "0";
                _context32.next = 5;
                return e.setBaseUrl(t.config.providerUri);

              case 5:
                return _context32.abrupt("return", e);

              case 6:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function getInstance(_x73) {
        return _getInstance3.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return mt;
}(st);

var gt = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function pt(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}

function wt(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}

var vt = pt(function (t) {
  !function (t, e) {
    function i(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    function r(t, e) {
      t.super_ = e;

      var i = function i() {};

      i.prototype = e.prototype, t.prototype = new i(), t.prototype.constructor = t;
    }

    function n(t, e, i) {
      if (n.isBN(t)) return t;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (i = e, e = 10), this._init(t || 0, e || 10, i || "be"));
    }

    var s;
    "object" == typeof t ? t.exports = n : e.BN = n, n.BN = n, n.wordSize = 26;

    try {
      s = wt("buffer").Buffer;
    } catch (t) {}

    function o(t, e, i) {
      for (var r = 0, n = Math.min(t.length, i), s = e; s < n; s++) {
        var o = t.charCodeAt(s) - 48;
        r <<= 4, r |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
      }

      return r;
    }

    function a(t, e, i, r) {
      for (var n = 0, s = Math.min(t.length, i), o = e; o < s; o++) {
        var a = t.charCodeAt(o) - 48;
        n *= r, n += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
      }

      return n;
    }

    n.isBN = function (t) {
      return t instanceof n || null !== t && "object" == typeof t && t.constructor.wordSize === n.wordSize && Array.isArray(t.words);
    }, n.max = function (t, e) {
      return t.cmp(e) > 0 ? t : e;
    }, n.min = function (t, e) {
      return t.cmp(e) < 0 ? t : e;
    }, n.prototype._init = function (t, e, r) {
      if ("number" == typeof t) return this._initNumber(t, e, r);
      if ("object" == typeof t) return this._initArray(t, e, r);
      "hex" === e && (e = 16), i(e === (0 | e) && e >= 2 && e <= 36);
      var n = 0;
      "-" === (t = t.toString().replace(/\s+/g, ""))[0] && n++, 16 === e ? this._parseHex(t, n) : this._parseBase(t, e, n), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initNumber = function (t, e, r) {
      t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (i(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initArray = function (t, e, r) {
      if (i("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

      for (var n = 0; n < this.length; n++) {
        this.words[n] = 0;
      }

      var s,
          o,
          a = 0;
      if ("be" === r) for (n = t.length - 1, s = 0; n >= 0; n -= 3) {
        this.words[s] |= (o = t[n] | t[n - 1] << 8 | t[n - 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      } else if ("le" === r) for (n = 0, s = 0; n < t.length; n += 3) {
        this.words[s] |= (o = t[n] | t[n + 1] << 8 | t[n + 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      }
      return this.strip();
    }, n.prototype._parseHex = function (t, e) {
      this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }

      var r,
          n,
          s = 0;

      for (i = t.length - 6, r = 0; i >= e; i -= 6) {
        n = o(t, i, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, (s += 24) >= 26 && (s -= 26, r++);
      }

      i + 6 !== e && (n = o(t, e, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
    }, n.prototype._parseBase = function (t, e, i) {
      this.words = [0], this.length = 1;

      for (var r = 0, n = 1; n <= 67108863; n *= e) {
        r++;
      }

      r--, n = n / e | 0;

      for (var s = t.length - i, o = s % r, h = Math.min(s, s - o) + i, u = 0, l = i; l < h; l += r) {
        u = a(t, l, l + r, e), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }

      if (0 !== o) {
        var c = 1;

        for (u = a(t, l, t.length, e), l = 0; l < o; l++) {
          c *= e;
        }

        this.imuln(c), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }
    }, n.prototype.copy = function (t) {
      t.words = new Array(this.length);

      for (var e = 0; e < this.length; e++) {
        t.words[e] = this.words[e];
      }

      t.length = this.length, t.negative = this.negative, t.red = this.red;
    }, n.prototype.clone = function () {
      var t = new n(null);
      return this.copy(t), t;
    }, n.prototype._expand = function (t) {
      for (; this.length < t;) {
        this.words[this.length++] = 0;
      }

      return this;
    }, n.prototype.strip = function () {
      for (; this.length > 1 && 0 === this.words[this.length - 1];) {
        this.length--;
      }

      return this._normSign();
    }, n.prototype._normSign = function () {
      return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
    }, n.prototype.inspect = function () {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var h = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        l = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

    function c(t, e, i) {
      i.negative = e.negative ^ t.negative;
      var r = t.length + e.length | 0;
      i.length = r, r = r - 1 | 0;
      var n = 0 | t.words[0],
          s = 0 | e.words[0],
          o = n * s,
          a = o / 67108864 | 0;
      i.words[0] = 67108863 & o;

      for (var h = 1; h < r; h++) {
        for (var u = a >>> 26, l = 67108863 & a, c = Math.min(h, e.length - 1), d = Math.max(0, h - t.length + 1); d <= c; d++) {
          u += (o = (n = 0 | t.words[h - d | 0]) * (s = 0 | e.words[d]) + l) / 67108864 | 0, l = 67108863 & o;
        }

        i.words[h] = 0 | l, a = 0 | u;
      }

      return 0 !== a ? i.words[h] = 0 | a : i.length--, i.strip();
    }

    n.prototype.toString = function (t, e) {
      var r;

      if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
        r = "";

        for (var n = 0, s = 0, o = 0; o < this.length; o++) {
          var a = this.words[o],
              c = (16777215 & (a << n | s)).toString(16);
          r = 0 != (s = a >>> 24 - n & 16777215) || o !== this.length - 1 ? h[6 - c.length] + c + r : c + r, (n += 2) >= 26 && (n -= 26, o--);
        }

        for (0 !== s && (r = s.toString(16) + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      if (t === (0 | t) && t >= 2 && t <= 36) {
        var d = u[t],
            f = l[t];
        r = "";
        var m = this.clone();

        for (m.negative = 0; !m.isZero();) {
          var g = m.modn(f).toString(t);
          r = (m = m.idivn(f)).isZero() ? g + r : h[d - g.length] + g + r;
        }

        for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function () {
      var t = this.words[0];
      return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
    }, n.prototype.toJSON = function () {
      return this.toString(16);
    }, n.prototype.toBuffer = function (t, e) {
      return i(void 0 !== s), this.toArrayLike(s, t, e);
    }, n.prototype.toArray = function (t, e) {
      return this.toArrayLike(Array, t, e);
    }, n.prototype.toArrayLike = function (t, e, r) {
      var n = this.byteLength(),
          s = r || Math.max(1, n);
      i(n <= s, "byte array longer than desired length"), i(s > 0, "Requested array length <= 0"), this.strip();
      var o,
          a,
          h = "le" === e,
          u = new t(s),
          l = this.clone();

      if (h) {
        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[a] = o;
        }

        for (; a < s; a++) {
          u[a] = 0;
        }
      } else {
        for (a = 0; a < s - n; a++) {
          u[a] = 0;
        }

        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[s - a - 1] = o;
        }
      }

      return u;
    }, n.prototype._countBits = Math.clz32 ? function (t) {
      return 32 - Math.clz32(t);
    } : function (t) {
      var e = t,
          i = 0;
      return e >= 4096 && (i += 13, e >>>= 13), e >= 64 && (i += 7, e >>>= 7), e >= 8 && (i += 4, e >>>= 4), e >= 2 && (i += 2, e >>>= 2), i + e;
    }, n.prototype._zeroBits = function (t) {
      if (0 === t) return 26;
      var e = t,
          i = 0;
      return 0 == (8191 & e) && (i += 13, e >>>= 13), 0 == (127 & e) && (i += 7, e >>>= 7), 0 == (15 & e) && (i += 4, e >>>= 4), 0 == (3 & e) && (i += 2, e >>>= 2), 0 == (1 & e) && i++, i;
    }, n.prototype.bitLength = function () {
      var t = this._countBits(this.words[this.length - 1]);

      return 26 * (this.length - 1) + t;
    }, n.prototype.zeroBits = function () {
      if (this.isZero()) return 0;

      for (var t = 0, e = 0; e < this.length; e++) {
        var i = this._zeroBits(this.words[e]);

        if (t += i, 26 !== i) break;
      }

      return t;
    }, n.prototype.byteLength = function () {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function (t) {
      return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function (t) {
      return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function () {
      return 0 !== this.negative;
    }, n.prototype.neg = function () {
      return this.clone().ineg();
    }, n.prototype.ineg = function () {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function (t) {
      for (; this.length < t.length;) {
        this.words[this.length++] = 0;
      }

      for (var e = 0; e < t.length; e++) {
        this.words[e] = this.words[e] | t.words[e];
      }

      return this.strip();
    }, n.prototype.ior = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuor(t);
    }, n.prototype.or = function (t) {
      return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
    }, n.prototype.uor = function (t) {
      return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
    }, n.prototype.iuand = function (t) {
      var e;
      e = this.length > t.length ? t : this;

      for (var i = 0; i < e.length; i++) {
        this.words[i] = this.words[i] & t.words[i];
      }

      return this.length = e.length, this.strip();
    }, n.prototype.iand = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuand(t);
    }, n.prototype.and = function (t) {
      return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
    }, n.prototype.uand = function (t) {
      return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
    }, n.prototype.iuxor = function (t) {
      var e, i;
      this.length > t.length ? (e = this, i = t) : (e = t, i = this);

      for (var r = 0; r < i.length; r++) {
        this.words[r] = e.words[r] ^ i.words[r];
      }

      if (this !== e) for (; r < e.length; r++) {
        this.words[r] = e.words[r];
      }
      return this.length = e.length, this.strip();
    }, n.prototype.ixor = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuxor(t);
    }, n.prototype.xor = function (t) {
      return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
    }, n.prototype.uxor = function (t) {
      return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
    }, n.prototype.inotn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = 0 | Math.ceil(t / 26),
          r = t % 26;
      this._expand(e), r > 0 && e--;

      for (var n = 0; n < e; n++) {
        this.words[n] = 67108863 & ~this.words[n];
      }

      return r > 0 && (this.words[n] = ~this.words[n] & 67108863 >> 26 - r), this.strip();
    }, n.prototype.notn = function (t) {
      return this.clone().inotn(t);
    }, n.prototype.setn = function (t, e) {
      i("number" == typeof t && t >= 0);
      var r = t / 26 | 0,
          n = t % 26;
      return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << n : this.words[r] & ~(1 << n), this.strip();
    }, n.prototype.iadd = function (t) {
      var e, i, r;
      if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
      if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
      this.length > t.length ? (i = this, r = t) : (i = t, r = this);

      for (var n = 0, s = 0; s < r.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + (0 | r.words[s]) + n), n = e >>> 26;
      }

      for (; 0 !== n && s < i.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + n), n = e >>> 26;
      }

      if (this.length = i.length, 0 !== n) this.words[this.length] = n, this.length++;else if (i !== this) for (; s < i.length; s++) {
        this.words[s] = i.words[s];
      }
      return this;
    }, n.prototype.add = function (t) {
      var e;
      return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
    }, n.prototype.isub = function (t) {
      if (0 !== t.negative) {
        t.negative = 0;
        var e = this.iadd(t);
        return t.negative = 1, e._normSign();
      }

      if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
      var i,
          r,
          n = this.cmp(t);
      if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      n > 0 ? (i = this, r = t) : (i = t, r = this);

      for (var s = 0, o = 0; o < r.length; o++) {
        s = (e = (0 | i.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      for (; 0 !== s && o < i.length; o++) {
        s = (e = (0 | i.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      if (0 === s && o < i.length && i !== this) for (; o < i.length; o++) {
        this.words[o] = i.words[o];
      }
      return this.length = Math.max(this.length, o), i !== this && (this.negative = 1), this.strip();
    }, n.prototype.sub = function (t) {
      return this.clone().isub(t);
    };

    var d = function d(t, e, i) {
      var r,
          n,
          s,
          o = t.words,
          a = e.words,
          h = i.words,
          u = 0,
          l = 0 | o[0],
          c = 8191 & l,
          d = l >>> 13,
          f = 0 | o[1],
          m = 8191 & f,
          g = f >>> 13,
          p = 0 | o[2],
          w = 8191 & p,
          v = p >>> 13,
          y = 0 | o[3],
          M = 8191 & y,
          b = y >>> 13,
          A = 0 | o[4],
          x = 8191 & A,
          E = A >>> 13,
          R = 0 | o[5],
          k = 8191 & R,
          S = R >>> 13,
          I = 0 | o[6],
          T = 8191 & I,
          O = I >>> 13,
          B = 0 | o[7],
          C = 8191 & B,
          _ = B >>> 13,
          D = 0 | o[8],
          P = 8191 & D,
          N = D >>> 13,
          L = 0 | o[9],
          W = 8191 & L,
          F = L >>> 13,
          U = 0 | a[0],
          $ = 8191 & U,
          j = U >>> 13,
          q = 0 | a[1],
          G = 8191 & q,
          z = q >>> 13,
          H = 0 | a[2],
          Z = 8191 & H,
          V = H >>> 13,
          J = 0 | a[3],
          K = 8191 & J,
          X = J >>> 13,
          Q = 0 | a[4],
          Y = 8191 & Q,
          tt = Q >>> 13,
          et = 0 | a[5],
          it = 8191 & et,
          rt = et >>> 13,
          nt = 0 | a[6],
          st = 8191 & nt,
          ot = nt >>> 13,
          at = 0 | a[7],
          ht = 8191 & at,
          ut = at >>> 13,
          lt = 0 | a[8],
          ct = 8191 & lt,
          dt = lt >>> 13,
          ft = 0 | a[9],
          mt = 8191 & ft,
          gt = ft >>> 13;

      i.negative = t.negative ^ e.negative, i.length = 19;
      var pt = (u + (r = Math.imul(c, $)) | 0) + ((8191 & (n = (n = Math.imul(c, j)) + Math.imul(d, $) | 0)) << 13) | 0;
      u = ((s = Math.imul(d, j)) + (n >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, r = Math.imul(m, $), n = (n = Math.imul(m, j)) + Math.imul(g, $) | 0, s = Math.imul(g, j);
      var wt = (u + (r = r + Math.imul(c, G) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, z) | 0) + Math.imul(d, G) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, z) | 0) + (n >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, r = Math.imul(w, $), n = (n = Math.imul(w, j)) + Math.imul(v, $) | 0, s = Math.imul(v, j), r = r + Math.imul(m, G) | 0, n = (n = n + Math.imul(m, z) | 0) + Math.imul(g, G) | 0, s = s + Math.imul(g, z) | 0;
      var vt = (u + (r = r + Math.imul(c, Z) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, V) | 0) + Math.imul(d, Z) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, V) | 0) + (n >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, r = Math.imul(M, $), n = (n = Math.imul(M, j)) + Math.imul(b, $) | 0, s = Math.imul(b, j), r = r + Math.imul(w, G) | 0, n = (n = n + Math.imul(w, z) | 0) + Math.imul(v, G) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(m, Z) | 0, n = (n = n + Math.imul(m, V) | 0) + Math.imul(g, Z) | 0, s = s + Math.imul(g, V) | 0;
      var yt = (u + (r = r + Math.imul(c, K) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, X) | 0) + Math.imul(d, K) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, X) | 0) + (n >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, r = Math.imul(x, $), n = (n = Math.imul(x, j)) + Math.imul(E, $) | 0, s = Math.imul(E, j), r = r + Math.imul(M, G) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(b, G) | 0, s = s + Math.imul(b, z) | 0, r = r + Math.imul(w, Z) | 0, n = (n = n + Math.imul(w, V) | 0) + Math.imul(v, Z) | 0, s = s + Math.imul(v, V) | 0, r = r + Math.imul(m, K) | 0, n = (n = n + Math.imul(m, X) | 0) + Math.imul(g, K) | 0, s = s + Math.imul(g, X) | 0;
      var Mt = (u + (r = r + Math.imul(c, Y) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, tt) | 0) + Math.imul(d, Y) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, tt) | 0) + (n >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, r = Math.imul(k, $), n = (n = Math.imul(k, j)) + Math.imul(S, $) | 0, s = Math.imul(S, j), r = r + Math.imul(x, G) | 0, n = (n = n + Math.imul(x, z) | 0) + Math.imul(E, G) | 0, s = s + Math.imul(E, z) | 0, r = r + Math.imul(M, Z) | 0, n = (n = n + Math.imul(M, V) | 0) + Math.imul(b, Z) | 0, s = s + Math.imul(b, V) | 0, r = r + Math.imul(w, K) | 0, n = (n = n + Math.imul(w, X) | 0) + Math.imul(v, K) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(m, Y) | 0, n = (n = n + Math.imul(m, tt) | 0) + Math.imul(g, Y) | 0, s = s + Math.imul(g, tt) | 0;
      var bt = (u + (r = r + Math.imul(c, it) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, rt) | 0) + Math.imul(d, it) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, rt) | 0) + (n >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, r = Math.imul(T, $), n = (n = Math.imul(T, j)) + Math.imul(O, $) | 0, s = Math.imul(O, j), r = r + Math.imul(k, G) | 0, n = (n = n + Math.imul(k, z) | 0) + Math.imul(S, G) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(x, Z) | 0, n = (n = n + Math.imul(x, V) | 0) + Math.imul(E, Z) | 0, s = s + Math.imul(E, V) | 0, r = r + Math.imul(M, K) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(b, K) | 0, s = s + Math.imul(b, X) | 0, r = r + Math.imul(w, Y) | 0, n = (n = n + Math.imul(w, tt) | 0) + Math.imul(v, Y) | 0, s = s + Math.imul(v, tt) | 0, r = r + Math.imul(m, it) | 0, n = (n = n + Math.imul(m, rt) | 0) + Math.imul(g, it) | 0, s = s + Math.imul(g, rt) | 0;
      var At = (u + (r = r + Math.imul(c, st) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ot) | 0) + Math.imul(d, st) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ot) | 0) + (n >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, r = Math.imul(C, $), n = (n = Math.imul(C, j)) + Math.imul(_, $) | 0, s = Math.imul(_, j), r = r + Math.imul(T, G) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(O, G) | 0, s = s + Math.imul(O, z) | 0, r = r + Math.imul(k, Z) | 0, n = (n = n + Math.imul(k, V) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, V) | 0, r = r + Math.imul(x, K) | 0, n = (n = n + Math.imul(x, X) | 0) + Math.imul(E, K) | 0, s = s + Math.imul(E, X) | 0, r = r + Math.imul(M, Y) | 0, n = (n = n + Math.imul(M, tt) | 0) + Math.imul(b, Y) | 0, s = s + Math.imul(b, tt) | 0, r = r + Math.imul(w, it) | 0, n = (n = n + Math.imul(w, rt) | 0) + Math.imul(v, it) | 0, s = s + Math.imul(v, rt) | 0, r = r + Math.imul(m, st) | 0, n = (n = n + Math.imul(m, ot) | 0) + Math.imul(g, st) | 0, s = s + Math.imul(g, ot) | 0;
      var xt = (u + (r = r + Math.imul(c, ht) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ut) | 0) + Math.imul(d, ht) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ut) | 0) + (n >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, r = Math.imul(P, $), n = (n = Math.imul(P, j)) + Math.imul(N, $) | 0, s = Math.imul(N, j), r = r + Math.imul(C, G) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(_, G) | 0, s = s + Math.imul(_, z) | 0, r = r + Math.imul(T, Z) | 0, n = (n = n + Math.imul(T, V) | 0) + Math.imul(O, Z) | 0, s = s + Math.imul(O, V) | 0, r = r + Math.imul(k, K) | 0, n = (n = n + Math.imul(k, X) | 0) + Math.imul(S, K) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(x, Y) | 0, n = (n = n + Math.imul(x, tt) | 0) + Math.imul(E, Y) | 0, s = s + Math.imul(E, tt) | 0, r = r + Math.imul(M, it) | 0, n = (n = n + Math.imul(M, rt) | 0) + Math.imul(b, it) | 0, s = s + Math.imul(b, rt) | 0, r = r + Math.imul(w, st) | 0, n = (n = n + Math.imul(w, ot) | 0) + Math.imul(v, st) | 0, s = s + Math.imul(v, ot) | 0, r = r + Math.imul(m, ht) | 0, n = (n = n + Math.imul(m, ut) | 0) + Math.imul(g, ht) | 0, s = s + Math.imul(g, ut) | 0;
      var Et = (u + (r = r + Math.imul(c, ct) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, dt) | 0) + Math.imul(d, ct) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, dt) | 0) + (n >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, r = Math.imul(W, $), n = (n = Math.imul(W, j)) + Math.imul(F, $) | 0, s = Math.imul(F, j), r = r + Math.imul(P, G) | 0, n = (n = n + Math.imul(P, z) | 0) + Math.imul(N, G) | 0, s = s + Math.imul(N, z) | 0, r = r + Math.imul(C, Z) | 0, n = (n = n + Math.imul(C, V) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, V) | 0, r = r + Math.imul(T, K) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(O, K) | 0, s = s + Math.imul(O, X) | 0, r = r + Math.imul(k, Y) | 0, n = (n = n + Math.imul(k, tt) | 0) + Math.imul(S, Y) | 0, s = s + Math.imul(S, tt) | 0, r = r + Math.imul(x, it) | 0, n = (n = n + Math.imul(x, rt) | 0) + Math.imul(E, it) | 0, s = s + Math.imul(E, rt) | 0, r = r + Math.imul(M, st) | 0, n = (n = n + Math.imul(M, ot) | 0) + Math.imul(b, st) | 0, s = s + Math.imul(b, ot) | 0, r = r + Math.imul(w, ht) | 0, n = (n = n + Math.imul(w, ut) | 0) + Math.imul(v, ht) | 0, s = s + Math.imul(v, ut) | 0, r = r + Math.imul(m, ct) | 0, n = (n = n + Math.imul(m, dt) | 0) + Math.imul(g, ct) | 0, s = s + Math.imul(g, dt) | 0;
      var Rt = (u + (r = r + Math.imul(c, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, gt) | 0) + Math.imul(d, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, gt) | 0) + (n >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, z)) + Math.imul(F, G) | 0, s = Math.imul(F, z), r = r + Math.imul(P, Z) | 0, n = (n = n + Math.imul(P, V) | 0) + Math.imul(N, Z) | 0, s = s + Math.imul(N, V) | 0, r = r + Math.imul(C, K) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(_, K) | 0, s = s + Math.imul(_, X) | 0, r = r + Math.imul(T, Y) | 0, n = (n = n + Math.imul(T, tt) | 0) + Math.imul(O, Y) | 0, s = s + Math.imul(O, tt) | 0, r = r + Math.imul(k, it) | 0, n = (n = n + Math.imul(k, rt) | 0) + Math.imul(S, it) | 0, s = s + Math.imul(S, rt) | 0, r = r + Math.imul(x, st) | 0, n = (n = n + Math.imul(x, ot) | 0) + Math.imul(E, st) | 0, s = s + Math.imul(E, ot) | 0, r = r + Math.imul(M, ht) | 0, n = (n = n + Math.imul(M, ut) | 0) + Math.imul(b, ht) | 0, s = s + Math.imul(b, ut) | 0, r = r + Math.imul(w, ct) | 0, n = (n = n + Math.imul(w, dt) | 0) + Math.imul(v, ct) | 0, s = s + Math.imul(v, dt) | 0;
      var kt = (u + (r = r + Math.imul(m, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(m, gt) | 0) + Math.imul(g, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(g, gt) | 0) + (n >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, r = Math.imul(W, Z), n = (n = Math.imul(W, V)) + Math.imul(F, Z) | 0, s = Math.imul(F, V), r = r + Math.imul(P, K) | 0, n = (n = n + Math.imul(P, X) | 0) + Math.imul(N, K) | 0, s = s + Math.imul(N, X) | 0, r = r + Math.imul(C, Y) | 0, n = (n = n + Math.imul(C, tt) | 0) + Math.imul(_, Y) | 0, s = s + Math.imul(_, tt) | 0, r = r + Math.imul(T, it) | 0, n = (n = n + Math.imul(T, rt) | 0) + Math.imul(O, it) | 0, s = s + Math.imul(O, rt) | 0, r = r + Math.imul(k, st) | 0, n = (n = n + Math.imul(k, ot) | 0) + Math.imul(S, st) | 0, s = s + Math.imul(S, ot) | 0, r = r + Math.imul(x, ht) | 0, n = (n = n + Math.imul(x, ut) | 0) + Math.imul(E, ht) | 0, s = s + Math.imul(E, ut) | 0, r = r + Math.imul(M, ct) | 0, n = (n = n + Math.imul(M, dt) | 0) + Math.imul(b, ct) | 0, s = s + Math.imul(b, dt) | 0;
      var St = (u + (r = r + Math.imul(w, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(w, gt) | 0) + Math.imul(v, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(v, gt) | 0) + (n >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, r = Math.imul(W, K), n = (n = Math.imul(W, X)) + Math.imul(F, K) | 0, s = Math.imul(F, X), r = r + Math.imul(P, Y) | 0, n = (n = n + Math.imul(P, tt) | 0) + Math.imul(N, Y) | 0, s = s + Math.imul(N, tt) | 0, r = r + Math.imul(C, it) | 0, n = (n = n + Math.imul(C, rt) | 0) + Math.imul(_, it) | 0, s = s + Math.imul(_, rt) | 0, r = r + Math.imul(T, st) | 0, n = (n = n + Math.imul(T, ot) | 0) + Math.imul(O, st) | 0, s = s + Math.imul(O, ot) | 0, r = r + Math.imul(k, ht) | 0, n = (n = n + Math.imul(k, ut) | 0) + Math.imul(S, ht) | 0, s = s + Math.imul(S, ut) | 0, r = r + Math.imul(x, ct) | 0, n = (n = n + Math.imul(x, dt) | 0) + Math.imul(E, ct) | 0, s = s + Math.imul(E, dt) | 0;
      var It = (u + (r = r + Math.imul(M, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, gt) | 0) + Math.imul(b, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(b, gt) | 0) + (n >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, r = Math.imul(W, Y), n = (n = Math.imul(W, tt)) + Math.imul(F, Y) | 0, s = Math.imul(F, tt), r = r + Math.imul(P, it) | 0, n = (n = n + Math.imul(P, rt) | 0) + Math.imul(N, it) | 0, s = s + Math.imul(N, rt) | 0, r = r + Math.imul(C, st) | 0, n = (n = n + Math.imul(C, ot) | 0) + Math.imul(_, st) | 0, s = s + Math.imul(_, ot) | 0, r = r + Math.imul(T, ht) | 0, n = (n = n + Math.imul(T, ut) | 0) + Math.imul(O, ht) | 0, s = s + Math.imul(O, ut) | 0, r = r + Math.imul(k, ct) | 0, n = (n = n + Math.imul(k, dt) | 0) + Math.imul(S, ct) | 0, s = s + Math.imul(S, dt) | 0;
      var Tt = (u + (r = r + Math.imul(x, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(x, gt) | 0) + Math.imul(E, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(E, gt) | 0) + (n >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, r = Math.imul(W, it), n = (n = Math.imul(W, rt)) + Math.imul(F, it) | 0, s = Math.imul(F, rt), r = r + Math.imul(P, st) | 0, n = (n = n + Math.imul(P, ot) | 0) + Math.imul(N, st) | 0, s = s + Math.imul(N, ot) | 0, r = r + Math.imul(C, ht) | 0, n = (n = n + Math.imul(C, ut) | 0) + Math.imul(_, ht) | 0, s = s + Math.imul(_, ut) | 0, r = r + Math.imul(T, ct) | 0, n = (n = n + Math.imul(T, dt) | 0) + Math.imul(O, ct) | 0, s = s + Math.imul(O, dt) | 0;
      var Ot = (u + (r = r + Math.imul(k, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(k, gt) | 0) + Math.imul(S, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(S, gt) | 0) + (n >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, r = Math.imul(W, st), n = (n = Math.imul(W, ot)) + Math.imul(F, st) | 0, s = Math.imul(F, ot), r = r + Math.imul(P, ht) | 0, n = (n = n + Math.imul(P, ut) | 0) + Math.imul(N, ht) | 0, s = s + Math.imul(N, ut) | 0, r = r + Math.imul(C, ct) | 0, n = (n = n + Math.imul(C, dt) | 0) + Math.imul(_, ct) | 0, s = s + Math.imul(_, dt) | 0;
      var Bt = (u + (r = r + Math.imul(T, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, gt) | 0) + Math.imul(O, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(O, gt) | 0) + (n >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, r = Math.imul(W, ht), n = (n = Math.imul(W, ut)) + Math.imul(F, ht) | 0, s = Math.imul(F, ut), r = r + Math.imul(P, ct) | 0, n = (n = n + Math.imul(P, dt) | 0) + Math.imul(N, ct) | 0, s = s + Math.imul(N, dt) | 0;
      var Ct = (u + (r = r + Math.imul(C, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, gt) | 0) + Math.imul(_, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(_, gt) | 0) + (n >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, r = Math.imul(W, ct), n = (n = Math.imul(W, dt)) + Math.imul(F, ct) | 0, s = Math.imul(F, dt);

      var _t = (u + (r = r + Math.imul(P, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(P, gt) | 0) + Math.imul(N, mt) | 0)) << 13) | 0;

      u = ((s = s + Math.imul(N, gt) | 0) + (n >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863;
      var Dt = (u + (r = Math.imul(W, mt)) | 0) + ((8191 & (n = (n = Math.imul(W, gt)) + Math.imul(F, mt) | 0)) << 13) | 0;
      return u = ((s = Math.imul(F, gt)) + (n >>> 13) | 0) + (Dt >>> 26) | 0, Dt &= 67108863, h[0] = pt, h[1] = wt, h[2] = vt, h[3] = yt, h[4] = Mt, h[5] = bt, h[6] = At, h[7] = xt, h[8] = Et, h[9] = Rt, h[10] = kt, h[11] = St, h[12] = It, h[13] = Tt, h[14] = Ot, h[15] = Bt, h[16] = Ct, h[17] = _t, h[18] = Dt, 0 !== u && (h[19] = u, i.length++), i;
    };

    function f(t, e, i) {
      return new m().mulp(t, e, i);
    }

    function m(t, e) {
      this.x = t, this.y = e;
    }

    Math.imul || (d = c), n.prototype.mulTo = function (t, e) {
      var i = this.length + t.length;
      return 10 === this.length && 10 === t.length ? d(this, t, e) : i < 63 ? c(this, t, e) : i < 1024 ? function (t, e, i) {
        i.negative = e.negative ^ t.negative, i.length = t.length + e.length;

        for (var r = 0, n = 0, s = 0; s < i.length - 1; s++) {
          var o = n;
          n = 0;

          for (var a = 67108863 & r, h = Math.min(s, e.length - 1), u = Math.max(0, s - t.length + 1); u <= h; u++) {
            var l = (0 | t.words[s - u]) * (0 | e.words[u]),
                c = 67108863 & l;
            a = 67108863 & (c = c + a | 0), n += (o = (o = o + (l / 67108864 | 0) | 0) + (c >>> 26) | 0) >>> 26, o &= 67108863;
          }

          i.words[s] = a, r = o, o = n;
        }

        return 0 !== r ? i.words[s] = r : i.length--, i.strip();
      }(this, t, e) : f(this, t, e);
    }, m.prototype.makeRBT = function (t) {
      for (var e = new Array(t), i = n.prototype._countBits(t) - 1, r = 0; r < t; r++) {
        e[r] = this.revBin(r, i, t);
      }

      return e;
    }, m.prototype.revBin = function (t, e, i) {
      if (0 === t || t === i - 1) return t;

      for (var r = 0, n = 0; n < e; n++) {
        r |= (1 & t) << e - n - 1, t >>= 1;
      }

      return r;
    }, m.prototype.permute = function (t, e, i, r, n, s) {
      for (var o = 0; o < s; o++) {
        r[o] = e[t[o]], n[o] = i[t[o]];
      }
    }, m.prototype.transform = function (t, e, i, r, n, s) {
      this.permute(s, t, e, i, r, n);

      for (var o = 1; o < n; o <<= 1) {
        for (var a = o << 1, h = Math.cos(2 * Math.PI / a), u = Math.sin(2 * Math.PI / a), l = 0; l < n; l += a) {
          for (var c = h, d = u, f = 0; f < o; f++) {
            var m = i[l + f],
                g = r[l + f],
                p = i[l + f + o],
                w = r[l + f + o],
                v = c * p - d * w;
            w = c * w + d * p, i[l + f] = m + (p = v), r[l + f] = g + w, i[l + f + o] = m - p, r[l + f + o] = g - w, f !== a && (v = h * c - u * d, d = h * d + u * c, c = v);
          }
        }
      }
    }, m.prototype.guessLen13b = function (t, e) {
      var i = 1 | Math.max(e, t),
          r = 1 & i,
          n = 0;

      for (i = i / 2 | 0; i; i >>>= 1) {
        n++;
      }

      return 1 << n + 1 + r;
    }, m.prototype.conjugate = function (t, e, i) {
      if (!(i <= 1)) for (var r = 0; r < i / 2; r++) {
        var n = t[r];
        t[r] = t[i - r - 1], t[i - r - 1] = n, n = e[r], e[r] = -e[i - r - 1], e[i - r - 1] = -n;
      }
    }, m.prototype.normalize13b = function (t, e) {
      for (var i = 0, r = 0; r < e / 2; r++) {
        var n = 8192 * Math.round(t[2 * r + 1] / e) + Math.round(t[2 * r] / e) + i;
        t[r] = 67108863 & n, i = n < 67108864 ? 0 : n / 67108864 | 0;
      }

      return t;
    }, m.prototype.convert13b = function (t, e, r, n) {
      for (var s = 0, o = 0; o < e; o++) {
        r[2 * o] = 8191 & (s += 0 | t[o]), r[2 * o + 1] = 8191 & (s >>>= 13), s >>>= 13;
      }

      for (o = 2 * e; o < n; ++o) {
        r[o] = 0;
      }

      i(0 === s), i(0 == (-8192 & s));
    }, m.prototype.stub = function (t) {
      for (var e = new Array(t), i = 0; i < t; i++) {
        e[i] = 0;
      }

      return e;
    }, m.prototype.mulp = function (t, e, i) {
      var r = 2 * this.guessLen13b(t.length, e.length),
          n = this.makeRBT(r),
          s = this.stub(r),
          o = new Array(r),
          a = new Array(r),
          h = new Array(r),
          u = new Array(r),
          l = new Array(r),
          c = new Array(r),
          d = i.words;
      d.length = r, this.convert13b(t.words, t.length, o, r), this.convert13b(e.words, e.length, u, r), this.transform(o, s, a, h, r, n), this.transform(u, s, l, c, r, n);

      for (var f = 0; f < r; f++) {
        var m = a[f] * l[f] - h[f] * c[f];
        h[f] = a[f] * c[f] + h[f] * l[f], a[f] = m;
      }

      return this.conjugate(a, h, r), this.transform(a, h, d, s, r, n), this.conjugate(d, s, r), this.normalize13b(d, r), i.negative = t.negative ^ e.negative, i.length = t.length + e.length, i.strip();
    }, n.prototype.mul = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), this.mulTo(t, e);
    }, n.prototype.mulf = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), f(this, t, e);
    }, n.prototype.imul = function (t) {
      return this.clone().mulTo(t, this);
    }, n.prototype.imuln = function (t) {
      i("number" == typeof t), i(t < 67108864);

      for (var e = 0, r = 0; r < this.length; r++) {
        var n = (0 | this.words[r]) * t,
            s = (67108863 & n) + (67108863 & e);
        e >>= 26, e += n / 67108864 | 0, e += s >>> 26, this.words[r] = 67108863 & s;
      }

      return 0 !== e && (this.words[r] = e, this.length++), this;
    }, n.prototype.muln = function (t) {
      return this.clone().imuln(t);
    }, n.prototype.sqr = function () {
      return this.mul(this);
    }, n.prototype.isqr = function () {
      return this.imul(this.clone());
    }, n.prototype.pow = function (t) {
      var e = function (t) {
        for (var e = new Array(t.bitLength()), i = 0; i < e.length; i++) {
          var r = i % 26;
          e[i] = (t.words[i / 26 | 0] & 1 << r) >>> r;
        }

        return e;
      }(t);

      if (0 === e.length) return new n(1);

      for (var i = this, r = 0; r < e.length && 0 === e[r]; r++, i = i.sqr()) {
        ;
      }

      if (++r < e.length) for (var s = i.sqr(); r < e.length; r++, s = s.sqr()) {
        0 !== e[r] && (i = i.mul(s));
      }
      return i;
    }, n.prototype.iushln = function (t) {
      i("number" == typeof t && t >= 0);
      var e,
          r = t % 26,
          n = (t - r) / 26,
          s = 67108863 >>> 26 - r << 26 - r;

      if (0 !== r) {
        var o = 0;

        for (e = 0; e < this.length; e++) {
          var a = this.words[e] & s;
          this.words[e] = (0 | this.words[e]) - a << r | o, o = a >>> 26 - r;
        }

        o && (this.words[e] = o, this.length++);
      }

      if (0 !== n) {
        for (e = this.length - 1; e >= 0; e--) {
          this.words[e + n] = this.words[e];
        }

        for (e = 0; e < n; e++) {
          this.words[e] = 0;
        }

        this.length += n;
      }

      return this.strip();
    }, n.prototype.ishln = function (t) {
      return i(0 === this.negative), this.iushln(t);
    }, n.prototype.iushrn = function (t, e, r) {
      var n;
      i("number" == typeof t && t >= 0), n = e ? (e - e % 26) / 26 : 0;
      var s = t % 26,
          o = Math.min((t - s) / 26, this.length),
          a = 67108863 ^ 67108863 >>> s << s,
          h = r;

      if (n -= o, n = Math.max(0, n), h) {
        for (var u = 0; u < o; u++) {
          h.words[u] = this.words[u];
        }

        h.length = o;
      }

      if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
        this.words[u] = this.words[u + o];
      } else this.words[0] = 0, this.length = 1;
      var l = 0;

      for (u = this.length - 1; u >= 0 && (0 !== l || u >= n); u--) {
        var c = 0 | this.words[u];
        this.words[u] = l << 26 - s | c >>> s, l = c & a;
      }

      return h && 0 !== l && (h.words[h.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
    }, n.prototype.ishrn = function (t, e, r) {
      return i(0 === this.negative), this.iushrn(t, e, r);
    }, n.prototype.shln = function (t) {
      return this.clone().ishln(t);
    }, n.prototype.ushln = function (t) {
      return this.clone().iushln(t);
    }, n.prototype.shrn = function (t) {
      return this.clone().ishrn(t);
    }, n.prototype.ushrn = function (t) {
      return this.clone().iushrn(t);
    }, n.prototype.testn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return !(this.length <= r || !(this.words[r] & 1 << e));
    }, n.prototype.imaskn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return i(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r ? this : (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e && (this.words[this.length - 1] &= 67108863 ^ 67108863 >>> e << e), this.strip());
    }, n.prototype.maskn = function (t) {
      return this.clone().imaskn(t);
    }, n.prototype.iaddn = function (t) {
      return i("number" == typeof t), i(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
    }, n.prototype._iaddn = function (t) {
      this.words[0] += t;

      for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
        this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
      }

      return this.length = Math.max(this.length, e + 1), this;
    }, n.prototype.isubn = function (t) {
      if (i("number" == typeof t), i(t < 67108864), t < 0) return this.iaddn(-t);
      if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
      if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
        this.words[e] += 67108864, this.words[e + 1] -= 1;
      }
      return this.strip();
    }, n.prototype.addn = function (t) {
      return this.clone().iaddn(t);
    }, n.prototype.subn = function (t) {
      return this.clone().isubn(t);
    }, n.prototype.iabs = function () {
      return this.negative = 0, this;
    }, n.prototype.abs = function () {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function (t, e, r) {
      var n, s;

      this._expand(t.length + r);

      var o = 0;

      for (n = 0; n < t.length; n++) {
        s = (0 | this.words[n + r]) + o;
        var a = (0 | t.words[n]) * e;
        o = ((s -= 67108863 & a) >> 26) - (a / 67108864 | 0), this.words[n + r] = 67108863 & s;
      }

      for (; n < this.length - r; n++) {
        o = (s = (0 | this.words[n + r]) + o) >> 26, this.words[n + r] = 67108863 & s;
      }

      if (0 === o) return this.strip();

      for (i(-1 === o), o = 0, n = 0; n < this.length; n++) {
        o = (s = -(0 | this.words[n]) + o) >> 26, this.words[n] = 67108863 & s;
      }

      return this.negative = 1, this.strip();
    }, n.prototype._wordDiv = function (t, e) {
      var i,
          r = this.clone(),
          s = t,
          o = 0 | s.words[s.length - 1];
      0 != (i = 26 - this._countBits(o)) && (s = s.ushln(i), r.iushln(i), o = 0 | s.words[s.length - 1]);
      var a,
          h = r.length - s.length;

      if ("mod" !== e) {
        (a = new n(null)).length = h + 1, a.words = new Array(a.length);

        for (var u = 0; u < a.length; u++) {
          a.words[u] = 0;
        }
      }

      var l = r.clone()._ishlnsubmul(s, 1, h);

      0 === l.negative && (r = l, a && (a.words[h] = 1));

      for (var c = h - 1; c >= 0; c--) {
        var d = 67108864 * (0 | r.words[s.length + c]) + (0 | r.words[s.length + c - 1]);

        for (d = Math.min(d / o | 0, 67108863), r._ishlnsubmul(s, d, c); 0 !== r.negative;) {
          d--, r.negative = 0, r._ishlnsubmul(s, 1, c), r.isZero() || (r.negative ^= 1);
        }

        a && (a.words[c] = d);
      }

      return a && a.strip(), r.strip(), "div" !== e && 0 !== i && r.iushrn(i), {
        div: a || null,
        mod: r
      };
    }, n.prototype.divmod = function (t, e, r) {
      return i(!t.isZero()), this.isZero() ? {
        div: new n(0),
        mod: new n(0)
      } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (s = a.div.neg()), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(t)), {
        div: s,
        mod: o
      }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (s = a.div.neg()), {
        div: s,
        mod: a.mod
      }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(t)), {
        div: a.div,
        mod: o
      }) : t.length > this.length || this.cmp(t) < 0 ? {
        div: new n(0),
        mod: this
      } : 1 === t.length ? "div" === e ? {
        div: this.divn(t.words[0]),
        mod: null
      } : "mod" === e ? {
        div: null,
        mod: new n(this.modn(t.words[0]))
      } : {
        div: this.divn(t.words[0]),
        mod: new n(this.modn(t.words[0]))
      } : this._wordDiv(t, e);
      var s, o, a;
    }, n.prototype.div = function (t) {
      return this.divmod(t, "div", !1).div;
    }, n.prototype.mod = function (t) {
      return this.divmod(t, "mod", !1).mod;
    }, n.prototype.umod = function (t) {
      return this.divmod(t, "mod", !0).mod;
    }, n.prototype.divRound = function (t) {
      var e = this.divmod(t);
      if (e.mod.isZero()) return e.div;
      var i = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
          r = t.ushrn(1),
          n = t.andln(1),
          s = i.cmp(r);
      return s < 0 || 1 === n && 0 === s ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
    }, n.prototype.modn = function (t) {
      i(t <= 67108863);

      for (var e = (1 << 26) % t, r = 0, n = this.length - 1; n >= 0; n--) {
        r = (e * r + (0 | this.words[n])) % t;
      }

      return r;
    }, n.prototype.idivn = function (t) {
      i(t <= 67108863);

      for (var e = 0, r = this.length - 1; r >= 0; r--) {
        var n = (0 | this.words[r]) + 67108864 * e;
        this.words[r] = n / t | 0, e = n % t;
      }

      return this.strip();
    }, n.prototype.divn = function (t) {
      return this.clone().idivn(t);
    }, n.prototype.egcd = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s = new n(1), o = new n(0), a = new n(0), h = new n(1), u = 0; e.isEven() && r.isEven();) {
        e.iushrn(1), r.iushrn(1), ++u;
      }

      for (var l = r.clone(), c = e.clone(); !e.isZero();) {
        for (var d = 0, f = 1; 0 == (e.words[0] & f) && d < 26; ++d, f <<= 1) {
          ;
        }

        if (d > 0) for (e.iushrn(d); d-- > 0;) {
          (s.isOdd() || o.isOdd()) && (s.iadd(l), o.isub(c)), s.iushrn(1), o.iushrn(1);
        }

        for (var m = 0, g = 1; 0 == (r.words[0] & g) && m < 26; ++m, g <<= 1) {
          ;
        }

        if (m > 0) for (r.iushrn(m); m-- > 0;) {
          (a.isOdd() || h.isOdd()) && (a.iadd(l), h.isub(c)), a.iushrn(1), h.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), s.isub(a), o.isub(h)) : (r.isub(e), a.isub(s), h.isub(o));
      }

      return {
        a: a,
        b: h,
        gcd: r.iushln(u)
      };
    }, n.prototype._invmp = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s, o = new n(1), a = new n(0), h = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
        for (var u = 0, l = 1; 0 == (e.words[0] & l) && u < 26; ++u, l <<= 1) {
          ;
        }

        if (u > 0) for (e.iushrn(u); u-- > 0;) {
          o.isOdd() && o.iadd(h), o.iushrn(1);
        }

        for (var c = 0, d = 1; 0 == (r.words[0] & d) && c < 26; ++c, d <<= 1) {
          ;
        }

        if (c > 0) for (r.iushrn(c); c-- > 0;) {
          a.isOdd() && a.iadd(h), a.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), o.isub(a)) : (r.isub(e), a.isub(o));
      }

      return (s = 0 === e.cmpn(1) ? o : a).cmpn(0) < 0 && s.iadd(t), s;
    }, n.prototype.gcd = function (t) {
      if (this.isZero()) return t.abs();
      if (t.isZero()) return this.abs();
      var e = this.clone(),
          i = t.clone();
      e.negative = 0, i.negative = 0;

      for (var r = 0; e.isEven() && i.isEven(); r++) {
        e.iushrn(1), i.iushrn(1);
      }

      for (;;) {
        for (; e.isEven();) {
          e.iushrn(1);
        }

        for (; i.isEven();) {
          i.iushrn(1);
        }

        var n = e.cmp(i);

        if (n < 0) {
          var s = e;
          e = i, i = s;
        } else if (0 === n || 0 === i.cmpn(1)) break;

        e.isub(i);
      }

      return i.iushln(r);
    }, n.prototype.invm = function (t) {
      return this.egcd(t).a.umod(t);
    }, n.prototype.isEven = function () {
      return 0 == (1 & this.words[0]);
    }, n.prototype.isOdd = function () {
      return 1 == (1 & this.words[0]);
    }, n.prototype.andln = function (t) {
      return this.words[0] & t;
    }, n.prototype.bincn = function (t) {
      i("number" == typeof t);
      var e = t % 26,
          r = (t - e) / 26,
          n = 1 << e;
      if (this.length <= r) return this._expand(r + 1), this.words[r] |= n, this;

      for (var s = n, o = r; 0 !== s && o < this.length; o++) {
        var a = 0 | this.words[o];
        s = (a += s) >>> 26, this.words[o] = a &= 67108863;
      }

      return 0 !== s && (this.words[o] = s, this.length++), this;
    }, n.prototype.isZero = function () {
      return 1 === this.length && 0 === this.words[0];
    }, n.prototype.cmpn = function (t) {
      var e,
          r = t < 0;
      if (0 !== this.negative && !r) return -1;
      if (0 === this.negative && r) return 1;
      if (this.strip(), this.length > 1) e = 1;else {
        r && (t = -t), i(t <= 67108863, "Number is too big");
        var n = 0 | this.words[0];
        e = n === t ? 0 : n < t ? -1 : 1;
      }
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.cmp = function (t) {
      if (0 !== this.negative && 0 === t.negative) return -1;
      if (0 === this.negative && 0 !== t.negative) return 1;
      var e = this.ucmp(t);
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.ucmp = function (t) {
      if (this.length > t.length) return 1;
      if (this.length < t.length) return -1;

      for (var e = 0, i = this.length - 1; i >= 0; i--) {
        var r = 0 | this.words[i],
            n = 0 | t.words[i];

        if (r !== n) {
          r < n ? e = -1 : r > n && (e = 1);
          break;
        }
      }

      return e;
    }, n.prototype.gtn = function (t) {
      return 1 === this.cmpn(t);
    }, n.prototype.gt = function (t) {
      return 1 === this.cmp(t);
    }, n.prototype.gten = function (t) {
      return this.cmpn(t) >= 0;
    }, n.prototype.gte = function (t) {
      return this.cmp(t) >= 0;
    }, n.prototype.ltn = function (t) {
      return -1 === this.cmpn(t);
    }, n.prototype.lt = function (t) {
      return -1 === this.cmp(t);
    }, n.prototype.lten = function (t) {
      return this.cmpn(t) <= 0;
    }, n.prototype.lte = function (t) {
      return this.cmp(t) <= 0;
    }, n.prototype.eqn = function (t) {
      return 0 === this.cmpn(t);
    }, n.prototype.eq = function (t) {
      return 0 === this.cmp(t);
    }, n.red = function (t) {
      return new b(t);
    }, n.prototype.toRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), i(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
    }, n.prototype.fromRed = function () {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function (t) {
      return this.red = t, this;
    }, n.prototype.forceRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(t);
    }, n.prototype.redAdd = function (t) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
    }, n.prototype.redIAdd = function (t) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
    }, n.prototype.redSub = function (t) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
    }, n.prototype.redISub = function (t) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
    }, n.prototype.redShl = function (t) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
    }, n.prototype.redMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
    }, n.prototype.redIMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
    }, n.prototype.redSqr = function () {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function () {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function () {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function () {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function () {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function (t) {
      return i(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
    };
    var g = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };

    function p(t, e) {
      this.name = t, this.p = new n(e, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }

    function w() {
      p.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }

    function v() {
      p.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }

    function y() {
      p.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }

    function M() {
      p.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }

    function b(t) {
      if ("string" == typeof t) {
        var e = n._prime(t);

        this.m = e.p, this.prime = e;
      } else i(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
    }

    function A(t) {
      b.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }

    p.prototype._tmp = function () {
      var t = new n(null);
      return t.words = new Array(Math.ceil(this.n / 13)), t;
    }, p.prototype.ireduce = function (t) {
      var e,
          i = t;

      do {
        this.split(i, this.tmp), e = (i = (i = this.imulK(i)).iadd(this.tmp)).bitLength();
      } while (e > this.n);

      var r = e < this.n ? -1 : i.ucmp(this.p);
      return 0 === r ? (i.words[0] = 0, i.length = 1) : r > 0 ? i.isub(this.p) : i.strip(), i;
    }, p.prototype.split = function (t, e) {
      t.iushrn(this.n, 0, e);
    }, p.prototype.imulK = function (t) {
      return t.imul(this.k);
    }, r(w, p), w.prototype.split = function (t, e) {
      for (var i = 4194303, r = Math.min(t.length, 9), n = 0; n < r; n++) {
        e.words[n] = t.words[n];
      }

      if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
      var s = t.words[9];

      for (e.words[e.length++] = s & i, n = 10; n < t.length; n++) {
        var o = 0 | t.words[n];
        t.words[n - 10] = (o & i) << 4 | s >>> 22, s = o;
      }

      t.words[n - 10] = s >>>= 22, t.length -= 0 === s && t.length > 10 ? 10 : 9;
    }, w.prototype.imulK = function (t) {
      t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 0 | t.words[i];
        t.words[i] = 67108863 & (e += 977 * r), e = 64 * r + (e / 67108864 | 0);
      }

      return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
    }, r(v, p), r(y, p), r(M, p), M.prototype.imulK = function (t) {
      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 19 * (0 | t.words[i]) + e,
            n = 67108863 & r;
        r >>>= 26, t.words[i] = n, e = r;
      }

      return 0 !== e && (t.words[t.length++] = e), t;
    }, n._prime = function (t) {
      if (g[t]) return g[t];
      var e;
      if ("k256" === t) e = new w();else if ("p224" === t) e = new v();else if ("p192" === t) e = new y();else {
        if ("p25519" !== t) throw new Error("Unknown prime " + t);
        e = new M();
      }
      return g[t] = e, e;
    }, b.prototype._verify1 = function (t) {
      i(0 === t.negative, "red works only with positives"), i(t.red, "red works only with red numbers");
    }, b.prototype._verify2 = function (t, e) {
      i(0 == (t.negative | e.negative), "red works only with positives"), i(t.red && t.red === e.red, "red works only with red numbers");
    }, b.prototype.imod = function (t) {
      return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
    }, b.prototype.neg = function (t) {
      return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
    }, b.prototype.add = function (t, e) {
      this._verify2(t, e);

      var i = t.add(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i._forceRed(this);
    }, b.prototype.iadd = function (t, e) {
      this._verify2(t, e);

      var i = t.iadd(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i;
    }, b.prototype.sub = function (t, e) {
      this._verify2(t, e);

      var i = t.sub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i._forceRed(this);
    }, b.prototype.isub = function (t, e) {
      this._verify2(t, e);

      var i = t.isub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i;
    }, b.prototype.shl = function (t, e) {
      return this._verify1(t), this.imod(t.ushln(e));
    }, b.prototype.imul = function (t, e) {
      return this._verify2(t, e), this.imod(t.imul(e));
    }, b.prototype.mul = function (t, e) {
      return this._verify2(t, e), this.imod(t.mul(e));
    }, b.prototype.isqr = function (t) {
      return this.imul(t, t.clone());
    }, b.prototype.sqr = function (t) {
      return this.mul(t, t);
    }, b.prototype.sqrt = function (t) {
      if (t.isZero()) return t.clone();
      var e = this.m.andln(3);

      if (i(e % 2 == 1), 3 === e) {
        var r = this.m.add(new n(1)).iushrn(2);
        return this.pow(t, r);
      }

      for (var s = this.m.subn(1), o = 0; !s.isZero() && 0 === s.andln(1);) {
        o++, s.iushrn(1);
      }

      i(!s.isZero());
      var a = new n(1).toRed(this),
          h = a.redNeg(),
          u = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();

      for (l = new n(2 * l * l).toRed(this); 0 !== this.pow(l, u).cmp(h);) {
        l.redIAdd(h);
      }

      for (var c = this.pow(l, s), d = this.pow(t, s.addn(1).iushrn(1)), f = this.pow(t, s), m = o; 0 !== f.cmp(a);) {
        for (var g = f, p = 0; 0 !== g.cmp(a); p++) {
          g = g.redSqr();
        }

        i(p < m);
        var w = this.pow(c, new n(1).iushln(m - p - 1));
        d = d.redMul(w), c = w.redSqr(), f = f.redMul(c), m = p;
      }

      return d;
    }, b.prototype.invm = function (t) {
      var e = t._invmp(this.m);

      return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
    }, b.prototype.pow = function (t, e) {
      if (e.isZero()) return new n(1);
      if (0 === e.cmpn(1)) return t.clone();
      var i = new Array(16);
      i[0] = new n(1).toRed(this), i[1] = t;

      for (var r = 2; r < i.length; r++) {
        i[r] = this.mul(i[r - 1], t);
      }

      var s = i[0],
          o = 0,
          a = 0,
          h = e.bitLength() % 26;

      for (0 === h && (h = 26), r = e.length - 1; r >= 0; r--) {
        for (var u = e.words[r], l = h - 1; l >= 0; l--) {
          var c = u >> l & 1;
          s !== i[0] && (s = this.sqr(s)), 0 !== c || 0 !== o ? (o <<= 1, o |= c, (4 == ++a || 0 === r && 0 === l) && (s = this.mul(s, i[o]), a = 0, o = 0)) : a = 0;
        }

        h = 26;
      }

      return s;
    }, b.prototype.convertTo = function (t) {
      var e = t.umod(this.m);
      return e === t ? e.clone() : e;
    }, b.prototype.convertFrom = function (t) {
      var e = t.clone();
      return e.red = null, e;
    }, n.mont = function (t) {
      return new A(t);
    }, r(A, b), A.prototype.convertTo = function (t) {
      return this.imod(t.ushln(this.shift));
    }, A.prototype.convertFrom = function (t) {
      var e = this.imod(t.mul(this.rinv));
      return e.red = null, e;
    }, A.prototype.imul = function (t, e) {
      if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
      var i = t.imul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          n = i.isub(r).iushrn(this.shift),
          s = n;
      return n.cmp(this.m) >= 0 ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
    }, A.prototype.mul = function (t, e) {
      if (t.isZero() || e.isZero()) return new n(0)._forceRed(this);
      var i = t.mul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          s = i.isub(r).iushrn(this.shift),
          o = s;
      return s.cmp(this.m) >= 0 ? o = s.isub(this.m) : s.cmpn(0) < 0 && (o = s.iadd(this.m)), o._forceRed(this);
    }, A.prototype.invm = function (t) {
      return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
    };
  }(t, gt);
}),
    yt = pt(function (t) {
  !function (t, e) {
    function i(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    function r(t, e) {
      t.super_ = e;

      var i = function i() {};

      i.prototype = e.prototype, t.prototype = new i(), t.prototype.constructor = t;
    }

    function n(t, e, i) {
      if (n.isBN(t)) return t;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (i = e, e = 10), this._init(t || 0, e || 10, i || "be"));
    }

    var s;
    "object" == typeof t ? t.exports = n : e.BN = n, n.BN = n, n.wordSize = 26;

    try {
      s = wt("buffer").Buffer;
    } catch (t) {}

    function o(t, e, i) {
      for (var r = 0, n = Math.min(t.length, i), s = e; s < n; s++) {
        var o = t.charCodeAt(s) - 48;
        r <<= 4, r |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
      }

      return r;
    }

    function a(t, e, i, r) {
      for (var n = 0, s = Math.min(t.length, i), o = e; o < s; o++) {
        var a = t.charCodeAt(o) - 48;
        n *= r, n += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
      }

      return n;
    }

    n.isBN = function (t) {
      return t instanceof n || null !== t && "object" == typeof t && t.constructor.wordSize === n.wordSize && Array.isArray(t.words);
    }, n.max = function (t, e) {
      return t.cmp(e) > 0 ? t : e;
    }, n.min = function (t, e) {
      return t.cmp(e) < 0 ? t : e;
    }, n.prototype._init = function (t, e, r) {
      if ("number" == typeof t) return this._initNumber(t, e, r);
      if ("object" == typeof t) return this._initArray(t, e, r);
      "hex" === e && (e = 16), i(e === (0 | e) && e >= 2 && e <= 36);
      var n = 0;
      "-" === (t = t.toString().replace(/\s+/g, ""))[0] && n++, 16 === e ? this._parseHex(t, n) : this._parseBase(t, e, n), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initNumber = function (t, e, r) {
      t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (i(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initArray = function (t, e, r) {
      if (i("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

      for (var n = 0; n < this.length; n++) {
        this.words[n] = 0;
      }

      var s,
          o,
          a = 0;
      if ("be" === r) for (n = t.length - 1, s = 0; n >= 0; n -= 3) {
        this.words[s] |= (o = t[n] | t[n - 1] << 8 | t[n - 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      } else if ("le" === r) for (n = 0, s = 0; n < t.length; n += 3) {
        this.words[s] |= (o = t[n] | t[n + 1] << 8 | t[n + 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      }
      return this.strip();
    }, n.prototype._parseHex = function (t, e) {
      this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }

      var r,
          n,
          s = 0;

      for (i = t.length - 6, r = 0; i >= e; i -= 6) {
        n = o(t, i, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, (s += 24) >= 26 && (s -= 26, r++);
      }

      i + 6 !== e && (n = o(t, e, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
    }, n.prototype._parseBase = function (t, e, i) {
      this.words = [0], this.length = 1;

      for (var r = 0, n = 1; n <= 67108863; n *= e) {
        r++;
      }

      r--, n = n / e | 0;

      for (var s = t.length - i, o = s % r, h = Math.min(s, s - o) + i, u = 0, l = i; l < h; l += r) {
        u = a(t, l, l + r, e), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }

      if (0 !== o) {
        var c = 1;

        for (u = a(t, l, t.length, e), l = 0; l < o; l++) {
          c *= e;
        }

        this.imuln(c), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }
    }, n.prototype.copy = function (t) {
      t.words = new Array(this.length);

      for (var e = 0; e < this.length; e++) {
        t.words[e] = this.words[e];
      }

      t.length = this.length, t.negative = this.negative, t.red = this.red;
    }, n.prototype.clone = function () {
      var t = new n(null);
      return this.copy(t), t;
    }, n.prototype._expand = function (t) {
      for (; this.length < t;) {
        this.words[this.length++] = 0;
      }

      return this;
    }, n.prototype.strip = function () {
      for (; this.length > 1 && 0 === this.words[this.length - 1];) {
        this.length--;
      }

      return this._normSign();
    }, n.prototype._normSign = function () {
      return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
    }, n.prototype.inspect = function () {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var h = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        l = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

    function c(t, e, i) {
      i.negative = e.negative ^ t.negative;
      var r = t.length + e.length | 0;
      i.length = r, r = r - 1 | 0;
      var n = 0 | t.words[0],
          s = 0 | e.words[0],
          o = n * s,
          a = o / 67108864 | 0;
      i.words[0] = 67108863 & o;

      for (var h = 1; h < r; h++) {
        for (var u = a >>> 26, l = 67108863 & a, c = Math.min(h, e.length - 1), d = Math.max(0, h - t.length + 1); d <= c; d++) {
          u += (o = (n = 0 | t.words[h - d | 0]) * (s = 0 | e.words[d]) + l) / 67108864 | 0, l = 67108863 & o;
        }

        i.words[h] = 0 | l, a = 0 | u;
      }

      return 0 !== a ? i.words[h] = 0 | a : i.length--, i.strip();
    }

    n.prototype.toString = function (t, e) {
      var r;

      if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
        r = "";

        for (var n = 0, s = 0, o = 0; o < this.length; o++) {
          var a = this.words[o],
              c = (16777215 & (a << n | s)).toString(16);
          r = 0 != (s = a >>> 24 - n & 16777215) || o !== this.length - 1 ? h[6 - c.length] + c + r : c + r, (n += 2) >= 26 && (n -= 26, o--);
        }

        for (0 !== s && (r = s.toString(16) + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      if (t === (0 | t) && t >= 2 && t <= 36) {
        var d = u[t],
            f = l[t];
        r = "";
        var m = this.clone();

        for (m.negative = 0; !m.isZero();) {
          var g = m.modn(f).toString(t);
          r = (m = m.idivn(f)).isZero() ? g + r : h[d - g.length] + g + r;
        }

        for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function () {
      var t = this.words[0];
      return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
    }, n.prototype.toJSON = function () {
      return this.toString(16);
    }, n.prototype.toBuffer = function (t, e) {
      return i(void 0 !== s), this.toArrayLike(s, t, e);
    }, n.prototype.toArray = function (t, e) {
      return this.toArrayLike(Array, t, e);
    }, n.prototype.toArrayLike = function (t, e, r) {
      var n = this.byteLength(),
          s = r || Math.max(1, n);
      i(n <= s, "byte array longer than desired length"), i(s > 0, "Requested array length <= 0"), this.strip();
      var o,
          a,
          h = "le" === e,
          u = new t(s),
          l = this.clone();

      if (h) {
        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[a] = o;
        }

        for (; a < s; a++) {
          u[a] = 0;
        }
      } else {
        for (a = 0; a < s - n; a++) {
          u[a] = 0;
        }

        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[s - a - 1] = o;
        }
      }

      return u;
    }, n.prototype._countBits = Math.clz32 ? function (t) {
      return 32 - Math.clz32(t);
    } : function (t) {
      var e = t,
          i = 0;
      return e >= 4096 && (i += 13, e >>>= 13), e >= 64 && (i += 7, e >>>= 7), e >= 8 && (i += 4, e >>>= 4), e >= 2 && (i += 2, e >>>= 2), i + e;
    }, n.prototype._zeroBits = function (t) {
      if (0 === t) return 26;
      var e = t,
          i = 0;
      return 0 == (8191 & e) && (i += 13, e >>>= 13), 0 == (127 & e) && (i += 7, e >>>= 7), 0 == (15 & e) && (i += 4, e >>>= 4), 0 == (3 & e) && (i += 2, e >>>= 2), 0 == (1 & e) && i++, i;
    }, n.prototype.bitLength = function () {
      var t = this._countBits(this.words[this.length - 1]);

      return 26 * (this.length - 1) + t;
    }, n.prototype.zeroBits = function () {
      if (this.isZero()) return 0;

      for (var t = 0, e = 0; e < this.length; e++) {
        var i = this._zeroBits(this.words[e]);

        if (t += i, 26 !== i) break;
      }

      return t;
    }, n.prototype.byteLength = function () {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function (t) {
      return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function (t) {
      return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function () {
      return 0 !== this.negative;
    }, n.prototype.neg = function () {
      return this.clone().ineg();
    }, n.prototype.ineg = function () {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function (t) {
      for (; this.length < t.length;) {
        this.words[this.length++] = 0;
      }

      for (var e = 0; e < t.length; e++) {
        this.words[e] = this.words[e] | t.words[e];
      }

      return this.strip();
    }, n.prototype.ior = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuor(t);
    }, n.prototype.or = function (t) {
      return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
    }, n.prototype.uor = function (t) {
      return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
    }, n.prototype.iuand = function (t) {
      var e;
      e = this.length > t.length ? t : this;

      for (var i = 0; i < e.length; i++) {
        this.words[i] = this.words[i] & t.words[i];
      }

      return this.length = e.length, this.strip();
    }, n.prototype.iand = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuand(t);
    }, n.prototype.and = function (t) {
      return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
    }, n.prototype.uand = function (t) {
      return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
    }, n.prototype.iuxor = function (t) {
      var e, i;
      this.length > t.length ? (e = this, i = t) : (e = t, i = this);

      for (var r = 0; r < i.length; r++) {
        this.words[r] = e.words[r] ^ i.words[r];
      }

      if (this !== e) for (; r < e.length; r++) {
        this.words[r] = e.words[r];
      }
      return this.length = e.length, this.strip();
    }, n.prototype.ixor = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuxor(t);
    }, n.prototype.xor = function (t) {
      return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
    }, n.prototype.uxor = function (t) {
      return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
    }, n.prototype.inotn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = 0 | Math.ceil(t / 26),
          r = t % 26;
      this._expand(e), r > 0 && e--;

      for (var n = 0; n < e; n++) {
        this.words[n] = 67108863 & ~this.words[n];
      }

      return r > 0 && (this.words[n] = ~this.words[n] & 67108863 >> 26 - r), this.strip();
    }, n.prototype.notn = function (t) {
      return this.clone().inotn(t);
    }, n.prototype.setn = function (t, e) {
      i("number" == typeof t && t >= 0);
      var r = t / 26 | 0,
          n = t % 26;
      return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << n : this.words[r] & ~(1 << n), this.strip();
    }, n.prototype.iadd = function (t) {
      var e, i, r;
      if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
      if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
      this.length > t.length ? (i = this, r = t) : (i = t, r = this);

      for (var n = 0, s = 0; s < r.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + (0 | r.words[s]) + n), n = e >>> 26;
      }

      for (; 0 !== n && s < i.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + n), n = e >>> 26;
      }

      if (this.length = i.length, 0 !== n) this.words[this.length] = n, this.length++;else if (i !== this) for (; s < i.length; s++) {
        this.words[s] = i.words[s];
      }
      return this;
    }, n.prototype.add = function (t) {
      var e;
      return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
    }, n.prototype.isub = function (t) {
      if (0 !== t.negative) {
        t.negative = 0;
        var e = this.iadd(t);
        return t.negative = 1, e._normSign();
      }

      if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
      var i,
          r,
          n = this.cmp(t);
      if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      n > 0 ? (i = this, r = t) : (i = t, r = this);

      for (var s = 0, o = 0; o < r.length; o++) {
        s = (e = (0 | i.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      for (; 0 !== s && o < i.length; o++) {
        s = (e = (0 | i.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      if (0 === s && o < i.length && i !== this) for (; o < i.length; o++) {
        this.words[o] = i.words[o];
      }
      return this.length = Math.max(this.length, o), i !== this && (this.negative = 1), this.strip();
    }, n.prototype.sub = function (t) {
      return this.clone().isub(t);
    };

    var d = function d(t, e, i) {
      var r,
          n,
          s,
          o = t.words,
          a = e.words,
          h = i.words,
          u = 0,
          l = 0 | o[0],
          c = 8191 & l,
          d = l >>> 13,
          f = 0 | o[1],
          m = 8191 & f,
          g = f >>> 13,
          p = 0 | o[2],
          w = 8191 & p,
          v = p >>> 13,
          y = 0 | o[3],
          M = 8191 & y,
          b = y >>> 13,
          A = 0 | o[4],
          x = 8191 & A,
          E = A >>> 13,
          R = 0 | o[5],
          k = 8191 & R,
          S = R >>> 13,
          I = 0 | o[6],
          T = 8191 & I,
          O = I >>> 13,
          B = 0 | o[7],
          C = 8191 & B,
          _ = B >>> 13,
          D = 0 | o[8],
          P = 8191 & D,
          N = D >>> 13,
          L = 0 | o[9],
          W = 8191 & L,
          F = L >>> 13,
          U = 0 | a[0],
          $ = 8191 & U,
          j = U >>> 13,
          q = 0 | a[1],
          G = 8191 & q,
          z = q >>> 13,
          H = 0 | a[2],
          Z = 8191 & H,
          V = H >>> 13,
          J = 0 | a[3],
          K = 8191 & J,
          X = J >>> 13,
          Q = 0 | a[4],
          Y = 8191 & Q,
          tt = Q >>> 13,
          et = 0 | a[5],
          it = 8191 & et,
          rt = et >>> 13,
          nt = 0 | a[6],
          st = 8191 & nt,
          ot = nt >>> 13,
          at = 0 | a[7],
          ht = 8191 & at,
          ut = at >>> 13,
          lt = 0 | a[8],
          ct = 8191 & lt,
          dt = lt >>> 13,
          ft = 0 | a[9],
          mt = 8191 & ft,
          gt = ft >>> 13;

      i.negative = t.negative ^ e.negative, i.length = 19;
      var pt = (u + (r = Math.imul(c, $)) | 0) + ((8191 & (n = (n = Math.imul(c, j)) + Math.imul(d, $) | 0)) << 13) | 0;
      u = ((s = Math.imul(d, j)) + (n >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, r = Math.imul(m, $), n = (n = Math.imul(m, j)) + Math.imul(g, $) | 0, s = Math.imul(g, j);
      var wt = (u + (r = r + Math.imul(c, G) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, z) | 0) + Math.imul(d, G) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, z) | 0) + (n >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, r = Math.imul(w, $), n = (n = Math.imul(w, j)) + Math.imul(v, $) | 0, s = Math.imul(v, j), r = r + Math.imul(m, G) | 0, n = (n = n + Math.imul(m, z) | 0) + Math.imul(g, G) | 0, s = s + Math.imul(g, z) | 0;
      var vt = (u + (r = r + Math.imul(c, Z) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, V) | 0) + Math.imul(d, Z) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, V) | 0) + (n >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, r = Math.imul(M, $), n = (n = Math.imul(M, j)) + Math.imul(b, $) | 0, s = Math.imul(b, j), r = r + Math.imul(w, G) | 0, n = (n = n + Math.imul(w, z) | 0) + Math.imul(v, G) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(m, Z) | 0, n = (n = n + Math.imul(m, V) | 0) + Math.imul(g, Z) | 0, s = s + Math.imul(g, V) | 0;
      var yt = (u + (r = r + Math.imul(c, K) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, X) | 0) + Math.imul(d, K) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, X) | 0) + (n >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, r = Math.imul(x, $), n = (n = Math.imul(x, j)) + Math.imul(E, $) | 0, s = Math.imul(E, j), r = r + Math.imul(M, G) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(b, G) | 0, s = s + Math.imul(b, z) | 0, r = r + Math.imul(w, Z) | 0, n = (n = n + Math.imul(w, V) | 0) + Math.imul(v, Z) | 0, s = s + Math.imul(v, V) | 0, r = r + Math.imul(m, K) | 0, n = (n = n + Math.imul(m, X) | 0) + Math.imul(g, K) | 0, s = s + Math.imul(g, X) | 0;
      var Mt = (u + (r = r + Math.imul(c, Y) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, tt) | 0) + Math.imul(d, Y) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, tt) | 0) + (n >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, r = Math.imul(k, $), n = (n = Math.imul(k, j)) + Math.imul(S, $) | 0, s = Math.imul(S, j), r = r + Math.imul(x, G) | 0, n = (n = n + Math.imul(x, z) | 0) + Math.imul(E, G) | 0, s = s + Math.imul(E, z) | 0, r = r + Math.imul(M, Z) | 0, n = (n = n + Math.imul(M, V) | 0) + Math.imul(b, Z) | 0, s = s + Math.imul(b, V) | 0, r = r + Math.imul(w, K) | 0, n = (n = n + Math.imul(w, X) | 0) + Math.imul(v, K) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(m, Y) | 0, n = (n = n + Math.imul(m, tt) | 0) + Math.imul(g, Y) | 0, s = s + Math.imul(g, tt) | 0;
      var bt = (u + (r = r + Math.imul(c, it) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, rt) | 0) + Math.imul(d, it) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, rt) | 0) + (n >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, r = Math.imul(T, $), n = (n = Math.imul(T, j)) + Math.imul(O, $) | 0, s = Math.imul(O, j), r = r + Math.imul(k, G) | 0, n = (n = n + Math.imul(k, z) | 0) + Math.imul(S, G) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(x, Z) | 0, n = (n = n + Math.imul(x, V) | 0) + Math.imul(E, Z) | 0, s = s + Math.imul(E, V) | 0, r = r + Math.imul(M, K) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(b, K) | 0, s = s + Math.imul(b, X) | 0, r = r + Math.imul(w, Y) | 0, n = (n = n + Math.imul(w, tt) | 0) + Math.imul(v, Y) | 0, s = s + Math.imul(v, tt) | 0, r = r + Math.imul(m, it) | 0, n = (n = n + Math.imul(m, rt) | 0) + Math.imul(g, it) | 0, s = s + Math.imul(g, rt) | 0;
      var At = (u + (r = r + Math.imul(c, st) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ot) | 0) + Math.imul(d, st) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ot) | 0) + (n >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, r = Math.imul(C, $), n = (n = Math.imul(C, j)) + Math.imul(_, $) | 0, s = Math.imul(_, j), r = r + Math.imul(T, G) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(O, G) | 0, s = s + Math.imul(O, z) | 0, r = r + Math.imul(k, Z) | 0, n = (n = n + Math.imul(k, V) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, V) | 0, r = r + Math.imul(x, K) | 0, n = (n = n + Math.imul(x, X) | 0) + Math.imul(E, K) | 0, s = s + Math.imul(E, X) | 0, r = r + Math.imul(M, Y) | 0, n = (n = n + Math.imul(M, tt) | 0) + Math.imul(b, Y) | 0, s = s + Math.imul(b, tt) | 0, r = r + Math.imul(w, it) | 0, n = (n = n + Math.imul(w, rt) | 0) + Math.imul(v, it) | 0, s = s + Math.imul(v, rt) | 0, r = r + Math.imul(m, st) | 0, n = (n = n + Math.imul(m, ot) | 0) + Math.imul(g, st) | 0, s = s + Math.imul(g, ot) | 0;
      var xt = (u + (r = r + Math.imul(c, ht) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ut) | 0) + Math.imul(d, ht) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ut) | 0) + (n >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, r = Math.imul(P, $), n = (n = Math.imul(P, j)) + Math.imul(N, $) | 0, s = Math.imul(N, j), r = r + Math.imul(C, G) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(_, G) | 0, s = s + Math.imul(_, z) | 0, r = r + Math.imul(T, Z) | 0, n = (n = n + Math.imul(T, V) | 0) + Math.imul(O, Z) | 0, s = s + Math.imul(O, V) | 0, r = r + Math.imul(k, K) | 0, n = (n = n + Math.imul(k, X) | 0) + Math.imul(S, K) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(x, Y) | 0, n = (n = n + Math.imul(x, tt) | 0) + Math.imul(E, Y) | 0, s = s + Math.imul(E, tt) | 0, r = r + Math.imul(M, it) | 0, n = (n = n + Math.imul(M, rt) | 0) + Math.imul(b, it) | 0, s = s + Math.imul(b, rt) | 0, r = r + Math.imul(w, st) | 0, n = (n = n + Math.imul(w, ot) | 0) + Math.imul(v, st) | 0, s = s + Math.imul(v, ot) | 0, r = r + Math.imul(m, ht) | 0, n = (n = n + Math.imul(m, ut) | 0) + Math.imul(g, ht) | 0, s = s + Math.imul(g, ut) | 0;
      var Et = (u + (r = r + Math.imul(c, ct) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, dt) | 0) + Math.imul(d, ct) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, dt) | 0) + (n >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, r = Math.imul(W, $), n = (n = Math.imul(W, j)) + Math.imul(F, $) | 0, s = Math.imul(F, j), r = r + Math.imul(P, G) | 0, n = (n = n + Math.imul(P, z) | 0) + Math.imul(N, G) | 0, s = s + Math.imul(N, z) | 0, r = r + Math.imul(C, Z) | 0, n = (n = n + Math.imul(C, V) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, V) | 0, r = r + Math.imul(T, K) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(O, K) | 0, s = s + Math.imul(O, X) | 0, r = r + Math.imul(k, Y) | 0, n = (n = n + Math.imul(k, tt) | 0) + Math.imul(S, Y) | 0, s = s + Math.imul(S, tt) | 0, r = r + Math.imul(x, it) | 0, n = (n = n + Math.imul(x, rt) | 0) + Math.imul(E, it) | 0, s = s + Math.imul(E, rt) | 0, r = r + Math.imul(M, st) | 0, n = (n = n + Math.imul(M, ot) | 0) + Math.imul(b, st) | 0, s = s + Math.imul(b, ot) | 0, r = r + Math.imul(w, ht) | 0, n = (n = n + Math.imul(w, ut) | 0) + Math.imul(v, ht) | 0, s = s + Math.imul(v, ut) | 0, r = r + Math.imul(m, ct) | 0, n = (n = n + Math.imul(m, dt) | 0) + Math.imul(g, ct) | 0, s = s + Math.imul(g, dt) | 0;
      var Rt = (u + (r = r + Math.imul(c, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, gt) | 0) + Math.imul(d, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, gt) | 0) + (n >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, z)) + Math.imul(F, G) | 0, s = Math.imul(F, z), r = r + Math.imul(P, Z) | 0, n = (n = n + Math.imul(P, V) | 0) + Math.imul(N, Z) | 0, s = s + Math.imul(N, V) | 0, r = r + Math.imul(C, K) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(_, K) | 0, s = s + Math.imul(_, X) | 0, r = r + Math.imul(T, Y) | 0, n = (n = n + Math.imul(T, tt) | 0) + Math.imul(O, Y) | 0, s = s + Math.imul(O, tt) | 0, r = r + Math.imul(k, it) | 0, n = (n = n + Math.imul(k, rt) | 0) + Math.imul(S, it) | 0, s = s + Math.imul(S, rt) | 0, r = r + Math.imul(x, st) | 0, n = (n = n + Math.imul(x, ot) | 0) + Math.imul(E, st) | 0, s = s + Math.imul(E, ot) | 0, r = r + Math.imul(M, ht) | 0, n = (n = n + Math.imul(M, ut) | 0) + Math.imul(b, ht) | 0, s = s + Math.imul(b, ut) | 0, r = r + Math.imul(w, ct) | 0, n = (n = n + Math.imul(w, dt) | 0) + Math.imul(v, ct) | 0, s = s + Math.imul(v, dt) | 0;
      var kt = (u + (r = r + Math.imul(m, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(m, gt) | 0) + Math.imul(g, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(g, gt) | 0) + (n >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, r = Math.imul(W, Z), n = (n = Math.imul(W, V)) + Math.imul(F, Z) | 0, s = Math.imul(F, V), r = r + Math.imul(P, K) | 0, n = (n = n + Math.imul(P, X) | 0) + Math.imul(N, K) | 0, s = s + Math.imul(N, X) | 0, r = r + Math.imul(C, Y) | 0, n = (n = n + Math.imul(C, tt) | 0) + Math.imul(_, Y) | 0, s = s + Math.imul(_, tt) | 0, r = r + Math.imul(T, it) | 0, n = (n = n + Math.imul(T, rt) | 0) + Math.imul(O, it) | 0, s = s + Math.imul(O, rt) | 0, r = r + Math.imul(k, st) | 0, n = (n = n + Math.imul(k, ot) | 0) + Math.imul(S, st) | 0, s = s + Math.imul(S, ot) | 0, r = r + Math.imul(x, ht) | 0, n = (n = n + Math.imul(x, ut) | 0) + Math.imul(E, ht) | 0, s = s + Math.imul(E, ut) | 0, r = r + Math.imul(M, ct) | 0, n = (n = n + Math.imul(M, dt) | 0) + Math.imul(b, ct) | 0, s = s + Math.imul(b, dt) | 0;
      var St = (u + (r = r + Math.imul(w, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(w, gt) | 0) + Math.imul(v, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(v, gt) | 0) + (n >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, r = Math.imul(W, K), n = (n = Math.imul(W, X)) + Math.imul(F, K) | 0, s = Math.imul(F, X), r = r + Math.imul(P, Y) | 0, n = (n = n + Math.imul(P, tt) | 0) + Math.imul(N, Y) | 0, s = s + Math.imul(N, tt) | 0, r = r + Math.imul(C, it) | 0, n = (n = n + Math.imul(C, rt) | 0) + Math.imul(_, it) | 0, s = s + Math.imul(_, rt) | 0, r = r + Math.imul(T, st) | 0, n = (n = n + Math.imul(T, ot) | 0) + Math.imul(O, st) | 0, s = s + Math.imul(O, ot) | 0, r = r + Math.imul(k, ht) | 0, n = (n = n + Math.imul(k, ut) | 0) + Math.imul(S, ht) | 0, s = s + Math.imul(S, ut) | 0, r = r + Math.imul(x, ct) | 0, n = (n = n + Math.imul(x, dt) | 0) + Math.imul(E, ct) | 0, s = s + Math.imul(E, dt) | 0;
      var It = (u + (r = r + Math.imul(M, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, gt) | 0) + Math.imul(b, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(b, gt) | 0) + (n >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, r = Math.imul(W, Y), n = (n = Math.imul(W, tt)) + Math.imul(F, Y) | 0, s = Math.imul(F, tt), r = r + Math.imul(P, it) | 0, n = (n = n + Math.imul(P, rt) | 0) + Math.imul(N, it) | 0, s = s + Math.imul(N, rt) | 0, r = r + Math.imul(C, st) | 0, n = (n = n + Math.imul(C, ot) | 0) + Math.imul(_, st) | 0, s = s + Math.imul(_, ot) | 0, r = r + Math.imul(T, ht) | 0, n = (n = n + Math.imul(T, ut) | 0) + Math.imul(O, ht) | 0, s = s + Math.imul(O, ut) | 0, r = r + Math.imul(k, ct) | 0, n = (n = n + Math.imul(k, dt) | 0) + Math.imul(S, ct) | 0, s = s + Math.imul(S, dt) | 0;
      var Tt = (u + (r = r + Math.imul(x, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(x, gt) | 0) + Math.imul(E, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(E, gt) | 0) + (n >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, r = Math.imul(W, it), n = (n = Math.imul(W, rt)) + Math.imul(F, it) | 0, s = Math.imul(F, rt), r = r + Math.imul(P, st) | 0, n = (n = n + Math.imul(P, ot) | 0) + Math.imul(N, st) | 0, s = s + Math.imul(N, ot) | 0, r = r + Math.imul(C, ht) | 0, n = (n = n + Math.imul(C, ut) | 0) + Math.imul(_, ht) | 0, s = s + Math.imul(_, ut) | 0, r = r + Math.imul(T, ct) | 0, n = (n = n + Math.imul(T, dt) | 0) + Math.imul(O, ct) | 0, s = s + Math.imul(O, dt) | 0;
      var Ot = (u + (r = r + Math.imul(k, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(k, gt) | 0) + Math.imul(S, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(S, gt) | 0) + (n >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, r = Math.imul(W, st), n = (n = Math.imul(W, ot)) + Math.imul(F, st) | 0, s = Math.imul(F, ot), r = r + Math.imul(P, ht) | 0, n = (n = n + Math.imul(P, ut) | 0) + Math.imul(N, ht) | 0, s = s + Math.imul(N, ut) | 0, r = r + Math.imul(C, ct) | 0, n = (n = n + Math.imul(C, dt) | 0) + Math.imul(_, ct) | 0, s = s + Math.imul(_, dt) | 0;
      var Bt = (u + (r = r + Math.imul(T, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, gt) | 0) + Math.imul(O, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(O, gt) | 0) + (n >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, r = Math.imul(W, ht), n = (n = Math.imul(W, ut)) + Math.imul(F, ht) | 0, s = Math.imul(F, ut), r = r + Math.imul(P, ct) | 0, n = (n = n + Math.imul(P, dt) | 0) + Math.imul(N, ct) | 0, s = s + Math.imul(N, dt) | 0;
      var Ct = (u + (r = r + Math.imul(C, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, gt) | 0) + Math.imul(_, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(_, gt) | 0) + (n >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, r = Math.imul(W, ct), n = (n = Math.imul(W, dt)) + Math.imul(F, ct) | 0, s = Math.imul(F, dt);

      var _t = (u + (r = r + Math.imul(P, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(P, gt) | 0) + Math.imul(N, mt) | 0)) << 13) | 0;

      u = ((s = s + Math.imul(N, gt) | 0) + (n >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863;
      var Dt = (u + (r = Math.imul(W, mt)) | 0) + ((8191 & (n = (n = Math.imul(W, gt)) + Math.imul(F, mt) | 0)) << 13) | 0;
      return u = ((s = Math.imul(F, gt)) + (n >>> 13) | 0) + (Dt >>> 26) | 0, Dt &= 67108863, h[0] = pt, h[1] = wt, h[2] = vt, h[3] = yt, h[4] = Mt, h[5] = bt, h[6] = At, h[7] = xt, h[8] = Et, h[9] = Rt, h[10] = kt, h[11] = St, h[12] = It, h[13] = Tt, h[14] = Ot, h[15] = Bt, h[16] = Ct, h[17] = _t, h[18] = Dt, 0 !== u && (h[19] = u, i.length++), i;
    };

    function f(t, e, i) {
      return new m().mulp(t, e, i);
    }

    function m(t, e) {
      this.x = t, this.y = e;
    }

    Math.imul || (d = c), n.prototype.mulTo = function (t, e) {
      var i = this.length + t.length;
      return 10 === this.length && 10 === t.length ? d(this, t, e) : i < 63 ? c(this, t, e) : i < 1024 ? function (t, e, i) {
        i.negative = e.negative ^ t.negative, i.length = t.length + e.length;

        for (var r = 0, n = 0, s = 0; s < i.length - 1; s++) {
          var o = n;
          n = 0;

          for (var a = 67108863 & r, h = Math.min(s, e.length - 1), u = Math.max(0, s - t.length + 1); u <= h; u++) {
            var l = (0 | t.words[s - u]) * (0 | e.words[u]),
                c = 67108863 & l;
            a = 67108863 & (c = c + a | 0), n += (o = (o = o + (l / 67108864 | 0) | 0) + (c >>> 26) | 0) >>> 26, o &= 67108863;
          }

          i.words[s] = a, r = o, o = n;
        }

        return 0 !== r ? i.words[s] = r : i.length--, i.strip();
      }(this, t, e) : f(this, t, e);
    }, m.prototype.makeRBT = function (t) {
      for (var e = new Array(t), i = n.prototype._countBits(t) - 1, r = 0; r < t; r++) {
        e[r] = this.revBin(r, i, t);
      }

      return e;
    }, m.prototype.revBin = function (t, e, i) {
      if (0 === t || t === i - 1) return t;

      for (var r = 0, n = 0; n < e; n++) {
        r |= (1 & t) << e - n - 1, t >>= 1;
      }

      return r;
    }, m.prototype.permute = function (t, e, i, r, n, s) {
      for (var o = 0; o < s; o++) {
        r[o] = e[t[o]], n[o] = i[t[o]];
      }
    }, m.prototype.transform = function (t, e, i, r, n, s) {
      this.permute(s, t, e, i, r, n);

      for (var o = 1; o < n; o <<= 1) {
        for (var a = o << 1, h = Math.cos(2 * Math.PI / a), u = Math.sin(2 * Math.PI / a), l = 0; l < n; l += a) {
          for (var c = h, d = u, f = 0; f < o; f++) {
            var m = i[l + f],
                g = r[l + f],
                p = i[l + f + o],
                w = r[l + f + o],
                v = c * p - d * w;
            w = c * w + d * p, i[l + f] = m + (p = v), r[l + f] = g + w, i[l + f + o] = m - p, r[l + f + o] = g - w, f !== a && (v = h * c - u * d, d = h * d + u * c, c = v);
          }
        }
      }
    }, m.prototype.guessLen13b = function (t, e) {
      var i = 1 | Math.max(e, t),
          r = 1 & i,
          n = 0;

      for (i = i / 2 | 0; i; i >>>= 1) {
        n++;
      }

      return 1 << n + 1 + r;
    }, m.prototype.conjugate = function (t, e, i) {
      if (!(i <= 1)) for (var r = 0; r < i / 2; r++) {
        var n = t[r];
        t[r] = t[i - r - 1], t[i - r - 1] = n, n = e[r], e[r] = -e[i - r - 1], e[i - r - 1] = -n;
      }
    }, m.prototype.normalize13b = function (t, e) {
      for (var i = 0, r = 0; r < e / 2; r++) {
        var n = 8192 * Math.round(t[2 * r + 1] / e) + Math.round(t[2 * r] / e) + i;
        t[r] = 67108863 & n, i = n < 67108864 ? 0 : n / 67108864 | 0;
      }

      return t;
    }, m.prototype.convert13b = function (t, e, r, n) {
      for (var s = 0, o = 0; o < e; o++) {
        r[2 * o] = 8191 & (s += 0 | t[o]), r[2 * o + 1] = 8191 & (s >>>= 13), s >>>= 13;
      }

      for (o = 2 * e; o < n; ++o) {
        r[o] = 0;
      }

      i(0 === s), i(0 == (-8192 & s));
    }, m.prototype.stub = function (t) {
      for (var e = new Array(t), i = 0; i < t; i++) {
        e[i] = 0;
      }

      return e;
    }, m.prototype.mulp = function (t, e, i) {
      var r = 2 * this.guessLen13b(t.length, e.length),
          n = this.makeRBT(r),
          s = this.stub(r),
          o = new Array(r),
          a = new Array(r),
          h = new Array(r),
          u = new Array(r),
          l = new Array(r),
          c = new Array(r),
          d = i.words;
      d.length = r, this.convert13b(t.words, t.length, o, r), this.convert13b(e.words, e.length, u, r), this.transform(o, s, a, h, r, n), this.transform(u, s, l, c, r, n);

      for (var f = 0; f < r; f++) {
        var m = a[f] * l[f] - h[f] * c[f];
        h[f] = a[f] * c[f] + h[f] * l[f], a[f] = m;
      }

      return this.conjugate(a, h, r), this.transform(a, h, d, s, r, n), this.conjugate(d, s, r), this.normalize13b(d, r), i.negative = t.negative ^ e.negative, i.length = t.length + e.length, i.strip();
    }, n.prototype.mul = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), this.mulTo(t, e);
    }, n.prototype.mulf = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), f(this, t, e);
    }, n.prototype.imul = function (t) {
      return this.clone().mulTo(t, this);
    }, n.prototype.imuln = function (t) {
      i("number" == typeof t), i(t < 67108864);

      for (var e = 0, r = 0; r < this.length; r++) {
        var n = (0 | this.words[r]) * t,
            s = (67108863 & n) + (67108863 & e);
        e >>= 26, e += n / 67108864 | 0, e += s >>> 26, this.words[r] = 67108863 & s;
      }

      return 0 !== e && (this.words[r] = e, this.length++), this;
    }, n.prototype.muln = function (t) {
      return this.clone().imuln(t);
    }, n.prototype.sqr = function () {
      return this.mul(this);
    }, n.prototype.isqr = function () {
      return this.imul(this.clone());
    }, n.prototype.pow = function (t) {
      var e = function (t) {
        for (var e = new Array(t.bitLength()), i = 0; i < e.length; i++) {
          var r = i % 26;
          e[i] = (t.words[i / 26 | 0] & 1 << r) >>> r;
        }

        return e;
      }(t);

      if (0 === e.length) return new n(1);

      for (var i = this, r = 0; r < e.length && 0 === e[r]; r++, i = i.sqr()) {
        ;
      }

      if (++r < e.length) for (var s = i.sqr(); r < e.length; r++, s = s.sqr()) {
        0 !== e[r] && (i = i.mul(s));
      }
      return i;
    }, n.prototype.iushln = function (t) {
      i("number" == typeof t && t >= 0);
      var e,
          r = t % 26,
          n = (t - r) / 26,
          s = 67108863 >>> 26 - r << 26 - r;

      if (0 !== r) {
        var o = 0;

        for (e = 0; e < this.length; e++) {
          var a = this.words[e] & s;
          this.words[e] = (0 | this.words[e]) - a << r | o, o = a >>> 26 - r;
        }

        o && (this.words[e] = o, this.length++);
      }

      if (0 !== n) {
        for (e = this.length - 1; e >= 0; e--) {
          this.words[e + n] = this.words[e];
        }

        for (e = 0; e < n; e++) {
          this.words[e] = 0;
        }

        this.length += n;
      }

      return this.strip();
    }, n.prototype.ishln = function (t) {
      return i(0 === this.negative), this.iushln(t);
    }, n.prototype.iushrn = function (t, e, r) {
      var n;
      i("number" == typeof t && t >= 0), n = e ? (e - e % 26) / 26 : 0;
      var s = t % 26,
          o = Math.min((t - s) / 26, this.length),
          a = 67108863 ^ 67108863 >>> s << s,
          h = r;

      if (n -= o, n = Math.max(0, n), h) {
        for (var u = 0; u < o; u++) {
          h.words[u] = this.words[u];
        }

        h.length = o;
      }

      if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
        this.words[u] = this.words[u + o];
      } else this.words[0] = 0, this.length = 1;
      var l = 0;

      for (u = this.length - 1; u >= 0 && (0 !== l || u >= n); u--) {
        var c = 0 | this.words[u];
        this.words[u] = l << 26 - s | c >>> s, l = c & a;
      }

      return h && 0 !== l && (h.words[h.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
    }, n.prototype.ishrn = function (t, e, r) {
      return i(0 === this.negative), this.iushrn(t, e, r);
    }, n.prototype.shln = function (t) {
      return this.clone().ishln(t);
    }, n.prototype.ushln = function (t) {
      return this.clone().iushln(t);
    }, n.prototype.shrn = function (t) {
      return this.clone().ishrn(t);
    }, n.prototype.ushrn = function (t) {
      return this.clone().iushrn(t);
    }, n.prototype.testn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return !(this.length <= r || !(this.words[r] & 1 << e));
    }, n.prototype.imaskn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return i(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r ? this : (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e && (this.words[this.length - 1] &= 67108863 ^ 67108863 >>> e << e), this.strip());
    }, n.prototype.maskn = function (t) {
      return this.clone().imaskn(t);
    }, n.prototype.iaddn = function (t) {
      return i("number" == typeof t), i(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
    }, n.prototype._iaddn = function (t) {
      this.words[0] += t;

      for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
        this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
      }

      return this.length = Math.max(this.length, e + 1), this;
    }, n.prototype.isubn = function (t) {
      if (i("number" == typeof t), i(t < 67108864), t < 0) return this.iaddn(-t);
      if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
      if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
        this.words[e] += 67108864, this.words[e + 1] -= 1;
      }
      return this.strip();
    }, n.prototype.addn = function (t) {
      return this.clone().iaddn(t);
    }, n.prototype.subn = function (t) {
      return this.clone().isubn(t);
    }, n.prototype.iabs = function () {
      return this.negative = 0, this;
    }, n.prototype.abs = function () {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function (t, e, r) {
      var n, s;

      this._expand(t.length + r);

      var o = 0;

      for (n = 0; n < t.length; n++) {
        s = (0 | this.words[n + r]) + o;
        var a = (0 | t.words[n]) * e;
        o = ((s -= 67108863 & a) >> 26) - (a / 67108864 | 0), this.words[n + r] = 67108863 & s;
      }

      for (; n < this.length - r; n++) {
        o = (s = (0 | this.words[n + r]) + o) >> 26, this.words[n + r] = 67108863 & s;
      }

      if (0 === o) return this.strip();

      for (i(-1 === o), o = 0, n = 0; n < this.length; n++) {
        o = (s = -(0 | this.words[n]) + o) >> 26, this.words[n] = 67108863 & s;
      }

      return this.negative = 1, this.strip();
    }, n.prototype._wordDiv = function (t, e) {
      var i,
          r = this.clone(),
          s = t,
          o = 0 | s.words[s.length - 1];
      0 != (i = 26 - this._countBits(o)) && (s = s.ushln(i), r.iushln(i), o = 0 | s.words[s.length - 1]);
      var a,
          h = r.length - s.length;

      if ("mod" !== e) {
        (a = new n(null)).length = h + 1, a.words = new Array(a.length);

        for (var u = 0; u < a.length; u++) {
          a.words[u] = 0;
        }
      }

      var l = r.clone()._ishlnsubmul(s, 1, h);

      0 === l.negative && (r = l, a && (a.words[h] = 1));

      for (var c = h - 1; c >= 0; c--) {
        var d = 67108864 * (0 | r.words[s.length + c]) + (0 | r.words[s.length + c - 1]);

        for (d = Math.min(d / o | 0, 67108863), r._ishlnsubmul(s, d, c); 0 !== r.negative;) {
          d--, r.negative = 0, r._ishlnsubmul(s, 1, c), r.isZero() || (r.negative ^= 1);
        }

        a && (a.words[c] = d);
      }

      return a && a.strip(), r.strip(), "div" !== e && 0 !== i && r.iushrn(i), {
        div: a || null,
        mod: r
      };
    }, n.prototype.divmod = function (t, e, r) {
      return i(!t.isZero()), this.isZero() ? {
        div: new n(0),
        mod: new n(0)
      } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (s = a.div.neg()), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(t)), {
        div: s,
        mod: o
      }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (s = a.div.neg()), {
        div: s,
        mod: a.mod
      }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(t)), {
        div: a.div,
        mod: o
      }) : t.length > this.length || this.cmp(t) < 0 ? {
        div: new n(0),
        mod: this
      } : 1 === t.length ? "div" === e ? {
        div: this.divn(t.words[0]),
        mod: null
      } : "mod" === e ? {
        div: null,
        mod: new n(this.modn(t.words[0]))
      } : {
        div: this.divn(t.words[0]),
        mod: new n(this.modn(t.words[0]))
      } : this._wordDiv(t, e);
      var s, o, a;
    }, n.prototype.div = function (t) {
      return this.divmod(t, "div", !1).div;
    }, n.prototype.mod = function (t) {
      return this.divmod(t, "mod", !1).mod;
    }, n.prototype.umod = function (t) {
      return this.divmod(t, "mod", !0).mod;
    }, n.prototype.divRound = function (t) {
      var e = this.divmod(t);
      if (e.mod.isZero()) return e.div;
      var i = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
          r = t.ushrn(1),
          n = t.andln(1),
          s = i.cmp(r);
      return s < 0 || 1 === n && 0 === s ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
    }, n.prototype.modn = function (t) {
      i(t <= 67108863);

      for (var e = (1 << 26) % t, r = 0, n = this.length - 1; n >= 0; n--) {
        r = (e * r + (0 | this.words[n])) % t;
      }

      return r;
    }, n.prototype.idivn = function (t) {
      i(t <= 67108863);

      for (var e = 0, r = this.length - 1; r >= 0; r--) {
        var n = (0 | this.words[r]) + 67108864 * e;
        this.words[r] = n / t | 0, e = n % t;
      }

      return this.strip();
    }, n.prototype.divn = function (t) {
      return this.clone().idivn(t);
    }, n.prototype.egcd = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s = new n(1), o = new n(0), a = new n(0), h = new n(1), u = 0; e.isEven() && r.isEven();) {
        e.iushrn(1), r.iushrn(1), ++u;
      }

      for (var l = r.clone(), c = e.clone(); !e.isZero();) {
        for (var d = 0, f = 1; 0 == (e.words[0] & f) && d < 26; ++d, f <<= 1) {
          ;
        }

        if (d > 0) for (e.iushrn(d); d-- > 0;) {
          (s.isOdd() || o.isOdd()) && (s.iadd(l), o.isub(c)), s.iushrn(1), o.iushrn(1);
        }

        for (var m = 0, g = 1; 0 == (r.words[0] & g) && m < 26; ++m, g <<= 1) {
          ;
        }

        if (m > 0) for (r.iushrn(m); m-- > 0;) {
          (a.isOdd() || h.isOdd()) && (a.iadd(l), h.isub(c)), a.iushrn(1), h.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), s.isub(a), o.isub(h)) : (r.isub(e), a.isub(s), h.isub(o));
      }

      return {
        a: a,
        b: h,
        gcd: r.iushln(u)
      };
    }, n.prototype._invmp = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s, o = new n(1), a = new n(0), h = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
        for (var u = 0, l = 1; 0 == (e.words[0] & l) && u < 26; ++u, l <<= 1) {
          ;
        }

        if (u > 0) for (e.iushrn(u); u-- > 0;) {
          o.isOdd() && o.iadd(h), o.iushrn(1);
        }

        for (var c = 0, d = 1; 0 == (r.words[0] & d) && c < 26; ++c, d <<= 1) {
          ;
        }

        if (c > 0) for (r.iushrn(c); c-- > 0;) {
          a.isOdd() && a.iadd(h), a.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), o.isub(a)) : (r.isub(e), a.isub(o));
      }

      return (s = 0 === e.cmpn(1) ? o : a).cmpn(0) < 0 && s.iadd(t), s;
    }, n.prototype.gcd = function (t) {
      if (this.isZero()) return t.abs();
      if (t.isZero()) return this.abs();
      var e = this.clone(),
          i = t.clone();
      e.negative = 0, i.negative = 0;

      for (var r = 0; e.isEven() && i.isEven(); r++) {
        e.iushrn(1), i.iushrn(1);
      }

      for (;;) {
        for (; e.isEven();) {
          e.iushrn(1);
        }

        for (; i.isEven();) {
          i.iushrn(1);
        }

        var n = e.cmp(i);

        if (n < 0) {
          var s = e;
          e = i, i = s;
        } else if (0 === n || 0 === i.cmpn(1)) break;

        e.isub(i);
      }

      return i.iushln(r);
    }, n.prototype.invm = function (t) {
      return this.egcd(t).a.umod(t);
    }, n.prototype.isEven = function () {
      return 0 == (1 & this.words[0]);
    }, n.prototype.isOdd = function () {
      return 1 == (1 & this.words[0]);
    }, n.prototype.andln = function (t) {
      return this.words[0] & t;
    }, n.prototype.bincn = function (t) {
      i("number" == typeof t);
      var e = t % 26,
          r = (t - e) / 26,
          n = 1 << e;
      if (this.length <= r) return this._expand(r + 1), this.words[r] |= n, this;

      for (var s = n, o = r; 0 !== s && o < this.length; o++) {
        var a = 0 | this.words[o];
        s = (a += s) >>> 26, this.words[o] = a &= 67108863;
      }

      return 0 !== s && (this.words[o] = s, this.length++), this;
    }, n.prototype.isZero = function () {
      return 1 === this.length && 0 === this.words[0];
    }, n.prototype.cmpn = function (t) {
      var e,
          r = t < 0;
      if (0 !== this.negative && !r) return -1;
      if (0 === this.negative && r) return 1;
      if (this.strip(), this.length > 1) e = 1;else {
        r && (t = -t), i(t <= 67108863, "Number is too big");
        var n = 0 | this.words[0];
        e = n === t ? 0 : n < t ? -1 : 1;
      }
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.cmp = function (t) {
      if (0 !== this.negative && 0 === t.negative) return -1;
      if (0 === this.negative && 0 !== t.negative) return 1;
      var e = this.ucmp(t);
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.ucmp = function (t) {
      if (this.length > t.length) return 1;
      if (this.length < t.length) return -1;

      for (var e = 0, i = this.length - 1; i >= 0; i--) {
        var r = 0 | this.words[i],
            n = 0 | t.words[i];

        if (r !== n) {
          r < n ? e = -1 : r > n && (e = 1);
          break;
        }
      }

      return e;
    }, n.prototype.gtn = function (t) {
      return 1 === this.cmpn(t);
    }, n.prototype.gt = function (t) {
      return 1 === this.cmp(t);
    }, n.prototype.gten = function (t) {
      return this.cmpn(t) >= 0;
    }, n.prototype.gte = function (t) {
      return this.cmp(t) >= 0;
    }, n.prototype.ltn = function (t) {
      return -1 === this.cmpn(t);
    }, n.prototype.lt = function (t) {
      return -1 === this.cmp(t);
    }, n.prototype.lten = function (t) {
      return this.cmpn(t) <= 0;
    }, n.prototype.lte = function (t) {
      return this.cmp(t) <= 0;
    }, n.prototype.eqn = function (t) {
      return 0 === this.cmpn(t);
    }, n.prototype.eq = function (t) {
      return 0 === this.cmp(t);
    }, n.red = function (t) {
      return new b(t);
    }, n.prototype.toRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), i(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
    }, n.prototype.fromRed = function () {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function (t) {
      return this.red = t, this;
    }, n.prototype.forceRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(t);
    }, n.prototype.redAdd = function (t) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
    }, n.prototype.redIAdd = function (t) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
    }, n.prototype.redSub = function (t) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
    }, n.prototype.redISub = function (t) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
    }, n.prototype.redShl = function (t) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
    }, n.prototype.redMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
    }, n.prototype.redIMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
    }, n.prototype.redSqr = function () {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function () {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function () {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function () {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function () {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function (t) {
      return i(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
    };
    var g = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };

    function p(t, e) {
      this.name = t, this.p = new n(e, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }

    function w() {
      p.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }

    function v() {
      p.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }

    function y() {
      p.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }

    function M() {
      p.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }

    function b(t) {
      if ("string" == typeof t) {
        var e = n._prime(t);

        this.m = e.p, this.prime = e;
      } else i(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
    }

    function A(t) {
      b.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }

    p.prototype._tmp = function () {
      var t = new n(null);
      return t.words = new Array(Math.ceil(this.n / 13)), t;
    }, p.prototype.ireduce = function (t) {
      var e,
          i = t;

      do {
        this.split(i, this.tmp), e = (i = (i = this.imulK(i)).iadd(this.tmp)).bitLength();
      } while (e > this.n);

      var r = e < this.n ? -1 : i.ucmp(this.p);
      return 0 === r ? (i.words[0] = 0, i.length = 1) : r > 0 ? i.isub(this.p) : i.strip(), i;
    }, p.prototype.split = function (t, e) {
      t.iushrn(this.n, 0, e);
    }, p.prototype.imulK = function (t) {
      return t.imul(this.k);
    }, r(w, p), w.prototype.split = function (t, e) {
      for (var i = 4194303, r = Math.min(t.length, 9), n = 0; n < r; n++) {
        e.words[n] = t.words[n];
      }

      if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
      var s = t.words[9];

      for (e.words[e.length++] = s & i, n = 10; n < t.length; n++) {
        var o = 0 | t.words[n];
        t.words[n - 10] = (o & i) << 4 | s >>> 22, s = o;
      }

      t.words[n - 10] = s >>>= 22, t.length -= 0 === s && t.length > 10 ? 10 : 9;
    }, w.prototype.imulK = function (t) {
      t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 0 | t.words[i];
        t.words[i] = 67108863 & (e += 977 * r), e = 64 * r + (e / 67108864 | 0);
      }

      return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
    }, r(v, p), r(y, p), r(M, p), M.prototype.imulK = function (t) {
      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 19 * (0 | t.words[i]) + e,
            n = 67108863 & r;
        r >>>= 26, t.words[i] = n, e = r;
      }

      return 0 !== e && (t.words[t.length++] = e), t;
    }, n._prime = function (t) {
      if (g[t]) return g[t];
      var e;
      if ("k256" === t) e = new w();else if ("p224" === t) e = new v();else if ("p192" === t) e = new y();else {
        if ("p25519" !== t) throw new Error("Unknown prime " + t);
        e = new M();
      }
      return g[t] = e, e;
    }, b.prototype._verify1 = function (t) {
      i(0 === t.negative, "red works only with positives"), i(t.red, "red works only with red numbers");
    }, b.prototype._verify2 = function (t, e) {
      i(0 == (t.negative | e.negative), "red works only with positives"), i(t.red && t.red === e.red, "red works only with red numbers");
    }, b.prototype.imod = function (t) {
      return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
    }, b.prototype.neg = function (t) {
      return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
    }, b.prototype.add = function (t, e) {
      this._verify2(t, e);

      var i = t.add(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i._forceRed(this);
    }, b.prototype.iadd = function (t, e) {
      this._verify2(t, e);

      var i = t.iadd(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i;
    }, b.prototype.sub = function (t, e) {
      this._verify2(t, e);

      var i = t.sub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i._forceRed(this);
    }, b.prototype.isub = function (t, e) {
      this._verify2(t, e);

      var i = t.isub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i;
    }, b.prototype.shl = function (t, e) {
      return this._verify1(t), this.imod(t.ushln(e));
    }, b.prototype.imul = function (t, e) {
      return this._verify2(t, e), this.imod(t.imul(e));
    }, b.prototype.mul = function (t, e) {
      return this._verify2(t, e), this.imod(t.mul(e));
    }, b.prototype.isqr = function (t) {
      return this.imul(t, t.clone());
    }, b.prototype.sqr = function (t) {
      return this.mul(t, t);
    }, b.prototype.sqrt = function (t) {
      if (t.isZero()) return t.clone();
      var e = this.m.andln(3);

      if (i(e % 2 == 1), 3 === e) {
        var r = this.m.add(new n(1)).iushrn(2);
        return this.pow(t, r);
      }

      for (var s = this.m.subn(1), o = 0; !s.isZero() && 0 === s.andln(1);) {
        o++, s.iushrn(1);
      }

      i(!s.isZero());
      var a = new n(1).toRed(this),
          h = a.redNeg(),
          u = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();

      for (l = new n(2 * l * l).toRed(this); 0 !== this.pow(l, u).cmp(h);) {
        l.redIAdd(h);
      }

      for (var c = this.pow(l, s), d = this.pow(t, s.addn(1).iushrn(1)), f = this.pow(t, s), m = o; 0 !== f.cmp(a);) {
        for (var g = f, p = 0; 0 !== g.cmp(a); p++) {
          g = g.redSqr();
        }

        i(p < m);
        var w = this.pow(c, new n(1).iushln(m - p - 1));
        d = d.redMul(w), c = w.redSqr(), f = f.redMul(c), m = p;
      }

      return d;
    }, b.prototype.invm = function (t) {
      var e = t._invmp(this.m);

      return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
    }, b.prototype.pow = function (t, e) {
      if (e.isZero()) return new n(1);
      if (0 === e.cmpn(1)) return t.clone();
      var i = new Array(16);
      i[0] = new n(1).toRed(this), i[1] = t;

      for (var r = 2; r < i.length; r++) {
        i[r] = this.mul(i[r - 1], t);
      }

      var s = i[0],
          o = 0,
          a = 0,
          h = e.bitLength() % 26;

      for (0 === h && (h = 26), r = e.length - 1; r >= 0; r--) {
        for (var u = e.words[r], l = h - 1; l >= 0; l--) {
          var c = u >> l & 1;
          s !== i[0] && (s = this.sqr(s)), 0 !== c || 0 !== o ? (o <<= 1, o |= c, (4 == ++a || 0 === r && 0 === l) && (s = this.mul(s, i[o]), a = 0, o = 0)) : a = 0;
        }

        h = 26;
      }

      return s;
    }, b.prototype.convertTo = function (t) {
      var e = t.umod(this.m);
      return e === t ? e.clone() : e;
    }, b.prototype.convertFrom = function (t) {
      var e = t.clone();
      return e.red = null, e;
    }, n.mont = function (t) {
      return new A(t);
    }, r(A, b), A.prototype.convertTo = function (t) {
      return this.imod(t.ushln(this.shift));
    }, A.prototype.convertFrom = function (t) {
      var e = this.imod(t.mul(this.rinv));
      return e.red = null, e;
    }, A.prototype.imul = function (t, e) {
      if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
      var i = t.imul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          n = i.isub(r).iushrn(this.shift),
          s = n;
      return n.cmp(this.m) >= 0 ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
    }, A.prototype.mul = function (t, e) {
      if (t.isZero() || e.isZero()) return new n(0)._forceRed(this);
      var i = t.mul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          s = i.isub(r).iushrn(this.shift),
          o = s;
      return s.cmp(this.m) >= 0 ? o = s.isub(this.m) : s.cmpn(0) < 0 && (o = s.iadd(this.m)), o._forceRed(this);
    }, A.prototype.invm = function (t) {
      return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
    };
  }(t, gt);
}),
    Mt = function Mt(t) {
  return "string" != typeof t ? t : function (t) {
    if ("string" != typeof t) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof t + ", while checking isHexPrefixed.");
    return "0x" === t.slice(0, 2);
  }(t) ? t.slice(2) : t;
},
    bt = function bt(t) {
  if ("string" == typeof t || "number" == typeof t) {
    var e = new yt(1),
        i = String(t).toLowerCase().trim(),
        r = "0x" === i.substr(0, 2) || "-0x" === i.substr(0, 3),
        n = Mt(i);
    if ("-" === n.substr(0, 1) && (n = Mt(n.slice(1)), e = new yt(-1, 10)), !(n = "" === n ? "0" : n).match(/^-?[0-9]+$/) && n.match(/^[0-9A-Fa-f]+$/) || n.match(/^[a-fA-F]+$/) || !0 === r && n.match(/^[0-9A-Fa-f]+$/)) return new yt(n, 16).mul(e);
    if ((n.match(/^-?[0-9]+$/) || "" === n) && !1 === r) return new yt(n, 10).mul(e);
  } else if ("object" == typeof t && t.toString && !t.pop && !t.push && t.toString(10).match(/^-?[0-9]+$/) && (t.mul || t.dividedToIntegerBy)) return new yt(t.toString(10), 10);

  throw new Error("[number-to-bn] while converting number " + JSON.stringify(t) + " to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.");
},
    At = new vt(0),
    xt = new vt(-1),
    Et = {
  noether: "0",
  wei: "1",
  kwei: "1000",
  Kwei: "1000",
  babbage: "1000",
  femtoether: "1000",
  mwei: "1000000",
  Mwei: "1000000",
  lovelace: "1000000",
  picoether: "1000000",
  gwei: "1000000000",
  Gwei: "1000000000",
  shannon: "1000000000",
  nanoether: "1000000000",
  nano: "1000000000",
  szabo: "1000000000000",
  microether: "1000000000000",
  micro: "1000000000000",
  finney: "1000000000000000",
  milliether: "1000000000000000",
  milli: "1000000000000000",
  ether: "1000000000000000000",
  kether: "1000000000000000000000",
  grand: "1000000000000000000000",
  mether: "1000000000000000000000000",
  gether: "1000000000000000000000000000",
  tether: "1000000000000000000000000000000"
};

function Rt(t) {
  var e = t ? t.toLowerCase() : "ether",
      i = Et[e];
  if ("string" != typeof i) throw new Error("[ethjs-unit] the unit provided " + t + " doesn't exists, please use the one of the following units " + JSON.stringify(Et, null, 2));
  return new vt(i, 10);
}

function kt(t) {
  if ("string" == typeof t) {
    if (!t.match(/^-?[0-9.]+$/)) throw new Error("while converting number to string, invalid number value '" + t + "', should be a number matching (^-?[0-9.]+).");
    return t;
  }

  if ("number" == typeof t) return String(t);
  if ("object" == typeof t && t.toString && (t.toTwos || t.dividedToIntegerBy)) return t.toPrecision ? String(t.toPrecision()) : t.toString(10);
  throw new Error("while converting number to string, invalid number value '" + t + "' type " + typeof t + ".");
}

var St = {
  unitMap: Et,
  numberToString: kt,
  getValueOfUnit: Rt,
  fromWei: function fromWei(t, e, i) {
    var r = bt(t),
        n = r.lt(At),
        s = Rt(e),
        o = Et[e].length - 1 || 1,
        a = i || {};
    n && (r = r.mul(xt));

    for (var h = r.mod(s).toString(10); h.length < o;) {
      h = "0" + h;
    }

    a.pad || (h = h.match(/^([0-9]*[1-9]|0)(0*)/)[1]);
    var u = r.div(s).toString(10);
    a.commify && (u = u.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    var l = u + ("0" == h ? "" : "." + h);
    return n && (l = "-" + l), l;
  },
  toWei: function toWei(t, e) {
    var i = kt(t),
        r = Rt(e),
        n = Et[e].length - 1 || 1,
        s = "-" === i.substring(0, 1);
    if (s && (i = i.substring(1)), "." === i) throw new Error("[ethjs-unit] while converting number " + t + " to wei, invalid value");
    var o = i.split(".");
    if (o.length > 2) throw new Error("[ethjs-unit] while converting number " + t + " to wei,  too many decimal points");
    var a = o[0],
        h = o[1];
    if (a || (a = "0"), h || (h = "0"), h.length > n) throw new Error("[ethjs-unit] while converting number " + t + " to wei, too many decimal places");

    for (; h.length < n;) {
      h += "0";
    }

    a = new vt(a), h = new vt(h);
    var u = a.mul(r).add(h);
    return s && (u = u.mul(xt)), new vt(u.toString(10), 10);
  }
},
    It = pt(function (t) {
  !function (t, e) {
    function i(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    function r(t, e) {
      t.super_ = e;

      var i = function i() {};

      i.prototype = e.prototype, t.prototype = new i(), t.prototype.constructor = t;
    }

    function n(t, e, i) {
      if (n.isBN(t)) return t;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (i = e, e = 10), this._init(t || 0, e || 10, i || "be"));
    }

    var s;
    "object" == typeof t ? t.exports = n : e.BN = n, n.BN = n, n.wordSize = 26;

    try {
      s = o.Buffer;
    } catch (t) {}

    function a(t, e, i) {
      for (var r = 0, n = Math.min(t.length, i), s = e; s < n; s++) {
        var o = t.charCodeAt(s) - 48;
        r <<= 4, r |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
      }

      return r;
    }

    function h(t, e, i, r) {
      for (var n = 0, s = Math.min(t.length, i), o = e; o < s; o++) {
        var a = t.charCodeAt(o) - 48;
        n *= r, n += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
      }

      return n;
    }

    n.isBN = function (t) {
      return t instanceof n || null !== t && "object" == typeof t && t.constructor.wordSize === n.wordSize && Array.isArray(t.words);
    }, n.max = function (t, e) {
      return t.cmp(e) > 0 ? t : e;
    }, n.min = function (t, e) {
      return t.cmp(e) < 0 ? t : e;
    }, n.prototype._init = function (t, e, r) {
      if ("number" == typeof t) return this._initNumber(t, e, r);
      if ("object" == typeof t) return this._initArray(t, e, r);
      "hex" === e && (e = 16), i(e === (0 | e) && e >= 2 && e <= 36);
      var n = 0;
      "-" === (t = t.toString().replace(/\s+/g, ""))[0] && n++, 16 === e ? this._parseHex(t, n) : this._parseBase(t, e, n), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initNumber = function (t, e, r) {
      t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (i(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
    }, n.prototype._initArray = function (t, e, r) {
      if (i("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

      for (var n = 0; n < this.length; n++) {
        this.words[n] = 0;
      }

      var s,
          o,
          a = 0;
      if ("be" === r) for (n = t.length - 1, s = 0; n >= 0; n -= 3) {
        this.words[s] |= (o = t[n] | t[n - 1] << 8 | t[n - 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      } else if ("le" === r) for (n = 0, s = 0; n < t.length; n += 3) {
        this.words[s] |= (o = t[n] | t[n + 1] << 8 | t[n + 2] << 16) << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
      }
      return this.strip();
    }, n.prototype._parseHex = function (t, e) {
      this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }

      var r,
          n,
          s = 0;

      for (i = t.length - 6, r = 0; i >= e; i -= 6) {
        n = a(t, i, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, (s += 24) >= 26 && (s -= 26, r++);
      }

      i + 6 !== e && (n = a(t, e, i + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
    }, n.prototype._parseBase = function (t, e, i) {
      this.words = [0], this.length = 1;

      for (var r = 0, n = 1; n <= 67108863; n *= e) {
        r++;
      }

      r--, n = n / e | 0;

      for (var s = t.length - i, o = s % r, a = Math.min(s, s - o) + i, u = 0, l = i; l < a; l += r) {
        u = h(t, l, l + r, e), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }

      if (0 !== o) {
        var c = 1;

        for (u = h(t, l, t.length, e), l = 0; l < o; l++) {
          c *= e;
        }

        this.imuln(c), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }
    }, n.prototype.copy = function (t) {
      t.words = new Array(this.length);

      for (var e = 0; e < this.length; e++) {
        t.words[e] = this.words[e];
      }

      t.length = this.length, t.negative = this.negative, t.red = this.red;
    }, n.prototype.clone = function () {
      var t = new n(null);
      return this.copy(t), t;
    }, n.prototype._expand = function (t) {
      for (; this.length < t;) {
        this.words[this.length++] = 0;
      }

      return this;
    }, n.prototype.strip = function () {
      for (; this.length > 1 && 0 === this.words[this.length - 1];) {
        this.length--;
      }

      return this._normSign();
    }, n.prototype._normSign = function () {
      return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
    }, n.prototype.inspect = function () {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
        l = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        c = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

    function d(t, e, i) {
      i.negative = e.negative ^ t.negative;
      var r = t.length + e.length | 0;
      i.length = r, r = r - 1 | 0;
      var n = 0 | t.words[0],
          s = 0 | e.words[0],
          o = n * s,
          a = o / 67108864 | 0;
      i.words[0] = 67108863 & o;

      for (var h = 1; h < r; h++) {
        for (var u = a >>> 26, l = 67108863 & a, c = Math.min(h, e.length - 1), d = Math.max(0, h - t.length + 1); d <= c; d++) {
          u += (o = (n = 0 | t.words[h - d | 0]) * (s = 0 | e.words[d]) + l) / 67108864 | 0, l = 67108863 & o;
        }

        i.words[h] = 0 | l, a = 0 | u;
      }

      return 0 !== a ? i.words[h] = 0 | a : i.length--, i.strip();
    }

    n.prototype.toString = function (t, e) {
      var r;

      if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
        r = "";

        for (var n = 0, s = 0, o = 0; o < this.length; o++) {
          var a = this.words[o],
              h = (16777215 & (a << n | s)).toString(16);
          r = 0 != (s = a >>> 24 - n & 16777215) || o !== this.length - 1 ? u[6 - h.length] + h + r : h + r, (n += 2) >= 26 && (n -= 26, o--);
        }

        for (0 !== s && (r = s.toString(16) + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      if (t === (0 | t) && t >= 2 && t <= 36) {
        var d = l[t],
            f = c[t];
        r = "";
        var m = this.clone();

        for (m.negative = 0; !m.isZero();) {
          var g = m.modn(f).toString(t);
          r = (m = m.idivn(f)).isZero() ? g + r : u[d - g.length] + g + r;
        }

        for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
          r = "0" + r;
        }

        return 0 !== this.negative && (r = "-" + r), r;
      }

      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function () {
      var t = this.words[0];
      return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
    }, n.prototype.toJSON = function () {
      return this.toString(16);
    }, n.prototype.toBuffer = function (t, e) {
      return i(void 0 !== s), this.toArrayLike(s, t, e);
    }, n.prototype.toArray = function (t, e) {
      return this.toArrayLike(Array, t, e);
    }, n.prototype.toArrayLike = function (t, e, r) {
      var n = this.byteLength(),
          s = r || Math.max(1, n);
      i(n <= s, "byte array longer than desired length"), i(s > 0, "Requested array length <= 0"), this.strip();
      var o,
          a,
          h = "le" === e,
          u = new t(s),
          l = this.clone();

      if (h) {
        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[a] = o;
        }

        for (; a < s; a++) {
          u[a] = 0;
        }
      } else {
        for (a = 0; a < s - n; a++) {
          u[a] = 0;
        }

        for (a = 0; !l.isZero(); a++) {
          o = l.andln(255), l.iushrn(8), u[s - a - 1] = o;
        }
      }

      return u;
    }, n.prototype._countBits = Math.clz32 ? function (t) {
      return 32 - Math.clz32(t);
    } : function (t) {
      var e = t,
          i = 0;
      return e >= 4096 && (i += 13, e >>>= 13), e >= 64 && (i += 7, e >>>= 7), e >= 8 && (i += 4, e >>>= 4), e >= 2 && (i += 2, e >>>= 2), i + e;
    }, n.prototype._zeroBits = function (t) {
      if (0 === t) return 26;
      var e = t,
          i = 0;
      return 0 == (8191 & e) && (i += 13, e >>>= 13), 0 == (127 & e) && (i += 7, e >>>= 7), 0 == (15 & e) && (i += 4, e >>>= 4), 0 == (3 & e) && (i += 2, e >>>= 2), 0 == (1 & e) && i++, i;
    }, n.prototype.bitLength = function () {
      var t = this._countBits(this.words[this.length - 1]);

      return 26 * (this.length - 1) + t;
    }, n.prototype.zeroBits = function () {
      if (this.isZero()) return 0;

      for (var t = 0, e = 0; e < this.length; e++) {
        var i = this._zeroBits(this.words[e]);

        if (t += i, 26 !== i) break;
      }

      return t;
    }, n.prototype.byteLength = function () {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function (t) {
      return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function (t) {
      return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function () {
      return 0 !== this.negative;
    }, n.prototype.neg = function () {
      return this.clone().ineg();
    }, n.prototype.ineg = function () {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function (t) {
      for (; this.length < t.length;) {
        this.words[this.length++] = 0;
      }

      for (var e = 0; e < t.length; e++) {
        this.words[e] = this.words[e] | t.words[e];
      }

      return this.strip();
    }, n.prototype.ior = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuor(t);
    }, n.prototype.or = function (t) {
      return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
    }, n.prototype.uor = function (t) {
      return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
    }, n.prototype.iuand = function (t) {
      var e;
      e = this.length > t.length ? t : this;

      for (var i = 0; i < e.length; i++) {
        this.words[i] = this.words[i] & t.words[i];
      }

      return this.length = e.length, this.strip();
    }, n.prototype.iand = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuand(t);
    }, n.prototype.and = function (t) {
      return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
    }, n.prototype.uand = function (t) {
      return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
    }, n.prototype.iuxor = function (t) {
      var e, i;
      this.length > t.length ? (e = this, i = t) : (e = t, i = this);

      for (var r = 0; r < i.length; r++) {
        this.words[r] = e.words[r] ^ i.words[r];
      }

      if (this !== e) for (; r < e.length; r++) {
        this.words[r] = e.words[r];
      }
      return this.length = e.length, this.strip();
    }, n.prototype.ixor = function (t) {
      return i(0 == (this.negative | t.negative)), this.iuxor(t);
    }, n.prototype.xor = function (t) {
      return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
    }, n.prototype.uxor = function (t) {
      return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
    }, n.prototype.inotn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = 0 | Math.ceil(t / 26),
          r = t % 26;
      this._expand(e), r > 0 && e--;

      for (var n = 0; n < e; n++) {
        this.words[n] = 67108863 & ~this.words[n];
      }

      return r > 0 && (this.words[n] = ~this.words[n] & 67108863 >> 26 - r), this.strip();
    }, n.prototype.notn = function (t) {
      return this.clone().inotn(t);
    }, n.prototype.setn = function (t, e) {
      i("number" == typeof t && t >= 0);
      var r = t / 26 | 0,
          n = t % 26;
      return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << n : this.words[r] & ~(1 << n), this.strip();
    }, n.prototype.iadd = function (t) {
      var e, i, r;
      if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
      if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
      this.length > t.length ? (i = this, r = t) : (i = t, r = this);

      for (var n = 0, s = 0; s < r.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + (0 | r.words[s]) + n), n = e >>> 26;
      }

      for (; 0 !== n && s < i.length; s++) {
        this.words[s] = 67108863 & (e = (0 | i.words[s]) + n), n = e >>> 26;
      }

      if (this.length = i.length, 0 !== n) this.words[this.length] = n, this.length++;else if (i !== this) for (; s < i.length; s++) {
        this.words[s] = i.words[s];
      }
      return this;
    }, n.prototype.add = function (t) {
      var e;
      return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
    }, n.prototype.isub = function (t) {
      if (0 !== t.negative) {
        t.negative = 0;
        var e = this.iadd(t);
        return t.negative = 1, e._normSign();
      }

      if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
      var i,
          r,
          n = this.cmp(t);
      if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      n > 0 ? (i = this, r = t) : (i = t, r = this);

      for (var s = 0, o = 0; o < r.length; o++) {
        s = (e = (0 | i.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      for (; 0 !== s && o < i.length; o++) {
        s = (e = (0 | i.words[o]) + s) >> 26, this.words[o] = 67108863 & e;
      }

      if (0 === s && o < i.length && i !== this) for (; o < i.length; o++) {
        this.words[o] = i.words[o];
      }
      return this.length = Math.max(this.length, o), i !== this && (this.negative = 1), this.strip();
    }, n.prototype.sub = function (t) {
      return this.clone().isub(t);
    };

    var f = function f(t, e, i) {
      var r,
          n,
          s,
          o = t.words,
          a = e.words,
          h = i.words,
          u = 0,
          l = 0 | o[0],
          c = 8191 & l,
          d = l >>> 13,
          f = 0 | o[1],
          m = 8191 & f,
          g = f >>> 13,
          p = 0 | o[2],
          w = 8191 & p,
          v = p >>> 13,
          y = 0 | o[3],
          M = 8191 & y,
          b = y >>> 13,
          A = 0 | o[4],
          x = 8191 & A,
          E = A >>> 13,
          R = 0 | o[5],
          k = 8191 & R,
          S = R >>> 13,
          I = 0 | o[6],
          T = 8191 & I,
          O = I >>> 13,
          B = 0 | o[7],
          C = 8191 & B,
          _ = B >>> 13,
          D = 0 | o[8],
          P = 8191 & D,
          N = D >>> 13,
          L = 0 | o[9],
          W = 8191 & L,
          F = L >>> 13,
          U = 0 | a[0],
          $ = 8191 & U,
          j = U >>> 13,
          q = 0 | a[1],
          G = 8191 & q,
          z = q >>> 13,
          H = 0 | a[2],
          Z = 8191 & H,
          V = H >>> 13,
          J = 0 | a[3],
          K = 8191 & J,
          X = J >>> 13,
          Q = 0 | a[4],
          Y = 8191 & Q,
          tt = Q >>> 13,
          et = 0 | a[5],
          it = 8191 & et,
          rt = et >>> 13,
          nt = 0 | a[6],
          st = 8191 & nt,
          ot = nt >>> 13,
          at = 0 | a[7],
          ht = 8191 & at,
          ut = at >>> 13,
          lt = 0 | a[8],
          ct = 8191 & lt,
          dt = lt >>> 13,
          ft = 0 | a[9],
          mt = 8191 & ft,
          gt = ft >>> 13;

      i.negative = t.negative ^ e.negative, i.length = 19;
      var pt = (u + (r = Math.imul(c, $)) | 0) + ((8191 & (n = (n = Math.imul(c, j)) + Math.imul(d, $) | 0)) << 13) | 0;
      u = ((s = Math.imul(d, j)) + (n >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, r = Math.imul(m, $), n = (n = Math.imul(m, j)) + Math.imul(g, $) | 0, s = Math.imul(g, j);
      var wt = (u + (r = r + Math.imul(c, G) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, z) | 0) + Math.imul(d, G) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, z) | 0) + (n >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, r = Math.imul(w, $), n = (n = Math.imul(w, j)) + Math.imul(v, $) | 0, s = Math.imul(v, j), r = r + Math.imul(m, G) | 0, n = (n = n + Math.imul(m, z) | 0) + Math.imul(g, G) | 0, s = s + Math.imul(g, z) | 0;
      var vt = (u + (r = r + Math.imul(c, Z) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, V) | 0) + Math.imul(d, Z) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, V) | 0) + (n >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, r = Math.imul(M, $), n = (n = Math.imul(M, j)) + Math.imul(b, $) | 0, s = Math.imul(b, j), r = r + Math.imul(w, G) | 0, n = (n = n + Math.imul(w, z) | 0) + Math.imul(v, G) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(m, Z) | 0, n = (n = n + Math.imul(m, V) | 0) + Math.imul(g, Z) | 0, s = s + Math.imul(g, V) | 0;
      var yt = (u + (r = r + Math.imul(c, K) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, X) | 0) + Math.imul(d, K) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, X) | 0) + (n >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, r = Math.imul(x, $), n = (n = Math.imul(x, j)) + Math.imul(E, $) | 0, s = Math.imul(E, j), r = r + Math.imul(M, G) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(b, G) | 0, s = s + Math.imul(b, z) | 0, r = r + Math.imul(w, Z) | 0, n = (n = n + Math.imul(w, V) | 0) + Math.imul(v, Z) | 0, s = s + Math.imul(v, V) | 0, r = r + Math.imul(m, K) | 0, n = (n = n + Math.imul(m, X) | 0) + Math.imul(g, K) | 0, s = s + Math.imul(g, X) | 0;
      var Mt = (u + (r = r + Math.imul(c, Y) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, tt) | 0) + Math.imul(d, Y) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, tt) | 0) + (n >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, r = Math.imul(k, $), n = (n = Math.imul(k, j)) + Math.imul(S, $) | 0, s = Math.imul(S, j), r = r + Math.imul(x, G) | 0, n = (n = n + Math.imul(x, z) | 0) + Math.imul(E, G) | 0, s = s + Math.imul(E, z) | 0, r = r + Math.imul(M, Z) | 0, n = (n = n + Math.imul(M, V) | 0) + Math.imul(b, Z) | 0, s = s + Math.imul(b, V) | 0, r = r + Math.imul(w, K) | 0, n = (n = n + Math.imul(w, X) | 0) + Math.imul(v, K) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(m, Y) | 0, n = (n = n + Math.imul(m, tt) | 0) + Math.imul(g, Y) | 0, s = s + Math.imul(g, tt) | 0;
      var bt = (u + (r = r + Math.imul(c, it) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, rt) | 0) + Math.imul(d, it) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, rt) | 0) + (n >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, r = Math.imul(T, $), n = (n = Math.imul(T, j)) + Math.imul(O, $) | 0, s = Math.imul(O, j), r = r + Math.imul(k, G) | 0, n = (n = n + Math.imul(k, z) | 0) + Math.imul(S, G) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(x, Z) | 0, n = (n = n + Math.imul(x, V) | 0) + Math.imul(E, Z) | 0, s = s + Math.imul(E, V) | 0, r = r + Math.imul(M, K) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(b, K) | 0, s = s + Math.imul(b, X) | 0, r = r + Math.imul(w, Y) | 0, n = (n = n + Math.imul(w, tt) | 0) + Math.imul(v, Y) | 0, s = s + Math.imul(v, tt) | 0, r = r + Math.imul(m, it) | 0, n = (n = n + Math.imul(m, rt) | 0) + Math.imul(g, it) | 0, s = s + Math.imul(g, rt) | 0;
      var At = (u + (r = r + Math.imul(c, st) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ot) | 0) + Math.imul(d, st) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ot) | 0) + (n >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, r = Math.imul(C, $), n = (n = Math.imul(C, j)) + Math.imul(_, $) | 0, s = Math.imul(_, j), r = r + Math.imul(T, G) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(O, G) | 0, s = s + Math.imul(O, z) | 0, r = r + Math.imul(k, Z) | 0, n = (n = n + Math.imul(k, V) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, V) | 0, r = r + Math.imul(x, K) | 0, n = (n = n + Math.imul(x, X) | 0) + Math.imul(E, K) | 0, s = s + Math.imul(E, X) | 0, r = r + Math.imul(M, Y) | 0, n = (n = n + Math.imul(M, tt) | 0) + Math.imul(b, Y) | 0, s = s + Math.imul(b, tt) | 0, r = r + Math.imul(w, it) | 0, n = (n = n + Math.imul(w, rt) | 0) + Math.imul(v, it) | 0, s = s + Math.imul(v, rt) | 0, r = r + Math.imul(m, st) | 0, n = (n = n + Math.imul(m, ot) | 0) + Math.imul(g, st) | 0, s = s + Math.imul(g, ot) | 0;
      var xt = (u + (r = r + Math.imul(c, ht) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, ut) | 0) + Math.imul(d, ht) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, ut) | 0) + (n >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, r = Math.imul(P, $), n = (n = Math.imul(P, j)) + Math.imul(N, $) | 0, s = Math.imul(N, j), r = r + Math.imul(C, G) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(_, G) | 0, s = s + Math.imul(_, z) | 0, r = r + Math.imul(T, Z) | 0, n = (n = n + Math.imul(T, V) | 0) + Math.imul(O, Z) | 0, s = s + Math.imul(O, V) | 0, r = r + Math.imul(k, K) | 0, n = (n = n + Math.imul(k, X) | 0) + Math.imul(S, K) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(x, Y) | 0, n = (n = n + Math.imul(x, tt) | 0) + Math.imul(E, Y) | 0, s = s + Math.imul(E, tt) | 0, r = r + Math.imul(M, it) | 0, n = (n = n + Math.imul(M, rt) | 0) + Math.imul(b, it) | 0, s = s + Math.imul(b, rt) | 0, r = r + Math.imul(w, st) | 0, n = (n = n + Math.imul(w, ot) | 0) + Math.imul(v, st) | 0, s = s + Math.imul(v, ot) | 0, r = r + Math.imul(m, ht) | 0, n = (n = n + Math.imul(m, ut) | 0) + Math.imul(g, ht) | 0, s = s + Math.imul(g, ut) | 0;
      var Et = (u + (r = r + Math.imul(c, ct) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, dt) | 0) + Math.imul(d, ct) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, dt) | 0) + (n >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, r = Math.imul(W, $), n = (n = Math.imul(W, j)) + Math.imul(F, $) | 0, s = Math.imul(F, j), r = r + Math.imul(P, G) | 0, n = (n = n + Math.imul(P, z) | 0) + Math.imul(N, G) | 0, s = s + Math.imul(N, z) | 0, r = r + Math.imul(C, Z) | 0, n = (n = n + Math.imul(C, V) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, V) | 0, r = r + Math.imul(T, K) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(O, K) | 0, s = s + Math.imul(O, X) | 0, r = r + Math.imul(k, Y) | 0, n = (n = n + Math.imul(k, tt) | 0) + Math.imul(S, Y) | 0, s = s + Math.imul(S, tt) | 0, r = r + Math.imul(x, it) | 0, n = (n = n + Math.imul(x, rt) | 0) + Math.imul(E, it) | 0, s = s + Math.imul(E, rt) | 0, r = r + Math.imul(M, st) | 0, n = (n = n + Math.imul(M, ot) | 0) + Math.imul(b, st) | 0, s = s + Math.imul(b, ot) | 0, r = r + Math.imul(w, ht) | 0, n = (n = n + Math.imul(w, ut) | 0) + Math.imul(v, ht) | 0, s = s + Math.imul(v, ut) | 0, r = r + Math.imul(m, ct) | 0, n = (n = n + Math.imul(m, dt) | 0) + Math.imul(g, ct) | 0, s = s + Math.imul(g, dt) | 0;
      var Rt = (u + (r = r + Math.imul(c, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(c, gt) | 0) + Math.imul(d, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(d, gt) | 0) + (n >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, z)) + Math.imul(F, G) | 0, s = Math.imul(F, z), r = r + Math.imul(P, Z) | 0, n = (n = n + Math.imul(P, V) | 0) + Math.imul(N, Z) | 0, s = s + Math.imul(N, V) | 0, r = r + Math.imul(C, K) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(_, K) | 0, s = s + Math.imul(_, X) | 0, r = r + Math.imul(T, Y) | 0, n = (n = n + Math.imul(T, tt) | 0) + Math.imul(O, Y) | 0, s = s + Math.imul(O, tt) | 0, r = r + Math.imul(k, it) | 0, n = (n = n + Math.imul(k, rt) | 0) + Math.imul(S, it) | 0, s = s + Math.imul(S, rt) | 0, r = r + Math.imul(x, st) | 0, n = (n = n + Math.imul(x, ot) | 0) + Math.imul(E, st) | 0, s = s + Math.imul(E, ot) | 0, r = r + Math.imul(M, ht) | 0, n = (n = n + Math.imul(M, ut) | 0) + Math.imul(b, ht) | 0, s = s + Math.imul(b, ut) | 0, r = r + Math.imul(w, ct) | 0, n = (n = n + Math.imul(w, dt) | 0) + Math.imul(v, ct) | 0, s = s + Math.imul(v, dt) | 0;
      var kt = (u + (r = r + Math.imul(m, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(m, gt) | 0) + Math.imul(g, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(g, gt) | 0) + (n >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, r = Math.imul(W, Z), n = (n = Math.imul(W, V)) + Math.imul(F, Z) | 0, s = Math.imul(F, V), r = r + Math.imul(P, K) | 0, n = (n = n + Math.imul(P, X) | 0) + Math.imul(N, K) | 0, s = s + Math.imul(N, X) | 0, r = r + Math.imul(C, Y) | 0, n = (n = n + Math.imul(C, tt) | 0) + Math.imul(_, Y) | 0, s = s + Math.imul(_, tt) | 0, r = r + Math.imul(T, it) | 0, n = (n = n + Math.imul(T, rt) | 0) + Math.imul(O, it) | 0, s = s + Math.imul(O, rt) | 0, r = r + Math.imul(k, st) | 0, n = (n = n + Math.imul(k, ot) | 0) + Math.imul(S, st) | 0, s = s + Math.imul(S, ot) | 0, r = r + Math.imul(x, ht) | 0, n = (n = n + Math.imul(x, ut) | 0) + Math.imul(E, ht) | 0, s = s + Math.imul(E, ut) | 0, r = r + Math.imul(M, ct) | 0, n = (n = n + Math.imul(M, dt) | 0) + Math.imul(b, ct) | 0, s = s + Math.imul(b, dt) | 0;
      var St = (u + (r = r + Math.imul(w, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(w, gt) | 0) + Math.imul(v, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(v, gt) | 0) + (n >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, r = Math.imul(W, K), n = (n = Math.imul(W, X)) + Math.imul(F, K) | 0, s = Math.imul(F, X), r = r + Math.imul(P, Y) | 0, n = (n = n + Math.imul(P, tt) | 0) + Math.imul(N, Y) | 0, s = s + Math.imul(N, tt) | 0, r = r + Math.imul(C, it) | 0, n = (n = n + Math.imul(C, rt) | 0) + Math.imul(_, it) | 0, s = s + Math.imul(_, rt) | 0, r = r + Math.imul(T, st) | 0, n = (n = n + Math.imul(T, ot) | 0) + Math.imul(O, st) | 0, s = s + Math.imul(O, ot) | 0, r = r + Math.imul(k, ht) | 0, n = (n = n + Math.imul(k, ut) | 0) + Math.imul(S, ht) | 0, s = s + Math.imul(S, ut) | 0, r = r + Math.imul(x, ct) | 0, n = (n = n + Math.imul(x, dt) | 0) + Math.imul(E, ct) | 0, s = s + Math.imul(E, dt) | 0;
      var It = (u + (r = r + Math.imul(M, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, gt) | 0) + Math.imul(b, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(b, gt) | 0) + (n >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, r = Math.imul(W, Y), n = (n = Math.imul(W, tt)) + Math.imul(F, Y) | 0, s = Math.imul(F, tt), r = r + Math.imul(P, it) | 0, n = (n = n + Math.imul(P, rt) | 0) + Math.imul(N, it) | 0, s = s + Math.imul(N, rt) | 0, r = r + Math.imul(C, st) | 0, n = (n = n + Math.imul(C, ot) | 0) + Math.imul(_, st) | 0, s = s + Math.imul(_, ot) | 0, r = r + Math.imul(T, ht) | 0, n = (n = n + Math.imul(T, ut) | 0) + Math.imul(O, ht) | 0, s = s + Math.imul(O, ut) | 0, r = r + Math.imul(k, ct) | 0, n = (n = n + Math.imul(k, dt) | 0) + Math.imul(S, ct) | 0, s = s + Math.imul(S, dt) | 0;
      var Tt = (u + (r = r + Math.imul(x, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(x, gt) | 0) + Math.imul(E, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(E, gt) | 0) + (n >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, r = Math.imul(W, it), n = (n = Math.imul(W, rt)) + Math.imul(F, it) | 0, s = Math.imul(F, rt), r = r + Math.imul(P, st) | 0, n = (n = n + Math.imul(P, ot) | 0) + Math.imul(N, st) | 0, s = s + Math.imul(N, ot) | 0, r = r + Math.imul(C, ht) | 0, n = (n = n + Math.imul(C, ut) | 0) + Math.imul(_, ht) | 0, s = s + Math.imul(_, ut) | 0, r = r + Math.imul(T, ct) | 0, n = (n = n + Math.imul(T, dt) | 0) + Math.imul(O, ct) | 0, s = s + Math.imul(O, dt) | 0;
      var Ot = (u + (r = r + Math.imul(k, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(k, gt) | 0) + Math.imul(S, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(S, gt) | 0) + (n >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, r = Math.imul(W, st), n = (n = Math.imul(W, ot)) + Math.imul(F, st) | 0, s = Math.imul(F, ot), r = r + Math.imul(P, ht) | 0, n = (n = n + Math.imul(P, ut) | 0) + Math.imul(N, ht) | 0, s = s + Math.imul(N, ut) | 0, r = r + Math.imul(C, ct) | 0, n = (n = n + Math.imul(C, dt) | 0) + Math.imul(_, ct) | 0, s = s + Math.imul(_, dt) | 0;
      var Bt = (u + (r = r + Math.imul(T, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, gt) | 0) + Math.imul(O, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(O, gt) | 0) + (n >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, r = Math.imul(W, ht), n = (n = Math.imul(W, ut)) + Math.imul(F, ht) | 0, s = Math.imul(F, ut), r = r + Math.imul(P, ct) | 0, n = (n = n + Math.imul(P, dt) | 0) + Math.imul(N, ct) | 0, s = s + Math.imul(N, dt) | 0;
      var Ct = (u + (r = r + Math.imul(C, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, gt) | 0) + Math.imul(_, mt) | 0)) << 13) | 0;
      u = ((s = s + Math.imul(_, gt) | 0) + (n >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, r = Math.imul(W, ct), n = (n = Math.imul(W, dt)) + Math.imul(F, ct) | 0, s = Math.imul(F, dt);

      var _t = (u + (r = r + Math.imul(P, mt) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(P, gt) | 0) + Math.imul(N, mt) | 0)) << 13) | 0;

      u = ((s = s + Math.imul(N, gt) | 0) + (n >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863;
      var Dt = (u + (r = Math.imul(W, mt)) | 0) + ((8191 & (n = (n = Math.imul(W, gt)) + Math.imul(F, mt) | 0)) << 13) | 0;
      return u = ((s = Math.imul(F, gt)) + (n >>> 13) | 0) + (Dt >>> 26) | 0, Dt &= 67108863, h[0] = pt, h[1] = wt, h[2] = vt, h[3] = yt, h[4] = Mt, h[5] = bt, h[6] = At, h[7] = xt, h[8] = Et, h[9] = Rt, h[10] = kt, h[11] = St, h[12] = It, h[13] = Tt, h[14] = Ot, h[15] = Bt, h[16] = Ct, h[17] = _t, h[18] = Dt, 0 !== u && (h[19] = u, i.length++), i;
    };

    function m(t, e, i) {
      return new g().mulp(t, e, i);
    }

    function g(t, e) {
      this.x = t, this.y = e;
    }

    Math.imul || (f = d), n.prototype.mulTo = function (t, e) {
      var i = this.length + t.length;
      return 10 === this.length && 10 === t.length ? f(this, t, e) : i < 63 ? d(this, t, e) : i < 1024 ? function (t, e, i) {
        i.negative = e.negative ^ t.negative, i.length = t.length + e.length;

        for (var r = 0, n = 0, s = 0; s < i.length - 1; s++) {
          var o = n;
          n = 0;

          for (var a = 67108863 & r, h = Math.min(s, e.length - 1), u = Math.max(0, s - t.length + 1); u <= h; u++) {
            var l = (0 | t.words[s - u]) * (0 | e.words[u]),
                c = 67108863 & l;
            a = 67108863 & (c = c + a | 0), n += (o = (o = o + (l / 67108864 | 0) | 0) + (c >>> 26) | 0) >>> 26, o &= 67108863;
          }

          i.words[s] = a, r = o, o = n;
        }

        return 0 !== r ? i.words[s] = r : i.length--, i.strip();
      }(this, t, e) : m(this, t, e);
    }, g.prototype.makeRBT = function (t) {
      for (var e = new Array(t), i = n.prototype._countBits(t) - 1, r = 0; r < t; r++) {
        e[r] = this.revBin(r, i, t);
      }

      return e;
    }, g.prototype.revBin = function (t, e, i) {
      if (0 === t || t === i - 1) return t;

      for (var r = 0, n = 0; n < e; n++) {
        r |= (1 & t) << e - n - 1, t >>= 1;
      }

      return r;
    }, g.prototype.permute = function (t, e, i, r, n, s) {
      for (var o = 0; o < s; o++) {
        r[o] = e[t[o]], n[o] = i[t[o]];
      }
    }, g.prototype.transform = function (t, e, i, r, n, s) {
      this.permute(s, t, e, i, r, n);

      for (var o = 1; o < n; o <<= 1) {
        for (var a = o << 1, h = Math.cos(2 * Math.PI / a), u = Math.sin(2 * Math.PI / a), l = 0; l < n; l += a) {
          for (var c = h, d = u, f = 0; f < o; f++) {
            var m = i[l + f],
                g = r[l + f],
                p = i[l + f + o],
                w = r[l + f + o],
                v = c * p - d * w;
            w = c * w + d * p, i[l + f] = m + (p = v), r[l + f] = g + w, i[l + f + o] = m - p, r[l + f + o] = g - w, f !== a && (v = h * c - u * d, d = h * d + u * c, c = v);
          }
        }
      }
    }, g.prototype.guessLen13b = function (t, e) {
      var i = 1 | Math.max(e, t),
          r = 1 & i,
          n = 0;

      for (i = i / 2 | 0; i; i >>>= 1) {
        n++;
      }

      return 1 << n + 1 + r;
    }, g.prototype.conjugate = function (t, e, i) {
      if (!(i <= 1)) for (var r = 0; r < i / 2; r++) {
        var n = t[r];
        t[r] = t[i - r - 1], t[i - r - 1] = n, n = e[r], e[r] = -e[i - r - 1], e[i - r - 1] = -n;
      }
    }, g.prototype.normalize13b = function (t, e) {
      for (var i = 0, r = 0; r < e / 2; r++) {
        var n = 8192 * Math.round(t[2 * r + 1] / e) + Math.round(t[2 * r] / e) + i;
        t[r] = 67108863 & n, i = n < 67108864 ? 0 : n / 67108864 | 0;
      }

      return t;
    }, g.prototype.convert13b = function (t, e, r, n) {
      for (var s = 0, o = 0; o < e; o++) {
        r[2 * o] = 8191 & (s += 0 | t[o]), r[2 * o + 1] = 8191 & (s >>>= 13), s >>>= 13;
      }

      for (o = 2 * e; o < n; ++o) {
        r[o] = 0;
      }

      i(0 === s), i(0 == (-8192 & s));
    }, g.prototype.stub = function (t) {
      for (var e = new Array(t), i = 0; i < t; i++) {
        e[i] = 0;
      }

      return e;
    }, g.prototype.mulp = function (t, e, i) {
      var r = 2 * this.guessLen13b(t.length, e.length),
          n = this.makeRBT(r),
          s = this.stub(r),
          o = new Array(r),
          a = new Array(r),
          h = new Array(r),
          u = new Array(r),
          l = new Array(r),
          c = new Array(r),
          d = i.words;
      d.length = r, this.convert13b(t.words, t.length, o, r), this.convert13b(e.words, e.length, u, r), this.transform(o, s, a, h, r, n), this.transform(u, s, l, c, r, n);

      for (var f = 0; f < r; f++) {
        var m = a[f] * l[f] - h[f] * c[f];
        h[f] = a[f] * c[f] + h[f] * l[f], a[f] = m;
      }

      return this.conjugate(a, h, r), this.transform(a, h, d, s, r, n), this.conjugate(d, s, r), this.normalize13b(d, r), i.negative = t.negative ^ e.negative, i.length = t.length + e.length, i.strip();
    }, n.prototype.mul = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), this.mulTo(t, e);
    }, n.prototype.mulf = function (t) {
      var e = new n(null);
      return e.words = new Array(this.length + t.length), m(this, t, e);
    }, n.prototype.imul = function (t) {
      return this.clone().mulTo(t, this);
    }, n.prototype.imuln = function (t) {
      i("number" == typeof t), i(t < 67108864);

      for (var e = 0, r = 0; r < this.length; r++) {
        var n = (0 | this.words[r]) * t,
            s = (67108863 & n) + (67108863 & e);
        e >>= 26, e += n / 67108864 | 0, e += s >>> 26, this.words[r] = 67108863 & s;
      }

      return 0 !== e && (this.words[r] = e, this.length++), this;
    }, n.prototype.muln = function (t) {
      return this.clone().imuln(t);
    }, n.prototype.sqr = function () {
      return this.mul(this);
    }, n.prototype.isqr = function () {
      return this.imul(this.clone());
    }, n.prototype.pow = function (t) {
      var e = function (t) {
        for (var e = new Array(t.bitLength()), i = 0; i < e.length; i++) {
          var r = i % 26;
          e[i] = (t.words[i / 26 | 0] & 1 << r) >>> r;
        }

        return e;
      }(t);

      if (0 === e.length) return new n(1);

      for (var i = this, r = 0; r < e.length && 0 === e[r]; r++, i = i.sqr()) {
        ;
      }

      if (++r < e.length) for (var s = i.sqr(); r < e.length; r++, s = s.sqr()) {
        0 !== e[r] && (i = i.mul(s));
      }
      return i;
    }, n.prototype.iushln = function (t) {
      i("number" == typeof t && t >= 0);
      var e,
          r = t % 26,
          n = (t - r) / 26,
          s = 67108863 >>> 26 - r << 26 - r;

      if (0 !== r) {
        var o = 0;

        for (e = 0; e < this.length; e++) {
          var a = this.words[e] & s;
          this.words[e] = (0 | this.words[e]) - a << r | o, o = a >>> 26 - r;
        }

        o && (this.words[e] = o, this.length++);
      }

      if (0 !== n) {
        for (e = this.length - 1; e >= 0; e--) {
          this.words[e + n] = this.words[e];
        }

        for (e = 0; e < n; e++) {
          this.words[e] = 0;
        }

        this.length += n;
      }

      return this.strip();
    }, n.prototype.ishln = function (t) {
      return i(0 === this.negative), this.iushln(t);
    }, n.prototype.iushrn = function (t, e, r) {
      var n;
      i("number" == typeof t && t >= 0), n = e ? (e - e % 26) / 26 : 0;
      var s = t % 26,
          o = Math.min((t - s) / 26, this.length),
          a = 67108863 ^ 67108863 >>> s << s,
          h = r;

      if (n -= o, n = Math.max(0, n), h) {
        for (var u = 0; u < o; u++) {
          h.words[u] = this.words[u];
        }

        h.length = o;
      }

      if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
        this.words[u] = this.words[u + o];
      } else this.words[0] = 0, this.length = 1;
      var l = 0;

      for (u = this.length - 1; u >= 0 && (0 !== l || u >= n); u--) {
        var c = 0 | this.words[u];
        this.words[u] = l << 26 - s | c >>> s, l = c & a;
      }

      return h && 0 !== l && (h.words[h.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
    }, n.prototype.ishrn = function (t, e, r) {
      return i(0 === this.negative), this.iushrn(t, e, r);
    }, n.prototype.shln = function (t) {
      return this.clone().ishln(t);
    }, n.prototype.ushln = function (t) {
      return this.clone().iushln(t);
    }, n.prototype.shrn = function (t) {
      return this.clone().ishrn(t);
    }, n.prototype.ushrn = function (t) {
      return this.clone().iushrn(t);
    }, n.prototype.testn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return !(this.length <= r || !(this.words[r] & 1 << e));
    }, n.prototype.imaskn = function (t) {
      i("number" == typeof t && t >= 0);
      var e = t % 26,
          r = (t - e) / 26;
      return i(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r ? this : (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e && (this.words[this.length - 1] &= 67108863 ^ 67108863 >>> e << e), this.strip());
    }, n.prototype.maskn = function (t) {
      return this.clone().imaskn(t);
    }, n.prototype.iaddn = function (t) {
      return i("number" == typeof t), i(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
    }, n.prototype._iaddn = function (t) {
      this.words[0] += t;

      for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
        this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
      }

      return this.length = Math.max(this.length, e + 1), this;
    }, n.prototype.isubn = function (t) {
      if (i("number" == typeof t), i(t < 67108864), t < 0) return this.iaddn(-t);
      if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
      if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
        this.words[e] += 67108864, this.words[e + 1] -= 1;
      }
      return this.strip();
    }, n.prototype.addn = function (t) {
      return this.clone().iaddn(t);
    }, n.prototype.subn = function (t) {
      return this.clone().isubn(t);
    }, n.prototype.iabs = function () {
      return this.negative = 0, this;
    }, n.prototype.abs = function () {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function (t, e, r) {
      var n, s;

      this._expand(t.length + r);

      var o = 0;

      for (n = 0; n < t.length; n++) {
        s = (0 | this.words[n + r]) + o;
        var a = (0 | t.words[n]) * e;
        o = ((s -= 67108863 & a) >> 26) - (a / 67108864 | 0), this.words[n + r] = 67108863 & s;
      }

      for (; n < this.length - r; n++) {
        o = (s = (0 | this.words[n + r]) + o) >> 26, this.words[n + r] = 67108863 & s;
      }

      if (0 === o) return this.strip();

      for (i(-1 === o), o = 0, n = 0; n < this.length; n++) {
        o = (s = -(0 | this.words[n]) + o) >> 26, this.words[n] = 67108863 & s;
      }

      return this.negative = 1, this.strip();
    }, n.prototype._wordDiv = function (t, e) {
      var i,
          r = this.clone(),
          s = t,
          o = 0 | s.words[s.length - 1];
      0 != (i = 26 - this._countBits(o)) && (s = s.ushln(i), r.iushln(i), o = 0 | s.words[s.length - 1]);
      var a,
          h = r.length - s.length;

      if ("mod" !== e) {
        (a = new n(null)).length = h + 1, a.words = new Array(a.length);

        for (var u = 0; u < a.length; u++) {
          a.words[u] = 0;
        }
      }

      var l = r.clone()._ishlnsubmul(s, 1, h);

      0 === l.negative && (r = l, a && (a.words[h] = 1));

      for (var c = h - 1; c >= 0; c--) {
        var d = 67108864 * (0 | r.words[s.length + c]) + (0 | r.words[s.length + c - 1]);

        for (d = Math.min(d / o | 0, 67108863), r._ishlnsubmul(s, d, c); 0 !== r.negative;) {
          d--, r.negative = 0, r._ishlnsubmul(s, 1, c), r.isZero() || (r.negative ^= 1);
        }

        a && (a.words[c] = d);
      }

      return a && a.strip(), r.strip(), "div" !== e && 0 !== i && r.iushrn(i), {
        div: a || null,
        mod: r
      };
    }, n.prototype.divmod = function (t, e, r) {
      return i(!t.isZero()), this.isZero() ? {
        div: new n(0),
        mod: new n(0)
      } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (s = a.div.neg()), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(t)), {
        div: s,
        mod: o
      }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (s = a.div.neg()), {
        div: s,
        mod: a.mod
      }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(t)), {
        div: a.div,
        mod: o
      }) : t.length > this.length || this.cmp(t) < 0 ? {
        div: new n(0),
        mod: this
      } : 1 === t.length ? "div" === e ? {
        div: this.divn(t.words[0]),
        mod: null
      } : "mod" === e ? {
        div: null,
        mod: new n(this.modn(t.words[0]))
      } : {
        div: this.divn(t.words[0]),
        mod: new n(this.modn(t.words[0]))
      } : this._wordDiv(t, e);
      var s, o, a;
    }, n.prototype.div = function (t) {
      return this.divmod(t, "div", !1).div;
    }, n.prototype.mod = function (t) {
      return this.divmod(t, "mod", !1).mod;
    }, n.prototype.umod = function (t) {
      return this.divmod(t, "mod", !0).mod;
    }, n.prototype.divRound = function (t) {
      var e = this.divmod(t);
      if (e.mod.isZero()) return e.div;
      var i = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
          r = t.ushrn(1),
          n = t.andln(1),
          s = i.cmp(r);
      return s < 0 || 1 === n && 0 === s ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
    }, n.prototype.modn = function (t) {
      i(t <= 67108863);

      for (var e = (1 << 26) % t, r = 0, n = this.length - 1; n >= 0; n--) {
        r = (e * r + (0 | this.words[n])) % t;
      }

      return r;
    }, n.prototype.idivn = function (t) {
      i(t <= 67108863);

      for (var e = 0, r = this.length - 1; r >= 0; r--) {
        var n = (0 | this.words[r]) + 67108864 * e;
        this.words[r] = n / t | 0, e = n % t;
      }

      return this.strip();
    }, n.prototype.divn = function (t) {
      return this.clone().idivn(t);
    }, n.prototype.egcd = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s = new n(1), o = new n(0), a = new n(0), h = new n(1), u = 0; e.isEven() && r.isEven();) {
        e.iushrn(1), r.iushrn(1), ++u;
      }

      for (var l = r.clone(), c = e.clone(); !e.isZero();) {
        for (var d = 0, f = 1; 0 == (e.words[0] & f) && d < 26; ++d, f <<= 1) {
          ;
        }

        if (d > 0) for (e.iushrn(d); d-- > 0;) {
          (s.isOdd() || o.isOdd()) && (s.iadd(l), o.isub(c)), s.iushrn(1), o.iushrn(1);
        }

        for (var m = 0, g = 1; 0 == (r.words[0] & g) && m < 26; ++m, g <<= 1) {
          ;
        }

        if (m > 0) for (r.iushrn(m); m-- > 0;) {
          (a.isOdd() || h.isOdd()) && (a.iadd(l), h.isub(c)), a.iushrn(1), h.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), s.isub(a), o.isub(h)) : (r.isub(e), a.isub(s), h.isub(o));
      }

      return {
        a: a,
        b: h,
        gcd: r.iushln(u)
      };
    }, n.prototype._invmp = function (t) {
      i(0 === t.negative), i(!t.isZero());
      var e = this,
          r = t.clone();
      e = 0 !== e.negative ? e.umod(t) : e.clone();

      for (var s, o = new n(1), a = new n(0), h = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
        for (var u = 0, l = 1; 0 == (e.words[0] & l) && u < 26; ++u, l <<= 1) {
          ;
        }

        if (u > 0) for (e.iushrn(u); u-- > 0;) {
          o.isOdd() && o.iadd(h), o.iushrn(1);
        }

        for (var c = 0, d = 1; 0 == (r.words[0] & d) && c < 26; ++c, d <<= 1) {
          ;
        }

        if (c > 0) for (r.iushrn(c); c-- > 0;) {
          a.isOdd() && a.iadd(h), a.iushrn(1);
        }
        e.cmp(r) >= 0 ? (e.isub(r), o.isub(a)) : (r.isub(e), a.isub(o));
      }

      return (s = 0 === e.cmpn(1) ? o : a).cmpn(0) < 0 && s.iadd(t), s;
    }, n.prototype.gcd = function (t) {
      if (this.isZero()) return t.abs();
      if (t.isZero()) return this.abs();
      var e = this.clone(),
          i = t.clone();
      e.negative = 0, i.negative = 0;

      for (var r = 0; e.isEven() && i.isEven(); r++) {
        e.iushrn(1), i.iushrn(1);
      }

      for (;;) {
        for (; e.isEven();) {
          e.iushrn(1);
        }

        for (; i.isEven();) {
          i.iushrn(1);
        }

        var n = e.cmp(i);

        if (n < 0) {
          var s = e;
          e = i, i = s;
        } else if (0 === n || 0 === i.cmpn(1)) break;

        e.isub(i);
      }

      return i.iushln(r);
    }, n.prototype.invm = function (t) {
      return this.egcd(t).a.umod(t);
    }, n.prototype.isEven = function () {
      return 0 == (1 & this.words[0]);
    }, n.prototype.isOdd = function () {
      return 1 == (1 & this.words[0]);
    }, n.prototype.andln = function (t) {
      return this.words[0] & t;
    }, n.prototype.bincn = function (t) {
      i("number" == typeof t);
      var e = t % 26,
          r = (t - e) / 26,
          n = 1 << e;
      if (this.length <= r) return this._expand(r + 1), this.words[r] |= n, this;

      for (var s = n, o = r; 0 !== s && o < this.length; o++) {
        var a = 0 | this.words[o];
        s = (a += s) >>> 26, this.words[o] = a &= 67108863;
      }

      return 0 !== s && (this.words[o] = s, this.length++), this;
    }, n.prototype.isZero = function () {
      return 1 === this.length && 0 === this.words[0];
    }, n.prototype.cmpn = function (t) {
      var e,
          r = t < 0;
      if (0 !== this.negative && !r) return -1;
      if (0 === this.negative && r) return 1;
      if (this.strip(), this.length > 1) e = 1;else {
        r && (t = -t), i(t <= 67108863, "Number is too big");
        var n = 0 | this.words[0];
        e = n === t ? 0 : n < t ? -1 : 1;
      }
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.cmp = function (t) {
      if (0 !== this.negative && 0 === t.negative) return -1;
      if (0 === this.negative && 0 !== t.negative) return 1;
      var e = this.ucmp(t);
      return 0 !== this.negative ? 0 | -e : e;
    }, n.prototype.ucmp = function (t) {
      if (this.length > t.length) return 1;
      if (this.length < t.length) return -1;

      for (var e = 0, i = this.length - 1; i >= 0; i--) {
        var r = 0 | this.words[i],
            n = 0 | t.words[i];

        if (r !== n) {
          r < n ? e = -1 : r > n && (e = 1);
          break;
        }
      }

      return e;
    }, n.prototype.gtn = function (t) {
      return 1 === this.cmpn(t);
    }, n.prototype.gt = function (t) {
      return 1 === this.cmp(t);
    }, n.prototype.gten = function (t) {
      return this.cmpn(t) >= 0;
    }, n.prototype.gte = function (t) {
      return this.cmp(t) >= 0;
    }, n.prototype.ltn = function (t) {
      return -1 === this.cmpn(t);
    }, n.prototype.lt = function (t) {
      return -1 === this.cmp(t);
    }, n.prototype.lten = function (t) {
      return this.cmpn(t) <= 0;
    }, n.prototype.lte = function (t) {
      return this.cmp(t) <= 0;
    }, n.prototype.eqn = function (t) {
      return 0 === this.cmpn(t);
    }, n.prototype.eq = function (t) {
      return 0 === this.cmp(t);
    }, n.red = function (t) {
      return new A(t);
    }, n.prototype.toRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), i(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
    }, n.prototype.fromRed = function () {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function (t) {
      return this.red = t, this;
    }, n.prototype.forceRed = function (t) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(t);
    }, n.prototype.redAdd = function (t) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
    }, n.prototype.redIAdd = function (t) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
    }, n.prototype.redSub = function (t) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
    }, n.prototype.redISub = function (t) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
    }, n.prototype.redShl = function (t) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
    }, n.prototype.redMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
    }, n.prototype.redIMul = function (t) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
    }, n.prototype.redSqr = function () {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function () {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function () {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function () {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function () {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function (t) {
      return i(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
    };
    var p = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };

    function w(t, e) {
      this.name = t, this.p = new n(e, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }

    function v() {
      w.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }

    function y() {
      w.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }

    function M() {
      w.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }

    function b() {
      w.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }

    function A(t) {
      if ("string" == typeof t) {
        var e = n._prime(t);

        this.m = e.p, this.prime = e;
      } else i(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
    }

    function x(t) {
      A.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }

    w.prototype._tmp = function () {
      var t = new n(null);
      return t.words = new Array(Math.ceil(this.n / 13)), t;
    }, w.prototype.ireduce = function (t) {
      var e,
          i = t;

      do {
        this.split(i, this.tmp), e = (i = (i = this.imulK(i)).iadd(this.tmp)).bitLength();
      } while (e > this.n);

      var r = e < this.n ? -1 : i.ucmp(this.p);
      return 0 === r ? (i.words[0] = 0, i.length = 1) : r > 0 ? i.isub(this.p) : void 0 !== i.strip ? i.strip() : i._strip(), i;
    }, w.prototype.split = function (t, e) {
      t.iushrn(this.n, 0, e);
    }, w.prototype.imulK = function (t) {
      return t.imul(this.k);
    }, r(v, w), v.prototype.split = function (t, e) {
      for (var i = 4194303, r = Math.min(t.length, 9), n = 0; n < r; n++) {
        e.words[n] = t.words[n];
      }

      if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
      var s = t.words[9];

      for (e.words[e.length++] = s & i, n = 10; n < t.length; n++) {
        var o = 0 | t.words[n];
        t.words[n - 10] = (o & i) << 4 | s >>> 22, s = o;
      }

      t.words[n - 10] = s >>>= 22, t.length -= 0 === s && t.length > 10 ? 10 : 9;
    }, v.prototype.imulK = function (t) {
      t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 0 | t.words[i];
        t.words[i] = 67108863 & (e += 977 * r), e = 64 * r + (e / 67108864 | 0);
      }

      return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
    }, r(y, w), r(M, w), r(b, w), b.prototype.imulK = function (t) {
      for (var e = 0, i = 0; i < t.length; i++) {
        var r = 19 * (0 | t.words[i]) + e,
            n = 67108863 & r;
        r >>>= 26, t.words[i] = n, e = r;
      }

      return 0 !== e && (t.words[t.length++] = e), t;
    }, n._prime = function (t) {
      if (p[t]) return p[t];
      var e;
      if ("k256" === t) e = new v();else if ("p224" === t) e = new y();else if ("p192" === t) e = new M();else {
        if ("p25519" !== t) throw new Error("Unknown prime " + t);
        e = new b();
      }
      return p[t] = e, e;
    }, A.prototype._verify1 = function (t) {
      i(0 === t.negative, "red works only with positives"), i(t.red, "red works only with red numbers");
    }, A.prototype._verify2 = function (t, e) {
      i(0 == (t.negative | e.negative), "red works only with positives"), i(t.red && t.red === e.red, "red works only with red numbers");
    }, A.prototype.imod = function (t) {
      return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
    }, A.prototype.neg = function (t) {
      return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
    }, A.prototype.add = function (t, e) {
      this._verify2(t, e);

      var i = t.add(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i._forceRed(this);
    }, A.prototype.iadd = function (t, e) {
      this._verify2(t, e);

      var i = t.iadd(e);
      return i.cmp(this.m) >= 0 && i.isub(this.m), i;
    }, A.prototype.sub = function (t, e) {
      this._verify2(t, e);

      var i = t.sub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i._forceRed(this);
    }, A.prototype.isub = function (t, e) {
      this._verify2(t, e);

      var i = t.isub(e);
      return i.cmpn(0) < 0 && i.iadd(this.m), i;
    }, A.prototype.shl = function (t, e) {
      return this._verify1(t), this.imod(t.ushln(e));
    }, A.prototype.imul = function (t, e) {
      return this._verify2(t, e), this.imod(t.imul(e));
    }, A.prototype.mul = function (t, e) {
      return this._verify2(t, e), this.imod(t.mul(e));
    }, A.prototype.isqr = function (t) {
      return this.imul(t, t.clone());
    }, A.prototype.sqr = function (t) {
      return this.mul(t, t);
    }, A.prototype.sqrt = function (t) {
      if (t.isZero()) return t.clone();
      var e = this.m.andln(3);

      if (i(e % 2 == 1), 3 === e) {
        var r = this.m.add(new n(1)).iushrn(2);
        return this.pow(t, r);
      }

      for (var s = this.m.subn(1), o = 0; !s.isZero() && 0 === s.andln(1);) {
        o++, s.iushrn(1);
      }

      i(!s.isZero());
      var a = new n(1).toRed(this),
          h = a.redNeg(),
          u = this.m.subn(1).iushrn(1),
          l = this.m.bitLength();

      for (l = new n(2 * l * l).toRed(this); 0 !== this.pow(l, u).cmp(h);) {
        l.redIAdd(h);
      }

      for (var c = this.pow(l, s), d = this.pow(t, s.addn(1).iushrn(1)), f = this.pow(t, s), m = o; 0 !== f.cmp(a);) {
        for (var g = f, p = 0; 0 !== g.cmp(a); p++) {
          g = g.redSqr();
        }

        i(p < m);
        var w = this.pow(c, new n(1).iushln(m - p - 1));
        d = d.redMul(w), c = w.redSqr(), f = f.redMul(c), m = p;
      }

      return d;
    }, A.prototype.invm = function (t) {
      var e = t._invmp(this.m);

      return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
    }, A.prototype.pow = function (t, e) {
      if (e.isZero()) return new n(1).toRed(this);
      if (0 === e.cmpn(1)) return t.clone();
      var i = new Array(16);
      i[0] = new n(1).toRed(this), i[1] = t;

      for (var r = 2; r < i.length; r++) {
        i[r] = this.mul(i[r - 1], t);
      }

      var s = i[0],
          o = 0,
          a = 0,
          h = e.bitLength() % 26;

      for (0 === h && (h = 26), r = e.length - 1; r >= 0; r--) {
        for (var u = e.words[r], l = h - 1; l >= 0; l--) {
          var c = u >> l & 1;
          s !== i[0] && (s = this.sqr(s)), 0 !== c || 0 !== o ? (o <<= 1, o |= c, (4 == ++a || 0 === r && 0 === l) && (s = this.mul(s, i[o]), a = 0, o = 0)) : a = 0;
        }

        h = 26;
      }

      return s;
    }, A.prototype.convertTo = function (t) {
      var e = t.umod(this.m);
      return e === t ? e.clone() : e;
    }, A.prototype.convertFrom = function (t) {
      var e = t.clone();
      return e.red = null, e;
    }, n.mont = function (t) {
      return new x(t);
    }, r(x, A), x.prototype.convertTo = function (t) {
      return this.imod(t.ushln(this.shift));
    }, x.prototype.convertFrom = function (t) {
      var e = this.imod(t.mul(this.rinv));
      return e.red = null, e;
    }, x.prototype.imul = function (t, e) {
      if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
      var i = t.imul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          n = i.isub(r).iushrn(this.shift),
          s = n;
      return n.cmp(this.m) >= 0 ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
    }, x.prototype.mul = function (t, e) {
      if (t.isZero() || e.isZero()) return new n(0)._forceRed(this);
      var i = t.mul(e),
          r = i.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
          s = i.isub(r).iushrn(this.shift),
          o = s;
      return s.cmp(this.m) >= 0 ? o = s.isub(this.m) : s.cmpn(0) < 0 && (o = s.iadd(this.m)), o._forceRed(this);
    }, x.prototype.invm = function (t) {
      return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
    };
  }(t, gt);
}),
    Tt = pt(function (t, e) {
  !function (t) {
    var e,
        i,
        r,
        n = String.fromCharCode;

    function s(t) {
      for (var e, i, r = [], n = 0, s = t.length; n < s;) {
        (e = t.charCodeAt(n++)) >= 55296 && e <= 56319 && n < s ? 56320 == (64512 & (i = t.charCodeAt(n++))) ? r.push(((1023 & e) << 10) + (1023 & i) + 65536) : (r.push(e), n--) : r.push(e);
      }

      return r;
    }

    function o(t) {
      if (t >= 55296 && t <= 57343) throw Error("Lone surrogate U+" + t.toString(16).toUpperCase() + " is not a scalar value");
    }

    function a(t, e) {
      return n(t >> e & 63 | 128);
    }

    function h(t) {
      if (0 == (4294967168 & t)) return n(t);
      var e = "";
      return 0 == (4294965248 & t) ? e = n(t >> 6 & 31 | 192) : 0 == (4294901760 & t) ? (o(t), e = n(t >> 12 & 15 | 224), e += a(t, 6)) : 0 == (4292870144 & t) && (e = n(t >> 18 & 7 | 240), e += a(t, 12), e += a(t, 6)), e + n(63 & t | 128);
    }

    function u() {
      if (r >= i) throw Error("Invalid byte index");
      var t = 255 & e[r];
      if (r++, 128 == (192 & t)) return 63 & t;
      throw Error("Invalid continuation byte");
    }

    function l() {
      var t, n;
      if (r > i) throw Error("Invalid byte index");
      if (r == i) return !1;
      if (t = 255 & e[r], r++, 0 == (128 & t)) return t;

      if (192 == (224 & t)) {
        if ((n = (31 & t) << 6 | u()) >= 128) return n;
        throw Error("Invalid continuation byte");
      }

      if (224 == (240 & t)) {
        if ((n = (15 & t) << 12 | u() << 6 | u()) >= 2048) return o(n), n;
        throw Error("Invalid continuation byte");
      }

      if (240 == (248 & t) && (n = (7 & t) << 18 | u() << 12 | u() << 6 | u()) >= 65536 && n <= 1114111) return n;
      throw Error("Invalid UTF-8 detected");
    }

    t.version = "3.0.0", t.encode = function (t) {
      for (var e = s(t), i = e.length, r = -1, n = ""; ++r < i;) {
        n += h(e[r]);
      }

      return n;
    }, t.decode = function (t) {
      e = s(t), i = e.length, r = 0;

      for (var o, a = []; !1 !== (o = l());) {
        a.push(o);
      }

      return function (t) {
        for (var e, i = t.length, r = -1, s = ""; ++r < i;) {
          (e = t[r]) > 65535 && (s += n((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), s += n(e);
        }

        return s;
      }(a);
    };
  }(e);
});

var Ot = "0123456789abcdef".split(""),
    Bt = [1, 256, 65536, 16777216],
    Ct = [0, 8, 16, 24],
    _t = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
    Dt = function Dt(t) {
  var e, i, r, n, s, o, a, h, u, l, c, d, f, m, g, p, w, v, y, M, b, A, x, E, R, k, S, I, T, O, B, C, _, D, P, N, L, W, F, U, $, j, q, G, z, H, Z, V, J, K, X, Q, Y, tt, et, it, rt, nt, st, ot, at, ht, ut;

  for (r = 0; r < 48; r += 2) {
    n = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], s = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], h = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], l = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], c = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], i = (f = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ ((a = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43]) << 1 | (o = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42]) >>> 31), t[0] ^= e = (d = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (o << 1 | a >>> 31), t[1] ^= i, t[10] ^= e, t[11] ^= i, t[20] ^= e, t[21] ^= i, t[30] ^= e, t[31] ^= i, t[40] ^= e, t[41] ^= i, i = s ^ (u << 1 | h >>> 31), t[2] ^= e = n ^ (h << 1 | u >>> 31), t[3] ^= i, t[12] ^= e, t[13] ^= i, t[22] ^= e, t[23] ^= i, t[32] ^= e, t[33] ^= i, t[42] ^= e, t[43] ^= i, i = a ^ (c << 1 | l >>> 31), t[4] ^= e = o ^ (l << 1 | c >>> 31), t[5] ^= i, t[14] ^= e, t[15] ^= i, t[24] ^= e, t[25] ^= i, t[34] ^= e, t[35] ^= i, t[44] ^= e, t[45] ^= i, i = u ^ (f << 1 | d >>> 31), t[6] ^= e = h ^ (d << 1 | f >>> 31), t[7] ^= i, t[16] ^= e, t[17] ^= i, t[26] ^= e, t[27] ^= i, t[36] ^= e, t[37] ^= i, t[46] ^= e, t[47] ^= i, i = c ^ (s << 1 | n >>> 31), t[8] ^= e = l ^ (n << 1 | s >>> 31), t[9] ^= i, t[18] ^= e, t[19] ^= i, t[28] ^= e, t[29] ^= i, t[38] ^= e, t[39] ^= i, t[48] ^= e, t[49] ^= i, g = t[1], H = t[11] << 4 | t[10] >>> 28, Z = t[10] << 4 | t[11] >>> 28, I = t[20] << 3 | t[21] >>> 29, T = t[21] << 3 | t[20] >>> 29, ot = t[31] << 9 | t[30] >>> 23, at = t[30] << 9 | t[31] >>> 23, j = t[40] << 18 | t[41] >>> 14, q = t[41] << 18 | t[40] >>> 14, D = t[2] << 1 | t[3] >>> 31, P = t[3] << 1 | t[2] >>> 31, w = t[12] << 12 | t[13] >>> 20, V = t[22] << 10 | t[23] >>> 22, J = t[23] << 10 | t[22] >>> 22, O = t[33] << 13 | t[32] >>> 19, B = t[32] << 13 | t[33] >>> 19, ht = t[42] << 2 | t[43] >>> 30, ut = t[43] << 2 | t[42] >>> 30, tt = t[5] << 30 | t[4] >>> 2, et = t[4] << 30 | t[5] >>> 2, N = t[14] << 6 | t[15] >>> 26, L = t[15] << 6 | t[14] >>> 26, y = t[24] << 11 | t[25] >>> 21, K = t[34] << 15 | t[35] >>> 17, X = t[35] << 15 | t[34] >>> 17, C = t[45] << 29 | t[44] >>> 3, _ = t[44] << 29 | t[45] >>> 3, E = t[6] << 28 | t[7] >>> 4, R = t[7] << 28 | t[6] >>> 4, it = t[17] << 23 | t[16] >>> 9, rt = t[16] << 23 | t[17] >>> 9, W = t[26] << 25 | t[27] >>> 7, F = t[27] << 25 | t[26] >>> 7, M = t[36] << 21 | t[37] >>> 11, b = t[37] << 21 | t[36] >>> 11, Q = t[47] << 24 | t[46] >>> 8, Y = t[46] << 24 | t[47] >>> 8, G = t[8] << 27 | t[9] >>> 5, z = t[9] << 27 | t[8] >>> 5, k = t[18] << 20 | t[19] >>> 12, S = t[19] << 20 | t[18] >>> 12, nt = t[29] << 7 | t[28] >>> 25, st = t[28] << 7 | t[29] >>> 25, U = t[38] << 8 | t[39] >>> 24, $ = t[39] << 8 | t[38] >>> 24, A = t[48] << 14 | t[49] >>> 18, x = t[49] << 14 | t[48] >>> 18, t[0] = (m = t[0]) ^ ~(p = t[13] << 12 | t[12] >>> 20) & (v = t[25] << 11 | t[24] >>> 21), t[1] = g ^ ~w & y, t[10] = E ^ ~k & I, t[11] = R ^ ~S & T, t[20] = D ^ ~N & W, t[21] = P ^ ~L & F, t[30] = G ^ ~H & V, t[31] = z ^ ~Z & J, t[40] = tt ^ ~it & nt, t[41] = et ^ ~rt & st, t[2] = p ^ ~v & M, t[3] = w ^ ~y & b, t[12] = k ^ ~I & O, t[13] = S ^ ~T & B, t[22] = N ^ ~W & U, t[23] = L ^ ~F & $, t[32] = H ^ ~V & K, t[33] = Z ^ ~J & X, t[42] = it ^ ~nt & ot, t[43] = rt ^ ~st & at, t[4] = v ^ ~M & A, t[5] = y ^ ~b & x, t[14] = I ^ ~O & C, t[15] = T ^ ~B & _, t[24] = W ^ ~U & j, t[25] = F ^ ~$ & q, t[34] = V ^ ~K & Q, t[35] = J ^ ~X & Y, t[44] = nt ^ ~ot & ht, t[45] = st ^ ~at & ut, t[6] = M ^ ~A & m, t[7] = b ^ ~x & g, t[16] = O ^ ~C & E, t[17] = B ^ ~_ & R, t[26] = U ^ ~j & D, t[27] = $ ^ ~q & P, t[36] = K ^ ~Q & G, t[37] = X ^ ~Y & z, t[46] = ot ^ ~ht & tt, t[47] = at ^ ~ut & et, t[8] = A ^ ~m & p, t[9] = x ^ ~g & w, t[18] = C ^ ~E & k, t[19] = _ ^ ~R & S, t[28] = j ^ ~D & N, t[29] = q ^ ~P & L, t[38] = Q ^ ~G & H, t[39] = Y ^ ~z & Z, t[48] = ht ^ ~tt & it, t[49] = ut ^ ~et & rt, t[0] ^= _t[r], t[1] ^= _t[r + 1];
  }
},
    Pt = function Pt(t) {
  return function (e) {
    var i;

    if ("0x" === e.slice(0, 2)) {
      i = [];

      for (var r = 2, n = e.length; r < n; r += 2) {
        i.push(parseInt(e.slice(r, r + 2), 16));
      }
    } else i = e;

    return function (t, e) {
      for (var i, r = e.length, n = t.blocks, s = t.blockCount << 2, o = t.blockCount, a = t.outputBlocks, h = t.s, u = 0; u < r;) {
        if (t.reset) for (t.reset = !1, n[0] = t.block, d = 1; d < o + 1; ++d) {
          n[d] = 0;
        }
        if ("string" != typeof e) for (d = t.start; u < r && d < s; ++u) {
          n[d >> 2] |= e[u] << Ct[3 & d++];
        } else for (d = t.start; u < r && d < s; ++u) {
          (i = e.charCodeAt(u)) < 128 ? n[d >> 2] |= i << Ct[3 & d++] : i < 2048 ? (n[d >> 2] |= (192 | i >> 6) << Ct[3 & d++], n[d >> 2] |= (128 | 63 & i) << Ct[3 & d++]) : i < 55296 || i >= 57344 ? (n[d >> 2] |= (224 | i >> 12) << Ct[3 & d++], n[d >> 2] |= (128 | i >> 6 & 63) << Ct[3 & d++], n[d >> 2] |= (128 | 63 & i) << Ct[3 & d++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++u)), n[d >> 2] |= (240 | i >> 18) << Ct[3 & d++], n[d >> 2] |= (128 | i >> 12 & 63) << Ct[3 & d++], n[d >> 2] |= (128 | i >> 6 & 63) << Ct[3 & d++], n[d >> 2] |= (128 | 63 & i) << Ct[3 & d++]);
        }

        if (t.lastByteIndex = d, d >= s) {
          for (t.start = d - s, t.block = n[o], d = 0; d < o; ++d) {
            h[d] ^= n[d];
          }

          Dt(h), t.reset = !0;
        } else t.start = d;
      }

      if (n[(d = t.lastByteIndex) >> 2] |= Bt[3 & d], t.lastByteIndex === s) for (n[0] = n[o], d = 1; d < o + 1; ++d) {
        n[d] = 0;
      }

      for (n[o - 1] |= 2147483648, d = 0; d < o; ++d) {
        h[d] ^= n[d];
      }

      Dt(h);

      for (var l, c = "", d = 0, f = 0; f < a;) {
        for (d = 0; d < o && f < a; ++d, ++f) {
          c += Ot[(l = h[d]) >> 4 & 15] + Ot[15 & l] + Ot[l >> 12 & 15] + Ot[l >> 8 & 15] + Ot[l >> 20 & 15] + Ot[l >> 16 & 15] + Ot[l >> 28 & 15] + Ot[l >> 24 & 15];
        }

        f % o == 0 && (Dt(h), d = 0);
      }

      return "0x" + c;
    }(function (t) {
      return {
        blocks: [],
        reset: !0,
        block: 0,
        start: 0,
        blockCount: 1600 - (t << 1) >> 5,
        outputBlocks: t >> 5,
        s: (e = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [].concat(e, e, e, e, e))
      };
      var e;
    }(t), i);
  };
};

var Nt = {
  keccak256: Pt(256),
  keccak512: Pt(512),
  keccak256s: Pt(256),
  keccak512s: Pt(512)
},
    Lt = pt(function (t) {
  !function () {
    var e = "input is invalid type",
        i = "object" == typeof window,
        r = i ? window : {};
    r.JS_SHA3_NO_WINDOW && (i = !1);
    var n = !i && "object" == typeof self;
    !r.JS_SHA3_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node ? r = gt : n && (r = self);
    var s = !r.JS_SHA3_NO_COMMON_JS && t.exports,
        o = !r.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
        a = "0123456789abcdef".split(""),
        h = [4, 1024, 262144, 67108864],
        u = [0, 8, 16, 24],
        l = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
        c = [224, 256, 384, 512],
        d = [128, 256],
        f = ["hex", "buffer", "arrayBuffer", "array", "digest"],
        m = {
      128: 168,
      256: 136
    };
    !r.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    }), !o || !r.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (t) {
      return "object" == typeof t && t.buffer && t.buffer.constructor === ArrayBuffer;
    });

    for (var g = function g(t, e, i) {
      return function (r) {
        return new O(t, e, t).update(r)[i]();
      };
    }, p = function p(t, e, i) {
      return function (r, n) {
        return new O(t, e, n).update(r)[i]();
      };
    }, w = function w(t, e, i) {
      return function (e, r, n, s) {
        return A["cshake" + t].update(e, r, n, s)[i]();
      };
    }, v = function v(t, e, i) {
      return function (e, r, n, s) {
        return A["kmac" + t].update(e, r, n, s)[i]();
      };
    }, y = function y(t, e, i, r) {
      for (var n = 0; n < f.length; ++n) {
        var s = f[n];
        t[s] = e(i, r, s);
      }

      return t;
    }, M = function M(t, e) {
      var i = g(t, e, "hex");
      return i.create = function () {
        return new O(t, e, t);
      }, i.update = function (t) {
        return i.create().update(t);
      }, y(i, g, t, e);
    }, b = [{
      name: "keccak",
      padding: [1, 256, 65536, 16777216],
      bits: c,
      createMethod: M
    }, {
      name: "sha3",
      padding: [6, 1536, 393216, 100663296],
      bits: c,
      createMethod: M
    }, {
      name: "shake",
      padding: [31, 7936, 2031616, 520093696],
      bits: d,
      createMethod: function createMethod(t, e) {
        var i = p(t, e, "hex");
        return i.create = function (i) {
          return new O(t, e, i);
        }, i.update = function (t, e) {
          return i.create(e).update(t);
        }, y(i, p, t, e);
      }
    }, {
      name: "cshake",
      padding: h,
      bits: d,
      createMethod: function createMethod(t, e) {
        var i = m[t],
            r = w(t, 0, "hex");
        return r.create = function (r, n, s) {
          return n || s ? new O(t, e, r).bytepad([n, s], i) : A["shake" + t].create(r);
        }, r.update = function (t, e, i, n) {
          return r.create(e, i, n).update(t);
        }, y(r, w, t, e);
      }
    }, {
      name: "kmac",
      padding: h,
      bits: d,
      createMethod: function createMethod(t, e) {
        var i = m[t],
            r = v(t, 0, "hex");
        return r.create = function (r, n, s) {
          return new B(t, e, n).bytepad(["KMAC", s], i).bytepad([r], i);
        }, r.update = function (t, e, i, n) {
          return r.create(t, i, n).update(e);
        }, y(r, v, t, e);
      }
    }], A = {}, x = [], E = 0; E < b.length; ++E) {
      for (var R = b[E], k = R.bits, S = 0; S < k.length; ++S) {
        var I = R.name + "_" + k[S];

        if (x.push(I), A[I] = R.createMethod(k[S], R.padding), "sha3" !== R.name) {
          var T = R.name + k[S];
          x.push(T), A[T] = A[I];
        }
      }
    }

    function O(t, e, i) {
      this.blocks = [], this.s = [], this.padding = e, this.outputBits = i, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (t << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = i >> 5, this.extraBytes = (31 & i) >> 3;

      for (var r = 0; r < 50; ++r) {
        this.s[r] = 0;
      }
    }

    function B(t, e, i) {
      O.call(this, t, e, i);
    }

    O.prototype.update = function (t) {
      if (this.finalized) throw new Error("finalize already called");
      var i,
          r = typeof t;

      if ("string" !== r) {
        if ("object" !== r) throw new Error(e);
        if (null === t) throw new Error(e);
        if (o && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!(Array.isArray(t) || o && ArrayBuffer.isView(t))) throw new Error(e);
        i = !0;
      }

      for (var n, s, a = this.blocks, h = this.byteCount, l = t.length, c = this.blockCount, d = 0, f = this.s; d < l;) {
        if (this.reset) for (this.reset = !1, a[0] = this.block, n = 1; n < c + 1; ++n) {
          a[n] = 0;
        }
        if (i) for (n = this.start; d < l && n < h; ++d) {
          a[n >> 2] |= t[d] << u[3 & n++];
        } else for (n = this.start; d < l && n < h; ++d) {
          (s = t.charCodeAt(d)) < 128 ? a[n >> 2] |= s << u[3 & n++] : s < 2048 ? (a[n >> 2] |= (192 | s >> 6) << u[3 & n++], a[n >> 2] |= (128 | 63 & s) << u[3 & n++]) : s < 55296 || s >= 57344 ? (a[n >> 2] |= (224 | s >> 12) << u[3 & n++], a[n >> 2] |= (128 | s >> 6 & 63) << u[3 & n++], a[n >> 2] |= (128 | 63 & s) << u[3 & n++]) : (s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(++d)), a[n >> 2] |= (240 | s >> 18) << u[3 & n++], a[n >> 2] |= (128 | s >> 12 & 63) << u[3 & n++], a[n >> 2] |= (128 | s >> 6 & 63) << u[3 & n++], a[n >> 2] |= (128 | 63 & s) << u[3 & n++]);
        }

        if (this.lastByteIndex = n, n >= h) {
          for (this.start = n - h, this.block = a[c], n = 0; n < c; ++n) {
            f[n] ^= a[n];
          }

          C(f), this.reset = !0;
        } else this.start = n;
      }

      return this;
    }, O.prototype.encode = function (t, e) {
      var i = 255 & t,
          r = 1,
          n = [i];

      for (i = 255 & (t >>= 8); i > 0;) {
        n.unshift(i), i = 255 & (t >>= 8), ++r;
      }

      return e ? n.push(r) : n.unshift(r), this.update(n), n.length;
    }, O.prototype.encodeString = function (t) {
      var i,
          r = typeof t;

      if ("string" !== r) {
        if ("object" !== r) throw new Error(e);
        if (null === t) throw new Error(e);
        if (o && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!(Array.isArray(t) || o && ArrayBuffer.isView(t))) throw new Error(e);
        i = !0;
      }

      var n = 0;
      if (i) n = t.length;else for (var s = 0; s < t.length; ++s) {
        var a = t.charCodeAt(s);
        a < 128 ? n += 1 : a < 2048 ? n += 2 : a < 55296 || a >= 57344 ? n += 3 : (a = 65536 + ((1023 & a) << 10 | 1023 & t.charCodeAt(++s)), n += 4);
      }
      return n += this.encode(8 * n), this.update(t), n;
    }, O.prototype.bytepad = function (t, e) {
      for (var i = this.encode(e), r = 0; r < t.length; ++r) {
        i += this.encodeString(t[r]);
      }

      var n = [];
      return n.length = e - i % e, this.update(n), this;
    }, O.prototype.finalize = function () {
      if (!this.finalized) {
        this.finalized = !0;
        var t = this.blocks,
            e = this.lastByteIndex,
            i = this.blockCount,
            r = this.s;
        if (t[e >> 2] |= this.padding[3 & e], this.lastByteIndex === this.byteCount) for (t[0] = t[i], e = 1; e < i + 1; ++e) {
          t[e] = 0;
        }

        for (t[i - 1] |= 2147483648, e = 0; e < i; ++e) {
          r[e] ^= t[e];
        }

        C(r);
      }
    }, O.prototype.toString = O.prototype.hex = function () {
      this.finalize();

      for (var t, e = this.blockCount, i = this.s, r = this.outputBlocks, n = this.extraBytes, s = 0, o = 0, h = ""; o < r;) {
        for (s = 0; s < e && o < r; ++s, ++o) {
          h += a[(t = i[s]) >> 4 & 15] + a[15 & t] + a[t >> 12 & 15] + a[t >> 8 & 15] + a[t >> 20 & 15] + a[t >> 16 & 15] + a[t >> 28 & 15] + a[t >> 24 & 15];
        }

        o % e == 0 && (C(i), s = 0);
      }

      return n && (h += a[(t = i[s]) >> 4 & 15] + a[15 & t], n > 1 && (h += a[t >> 12 & 15] + a[t >> 8 & 15]), n > 2 && (h += a[t >> 20 & 15] + a[t >> 16 & 15])), h;
    }, O.prototype.buffer = O.prototype.arrayBuffer = function () {
      this.finalize();
      var t,
          e = this.blockCount,
          i = this.s,
          r = this.outputBlocks,
          n = this.extraBytes,
          s = 0,
          o = 0,
          a = this.outputBits >> 3;
      t = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(a);

      for (var h = new Uint32Array(t); o < r;) {
        for (s = 0; s < e && o < r; ++s, ++o) {
          h[o] = i[s];
        }

        o % e == 0 && C(i);
      }

      return n && (h[s] = i[s], t = t.slice(0, a)), t;
    }, O.prototype.digest = O.prototype.array = function () {
      this.finalize();

      for (var t, e, i = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, a = 0, h = []; a < n;) {
        for (o = 0; o < i && a < n; ++o, ++a) {
          h[t = a << 2] = 255 & (e = r[o]), h[t + 1] = e >> 8 & 255, h[t + 2] = e >> 16 & 255, h[t + 3] = e >> 24 & 255;
        }

        a % i == 0 && C(r);
      }

      return s && (h[t = a << 2] = 255 & (e = r[o]), s > 1 && (h[t + 1] = e >> 8 & 255), s > 2 && (h[t + 2] = e >> 16 & 255)), h;
    }, (B.prototype = new O()).finalize = function () {
      return this.encode(this.outputBits, !0), O.prototype.finalize.call(this);
    };

    var C = function C(t) {
      var e, i, r, n, s, o, a, h, u, c, d, f, m, g, p, w, v, y, M, b, A, x, E, R, k, S, I, T, O, B, C, _, D, P, N, L, W, F, U, $, j, q, G, z, H, Z, V, J, K, X, Q, Y, tt, et, it, rt, nt, st, ot, at, ht, ut, lt;

      for (r = 0; r < 48; r += 2) {
        n = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], s = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], h = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], c = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], d = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], i = (m = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ ((a = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43]) << 1 | (o = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42]) >>> 31), t[0] ^= e = (f = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (o << 1 | a >>> 31), t[1] ^= i, t[10] ^= e, t[11] ^= i, t[20] ^= e, t[21] ^= i, t[30] ^= e, t[31] ^= i, t[40] ^= e, t[41] ^= i, i = s ^ (u << 1 | h >>> 31), t[2] ^= e = n ^ (h << 1 | u >>> 31), t[3] ^= i, t[12] ^= e, t[13] ^= i, t[22] ^= e, t[23] ^= i, t[32] ^= e, t[33] ^= i, t[42] ^= e, t[43] ^= i, i = a ^ (d << 1 | c >>> 31), t[4] ^= e = o ^ (c << 1 | d >>> 31), t[5] ^= i, t[14] ^= e, t[15] ^= i, t[24] ^= e, t[25] ^= i, t[34] ^= e, t[35] ^= i, t[44] ^= e, t[45] ^= i, i = u ^ (m << 1 | f >>> 31), t[6] ^= e = h ^ (f << 1 | m >>> 31), t[7] ^= i, t[16] ^= e, t[17] ^= i, t[26] ^= e, t[27] ^= i, t[36] ^= e, t[37] ^= i, t[46] ^= e, t[47] ^= i, i = d ^ (s << 1 | n >>> 31), t[8] ^= e = c ^ (n << 1 | s >>> 31), t[9] ^= i, t[18] ^= e, t[19] ^= i, t[28] ^= e, t[29] ^= i, t[38] ^= e, t[39] ^= i, t[48] ^= e, t[49] ^= i, p = t[1], Z = t[11] << 4 | t[10] >>> 28, V = t[10] << 4 | t[11] >>> 28, T = t[20] << 3 | t[21] >>> 29, O = t[21] << 3 | t[20] >>> 29, at = t[31] << 9 | t[30] >>> 23, ht = t[30] << 9 | t[31] >>> 23, q = t[40] << 18 | t[41] >>> 14, G = t[41] << 18 | t[40] >>> 14, P = t[2] << 1 | t[3] >>> 31, N = t[3] << 1 | t[2] >>> 31, v = t[12] << 12 | t[13] >>> 20, J = t[22] << 10 | t[23] >>> 22, K = t[23] << 10 | t[22] >>> 22, B = t[33] << 13 | t[32] >>> 19, C = t[32] << 13 | t[33] >>> 19, ut = t[42] << 2 | t[43] >>> 30, lt = t[43] << 2 | t[42] >>> 30, et = t[5] << 30 | t[4] >>> 2, it = t[4] << 30 | t[5] >>> 2, L = t[14] << 6 | t[15] >>> 26, W = t[15] << 6 | t[14] >>> 26, M = t[24] << 11 | t[25] >>> 21, X = t[34] << 15 | t[35] >>> 17, Q = t[35] << 15 | t[34] >>> 17, _ = t[45] << 29 | t[44] >>> 3, D = t[44] << 29 | t[45] >>> 3, R = t[6] << 28 | t[7] >>> 4, k = t[7] << 28 | t[6] >>> 4, rt = t[17] << 23 | t[16] >>> 9, nt = t[16] << 23 | t[17] >>> 9, F = t[26] << 25 | t[27] >>> 7, U = t[27] << 25 | t[26] >>> 7, b = t[36] << 21 | t[37] >>> 11, A = t[37] << 21 | t[36] >>> 11, Y = t[47] << 24 | t[46] >>> 8, tt = t[46] << 24 | t[47] >>> 8, z = t[8] << 27 | t[9] >>> 5, H = t[9] << 27 | t[8] >>> 5, S = t[18] << 20 | t[19] >>> 12, I = t[19] << 20 | t[18] >>> 12, st = t[29] << 7 | t[28] >>> 25, ot = t[28] << 7 | t[29] >>> 25, $ = t[38] << 8 | t[39] >>> 24, j = t[39] << 8 | t[38] >>> 24, x = t[48] << 14 | t[49] >>> 18, E = t[49] << 14 | t[48] >>> 18, t[0] = (g = t[0]) ^ ~(w = t[13] << 12 | t[12] >>> 20) & (y = t[25] << 11 | t[24] >>> 21), t[1] = p ^ ~v & M, t[10] = R ^ ~S & T, t[11] = k ^ ~I & O, t[20] = P ^ ~L & F, t[21] = N ^ ~W & U, t[30] = z ^ ~Z & J, t[31] = H ^ ~V & K, t[40] = et ^ ~rt & st, t[41] = it ^ ~nt & ot, t[2] = w ^ ~y & b, t[3] = v ^ ~M & A, t[12] = S ^ ~T & B, t[13] = I ^ ~O & C, t[22] = L ^ ~F & $, t[23] = W ^ ~U & j, t[32] = Z ^ ~J & X, t[33] = V ^ ~K & Q, t[42] = rt ^ ~st & at, t[43] = nt ^ ~ot & ht, t[4] = y ^ ~b & x, t[5] = M ^ ~A & E, t[14] = T ^ ~B & _, t[15] = O ^ ~C & D, t[24] = F ^ ~$ & q, t[25] = U ^ ~j & G, t[34] = J ^ ~X & Y, t[35] = K ^ ~Q & tt, t[44] = st ^ ~at & ut, t[45] = ot ^ ~ht & lt, t[6] = b ^ ~x & g, t[7] = A ^ ~E & p, t[16] = B ^ ~_ & R, t[17] = C ^ ~D & k, t[26] = $ ^ ~q & P, t[27] = j ^ ~G & N, t[36] = X ^ ~Y & z, t[37] = Q ^ ~tt & H, t[46] = at ^ ~ut & et, t[47] = ht ^ ~lt & it, t[8] = x ^ ~g & w, t[9] = E ^ ~p & v, t[18] = _ ^ ~R & S, t[19] = D ^ ~k & I, t[28] = q ^ ~P & L, t[29] = G ^ ~N & W, t[38] = Y ^ ~z & Z, t[39] = tt ^ ~H & V, t[48] = ut ^ ~et & rt, t[49] = lt ^ ~it & nt, t[0] ^= l[r], t[1] ^= l[r + 1];
      }
    };

    if (s) t.exports = A;else for (E = 0; E < x.length; ++E) {
      r[x[E]] = A[x[E]];
    }
  }();
});

function Wt(t) {
  if (null == t) throw new Error("cannot convert null value to array");

  if ("string" == typeof t) {
    var _e4 = t.match(/^(0x)?[0-9a-fA-F]*$/);

    if (!_e4) throw new Error("invalid hexidecimal string");
    if ("0x" !== _e4[1]) throw new Error("hex string must have 0x prefix");
    (t = t.substring(2)).length % 2 && (t = "0" + t);
    var _i3 = [];

    for (var _e5 = 0; _e5 < t.length; _e5 += 2) {
      _i3.push(parseInt(t.substr(_e5, 2), 16));
    }

    return Ft(new Uint8Array(_i3));
  }

  if (function (t) {
    if (!t || parseInt(String(t.length)) != t.length || "string" == typeof t) return !1;

    for (var _e6 = 0; _e6 < t.length; _e6++) {
      var _i4 = t[_e6];
      if (_i4 < 0 || _i4 >= 256 || parseInt(String(_i4)) != _i4) return !1;
    }

    return !0;
  }(t)) return Ft(new Uint8Array(t));
  throw new Error("invalid arrayify value");
}

function Ft(t) {
  var _arguments = arguments;
  return void 0 !== t.slice || (t.slice = function () {
    var e = Array.prototype.slice.call(_arguments);
    return Ft(new Uint8Array(Array.prototype.slice.apply(t, e)));
  }), t;
}

var Ut = /*#__PURE__*/Object.defineProperty({
  keccak256: function keccak256(t) {
    return "0x" + Lt.keccak_256(Wt(t));
  },
  padLeft: function padLeft(t, e) {
    var i = /^0x/i.test(t) || "number" == typeof t;
    return t = t.toString().replace(/^0x/i, ""), (i ? "0x" : "") + new Array(e - t.length + 1 >= 0 ? e - t.length + 1 : 0).join("0") + t;
  },
  bytesToHex: function bytesToHex(t) {
    var e = [];

    for (var _i5 = 0; _i5 < t.length; _i5++) {
      e.push((t[_i5] >>> 4).toString(16)), e.push((15 & t[_i5]).toString(16));
    }

    return "0x".concat(e.join("").replace(/^0+/, ""));
  },
  toByteArray: Wt
}, "__esModule", {
  value: !0
});

function $t(t) {
  return !("string" != typeof t || !/^(0x)?[0-9a-f]{512}$/i.test(t) || !/^(0x)?[0-9a-f]{512}$/.test(t) && !/^(0x)?[0-9A-F]{512}$/.test(t));
}

function jt(t, e) {
  "object" == typeof e && e.constructor === Uint8Array && (e = Ut.bytesToHex(e));
  var i = Ut.keccak256(e).replace("0x", "");

  for (var _e7 = 0; _e7 < 12; _e7 += 4) {
    var _r2 = (parseInt(i.substr(_e7, 2), 16) << 8) + parseInt(i.substr(_e7 + 2, 2), 16) & 2047,
        _n2 = 1 << _r2 % 4;

    if ((qt(t.charCodeAt(t.length - 1 - Math.floor(_r2 / 4))) & _n2) !== _n2) return !1;
  }

  return !0;
}

function qt(t) {
  if (t >= 48 && t <= 57) return t - 48;
  if (t >= 65 && t <= 70) return t - 55;
  if (t >= 97 && t <= 102) return t - 87;
  throw new Error("invalid bloom");
}

function Gt(t) {
  return !("string" != typeof t || !/^(0x)?[0-9a-f]{64}$/i.test(t) || !/^(0x)?[0-9a-f]{64}$/.test(t) && !/^(0x)?[0-9A-F]{64}$/.test(t));
}

function zt(t) {
  return !("string" != typeof t || !t.match(/^(0x)?[0-9a-fA-F]{40}$/) && !t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/));
}

var Ht = /*#__PURE__*/Object.defineProperty({
  isBloom: $t,
  isInBloom: jt,
  isUserEthereumAddressInBloom: function isUserEthereumAddressInBloom(t, e) {
    if (!$t(t)) throw new Error("Invalid bloom given");
    if (!zt(e)) throw new Error("Invalid ethereum address given: \"".concat(e, "\""));
    return jt(t, Ut.padLeft(e, 64));
  },
  isContractAddressInBloom: function isContractAddressInBloom(t, e) {
    if (!$t(t)) throw new Error("Invalid bloom given");
    if (!zt(e)) throw new Error("Invalid contract address given: \"".concat(e, "\""));
    return jt(t, e);
  },
  isTopicInBloom: function isTopicInBloom(t, e) {
    if (!$t(t)) throw new Error("Invalid bloom given");
    if (!Gt(e)) throw new Error("Invalid topic");
    return jt(t, e);
  },
  isTopic: Gt,
  isAddress: zt
}, "__esModule", {
  value: !0
}),
    Zt = function Zt(t) {
  return It.isBN(t);
},
    Vt = function Vt(t) {
  return t && t.constructor && "BigNumber" === t.constructor.name;
},
    Jt = function Jt(t) {
  try {
    return bt.apply(null, arguments);
  } catch (e) {
    throw new Error(e + ' Given value: "' + t + '"');
  }
},
    Kt = function Kt(t) {
  return !!/^(0x)?[0-9a-f]{40}$/i.test(t) && (!(!/^(0x|0X)?[0-9a-f]{40}$/.test(t) && !/^(0x|0X)?[0-9A-F]{40}$/.test(t)) || Xt(t));
},
    Xt = function Xt(t) {
  t = t.replace(/^0x/i, "");

  for (var e = oe(t.toLowerCase()).replace(/^0x/i, ""), i = 0; i < 40; i++) {
    if (parseInt(e[i], 16) > 7 && t[i].toUpperCase() !== t[i] || parseInt(e[i], 16) <= 7 && t[i].toLowerCase() !== t[i]) return !1;
  }

  return !0;
},
    Qt = function Qt(t) {
  var e = "";
  t = (t = (t = (t = (t = Tt.encode(t)).replace(/^(?:\u0000)*/, "")).split("").reverse().join("")).replace(/^(?:\u0000)*/, "")).split("").reverse().join("");

  for (var i = 0; i < t.length; i++) {
    var r = t.charCodeAt(i).toString(16);
    e += r.length < 2 ? "0" + r : r;
  }

  return "0x" + e;
},
    Yt = function Yt(t) {
  if (!t) return t;
  if ("string" == typeof t && !re(t)) throw new Error('Given value "' + t + '" is not a valid hex string.');
  return Jt(t).toNumber();
},
    te = function te(t) {
  if (null == t) return t;
  if (!isFinite(t) && !re(t)) throw new Error('Given input "' + t + '" is not a number.');
  var e = Jt(t),
      i = e.toString(16);
  return e.lt(new It(0)) ? "-0x" + i.substr(1) : "0x" + i;
},
    ee = function ee(t) {
  if (t = t.toString(16), !re(t)) throw new Error('Given value "' + t + '" is not a valid hex string.');
  t = t.replace(/^0x/i, "");

  for (var e = [], i = 0; i < t.length; i += 2) {
    e.push(parseInt(t.substr(i, 2), 16));
  }

  return e;
},
    ie = function ie(t, e) {
  if (Kt(t)) return e ? "address" : "0x" + t.toLowerCase().replace(/^0x/i, "");
  if ("boolean" == typeof t) return e ? "bool" : t ? "0x01" : "0x00";
  if (Buffer.isBuffer(t)) return "0x" + t.toString("hex");
  if ("object" == typeof t && t && !Vt(t) && !Zt(t)) return e ? "string" : Qt(JSON.stringify(t));

  if ("string" == typeof t) {
    if (0 === t.indexOf("-0x") || 0 === t.indexOf("-0X")) return e ? "int256" : te(t);
    if (0 === t.indexOf("0x") || 0 === t.indexOf("0X")) return e ? "bytes" : t;
    if (!isFinite(t)) return e ? "string" : Qt(t);
  }

  return e ? t < 0 ? "int256" : "uint256" : te(t);
},
    re = function re(t) {
  return ("string" == typeof t || "number" == typeof t) && /^(-)?0x[0-9a-f]*$/i.test(t);
},
    ne = function ne(t) {
  return ("string" == typeof t || "number" == typeof t) && /^(-0x|0x)?[0-9a-f]*$/i.test(t);
},
    se = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
    oe = function oe(t) {
  Zt(t) && (t = t.toString()), re(t) && /^0x/i.test(t.toString()) && (t = ee(t));
  var e = Nt.keccak256(t);
  return e === se ? null : e;
};

oe._Hash = Nt;

var ae,
    he,
    ue,
    le = {
  BN: It,
  isBN: Zt,
  isBigNumber: Vt,
  toBN: Jt,
  isAddress: Kt,
  isBloom: function isBloom(t) {
    return Ht.isBloom(t);
  },
  isUserEthereumAddressInBloom: function isUserEthereumAddressInBloom(t, e) {
    return Ht.isUserEthereumAddressInBloom(t, e);
  },
  isContractAddressInBloom: function isContractAddressInBloom(t, e) {
    return Ht.isContractAddressInBloom(t, e);
  },
  isTopic: function isTopic(t) {
    return Ht.isTopic(t);
  },
  isTopicInBloom: function isTopicInBloom(t, e) {
    return Ht.isTopicInBloom(t, e);
  },
  isInBloom: function isInBloom(t, e) {
    return Ht.isInBloom(t, e);
  },
  checkAddressChecksum: Xt,
  utf8ToHex: Qt,
  hexToUtf8: function hexToUtf8(t) {
    if (!re(t)) throw new Error('The parameter "' + t + '" must be a valid HEX string.');

    for (var e = "", i = 0, r = (t = (t = (t = (t = (t = t.replace(/^0x/i, "")).replace(/^(?:00)*/, "")).split("").reverse().join("")).replace(/^(?:00)*/, "")).split("").reverse().join("")).length, n = 0; n < r; n += 2) {
      i = parseInt(t.substr(n, 2), 16), e += String.fromCharCode(i);
    }

    return Tt.decode(e);
  },
  hexToNumber: Yt,
  hexToNumberString: function hexToNumberString(t) {
    if (!t) return t;
    if ("string" == typeof t && !re(t)) throw new Error('Given value "' + t + '" is not a valid hex string.');
    return Jt(t).toString(10);
  },
  numberToHex: te,
  toHex: ie,
  hexToBytes: ee,
  bytesToHex: function bytesToHex(t) {
    for (var e = [], i = 0; i < t.length; i++) {
      e.push((t[i] >>> 4).toString(16)), e.push((15 & t[i]).toString(16));
    }

    return "0x" + e.join("");
  },
  isHex: ne,
  isHexStrict: re,
  stripHexPrefix: function stripHexPrefix(t) {
    return 0 !== t && ne(t) ? t.replace(/^(-)?0x/i, "$1") : t;
  },
  leftPad: function leftPad(t, e, i) {
    var r = /^0x/i.test(t) || "number" == typeof t;
    return t = t.toString(16).replace(/^0x/i, ""), (r ? "0x" : "") + new Array(e - t.length + 1 >= 0 ? e - t.length + 1 : 0).join(i || "0") + t;
  },
  rightPad: function rightPad(t, e, i) {
    return (/^0x/i.test(t) || "number" == typeof t ? "0x" : "") + (t = t.toString(16).replace(/^0x/i, "")) + new Array(e - t.length + 1 >= 0 ? e - t.length + 1 : 0).join(i || "0");
  },
  toTwosComplement: function toTwosComplement(t) {
    return "0x" + Jt(t).toTwos(256).toString(16, 64);
  },
  sha3: oe,
  sha3Raw: function sha3Raw(t) {
    return null === (t = oe(t)) ? se : t;
  },
  toNumber: function toNumber(t) {
    return "number" == typeof t ? t : Yt(ie(t));
  }
},
    ce = function ce(t) {
  var e = typeof t;
  if ("string" === e) return le.isHexStrict(t) ? new It(t.replace(/0x/i, ""), 16) : new It(t, 10);
  if ("number" === e) return new It(t);
  if (le.isBigNumber(t)) return new It(t.toString(10));
  if (le.isBN(t)) return t;
  throw new Error(t + " is not a number");
},
    de = function de(t, e, i) {
  var r, n, s;

  if ("bytes" === (t = (s = t).startsWith("int[") ? "int256" + s.slice(3) : "int" === s ? "int256" : s.startsWith("uint[") ? "uint256" + s.slice(4) : "uint" === s ? "uint256" : s.startsWith("fixed[") ? "fixed128x128" + s.slice(5) : "fixed" === s ? "fixed128x128" : s.startsWith("ufixed[") ? "ufixed128x128" + s.slice(6) : "ufixed" === s ? "ufixed128x128" : s)) {
    if (e.replace(/^0x/i, "").length % 2 != 0) throw new Error("Invalid bytes characters " + e.length);
    return e;
  }

  if ("string" === t) return le.utf8ToHex(e);
  if ("bool" === t) return e ? "01" : "00";

  if (t.startsWith("address")) {
    if (r = i ? 64 : 40, !le.isAddress(e)) throw new Error(e + " is not a valid address, or the checksum is invalid.");
    return le.leftPad(e.toLowerCase(), r);
  }

  if (r = function (t) {
    var e = /^\D+(\d+).*$/.exec(t);
    return e ? parseInt(e[1], 10) : null;
  }(t), t.startsWith("bytes")) {
    if (!r) throw new Error("bytes[] not yet supported in solidity");
    if (i && (r = 32), r < 1 || r > 32 || r < e.replace(/^0x/i, "").length / 2) throw new Error("Invalid bytes" + r + " for " + e);
    return le.rightPad(e, 2 * r);
  }

  if (t.startsWith("uint")) {
    if (r % 8 || r < 8 || r > 256) throw new Error("Invalid uint" + r + " size");
    if ((n = ce(e)).bitLength() > r) throw new Error("Supplied uint exceeds width: " + r + " vs " + n.bitLength());
    if (n.lt(new It(0))) throw new Error("Supplied uint " + n.toString() + " is negative");
    return r ? le.leftPad(n.toString("hex"), r / 8 * 2) : n;
  }

  if (t.startsWith("int")) {
    if (r % 8 || r < 8 || r > 256) throw new Error("Invalid int" + r + " size");
    if ((n = ce(e)).bitLength() > r) throw new Error("Supplied int exceeds width: " + r + " vs " + n.bitLength());
    return n.lt(new It(0)) ? n.toTwos(r).toString("hex") : r ? le.leftPad(n.toString("hex"), r / 8 * 2) : n;
  }

  throw new Error("Unsupported or invalid type: " + t);
},
    fe = function fe(t) {
  if (Array.isArray(t)) throw new Error("Autodetection of array types is not supported.");
  var e,
      i,
      r = "";

  if (t && "object" == typeof t && (t.hasOwnProperty("v") || t.hasOwnProperty("t") || t.hasOwnProperty("value") || t.hasOwnProperty("type")) ? (e = t.hasOwnProperty("t") ? t.t : t.type, r = t.hasOwnProperty("v") ? t.v : t.value) : (e = le.toHex(t, !0), r = le.toHex(t), e.startsWith("int") || e.startsWith("uint") || (e = "bytes")), !e.startsWith("int") && !e.startsWith("uint") || "string" != typeof r || /^(-)?0x/i.test(r) || (r = new It(r)), Array.isArray(r)) {
    if ((i = function (t) {
      var e = /^\D+\d*\[(\d+)\]$/.exec(t);
      return e ? parseInt(e[1], 10) : null;
    }(e)) && r.length !== i) throw new Error(e + " is not matching the given array " + JSON.stringify(r));
    i = r.length;
  }

  return Array.isArray(r) ? r.map(function (t) {
    return de(e, t, i).toString("hex").replace("0x", "");
  }).join("") : de(e, r, i).toString("hex").replace("0x", "");
},
    me = {
  soliditySha3: function soliditySha3() {
    var t = Array.prototype.slice.call(arguments),
        e = t.map(fe);
    return le.sha3("0x" + e.join(""));
  },
  soliditySha3Raw: function soliditySha3Raw() {
    return le.sha3Raw("0x" + Array.prototype.slice.call(arguments).map(fe).join(""));
  },
  encodePacked: function encodePacked() {
    var t = Array.prototype.slice.call(arguments),
        e = t.map(fe);
    return "0x" + e.join("").toLowerCase();
  }
},
    ge = a.randomBytes,
    pe = function pe(t, e) {
  var i = [];
  return e.forEach(function (e) {
    if ("object" == typeof e.components) {
      if ("tuple" !== e.type.substring(0, 5)) throw new Error("components found but type is not tuple; report on GitHub");
      var r = "",
          n = e.type.indexOf("[");
      n >= 0 && (r = e.type.substring(n));
      var s = pe(t, e.components);
      Array.isArray(s) && t ? i.push("tuple(" + s.join(",") + ")" + r) : i.push(t ? "(" + s + ")" : "(" + s.join(",") + ")" + r);
    } else i.push(e.type);
  }), i;
},
    we = function we(t) {
  if (!le.isHexStrict(t)) throw new Error("The parameter must be a valid HEX string.");
  var e = "",
      i = 0,
      r = t.length;

  for ("0x" === t.substring(0, 2) && (i = 2); i < r; i += 2) {
    var n = parseInt(t.substr(i, 2), 16);
    e += String.fromCharCode(n);
  }

  return e;
},
    ve = function ve(t) {
  if (!t) return "0x00";

  for (var e = "", i = 0; i < t.length; i++) {
    var r = t.charCodeAt(i).toString(16);
    e += r.length < 2 ? "0" + r : r;
  }

  return "0x" + e;
},
    ye = function ye(t) {
  if (t = t ? t.toLowerCase() : "ether", !St.unitMap[t]) throw new Error('This unit "' + t + "\" doesn't exist, please use the one of the following units" + JSON.stringify(St.unitMap, null, 2));
  return t;
},
    Me = {
  _fireError: function _fireError(t, e, i, r, n) {
    return !t || "object" != typeof t || t instanceof Error || !t.data || ((t.data && "object" == typeof t.data || Array.isArray(t.data)) && (t.data = JSON.stringify(t.data, null, 2)), t = t.message + "\n" + t.data), "string" == typeof t && (t = new Error(t)), "function" == typeof r && r(t, n), "function" == typeof i && ((e && "function" == typeof e.listeners && e.listeners("error").length || "function" == typeof r) && e.catch(function () {}), setTimeout(function () {
      i(t);
    }, 1)), e && "function" == typeof e.emit && setTimeout(function () {
      e.emit("error", t, n), e.removeAllListeners();
    }, 1), e;
  },
  _jsonInterfaceMethodToString: function _jsonInterfaceMethodToString(t) {
    return t && "object" == typeof t && t.name && -1 !== t.name.indexOf("(") ? t.name : t.name + "(" + pe(!1, t.inputs).join(",") + ")";
  },
  _flattenTypes: pe,
  randomHex: function randomHex(t) {
    return "0x" + ge(t).toString("hex");
  },
  BN: le.BN,
  isBN: le.isBN,
  isBigNumber: le.isBigNumber,
  isHex: le.isHex,
  isHexStrict: le.isHexStrict,
  sha3: le.sha3,
  sha3Raw: le.sha3Raw,
  keccak256: le.sha3,
  soliditySha3: me.soliditySha3,
  soliditySha3Raw: me.soliditySha3Raw,
  encodePacked: me.encodePacked,
  isAddress: le.isAddress,
  checkAddressChecksum: le.checkAddressChecksum,
  toChecksumAddress: function toChecksumAddress(t) {
    if (void 0 === t) return "";
    if (!/^(0x)?[0-9a-f]{40}$/i.test(t)) throw new Error('Given address "' + t + '" is not a valid Ethereum address.');
    t = t.toLowerCase().replace(/^0x/i, "");

    for (var e = le.sha3(t).replace(/^0x/i, ""), i = "0x", r = 0; r < t.length; r++) {
      parseInt(e[r], 16) > 7 ? i += t[r].toUpperCase() : i += t[r];
    }

    return i;
  },
  toHex: le.toHex,
  toBN: le.toBN,
  bytesToHex: le.bytesToHex,
  hexToBytes: le.hexToBytes,
  hexToNumberString: le.hexToNumberString,
  hexToNumber: le.hexToNumber,
  toDecimal: le.hexToNumber,
  numberToHex: le.numberToHex,
  fromDecimal: le.numberToHex,
  hexToUtf8: le.hexToUtf8,
  hexToString: le.hexToUtf8,
  toUtf8: le.hexToUtf8,
  stripHexPrefix: le.stripHexPrefix,
  utf8ToHex: le.utf8ToHex,
  stringToHex: le.utf8ToHex,
  fromUtf8: le.utf8ToHex,
  hexToAscii: we,
  toAscii: we,
  asciiToHex: ve,
  fromAscii: ve,
  unitMap: St.unitMap,
  toWei: function toWei(t, e) {
    if (e = ye(e), !le.isBN(t) && "string" != typeof t) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return le.isBN(t) ? St.toWei(t, e) : St.toWei(t, e).toString(10);
  },
  fromWei: function fromWei(t, e) {
    if (e = ye(e), !le.isBN(t) && "string" != typeof t) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return le.isBN(t) ? St.fromWei(t, e) : St.fromWei(t, e).toString(10);
  },
  padLeft: le.leftPad,
  leftPad: le.leftPad,
  padRight: le.rightPad,
  rightPad: le.rightPad,
  toTwosComplement: le.toTwosComplement,
  isBloom: le.isBloom,
  isUserEthereumAddressInBloom: le.isUserEthereumAddressInBloom,
  isContractAddressInBloom: le.isContractAddressInBloom,
  isTopic: le.isTopic,
  isTopicInBloom: le.isTopicInBloom,
  isInBloom: le.isInBloom,
  compareBlockNumbers: function compareBlockNumbers(t, e) {
    if (t == e) return 0;

    if ("genesis" != t && "earliest" != t && 0 != t || "genesis" != e && "earliest" != e && 0 != e) {
      if ("genesis" == t || "earliest" == t) return -1;
      if ("genesis" == e || "earliest" == e) return 1;
      if ("latest" == t) return "pending" == e ? -1 : 1;
      if ("latest" === e) return "pending" == t ? 1 : -1;
      if ("pending" == t) return 1;
      if ("pending" == e) return -1;
      {
        var _i6 = new It(t),
            _r3 = new It(e);

        return _i6.lt(_r3) ? -1 : _i6.eq(_r3) ? 0 : 1;
      }
    }

    return 0;
  },
  toNumber: le.toNumber
};

function be(t, e, i) {
  var r = !1;

  if ("allow" === i) {
    if (t && t.allow) {
      var _i7 = t.allow.find(function (t) {
        return t.type === e;
      });

      r = _i7 && _i7.values.length > 0;
    }

    return r;
  }

  if (t && t.deny) {
    var _i8 = t.deny.find(function (t) {
      return t.type === e;
    });

    r = _i8 && _i8.values.length > 0;
  }

  return r;
}

function Ae(t, e, i) {
  var r = be(t.credentials, e, i);
  return "allow" === i ? (r && (t.credentials.allow = t.credentials.allow.filter(function (t) {
    return t.type !== e;
  })), t.credentials && !t.credentials.allow && (t.credentials = {
    deny: t.credentials && t.credentials.deny
  })) : (r && (t.credentials.deny = t.credentials.deny.filter(function (t) {
    return t.type !== e;
  })), t.credentials && !t.credentials.deny && (t.credentials = {
    allow: t.credentials && t.credentials.allow
  })), t;
}

function xe(t, e, i, r) {
  var n = be(t.credentials, e, r);
  return "allow" === r ? n ? t.credentials.allow.find(function (t) {
    t.type === e && (t.values = i);
  }) : t = Ee(t, e, i, r) : n ? t.credentials.deny.find(function (t) {
    t.type === e && (t.values = i);
  }) : t = Ee(t, e, i, r), t;
}

function Ee(t, e, i, r) {
  var n = {
    type: e,
    values: i
  };
  return "allow" === r ? t.credentials && t.credentials.allow ? t.credentials.allow.push(n) : t.credentials = {
    allow: [n],
    deny: t.credentials && t.credentials.deny
  } : t.credentials && t.credentials.deny ? t.credentials.deny.push(n) : t.credentials = {
    allow: t.credentials && t.credentials.allow,
    deny: [n]
  }, t;
}

var Re = /*#__PURE__*/function (_st4) {
  _inherits(Re, _st4);

  var _super4 = _createSuper(Re);

  function Re() {
    var _this8;

    _classCallCheck(this, Re);

    for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      t[_key8] = arguments[_key8];
    }

    _this8 = _super4.call.apply(_super4, [this].concat(t)), _this8.baseUrl = void 0;
    return _this8;
  }

  _createClass(Re, [{
    key: "setBaseUrl",
    value: function () {
      var _setBaseUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(t) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this.baseUrl = t;

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function setBaseUrl(_x74) {
        return _setBaseUrl2.apply(this, arguments);
      }

      return setBaseUrl;
    }()
  }, {
    key: "url",
    get: function get() {
      return this.baseUrl;
    }
  }, {
    key: "getIsPermitArgs",
    value: function getIsPermitArgs(t, e, i, r, n, s) {
      return "consume" === e ? {
        component: t,
        eventType: e,
        authService: i,
        did: s,
        credentials: {
          type: n,
          value: r
        }
      } : {
        component: t,
        eventType: e,
        authService: i,
        credentials: {
          type: n,
          value: r
        }
      };
    }
  }, {
    key: "isPermit",
    value: function () {
      var _isPermit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(t, e, i, r, n, s) {
        var o, _t12, _e8;

        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                if (this.url) {
                  _context34.next = 2;
                  break;
                }

                return _context34.abrupt("return", !0);

              case 2:
                o = this.getIsPermitArgs(t, e, i, r, n, s);
                _context34.prev = 3;
                _context34.next = 6;
                return this.ocean.utils.fetch.post(this.url, JSON.stringify(o));

              case 6:
                _t12 = _context34.sent;
                _context34.next = 9;
                return _t12.json();

              case 9:
                _e8 = _context34.sent;
                return _context34.abrupt("return", (_e8 = JSON.stringify(_e8), "true" === _e8));

              case 13:
                _context34.prev = 13;
                _context34.t0 = _context34["catch"](3);
                throw this.logger.error(_context34.t0), new Error("ERROR: Asset URL not found or not available.");

              case 16:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[3, 13]]);
      }));

      function isPermit(_x75, _x76, _x77, _x78, _x79, _x80) {
        return _isPermit.apply(this, arguments);
      }

      return isPermit;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                i = new Re();
                i.setInstanceConfig(t);
                _context35.next = 4;
                return i.setBaseUrl(null == (e = t.config) ? void 0 : e.rbacUri);

              case 4:
                return _context35.abrupt("return", i);

              case 5:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function getInstance(_x81) {
        return _getInstance4.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return Re;
}(st);

!function (t) {
  t[t.CreatingDataToken = 0] = "CreatingDataToken", t[t.DataTokenCreated = 1] = "DataTokenCreated", t[t.EncryptingFiles = 2] = "EncryptingFiles", t[t.FilesEncrypted = 3] = "FilesEncrypted", t[t.StoringDdo = 4] = "StoringDdo", t[t.DdoStored = 5] = "DdoStored";
}(ae || (ae = {})), function (t) {
  t[t.TransferDataToken = 0] = "TransferDataToken";
}(he || (he = {}));

var ke = /*#__PURE__*/function (_st5) {
  _inherits(ke, _st5);

  var _super5 = _createSuper(ke);

  function ke() {
    _classCallCheck(this, ke);

    return _super5.apply(this, arguments);
  }

  _createClass(ke, [{
    key: "create",
    value: function create(t, e) {
      var _this9 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var r = arguments.length > 3 ? arguments[3] : undefined;
      var n = arguments.length > 4 ? arguments[4] : undefined;
      var s = arguments.length > 5 ? arguments[5] : undefined;
      var o = arguments.length > 6 ? arguments[6] : undefined;
      var a = arguments.length > 7 ? arguments[7] : undefined;
      return r && !Me.isAddress(r) ? (this.logger.error("Passed Data Token address ".concat(r, " is not valid. Aborting publishing.")), null) : (this.logger.log("Creating asset"), new P( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(h) {
          var u, l, c, d, f, m;
          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  0 === i.length && _this9.logger.log("You have no services. Are you sure about this?");
                  u = _this9.ocean.datatokens;

                  if (r) {
                    _context36.next = 11;
                    break;
                  }

                  _this9.logger.log("Creating datatoken");

                  h.next(ae.CreatingDataToken);
                  _context36.next = 7;
                  return u.create("", e.getId(), n, s, o);

                case 7:
                  r = _context36.sent;

                  if (Me.isAddress(r)) {
                    _context36.next = 10;
                    break;
                  }

                  return _context36.abrupt("return", (_this9.logger.error("Created Data Token address ".concat(r, " is not valid. Aborting publishing.")), null));

                case 10:
                  _this9.logger.log("DataToken ".concat(r, " created")), h.next(ae.DataTokenCreated);

                case 11:
                  l = at.generate(r);

                  _this9.logger.log("Encrypting files");

                  h.next(ae.EncryptingFiles);

                  if (!a) {
                    _context36.next = 22;
                    break;
                  }

                  _context36.next = 17;
                  return mt.getInstance(_this9.instanceConfig);

                case 17:
                  c = _context36.sent;
                  _context36.next = 20;
                  return c.setBaseUrl(a);

                case 20:
                  _context36.next = 23;
                  break;

                case 22:
                  c = _this9.ocean.provider;

                case 23:
                  _context36.next = 25;
                  return c.encrypt(l.getDid(), t.main.files, e);

                case 25:
                  d = _context36.sent;
                  _this9.logger.log("Files encrypted"), h.next(ae.FilesEncrypted);
                  f = 0;
                  m = new lt({
                    id: l.getDid(),
                    dataToken: r,
                    authentication: [{
                      type: "RsaSignatureAuthentication2018",
                      publicKey: l.getDid()
                    }],
                    publicKey: [{
                      id: l.getDid(),
                      type: "EthereumECDSAKey",
                      owner: e.getId()
                    }],
                    service: [{
                      type: "metadata",
                      attributes: A({
                        status: {
                          isListed: !0,
                          isRetired: !1,
                          isOrderDisabled: !1
                        }
                      }, t, {
                        encryptedFiles: d,
                        main: A({}, t.main, {
                          files: t.main.files.map(function (t, e) {
                            return A({}, t, {
                              index: e,
                              url: void 0
                            });
                          })
                        })
                      })
                    }].concat(_toConsumableArray(i)).reverse().filter(function (_ref9, e, i) {
                      var t = _ref9.type;
                      return i.findIndex(function (_ref10) {
                        var e = _ref10.type;
                        return e === t;
                      }) === e;
                    }).reverse().map(function (t) {
                      return A({}, t, {
                        index: f++
                      });
                    })
                  });
                  _context36.next = 31;
                  return m.addProof(_this9.ocean, e.getId());

                case 31:
                  _context36.next = 33;
                  return u.getName(r);

                case 33:
                  _context36.t0 = _context36.sent;
                  _context36.next = 36;
                  return u.getSymbol(r);

                case 36:
                  _context36.t1 = _context36.sent;
                  _context36.t2 = r;
                  _context36.t3 = parseFloat;
                  _context36.next = 41;
                  return u.getCap(r);

                case 41:
                  _context36.t4 = _context36.sent;
                  _context36.t5 = (0, _context36.t3)(_context36.t4);
                  m.dataTokenInfo = {
                    name: _context36.t0,
                    symbol: _context36.t1,
                    address: _context36.t2,
                    cap: _context36.t5
                  };
                  return _context36.abrupt("return", m);

                case 45:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36);
        }));

        return function (_x82) {
          return _ref8.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(t) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", this.ocean.metadataCache.retrieveDDO(t));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function resolve(_x83) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "editMetadata",
    value: function () {
      var _editMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(t, e) {
        var _r4, i;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (t) {
                  _context38.next = 2;
                  break;
                }

                return _context38.abrupt("return", null);

              case 2:
                for (_r4 = 0; _r4 < t.service.length; _r4++) {
                  "metadata" === t.service[_r4].type && (e.title && (t.service[_r4].attributes.main.name = e.title), e.author && (t.service[_r4].attributes.main.author = e.author), t.service[_r4].attributes.additionalInformation || (t.service[_r4].attributes.additionalInformation = Object()), e.description && (t.service[_r4].attributes.additionalInformation.description = e.description), t.service[_r4].attributes.additionalInformation.links = e.links ? e.links : [], void 0 !== (null == (i = e.status) ? void 0 : i.isOrderDisabled) && (t.service[_r4].attributes.status ? t.service[_r4].attributes.status.isOrderDisabled = e.status.isOrderDisabled : t.service[_r4].attributes.status = {
                    isOrderDisabled: e.status.isOrderDisabled
                  }));
                }

                return _context38.abrupt("return", t);

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      function editMetadata(_x84, _x85) {
        return _editMetadata.apply(this, arguments);
      }

      return editMetadata;
    }()
  }, {
    key: "updateCredentials",
    value: function () {
      var _updateCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(t, e, i, r) {
        var n;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                return _context39.abrupt("return", (n = i && i.length > 0 ? xe(t, e, i, "allow") : Ae(t, e, "allow"), n = r && r.length > 0 ? xe(t, e, r, "deny") : Ae(t, e, "deny"), n));

              case 1:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));

      function updateCredentials(_x86, _x87, _x88, _x89) {
        return _updateCredentials.apply(this, arguments);
      }

      return updateCredentials;
    }()
  }, {
    key: "checkCredential",
    value: function checkCredential(t, e, i) {
      var r = 0,
          n = "All good",
          s = !0;

      if (t.credentials) {
        if (t.credentials.allow && t.credentials.allow.length > 0) {
          var o = t.credentials.allow.find(function (t) {
            return t.type === e;
          });
          o && !o.values.includes(i) && (r = 2, n = "Access is denied, your wallet address is not found on allow list", s = !1);
        }

        if (t.credentials.deny && t.credentials.deny.length > 0) {
          var _o2 = t.credentials.deny.find(function (t) {
            return t.type === e;
          });

          _o2 && _o2.values.includes(i) && (r = 3, n = "Access is denied, your wallet address is found on deny list", s = !1);
        }
      }

      return {
        status: r,
        message: n,
        result: s
      };
    }
  }, {
    key: "publishDdo",
    value: function () {
      var _publishDdo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(t, e) {
        var i,
            _args40 = arguments;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                i = _args40.length > 2 && _args40[2] !== undefined ? _args40[2] : !1;
                _context40.next = 3;
                return this.ocean.onChainMetadata.publish(t.id, t, e, i);

              case 3:
                return _context40.abrupt("return", _context40.sent);

              case 4:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function publishDdo(_x90, _x91) {
        return _publishDdo.apply(this, arguments);
      }

      return publishDdo;
    }()
  }, {
    key: "updateMetadata",
    value: function () {
      var _updateMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(t, e) {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return this.ocean.onChainMetadata.update(t.id, t, e);

              case 2:
                return _context41.abrupt("return", _context41.sent);

              case 3:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function updateMetadata(_x92, _x93) {
        return _updateMetadata.apply(this, arguments);
      }

      return updateMetadata;
    }()
  }, {
    key: "editServiceTimeout",
    value: function () {
      var _editServiceTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", t ? void 0 === t.service[e] || i < 0 ? null : (t.service[e].attributes.main.timeout = parseInt(i.toFixed()), t) : null);

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      function editServiceTimeout(_x94, _x95, _x96) {
        return _editServiceTimeout.apply(this, arguments);
      }

      return editServiceTimeout;
    }()
  }, {
    key: "creator",
    value: function () {
      var _creator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(t) {
        var _yield$et2, e, i, r, _i$proof, n, s, o;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return et(t, this.ocean);

              case 2:
                _yield$et2 = _context43.sent;
                e = _yield$et2.did;
                i = _yield$et2.ddo;
                r = i.getChecksum();
                _i$proof = i.proof;
                n = _i$proof.creator;
                s = _i$proof.signatureValue;
                _context43.next = 11;
                return this.ocean.utils.signature.verifyText(r, s);

              case 11:
                o = _context43.sent;
                return _context43.abrupt("return", (o.toLowerCase() !== n.toLowerCase() && this.logger.warn("Owner of ".concat(e, " doesn't match. Expected ").concat(n, " instead of ").concat(o, ".")), n));

              case 13:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function creator(_x97) {
        return _creator.apply(this, arguments);
      }

      return creator;
    }()
  }, {
    key: "getServiceByType",
    value: function () {
      var _getServiceByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(t, e) {
        var _yield$et3, i, r;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return et(t, this.ocean);

              case 2:
                _yield$et3 = _context44.sent;
                i = _yield$et3.ddo;
                return _context44.abrupt("return", (i.service.forEach(function (t) {
                  t.type.toString() === e && (r = t);
                }), r));

              case 5:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function getServiceByType(_x98, _x99) {
        return _getServiceByType.apply(this, arguments);
      }

      return getServiceByType;
    }()
  }, {
    key: "getServiceByIndex",
    value: function () {
      var _getServiceByIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(t, e) {
        var _yield$et4, i, r;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return et(t, this.ocean);

              case 2:
                _yield$et4 = _context45.sent;
                i = _yield$et4.ddo;
                return _context45.abrupt("return", (i.service.forEach(function (t) {
                  t.index === e && (r = t);
                }), r));

              case 5:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function getServiceByIndex(_x100, _x101) {
        return _getServiceByIndex.apply(this, arguments);
      }

      return getServiceByIndex;
    }()
  }, {
    key: "query",
    value: function () {
      var _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(t) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                return _context46.abrupt("return", this.ocean.metadataCache.queryMetadata(t));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function query(_x102) {
        return _query.apply(this, arguments);
      }

      return query;
    }()
  }, {
    key: "createAccessServiceAttributes",
    value: function () {
      var _createAccessServiceAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(t, e, i) {
        var r,
            n,
            s,
            o,
            _args47 = arguments;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                r = _args47.length > 3 && _args47[3] !== undefined ? _args47[3] : 0;
                n = _args47.length > 4 ? _args47[4] : undefined;
                s = _args47.length > 5 ? _args47[5] : undefined;
                o = {
                  type: "access",
                  index: 2,
                  serviceEndpoint: n || this.ocean.provider.url,
                  attributes: {
                    main: {
                      creator: t.getId(),
                      datePublished: i,
                      cost: e,
                      timeout: r,
                      name: "dataAssetAccess"
                    }
                  }
                };
                return _context47.abrupt("return", (null != s && s.userCustomParameters && (o.attributes.userCustomParameters = s.userCustomParameters), null != s && s.algoCustomParameters && (o.attributes.algoCustomParameters = s.algoCustomParameters), o));

              case 5:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function createAccessServiceAttributes(_x103, _x104, _x105) {
        return _createAccessServiceAttributes.apply(this, arguments);
      }

      return createAccessServiceAttributes;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(t, e, i) {
        var r,
            n,
            s,
            o,
            a,
            _args48 = arguments;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                r = _args48.length > 3 && _args48[3] !== undefined ? _args48[3] : -1;
                n = _args48.length > 4 ? _args48[4] : undefined;
                s = _args48.length > 5 ? _args48[5] : undefined;
                _context48.next = 5;
                return mt.getInstance(this.instanceConfig);

              case 5:
                o = _context48.sent;
                _context48.next = 8;
                return o.setBaseUrl(n);

              case 8:
                _context48.next = 10;
                return o.initialize(t, r, e, i, s);

              case 10:
                a = _context48.sent;
                return _context48.abrupt("return", null === a ? null : JSON.parse(a));

              case 12:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function initialize(_x106, _x107, _x108) {
        return _initialize2.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "order",
    value: function () {
      var _order = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(t, e, i) {
        var r,
            n,
            s,
            o,
            a,
            h,
            u,
            _yield$et5,
            l,
            c,
            _t13,
            _e9,
            _a,
            _c,
            _d,
            _args49 = arguments;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                r = _args49.length > 3 && _args49[3] !== undefined ? _args49[3] : -1;
                n = _args49.length > 4 ? _args49[4] : undefined;
                s = _args49.length > 5 ? _args49[5] : undefined;
                o = _args49.length > 6 ? _args49[6] : undefined;
                a = _args49.length > 7 && _args49[7] !== undefined ? _args49[7] : "json";
                h = _args49.length > 8 && _args49[8] !== undefined ? _args49[8] : !0;
                _context49.next = 8;
                return et(t, this.ocean);

              case 8:
                _yield$et5 = _context49.sent;
                l = _yield$et5.ddo;
                _context49.next = 12;
                return this.isConsumable(l, i, "address", a);

              case 12:
                c = _context49.sent;

                if (c.result) {
                  _context49.next = 15;
                  break;
                }

                throw new Error("Order asset failed, " + c.message);

              case 15:
                s || (s = i);

                if (!(-1 === r)) {
                  _context49.next = 23;
                  break;
                }

                _context49.next = 19;
                return this.getServiceByType(l, e);

              case 19:
                u = _context49.sent;
                r = u.index;
                _context49.next = 27;
                break;

              case 23:
                _context49.next = 25;
                return this.getServiceByIndex(l, r);

              case 25:
                u = _context49.sent;
                e = u.type;

              case 27:
                _context49.next = 29;
                return this.isUserCustomParametersValid(u.attributes.userCustomParameters, o);

              case 29:
                if (_context49.sent) {
                  _context49.next = 31;
                  break;
                }

                throw new Error("Order asset failed, Missing required fiels in userCustomParameters");

              case 31:
                _context49.prev = 31;
                _context49.next = 34;
                return this.initialize(l, e, i, r, u.serviceEndpoint, o);

              case 34:
                _t13 = _context49.sent;

                if (_t13) {
                  _context49.next = 37;
                  break;
                }

                throw new Error("Order asset failed, Failed to initialize service to compute totalCost for ordering");

              case 37:
                if (!h) {
                  _context49.next = 43;
                  break;
                }

                _context49.next = 40;
                return this.ocean.datatokens.getPreviousValidOrders(_t13.dataToken, _t13.numTokens, r, u.attributes.main.timeout, s);

              case 40:
                _e9 = _context49.sent;

                if (!_e9) {
                  _context49.next = 43;
                  break;
                }

                return _context49.abrupt("return", _e9);

              case 43:
                _context49.t0 = X;
                _context49.next = 46;
                return this.ocean.datatokens.balance(_t13.dataToken, i);

              case 46:
                _context49.t1 = _context49.sent;
                _a = new _context49.t0(_context49.t1);
                _c = new X(String(_t13.numTokens));

                if (!_a.isLessThan(_c)) {
                  _context49.next = 51;
                  break;
                }

                throw this.logger.error("ERROR: Not enough funds Needed " + _c.toString() + " but balance is " + _a.toString()), new Error("ERROR: Not enough funds Needed " + _c.toString() + " but balance is " + _a.toString());

              case 51:
                _context49.next = 53;
                return this.ocean.datatokens.startOrder(_t13.dataToken, s, String(_t13.numTokens), r, n, i);

              case 53:
                _d = _context49.sent;

                if (!_d) {
                  _context49.next = 56;
                  break;
                }

                return _context49.abrupt("return", _d.transactionHash);

              case 56:
                _context49.next = 61;
                break;

              case 58:
                _context49.prev = 58;
                _context49.t2 = _context49["catch"](31);
                throw this.logger.error("ERROR: Failed to order a service : ".concat(_context49.t2.message)), new Error("".concat(_context49.t2.message));

              case 61:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this, [[31, 58]]);
      }));

      function order(_x109, _x110, _x111) {
        return _order.apply(this, arguments);
      }

      return order;
    }()
  }, {
    key: "download",
    value: function () {
      var _download2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(t, e, i, r, n) {
        var _yield$et6, s, o, _o$findServiceByType, a, h, u, l, c;

        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return et(t, this.ocean);

              case 2:
                _yield$et6 = _context50.sent;
                s = _yield$et6.did;
                o = _yield$et6.ddo;
                _o$findServiceByType = o.findServiceByType("metadata");
                a = _o$findServiceByType.attributes;
                h = o.findServiceByType("access");
                u = a.main.files;
                l = h.serviceEndpoint;

                if (l) {
                  _context50.next = 12;
                  break;
                }

                throw new Error("Consume asset failed, service definition is missing the `serviceEndpoint`.");

              case 12:
                this.logger.log("Consuming files"), n = n ? "".concat(n, "/datafile.").concat(o.shortId(), ".").concat(h.index, "/") : void 0;
                _context50.next = 15;
                return mt.getInstance(this.instanceConfig);

              case 15:
                c = _context50.sent;
                _context50.next = 18;
                return c.setBaseUrl(l);

              case 18:
                _context50.next = 20;
                return c.download(s, e, i, h.type, h.index.toString(), n, r, u);

              case 20:
                return _context50.abrupt("return", !0);

              case 21:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function download(_x112, _x113, _x114, _x115, _x116) {
        return _download2.apply(this, arguments);
      }

      return download;
    }()
  }, {
    key: "simpleDownload",
    value: function () {
      var _simpleDownload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(t, e, i, r) {
        var n, s;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                n = e;
                n += "?consumerAddress=".concat(r), n += "&tokenAddress=".concat(t), n += "&transferTxId=".concat(i);
                s = new ft(this.logger);
                _context51.prev = 3;
                _context51.next = 6;
                return s.downloadFile(n);

              case 6:
                _context51.next = 11;
                break;

              case 8:
                _context51.prev = 8;
                _context51.t0 = _context51["catch"](3);
                throw this.logger.error("Error consuming assets"), this.logger.error(_context51.t0), _context51.t0;

              case 11:
                return _context51.abrupt("return", e);

              case 12:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this, [[3, 8]]);
      }));

      function simpleDownload(_x117, _x118, _x119, _x120) {
        return _simpleDownload.apply(this, arguments);
      }

      return simpleDownload;
    }()
  }, {
    key: "getOrderHistory",
    value: function () {
      var _getOrderHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(t, e, i) {
        var r, n, s, o, a, h, _t14, _i9, _n3, _s2;

        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                r = [];
                n = t.getId().toLowerCase();
                s = this.ocean.datatokens;
                o = "0x000000000000000000000000" + n.substring(2);
                a = s.getStartOrderEventSignature();
                _context52.next = 7;
                return this.web3.eth.getPastLogs({
                  topics: [a, null, o],
                  fromBlock: i || 0,
                  toBlock: "latest"
                });

              case 7:
                h = _context52.sent;
                _t14 = 0;

              case 9:
                if (!(_t14 < h.length)) {
                  _context52.next = 25;
                  break;
                }

                _i9 = {
                  dtAddress: h[_t14].address,
                  timestamp: 0,
                  transactionHash: h[_t14].transactionHash,
                  amount: null,
                  consumer: "0x" + h[_t14].topics[1].substring(h[_t14].topics[1].length - 40),
                  payer: "0x" + h[_t14].topics[2].substring(h[_t14].topics[2].length - 40)
                };
                _context52.prev = 11;
                _n3 = this.web3.eth.abi.decodeParameters(["uint256", "uint256", "uint256", "uint256"], h[_t14].data);
                _i9.serviceId = parseInt(_n3[1]), _i9.timestamp = parseInt(_n3[2]), _i9.amount = this.web3.utils.fromWei(_n3[0]), _i9.did = T(C(_i9.dtAddress));
                _context52.next = 16;
                return this.getServiceByIndex(_i9.did, _i9.serviceId);

              case 16:
                _s2 = _context52.sent;
                _i9.serviceType = _s2.type, (!e || e && e === _s2.type) && r.push(_i9);
                _context52.next = 22;
                break;

              case 20:
                _context52.prev = 20;
                _context52.t0 = _context52["catch"](11);

              case 22:
                _t14++;
                _context52.next = 9;
                break;

              case 25:
                return _context52.abrupt("return", r);

              case 26:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this, [[11, 20]]);
      }));

      function getOrderHistory(_x121, _x122, _x123) {
        return _getOrderHistory.apply(this, arguments);
      }

      return getOrderHistory;
    }()
  }, {
    key: "isConsumable",
    value: function () {
      var _isConsumable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(t, e, i, r) {
        var n, s, o, a, _n4;

        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                if (t) {
                  _context53.next = 2;
                  break;
                }

                throw new Error("ERROR: DDO does not exist");

              case 2:
                o = {
                  status: 2,
                  message: "Consume access is denied.",
                  result: !1
                };

                if (!(null != (n = t.findServiceByType("metadata").attributes.status) && n.isOrderDisabled)) {
                  _context53.next = 5;
                  break;
                }

                return _context53.abrupt("return", {
                  status: 1,
                  message: "Ordering this asset has been temporarily disabled by the publisher.",
                  result: !1
                });

              case 5:
                a = this.instanceConfig;

                if (!(e && null != a && null != (s = a.config) && s.rbacUri)) {
                  _context53.next = 14;
                  break;
                }

                _context53.next = 9;
                return Re.getInstance(this.instanceConfig);

              case 9:
                _n4 = _context53.sent;
                _context53.next = 12;
                return _n4.isPermit("market", "consume", r, e, i, t.id);

              case 12:
                if (_context53.sent) {
                  _context53.next = 14;
                  break;
                }

                return _context53.abrupt("return", o);

              case 14:
                return _context53.abrupt("return", {
                  status: 0,
                  message: "All good",
                  result: !0
                });

              case 15:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function isConsumable(_x124, _x125, _x126, _x127) {
        return _isConsumable.apply(this, arguments);
      }

      return isConsumable;
    }()
  }, {
    key: "isUserCustomParametersValid",
    value: function () {
      var _isUserCustomParametersValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(t, e) {
        var _iterator2, _step2, i, _t15;

        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                if (!t) {
                  _context54.next = 19;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(t);
                _context54.prev = 2;

                _iterator2.s();

              case 4:
                if ((_step2 = _iterator2.n()).done) {
                  _context54.next = 11;
                  break;
                }

                i = _step2.value;
                _t15 = i.name;

                if (!(!e || !e[_t15])) {
                  _context54.next = 9;
                  break;
                }

                return _context54.abrupt("return", (this.logger.error("Missing key: " + _t15 + " from customData"), !1));

              case 9:
                _context54.next = 4;
                break;

              case 11:
                _context54.next = 16;
                break;

              case 13:
                _context54.prev = 13;
                _context54.t0 = _context54["catch"](2);

                _iterator2.e(_context54.t0);

              case 16:
                _context54.prev = 16;

                _iterator2.f();

                return _context54.finish(16);

              case 19:
                return _context54.abrupt("return", !0);

              case 20:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this, [[2, 13, 16, 19]]);
      }));

      function isUserCustomParametersValid(_x128, _x129) {
        return _isUserCustomParametersValid.apply(this, arguments);
      }

      return isUserCustomParametersValid;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                e = new ke();
                return _context55.abrupt("return", (e.setInstanceConfig(t), e));

              case 2:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55);
      }));

      function getInstance(_x130) {
        return _getInstance5.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return ke;
}(st);

!function (t) {
  t.Loading = "Loading", t.Unknown = "Unknown", t.Stopped = "Stopped", t.Working = "Working";
}(ue || (ue = {}));

var Se = /*#__PURE__*/function (_st6) {
  _inherits(Se, _st6);

  var _super6 = _createSuper(Se);

  function Se() {
    _classCallCheck(this, Se);

    return _super6.apply(this, arguments);
  }

  _createClass(Se, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
        var t, _yield$this$ocean$met, _e10, i, e;

        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                t = {};
                t.lib = {
                  name: "Lib",
                  version: "0.20.0",
                  commit: "f79194faf37e447c07963c1114f0481b0b18030b",
                  status: ue.Working
                };
                _context56.prev = 2;
                _context56.next = 5;
                return this.ocean.metadataCache.getVersionInfo();

              case 5:
                _yield$this$ocean$met = _context56.sent;
                _e10 = _yield$this$ocean$met.software;
                i = _yield$this$ocean$met.version;
                t.metadataCache = {
                  name: _e10,
                  status: ue.Working,
                  version: i
                };
                _context56.next = 14;
                break;

              case 11:
                _context56.prev = 11;
                _context56.t0 = _context56["catch"](2);
                t.metadataCache = {
                  name: "MetadataCache",
                  status: ue.Stopped
                };

              case 14:
                e = Object.values(t);
                return _context56.abrupt("return", (t.status = {
                  ok: !e.find(function (_ref11) {
                    var t = _ref11.status;
                    return t !== ue.Working;
                  })
                }, t));

              case 16:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this, [[2, 11]]);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                e = new Se();
                return _context57.abrupt("return", (e.setInstanceConfig(t), e));

              case 2:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57);
      }));

      function getInstance(_x131) {
        return _getInstance6.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return Se;
}(st);

var Ie = /*#__PURE__*/function () {
  function Ie(t, e) {
    _classCallCheck(this, Ie);

    this.web3 = void 0, this.logger = void 0, this.web3 = t, this.logger = e;
  }

  _createClass(Ie, [{
    key: "signText",
    value: function () {
      var _signText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(t, e, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                r = this.web3 && this.web3.currentProvider && this.web3.currentProvider.isMetaMask;
                _context58.prev = 1;
                _context58.next = 4;
                return this.web3.eth.personal.sign(t, e, i);

              case 4:
                return _context58.abrupt("return", _context58.sent);

              case 7:
                _context58.prev = 7;
                _context58.t0 = _context58["catch"](1);

                if (!r) {
                  _context58.next = 11;
                  break;
                }

                throw _context58.t0;

              case 11:
                this.logger.warn("Error on personal sign."), this.logger.warn(_context58.t0);
                _context58.prev = 12;
                _context58.next = 15;
                return this.web3.eth.sign(t, e);

              case 15:
                return _context58.abrupt("return", _context58.sent);

              case 18:
                _context58.prev = 18;
                _context58.t1 = _context58["catch"](12);
                throw this.logger.error("Error on sign."), this.logger.error(_context58.t1), new Error("Error executing personal sign");

              case 21:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this, [[1, 7], [12, 18]]);
      }));

      function signText(_x132, _x133, _x134) {
        return _signText.apply(this, arguments);
      }

      return signText;
    }()
  }, {
    key: "signWithHash",
    value: function () {
      var _signWithHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                r = this.web3.utils.utf8ToHex(t), n = this.web3 && this.web3.currentProvider && this.web3.currentProvider.isMetaMask;
                _context59.prev = 1;
                _context59.next = 4;
                return this.web3.eth.personal.sign(r, e, i);

              case 4:
                return _context59.abrupt("return", _context59.sent);

              case 7:
                _context59.prev = 7;
                _context59.t0 = _context59["catch"](1);

                if (!n) {
                  _context59.next = 11;
                  break;
                }

                throw _context59.t0;

              case 11:
                this.logger.warn("Error on personal sign."), this.logger.warn(_context59.t0);
                _context59.prev = 12;
                _context59.next = 15;
                return this.web3.eth.sign(r, e);

              case 15:
                return _context59.abrupt("return", _context59.sent);

              case 18:
                _context59.prev = 18;
                _context59.t1 = _context59["catch"](12);
                throw this.logger.error("Error on sign."), this.logger.error(_context59.t1), new Error("Error executing personal sign");

              case 21:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[1, 7], [12, 18]]);
      }));

      function signWithHash(_x135, _x136, _x137) {
        return _signWithHash.apply(this, arguments);
      }

      return signWithHash;
    }()
  }, {
    key: "verifyText",
    value: function () {
      var _verifyText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(t, e) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                return _context60.abrupt("return", this.web3.eth.personal.ecRecover(t, e));

              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function verifyText(_x138, _x139) {
        return _verifyText.apply(this, arguments);
      }

      return verifyText;
    }()
  }, {
    key: "getHash",
    value: function () {
      var _getHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                e = "";

                for (i = 0; i < t.length; i++) {
                  e += "" + t.charCodeAt(i).toString(16);
                }

                return _context61.abrupt("return", "0x" + e);

              case 3:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61);
      }));

      function getHash(_x140) {
        return _getHash.apply(this, arguments);
      }

      return getHash;
    }()
  }, {
    key: "signForAquarius",
    value: function () {
      var _signForAquarius = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(t, e) {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return this.getHash(t);

              case 2:
                i = _context62.sent;
                r = this.web3 && this.web3.currentProvider && this.web3.currentProvider.isMetaMask;
                _context62.prev = 4;
                return _context62.abrupt("return", this.web3.eth.personal.sign(i, e.getId(), e.getPassword()));

              case 8:
                _context62.prev = 8;
                _context62.t0 = _context62["catch"](4);

                if (!r) {
                  _context62.next = 12;
                  break;
                }

                throw _context62.t0;

              case 12:
                return _context62.abrupt("return", (this.logger.warn("Error on personal sign."), this.logger.warn(_context62.t0), null));

              case 13:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this, [[4, 8]]);
      }));

      function signForAquarius(_x141, _x142) {
        return _signForAquarius.apply(this, arguments);
      }

      return signForAquarius;
    }()
  }]);

  return Ie;
}();

var Te = /*#__PURE__*/function (_st7) {
  _inherits(Te, _st7);

  var _super7 = _createSuper(Te);

  function Te() {
    var _this10;

    _classCallCheck(this, Te);

    for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      t[_key9] = arguments[_key9];
    }

    _this10 = _super7.call.apply(_super7, [this].concat(t)), _this10.signature = void 0, _this10.fetch = void 0;
    return _this10;
  }

  _createClass(Te, null, [{
    key: "getInstance",
    value: function () {
      var _getInstance7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                e = new Te();
                return _context63.abrupt("return", (e.setInstanceConfig(t), e.signature = new Ie(t.web3, t.logger), e.fetch = new ft(t.logger), e));

              case 2:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63);
      }));

      function getInstance(_x143) {
        return _getInstance7.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return Te;
}(st);

var Oe = "/api/v1/aquarius/assets/ddo";

var Be = /*#__PURE__*/function () {
  function Be(t, e) {
    _classCallCheck(this, Be);

    this.fetch = void 0, this.logger = void 0, this.metadataCacheUri = void 0, this.fetch = new ft(e), this.logger = e, this.metadataCacheUri = t;
  }

  _createClass(Be, [{
    key: "url",
    get: function get() {
      return this.metadataCacheUri;
    }
  }, {
    key: "getVersionInfo",
    value: function () {
      var _getVersionInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return this.fetch.get(this.url);

              case 2:
                return _context64.abrupt("return", _context64.sent.json());

              case 3:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function getVersionInfo() {
        return _getVersionInfo.apply(this, arguments);
      }

      return getVersionInfo;
    }()
  }, {
    key: "getAccessUrl",
    value: function () {
      var _getAccessUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(t, e) {
        var _this11 = this;

        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.next = 2;
                return this.fetch.post("".concat(t.service_endpoint, "/").concat(t.resource_id), e).then(function (t) {
                  return t.ok ? t.text() : (_this11.logger.error("Failed: ", t.status, t.statusText), null);
                }).then(function (t) {
                  return _this11.logger.error("Success accessing consume endpoint: ", t), t;
                }).catch(function (t) {
                  return _this11.logger.error("Error fetching the data asset consumption url: ", t), null;
                });

              case 2:
                return _context65.abrupt("return", _context65.sent);

              case 3:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function getAccessUrl(_x144, _x145) {
        return _getAccessUrl.apply(this, arguments);
      }

      return getAccessUrl;
    }()
  }, {
    key: "queryMetadata",
    value: function () {
      var _queryMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(t) {
        var _this12 = this;

        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.next = 2;
                return this.fetch.post("".concat(this.url, "/api/v1/aquarius/assets/query"), JSON.stringify(t)).then(function (t) {
                  return t.ok ? t.json() : (_this12.logger.error("queryMetadata failed:", t.status, t.statusText), null);
                }).then(function (t) {
                  return t;
                }).catch(function (t) {
                  return _this12.logger.error("Error fetching querying metadata: ", t), null;
                });

              case 2:
                return _context66.abrupt("return", _context66.sent);

              case 3:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function queryMetadata(_x146) {
        return _queryMetadata.apply(this, arguments);
      }

      return queryMetadata;
    }()
  }, {
    key: "encryptDDO",
    value: function () {
      var _encryptDDO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(t) {
        var _this13 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                e = "".concat(this.url, "/api/v1/aquarius/assets/ddo/encryptashex ");
                _context67.next = 3;
                return this.fetch.postWithOctet(e, t).then(function (e) {
                  return e.ok ? e.text() : (_this13.logger.error("encryptDDO failed:", e.status, e.statusText, t), null);
                }).catch(function (t) {
                  return _this13.logger.error("Error encryptDDO: ", t), null;
                });

              case 3:
                return _context67.abrupt("return", _context67.sent);

              case 4:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function encryptDDO(_x147) {
        return _encryptDDO.apply(this, arguments);
      }

      return encryptDDO;
    }()
  }, {
    key: "validateMetadata",
    value: function () {
      var _validateMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(t) {
        var e, i, r, _t16;

        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                e = {
                  valid: !1
                }, i = tt(t) ? "/validate-remote" : "/validate";
                _context68.prev = 1;
                _context68.next = 4;
                return this.fetch.post("".concat(this.url).concat(Oe).concat(i), JSON.stringify(t));

              case 4:
                r = _context68.sent;

                if (!r.ok) {
                  _context68.next = 12;
                  break;
                }

                _context68.next = 8;
                return r.json();

              case 8:
                _t16 = _context68.sent;
                !0 === _t16 ? e.valid = !0 : e.errors = _t16;
                _context68.next = 13;
                break;

              case 12:
                this.logger.error("validate Metadata failed:", r.status, r.statusText);

              case 13:
                _context68.next = 18;
                break;

              case 15:
                _context68.prev = 15;
                _context68.t0 = _context68["catch"](1);
                this.logger.error("Error validating metadata: ", _context68.t0);

              case 18:
                return _context68.abrupt("return", e);

              case 19:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this, [[1, 15]]);
      }));

      function validateMetadata(_x148) {
        return _validateMetadata.apply(this, arguments);
      }

      return validateMetadata;
    }()
  }, {
    key: "retrieveDDO",
    value: function () {
      var _retrieveDDO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(t, e) {
        var _this14 = this;

        var i;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                t = t && at.parse(t);
                i = e || "".concat(this.url).concat(Oe, "/").concat(t.getDid());
                _context69.next = 4;
                return this.fetch.get(i).then(function (e) {
                  return e.ok ? e.json() : (_this14.logger.log("retrieveDDO failed:", e.status, e.statusText, t), null);
                }).then(function (t) {
                  return new lt(t);
                }).catch(function (t) {
                  return _this14.logger.error("Error fetching querying metadata: ", t), null;
                });

              case 4:
                return _context69.abrupt("return", _context69.sent);

              case 5:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function retrieveDDO(_x149, _x150) {
        return _retrieveDDO.apply(this, arguments);
      }

      return retrieveDDO;
    }()
  }, {
    key: "retrieveDDOByUrl",
    value: function () {
      var _retrieveDDOByUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(t) {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                return _context70.abrupt("return", this.retrieveDDO(void 0, t));

              case 1:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function retrieveDDOByUrl(_x151) {
        return _retrieveDDOByUrl.apply(this, arguments);
      }

      return retrieveDDOByUrl;
    }()
  }, {
    key: "getServiceEndpoint",
    value: function getServiceEndpoint(t) {
      return "".concat(this.url, "/api/v1/aquarius/assets/ddo/did:op:").concat(t.getId());
    }
  }, {
    key: "getURI",
    value: function getURI() {
      return "".concat(this.url);
    }
  }, {
    key: "sleep",
    value: function sleep(t) {
      return new Promise(function (e) {
        setTimeout(e, t);
      });
    }
  }, {
    key: "waitForAqua",
    value: function () {
      var _waitForAqua = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(t, e) {
        var i, _i10, _t17;

        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                i = 0;

              case 1:
                _context71.prev = 1;
                _context71.next = 4;
                return h(this.getURI() + "/api/v1/aquarius/assets/ddo/" + t);

              case 4:
                _i10 = _context71.sent;

                if (!_i10.ok) {
                  _context71.next = 13;
                  break;
                }

                if (e) {
                  _context71.next = 8;
                  break;
                }

                return _context71.abrupt("break", 21);

              case 8:
                _context71.next = 10;
                return _i10.json();

              case 10:
                _t17 = _context71.sent;

                if (!(_t17.event && _t17.event.txid === e)) {
                  _context71.next = 13;
                  break;
                }

                return _context71.abrupt("break", 21);

              case 13:
                _context71.next = 17;
                break;

              case 15:
                _context71.prev = 15;
                _context71.t0 = _context71["catch"](1);

              case 17:
                _context71.next = 19;
                return this.sleep(1500);

              case 19:
                i++;

              case 20:
                if (i < 100) {
                  _context71.next = 1;
                  break;
                }

              case 21:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this, [[1, 15]]);
      }));

      function waitForAqua(_x152, _x153) {
        return _waitForAqua.apply(this, arguments);
      }

      return waitForAqua;
    }()
  }]);

  return Be;
}();

var Ce = /*#__PURE__*/function () {
  function Ce(t, e) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 ? arguments[4] : undefined;
    var s = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, Ce);

    this.GASLIMIT_DEFAULT = 1e6, this.DDOContractAddress = void 0, this.DDOContractABI = void 0, this.web3 = void 0, this.DDOContract = null, this.logger = void 0, this.metadataCache = void 0, this.config = void 0, this.web3 = t, this.config = s, this.DDOContractAddress = i, this.DDOContractABI = r || u.abi, t && (this.DDOContract = Y(new this.web3.eth.Contract(this.DDOContractABI, this.DDOContractAddress), this.config)), this.logger = e, this.metadataCache = n;
  }

  _createClass(Ce, [{
    key: "compressDDO",
    value: function () {
      var _compressDDO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(t) {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                return _context72.abrupt("return", (l.disableEndMark = !0, l.compress(t, 9)));

              case 1:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72);
      }));

      function compressDDO(_x154) {
        return _compressDDO.apply(this, arguments);
      }

      return compressDDO;
    }()
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(t, e, i) {
        var r,
            n,
            s,
            _args73 = arguments;
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                r = _args73.length > 3 && _args73[3] !== undefined ? _args73[3] : !1;
                n = _args73.length > 4 && _args73[4] !== undefined ? _args73[4] : !0;
                _context73.t0 = n;

                if (!_context73.t0) {
                  _context73.next = 7;
                  break;
                }

                _context73.next = 6;
                return this.metadataCache.validateMetadata(e);

              case 6:
                _context73.t0 = !_context73.sent.valid;

              case 7:
                if (!_context73.t0) {
                  _context73.next = 9;
                  break;
                }

                throw new Error("DDO has failed validation");

              case 9:
                _context73.next = 11;
                return this.prepareRawData(e, r);

              case 11:
                s = _context73.sent;

                if (!s) {
                  _context73.next = 14;
                  break;
                }

                return _context73.abrupt("return", this.publishRaw(B(t), s.flags, s.data, i));

              case 14:
                throw new Error("Could not prepare raw data for publish");

              case 15:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function publish(_x155, _x156, _x157) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(t, e, i) {
        var r,
            n,
            s,
            _args74 = arguments;
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                r = _args74.length > 3 && _args74[3] !== undefined ? _args74[3] : !1;
                n = _args74.length > 4 && _args74[4] !== undefined ? _args74[4] : !0;
                _context74.t0 = n;

                if (!_context74.t0) {
                  _context74.next = 7;
                  break;
                }

                _context74.next = 6;
                return this.metadataCache.validateMetadata(e);

              case 6:
                _context74.t0 = !_context74.sent.valid;

              case 7:
                if (!_context74.t0) {
                  _context74.next = 9;
                  break;
                }

                throw new Error("DDO has failed validation");

              case 9:
                _context74.next = 11;
                return this.prepareRawData(e, r);

              case 11:
                s = _context74.sent;

                if (!s) {
                  _context74.next = 14;
                  break;
                }

                return _context74.abrupt("return", this.updateRaw(B(t), s.flags, s.data, i));

              case 14:
                throw new Error("Could not prepare raw data for udate");

              case 15:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function update(_x158, _x159, _x160) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "prepareRawData",
    value: function () {
      var _prepareRawData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(t) {
        var e,
            i,
            r,
            _args75 = arguments;
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                e = _args75.length > 1 && _args75[1] !== undefined ? _args75[1] : !1;
                i = 0, r = lt.serialize(t);

                if (!(!1 === e)) {
                  _context75.next = 10;
                  break;
                }

                _context75.next = 5;
                return this.compressDDO(r);

              case 5:
                r = _context75.sent;
                i |= 1;
                r = this.getHex(r);
                _context75.next = 16;
                break;

              case 10:
                _context75.next = 12;
                return this.metadataCache.encryptDDO(r);

              case 12:
                r = _context75.sent;

                if (r) {
                  _context75.next = 15;
                  break;
                }

                return _context75.abrupt("return", null);

              case 15:
                i |= 2;

              case 16:
                return _context75.abrupt("return", {
                  flags: i,
                  data: r
                });

              case 17:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function prepareRawData(_x161) {
        return _prepareRawData.apply(this, arguments);
      }

      return prepareRawData;
    }()
  }, {
    key: "publishRaw",
    value: function () {
      var _publishRaw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(t, e, i, r) {
        var n, s;
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                if (this.DDOContract) {
                  _context76.next = 2;
                  break;
                }

                return _context76.abrupt("return", (this.logger.error("ERROR: Missing DDOContract"), null));

              case 2:
                n = this.GASLIMIT_DEFAULT;
                _context76.prev = 3;
                _context76.next = 6;
                return this.DDOContract.methods.create(B(t), e, i).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? n : e;
                });

              case 6:
                s = _context76.sent;
                _context76.next = 12;
                break;

              case 9:
                _context76.prev = 9;
                _context76.t0 = _context76["catch"](3);
                s = n;

              case 12:
                _context76.prev = 12;
                _context76.t1 = this.DDOContract.methods.create(B(t), e, i);
                _context76.t2 = r;
                _context76.t3 = s + 1;
                _context76.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context76.t4 = _context76.sent;
                _context76.t5 = {
                  from: _context76.t2,
                  gas: _context76.t3,
                  gasPrice: _context76.t4
                };
                _context76.next = 22;
                return _context76.t1.send.call(_context76.t1, _context76.t5);

              case 22:
                return _context76.abrupt("return", _context76.sent);

              case 25:
                _context76.prev = 25;
                _context76.t6 = _context76["catch"](12);
                return _context76.abrupt("return", (this.logger.error("ERROR: Failed to publish raw DDO : ".concat(_context76.t6.message)), null));

              case 28:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this, [[3, 9], [12, 25]]);
      }));

      function publishRaw(_x162, _x163, _x164, _x165) {
        return _publishRaw.apply(this, arguments);
      }

      return publishRaw;
    }()
  }, {
    key: "updateRaw",
    value: function () {
      var _updateRaw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(t, e, i, r) {
        var n, s;
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                if (this.DDOContract) {
                  _context77.next = 2;
                  break;
                }

                return _context77.abrupt("return", (this.logger.error("ERROR: Missing DDOContract"), null));

              case 2:
                n = this.GASLIMIT_DEFAULT;
                _context77.prev = 3;
                _context77.next = 6;
                return this.DDOContract.methods.update(B(t), e, i).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? n : e;
                });

              case 6:
                s = _context77.sent;
                _context77.next = 12;
                break;

              case 9:
                _context77.prev = 9;
                _context77.t0 = _context77["catch"](3);
                s = n;

              case 12:
                _context77.prev = 12;
                _context77.t1 = this.DDOContract.methods.update(B(t), e, i);
                _context77.t2 = r;
                _context77.t3 = s + 1;
                _context77.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context77.t4 = _context77.sent;
                _context77.t5 = {
                  from: _context77.t2,
                  gas: _context77.t3,
                  gasPrice: _context77.t4
                };
                _context77.next = 22;
                return _context77.t1.send.call(_context77.t1, _context77.t5);

              case 22:
                return _context77.abrupt("return", _context77.sent);

              case 25:
                _context77.prev = 25;
                _context77.t6 = _context77["catch"](12);
                return _context77.abrupt("return", (this.logger.error("ERROR: Failed to update raw DDO : ".concat(_context77.t6.message)), null));

              case 28:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this, [[3, 9], [12, 25]]);
      }));

      function updateRaw(_x166, _x167, _x168, _x169) {
        return _updateRaw.apply(this, arguments);
      }

      return updateRaw;
    }()
  }, {
    key: "transferOwnership",
    value: function () {
      var _transferOwnership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                if (this.DDOContract) {
                  _context78.next = 2;
                  break;
                }

                return _context78.abrupt("return", null);

              case 2:
                _context78.prev = 2;
                _context78.next = 5;
                return this.DDOContract.methods.transferOwnership(B(t), e).send({
                  from: i
                });

              case 5:
                return _context78.abrupt("return", _context78.sent);

              case 8:
                _context78.prev = 8;
                _context78.t0 = _context78["catch"](2);
                return _context78.abrupt("return", (this.logger.error("ERROR: Failed to transfer DDO ownership : ".concat(_context78.t0.message)), null));

              case 11:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this, [[2, 8]]);
      }));

      function transferOwnership(_x170, _x171, _x172) {
        return _transferOwnership.apply(this, arguments);
      }

      return transferOwnership;
    }()
  }, {
    key: "getHex",
    value: function getHex(t) {
      var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
      var i = "";

      try {
        for (var r = 0; r < t.length; r++) {
          i += "" + e[t[r] >> 4 & 15] + e[15 & t[r]];
        }
      } catch (t) {
        this.logger.error("ERROR: Failed to get hex message value : ".concat(t.message));
      }

      return "0x" + i;
    }
  }]);

  return Ce;
}();

var _e = /*#__PURE__*/function () {
  function _e(t, e, i, r, n, s) {
    _classCallCheck(this, _e);

    this.GASLIMIT_DEFAULT = 1e6, this.factoryAddress = void 0, this.factoryABI = void 0, this.datatokensABI = void 0, this.web3 = void 0, this.logger = void 0, this.startBlock = void 0, this.config = void 0, this.factoryAddress = t, this.factoryABI = e || c.abi, this.datatokensABI = i || d.abi, this.web3 = r, this.logger = n, this.config = s, this.startBlock = s && s.startBlock || 0;
  }

  _createClass(_e, [{
    key: "generateDtName",
    value: function generateDtName(t) {
      var _rt = rt(t),
          e = _rt.name,
          i = _rt.symbol;

      return {
        name: e,
        symbol: i
      };
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(t, e, i, r, n) {
        var _this$generateDtName;

        var s, o, a, h, u;
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                i || (i = "1000"), r && n || (_this$generateDtName = this.generateDtName(), r = _this$generateDtName.name, n = _this$generateDtName.symbol, _this$generateDtName);
                s = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress, {
                  from: e
                }), this.config), o = this.GASLIMIT_DEFAULT;
                _context79.prev = 2;
                _context79.next = 5;
                return s.methods.createToken(t, r, n, this.web3.utils.toWei(i)).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? o : e;
                });

              case 5:
                a = _context79.sent;
                _context79.next = 11;
                break;

              case 8:
                _context79.prev = 8;
                _context79.t0 = _context79["catch"](2);
                a = o;

              case 11:
                _context79.t1 = s.methods.createToken(t, r, n, this.web3.utils.toWei(i));
                _context79.t2 = e;
                _context79.t3 = a + 1;
                _context79.next = 16;
                return Q(this.web3, this.config);

              case 16:
                _context79.t4 = _context79.sent;
                _context79.t5 = {
                  from: _context79.t2,
                  gas: _context79.t3,
                  gasPrice: _context79.t4
                };
                _context79.next = 20;
                return _context79.t1.send.call(_context79.t1, _context79.t5);

              case 20:
                h = _context79.sent;
                u = null;

                try {
                  u = h.events.TokenCreated.returnValues[0];
                } catch (t) {
                  this.logger.error("ERROR: Failed to create datatoken : ".concat(t.message));
                }

                return _context79.abrupt("return", u);

              case 24:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this, [[2, 8]]);
      }));

      function create(_x173, _x174, _x175, _x176, _x177) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "approve",
    value: function () {
      var _approve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(t, e, i, r) {
        var n, s, o;
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                n = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: r
                }), this.config), s = this.GASLIMIT_DEFAULT;
                _context80.prev = 1;
                _context80.next = 4;
                return n.methods.approve(e, this.web3.utils.toWei(i)).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? s : e;
                });

              case 4:
                o = _context80.sent;
                _context80.next = 10;
                break;

              case 7:
                _context80.prev = 7;
                _context80.t0 = _context80["catch"](1);
                o = s;

              case 10:
                _context80.t1 = n.methods.approve(e, this.web3.utils.toWei(i));
                _context80.t2 = r;
                _context80.t3 = o + 1;
                _context80.next = 15;
                return Q(this.web3, this.config);

              case 15:
                _context80.t4 = _context80.sent;
                _context80.t5 = {
                  from: _context80.t2,
                  gas: _context80.t3,
                  gasPrice: _context80.t4
                };
                _context80.next = 19;
                return _context80.t1.send.call(_context80.t1, _context80.t5);

              case 19:
                return _context80.abrupt("return", _context80.sent);

              case 20:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this, [[1, 7]]);
      }));

      function approve(_x178, _x179, _x180, _x181) {
        return _approve.apply(this, arguments);
      }

      return approve;
    }()
  }, {
    key: "mint",
    value: function () {
      var _mint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(t, i, r, n) {
        var s, o, _t18, _e11;

        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                s = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: i
                }), this.config);
                _context81.next = 3;
                return this.getCap(t);

              case 3:
                o = _context81.sent;

                if (!new e(o).gte(r)) {
                  _context81.next = 25;
                  break;
                }

                _t18 = this.GASLIMIT_DEFAULT;
                _context81.prev = 6;
                _context81.next = 9;
                return s.methods.mint(n || i, this.web3.utils.toWei(r)).estimateGas({
                  from: i
                }, function (e, i) {
                  return e ? _t18 : i;
                });

              case 9:
                _e11 = _context81.sent;
                _context81.next = 15;
                break;

              case 12:
                _context81.prev = 12;
                _context81.t0 = _context81["catch"](6);
                _e11 = _t18;

              case 15:
                _context81.t1 = s.methods.mint(n || i, this.web3.utils.toWei(r));
                _context81.t2 = i;
                _context81.t3 = _e11 + 1;
                _context81.next = 20;
                return Q(this.web3, this.config);

              case 20:
                _context81.t4 = _context81.sent;
                _context81.t5 = {
                  from: _context81.t2,
                  gas: _context81.t3,
                  gasPrice: _context81.t4
                };
                _context81.next = 24;
                return _context81.t1.send.call(_context81.t1, _context81.t5);

              case 24:
                return _context81.abrupt("return", _context81.sent);

              case 25:
                throw new Error("Mint amount exceeds cap available");

              case 26:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this, [[6, 12]]);
      }));

      function mint(_x182, _x183, _x184, _x185) {
        return _mint.apply(this, arguments);
      }

      return mint;
    }()
  }, {
    key: "transfer",
    value: function () {
      var _transfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(t, e, i, r) {
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                return _context82.abrupt("return", this.transferToken(t, e, i, r));

              case 1:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));

      function transfer(_x186, _x187, _x188, _x189) {
        return _transfer.apply(this, arguments);
      }

      return transfer;
    }()
  }, {
    key: "transferToken",
    value: function () {
      var _transferToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(t, e, i, r) {
        var n;
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                n = this.web3.utils.toWei(i);
                return _context83.abrupt("return", this.transferWei(t, e, n, r));

              case 2:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function transferToken(_x190, _x191, _x192, _x193) {
        return _transferToken.apply(this, arguments);
      }

      return transferToken;
    }()
  }, {
    key: "transferWei",
    value: function () {
      var _transferWei = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(t, e, i, r) {
        var n, s, o;
        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                n = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: r
                }), this.config), s = this.GASLIMIT_DEFAULT;
                _context84.prev = 1;
                _context84.next = 4;
                return n.methods.transfer(e, i).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? s : e;
                });

              case 4:
                o = _context84.sent;
                _context84.next = 10;
                break;

              case 7:
                _context84.prev = 7;
                _context84.t0 = _context84["catch"](1);
                o = s;

              case 10:
                _context84.t1 = n.methods.transfer(e, i);
                _context84.t2 = r;
                _context84.t3 = o + 1;
                _context84.next = 15;
                return Q(this.web3, this.config);

              case 15:
                _context84.t4 = _context84.sent;
                _context84.t5 = {
                  from: _context84.t2,
                  gas: _context84.t3,
                  gasPrice: _context84.t4
                };
                _context84.next = 19;
                return _context84.t1.send.call(_context84.t1, _context84.t5);

              case 19:
                return _context84.abrupt("return", _context84.sent);

              case 20:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this, [[1, 7]]);
      }));

      function transferWei(_x194, _x195, _x196, _x197) {
        return _transferWei.apply(this, arguments);
      }

      return transferWei;
    }()
  }, {
    key: "transferFrom",
    value: function () {
      var _transferFrom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(t, e, i, r) {
        var n, s, o;
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                n = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: r
                }), this.config), s = this.GASLIMIT_DEFAULT;
                _context85.prev = 1;
                _context85.next = 4;
                return n.methods.transferFrom(e, r, this.web3.utils.toWei(i)).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? s : e;
                });

              case 4:
                o = _context85.sent;
                _context85.next = 10;
                break;

              case 7:
                _context85.prev = 7;
                _context85.t0 = _context85["catch"](1);
                o = s;

              case 10:
                _context85.t1 = n.methods.transferFrom(e, r, this.web3.utils.toWei(i));
                _context85.t2 = r;
                _context85.t3 = o + 1;
                _context85.next = 15;
                return Q(this.web3, this.config);

              case 15:
                _context85.t4 = _context85.sent;
                _context85.t5 = {
                  from: _context85.t2,
                  gas: _context85.t3,
                  gasPrice: _context85.t4
                };
                _context85.next = 19;
                return _context85.t1.send.call(_context85.t1, _context85.t5);

              case 19:
                return _context85.abrupt("return", _context85.sent);

              case 20:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this, [[1, 7]]);
      }));

      function transferFrom(_x198, _x199, _x200, _x201) {
        return _transferFrom.apply(this, arguments);
      }

      return transferFrom;
    }()
  }, {
    key: "balance",
    value: function () {
      var _balance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(t, e) {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: e
                }), this.config);
                _context86.next = 3;
                return i.methods.balanceOf(e).call();

              case 3:
                r = _context86.sent;
                return _context86.abrupt("return", this.web3.utils.fromWei(r));

              case 5:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function balance(_x202, _x203) {
        return _balance.apply(this, arguments);
      }

      return balance;
    }()
  }, {
    key: "allowance",
    value: function () {
      var _allowance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: i
                }), this.config);
                _context87.next = 3;
                return r.methods.allowance(e, i).call();

              case 3:
                n = _context87.sent;
                return _context87.abrupt("return", this.web3.utils.fromWei(n));

              case 5:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function allowance(_x204, _x205, _x206) {
        return _allowance.apply(this, arguments);
      }

      return allowance;
    }()
  }, {
    key: "getBlob",
    value: function () {
      var _getBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.datatokensABI, t), this.config);
                _context88.next = 3;
                return e.methods.blob().call();

              case 3:
                return _context88.abrupt("return", _context88.sent);

              case 4:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function getBlob(_x207) {
        return _getBlob.apply(this, arguments);
      }

      return getBlob;
    }()
  }, {
    key: "getName",
    value: function () {
      var _getName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.datatokensABI, t), this.config);
                _context89.next = 3;
                return e.methods.name().call();

              case 3:
                return _context89.abrupt("return", _context89.sent);

              case 4:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function getName(_x208) {
        return _getName.apply(this, arguments);
      }

      return getName;
    }()
  }, {
    key: "getSymbol",
    value: function () {
      var _getSymbol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.datatokensABI, t), this.config);
                _context90.next = 3;
                return e.methods.symbol().call();

              case 3:
                return _context90.abrupt("return", _context90.sent);

              case 4:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function getSymbol(_x209) {
        return _getSymbol.apply(this, arguments);
      }

      return getSymbol;
    }()
  }, {
    key: "getCap",
    value: function () {
      var _getCap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.datatokensABI, t), this.config);
                _context91.next = 3;
                return e.methods.cap().call();

              case 3:
                i = _context91.sent;
                return _context91.abrupt("return", this.web3.utils.fromWei(i));

              case 5:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function getCap(_x210) {
        return _getCap.apply(this, arguments);
      }

      return getCap;
    }()
  }, {
    key: "toWei",
    value: function toWei(t) {
      return this.web3.utils.toWei(t);
    }
  }, {
    key: "fromWei",
    value: function fromWei(t) {
      return this.web3.utils.fromWei(t);
    }
  }, {
    key: "startOrder",
    value: function () {
      var _startOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(t, e, i, r, n, s) {
        var o, _t19, a;

        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                o = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: s
                }), this.config);
                n || (n = "0x0000000000000000000000000000000000000000");
                _context92.prev = 2;
                _t19 = this.GASLIMIT_DEFAULT;
                _context92.prev = 4;
                _context92.next = 7;
                return o.methods.startOrder(e, this.web3.utils.toWei(i), String(r), n).estimateGas({
                  from: s
                }, function (e, i) {
                  return e ? _t19 : i;
                });

              case 7:
                a = _context92.sent;
                _context92.next = 13;
                break;

              case 10:
                _context92.prev = 10;
                _context92.t0 = _context92["catch"](4);
                a = _t19;

              case 13:
                _context92.t1 = o.methods.startOrder(e, this.web3.utils.toWei(i), String(r), n);
                _context92.t2 = s;
                _context92.t3 = a + 1;
                _context92.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context92.t4 = _context92.sent;
                _context92.t5 = {
                  from: _context92.t2,
                  gas: _context92.t3,
                  gasPrice: _context92.t4
                };
                _context92.next = 22;
                return _context92.t1.send.call(_context92.t1, _context92.t5);

              case 22:
                return _context92.abrupt("return", _context92.sent);

              case 25:
                _context92.prev = 25;
                _context92.t6 = _context92["catch"](2);
                throw this.logger.error("ERROR: Failed to start order : ".concat(_context92.t6.message)), new Error("Failed to start order: ".concat(_context92.t6.message));

              case 28:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this, [[2, 25], [4, 10]]);
      }));

      function startOrder(_x211, _x212, _x213, _x214, _x215, _x216) {
        return _startOrder.apply(this, arguments);
      }

      return startOrder;
    }()
  }, {
    key: "getPreviousValidOrders",
    value: function () {
      var _getPreviousValidOrders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(t, e, i, r, n) {
        var s, o, a, _t20, _e12, _i11;

        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                s = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: n
                }), this.config);

                if (!(r > 0)) {
                  _context93.next = 10;
                  break;
                }

                _context93.next = 4;
                return this.web3.eth.getBlockNumber();

              case 4:
                _context93.t0 = _context93.sent;
                _context93.t1 = r;
                o = _context93.t0 - _context93.t1;
                o < this.startBlock && (o = this.startBlock);
                _context93.next = 11;
                break;

              case 10:
                o = this.startBlock;

              case 11:
                _context93.next = 13;
                return s.getPastEvents("OrderStarted", {
                  filter: {
                    consumer: n
                  },
                  fromBlock: o,
                  toBlock: "latest"
                });

              case 13:
                a = _context93.sent;
                _t20 = 0;

              case 15:
                if (!(_t20 < a.length)) {
                  _context93.next = 28;
                  break;
                }

                if (!(String(a[_t20].returnValues.amount) === this.web3.utils.toWei(String(e)) && String(a[_t20].returnValues.serviceId) === String(i) && a[_t20].returnValues.consumer.toLowerCase() === n.toLowerCase())) {
                  _context93.next = 25;
                  break;
                }

                if (!(0 === r)) {
                  _context93.next = 19;
                  break;
                }

                return _context93.abrupt("return", a[_t20].transactionHash);

              case 19:
                _context93.next = 21;
                return this.web3.eth.getBlock(a[_t20].blockHash);

              case 21:
                _e12 = _context93.sent;
                _i11 = new X(_e12.timestamp).plus(r);

                if (!new X(Math.floor(Date.now() / 1e3)).isLessThan(_i11)) {
                  _context93.next = 25;
                  break;
                }

                return _context93.abrupt("return", a[_t20].transactionHash);

              case 25:
                _t20++;
                _context93.next = 15;
                break;

              case 28:
                return _context93.abrupt("return", null);

              case 29:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function getPreviousValidOrders(_x217, _x218, _x219, _x220, _x221) {
        return _getPreviousValidOrders.apply(this, arguments);
      }

      return getPreviousValidOrders;
    }()
  }, {
    key: "getStartOrderEventSignature",
    value: function getStartOrderEventSignature() {
      var t = this.datatokensABI.find(function (t) {
        if ("OrderStarted" === t.name && "event" === t.type) return t;
      });
      return this.web3.eth.abi.encodeEventSignature(t);
    }
  }, {
    key: "proposeMinter",
    value: function () {
      var _proposeMinter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(t, e, i) {
        var r, n, s;
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: i
                }), this.config), n = this.GASLIMIT_DEFAULT;
                _context94.prev = 1;
                _context94.next = 4;
                return r.methods.proposeMinter(e).estimateGas({
                  from: i
                }, function (t, e) {
                  return t ? n : e;
                });

              case 4:
                s = _context94.sent;
                _context94.next = 10;
                break;

              case 7:
                _context94.prev = 7;
                _context94.t0 = _context94["catch"](1);
                s = n;

              case 10:
                _context94.prev = 10;
                _context94.t1 = r.methods.proposeMinter(e);
                _context94.t2 = i;
                _context94.t3 = s + 1;
                _context94.next = 16;
                return Q(this.web3, this.config);

              case 16:
                _context94.t4 = _context94.sent;
                _context94.t5 = {
                  from: _context94.t2,
                  gas: _context94.t3,
                  gasPrice: _context94.t4
                };
                _context94.next = 20;
                return _context94.t1.send.call(_context94.t1, _context94.t5);

              case 20:
                return _context94.abrupt("return", _context94.sent);

              case 23:
                _context94.prev = 23;
                _context94.t6 = _context94["catch"](10);
                return _context94.abrupt("return", (this.logger.error("ERROR: Propose minter failed"), null));

              case 26:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this, [[1, 7], [10, 23]]);
      }));

      function proposeMinter(_x222, _x223, _x224) {
        return _proposeMinter.apply(this, arguments);
      }

      return proposeMinter;
    }()
  }, {
    key: "approveMinter",
    value: function () {
      var _approveMinter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.datatokensABI, t, {
                  from: e
                }), this.config), r = this.GASLIMIT_DEFAULT;
                _context95.prev = 1;
                _context95.next = 4;
                return i.methods.approveMinter().estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? r : e;
                });

              case 4:
                n = _context95.sent;
                _context95.next = 10;
                break;

              case 7:
                _context95.prev = 7;
                _context95.t0 = _context95["catch"](1);
                n = r;

              case 10:
                _context95.prev = 10;
                _context95.t1 = i.methods.approveMinter();
                _context95.t2 = e;
                _context95.t3 = n + 1;
                _context95.next = 16;
                return Q(this.web3, this.config);

              case 16:
                _context95.t4 = _context95.sent;
                _context95.t5 = {
                  from: _context95.t2,
                  gas: _context95.t3,
                  gasPrice: _context95.t4
                };
                _context95.next = 20;
                return _context95.t1.send.call(_context95.t1, _context95.t5);

              case 20:
                return _context95.abrupt("return", _context95.sent);

              case 23:
                _context95.prev = 23;
                _context95.t6 = _context95["catch"](10);
                return _context95.abrupt("return", null);

              case 26:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this, [[1, 7], [10, 23]]);
      }));

      function approveMinter(_x225, _x226) {
        return _approveMinter.apply(this, arguments);
      }

      return approveMinter;
    }()
  }, {
    key: "isMinter",
    value: function () {
      var _isMinter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.datatokensABI, t), this.config);
                _context96.next = 3;
                return i.methods.isMinter(e).call();

              case 3:
                return _context96.abrupt("return", _context96.sent);

              case 4:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function isMinter(_x227, _x228) {
        return _isMinter.apply(this, arguments);
      }

      return isMinter;
    }()
  }]);

  return _e;
}();

var De = /*#__PURE__*/function (_st8) {
  _inherits(De, _st8);

  var _super8 = _createSuper(De);

  function De() {
    _classCallCheck(this, De);

    return _super8.apply(this, arguments);
  }

  _createClass(De, [{
    key: "getNetworkId",
    value: function getNetworkId() {
      return this.web3.eth.net.getId();
    }
  }, {
    key: "getNetworkName",
    value: function () {
      var _getNetworkName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97() {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                return _context97.abrupt("return", this.web3.eth.net.getId().then(function (t) {
                  var e = f(t);
                  return e && e.name ? e.name : "Development";
                }));

              case 1:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function getNetworkName() {
        return _getNetworkName.apply(this, arguments);
      }

      return getNetworkName;
    }()
  }]);

  return De;
}(st);

var Pe;
!function (t) {
  t[t.TransferDataToken = 0] = "TransferDataToken";
}(Pe || (Pe = {})), Object.freeze({
  WarmingUp: 1,
  Started: 10,
  ConfiguringVolumes: 20,
  ProvisioningSuccess: 30,
  DataProvisioningFailed: 31,
  AlgorithmProvisioningFailed: 32,
  RunningAlgorithm: 40,
  FilteringResults: 50,
  PublishingResult: 60,
  Completed: 70,
  Stopped: 80,
  Deleted: 90
});

var Ne = /*#__PURE__*/function (_st9) {
  _inherits(Ne, _st9);

  var _super9 = _createSuper(Ne);

  function Ne() {
    _classCallCheck(this, Ne);

    return _super9.apply(this, arguments);
  }

  _createClass(Ne, [{
    key: "getComputeAddress",
    value: function () {
      var _getComputeAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(t) {
        var e,
            i,
            r,
            _i12,
            n,
            s,
            _args98 = arguments;

        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                e = _args98.length > 1 && _args98[1] !== undefined ? _args98[1] : -1;
                r = "compute";

                if (!(-1 === e)) {
                  _context98.next = 9;
                  break;
                }

                _context98.next = 5;
                return this.ocean.assets.getServiceByType(t, r);

              case 5:
                i = _context98.sent;
                e = i.index;
                _context98.next = 13;
                break;

              case 9:
                _context98.next = 11;
                return this.ocean.assets.getServiceByIndex(t, e);

              case 11:
                i = _context98.sent;
                r = i.type;

              case 13:
                _i12 = i;
                n = _i12.serviceEndpoint;
                _context98.next = 17;
                return mt.getInstance(this.instanceConfig);

              case 17:
                s = _context98.sent;
                _context98.next = 20;
                return s.setBaseUrl(n);

              case 20:
                return _context98.abrupt("return", s.computeAddress);

              case 21:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function getComputeAddress(_x229) {
        return _getComputeAddress.apply(this, arguments);
      }

      return getComputeAddress;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(t, e, i, r, n, s, o, a, h) {
        var _yield$et7, u, l, c, d, _yield$et8, _t21, _e13, _t22, _l;

        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                s = this.checkOutput(r, s);
                _context99.next = 3;
                return et(t, this.ocean);

              case 3:
                _yield$et7 = _context99.sent;
                u = _yield$et7.did;
                l = _yield$et7.ddo;
                c = l.findServiceByType("compute");
                d = c.serviceEndpoint;

                if (!n.serviceIndex) {
                  _context99.next = 18;
                  break;
                }

                _context99.next = 11;
                return et(n.did, this.ocean);

              case 11:
                _yield$et8 = _context99.sent;
                _t21 = _yield$et8.ddo;
                _e13 = _t21.findServiceById(n.serviceIndex);
                _context99.next = 16;
                return this.ocean.assets.isUserCustomParametersValid(_e13.attributes.algoCustomParameters, n.algoCustomParameters);

              case 16:
                if (_context99.sent) {
                  _context99.next = 18;
                  break;
                }

                return _context99.abrupt("return", null);

              case 18:
                if (!(u && e)) {
                  _context99.next = 28;
                  break;
                }

                _context99.next = 21;
                return mt.getInstance(this.instanceConfig);

              case 21:
                _t22 = _context99.sent;
                _context99.next = 24;
                return _t22.setBaseUrl(d);

              case 24:
                _context99.next = 26;
                return _t22.computeStart(u, r, n, s, e, o, a, i, h);

              case 26:
                _l = _context99.sent;
                return _context99.abrupt("return", _l ? _l[0] : null);

              case 28:
                return _context99.abrupt("return", null);

              case 29:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function start(_x230, _x231, _x232, _x233, _x234, _x235, _x236, _x237, _x238) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(t, e, i) {
        var _yield$et9, r, n, s, o, a, h;

        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                _context100.next = 2;
                return et(e, this.ocean);

              case 2:
                _yield$et9 = _context100.sent;
                r = _yield$et9.did;
                n = _yield$et9.ddo;
                s = n.findServiceByType("compute");
                o = s.serviceEndpoint;
                _context100.next = 9;
                return mt.getInstance(this.instanceConfig);

              case 9:
                a = _context100.sent;
                _context100.next = 12;
                return a.setBaseUrl(o);

              case 12:
                _context100.next = 14;
                return a.computeStop(r, t, i);

              case 14:
                h = _context100.sent;
                return _context100.abrupt("return", h ? h[0] : null);

              case 16:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));

      function stop(_x239, _x240, _x241) {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(t, e, i) {
        var _yield$et10, r, n, s, o, a, h;

        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                _context101.next = 2;
                return et(e, this.ocean);

              case 2:
                _yield$et10 = _context101.sent;
                r = _yield$et10.did;
                n = _yield$et10.ddo;
                s = n.findServiceByType("compute");
                o = s.serviceEndpoint;
                _context101.next = 9;
                return mt.getInstance(this.instanceConfig);

              case 9:
                a = _context101.sent;
                _context101.next = 12;
                return a.setBaseUrl(o);

              case 12:
                _context101.next = 14;
                return a.computeDelete(r, t, i);

              case 14:
                h = _context101.sent;
                return _context101.abrupt("return", h ? h[0] : null);

              case 16:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function _delete(_x242, _x243, _x244) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "status",
    value: function () {
      var _status = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(t, e, i, r, n, s) {
        var o, _r5, _t23;

        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                if (!(e || r || i)) {
                  _context102.next = 19;
                  break;
                }

                if (r) {
                  _context102.next = 11;
                  break;
                }

                _context102.t0 = !i;

                if (!_context102.t0) {
                  _context102.next = 7;
                  break;
                }

                _context102.next = 6;
                return this.ocean.assets.resolve(e);

              case 6:
                _context102.t0 = !(i = _context102.sent);

              case 7:
                if (!_context102.t0) {
                  _context102.next = 9;
                  break;
                }

                throw new Error("Couldn't resolve the did ".concat(e));

              case 9:
                if (r = i.findServiceByType("compute")) {
                  _context102.next = 11;
                  break;
                }

                throw new Error("Couldn't find a compute service on the asset with did ".concat(e));

              case 11:
                _r5 = r, _t23 = _r5.serviceEndpoint;
                _context102.next = 14;
                return mt.getInstance(this.instanceConfig);

              case 14:
                o = _context102.sent;
                _context102.next = 17;
                return o.setBaseUrl(_t23);

              case 17:
                _context102.next = 20;
                break;

              case 19:
                o = this.ocean.provider;

              case 20:
                _context102.next = 22;
                return o.computeStatus(e, t, n, s);

              case 22:
                return _context102.abrupt("return", _context102.sent);

              case 23:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function status(_x245, _x246, _x247, _x248, _x249, _x250) {
        return _status.apply(this, arguments);
      }

      return status;
    }()
  }, {
    key: "getResult",
    value: function () {
      var _getResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(t, e, i, r, n, s, o) {
        var a, _o3, _t24;

        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                if (!(n || o || s)) {
                  _context103.next = 19;
                  break;
                }

                if (o) {
                  _context103.next = 11;
                  break;
                }

                _context103.t0 = !s;

                if (!_context103.t0) {
                  _context103.next = 7;
                  break;
                }

                _context103.next = 6;
                return this.ocean.assets.resolve(n);

              case 6:
                _context103.t0 = !(s = _context103.sent);

              case 7:
                if (!_context103.t0) {
                  _context103.next = 9;
                  break;
                }

                throw new Error("Couldn't resolve the did ".concat(n));

              case 9:
                if (o = s.findServiceByType("compute")) {
                  _context103.next = 11;
                  break;
                }

                throw new Error("Couldn't find a compute service on the asset with did ".concat(n));

              case 11:
                _o3 = o, _t24 = _o3.serviceEndpoint;
                _context103.next = 14;
                return mt.getInstance(this.instanceConfig);

              case 14:
                a = _context103.sent;
                _context103.next = 17;
                return a.setBaseUrl(_t24);

              case 17:
                _context103.next = 20;
                break;

              case 19:
                a = this.ocean.provider;

              case 20:
                _context103.next = 22;
                return a.computeResult(e, i, r, t);

              case 22:
                return _context103.abrupt("return", _context103.sent);

              case 23:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function getResult(_x251, _x252, _x253, _x254, _x255, _x256, _x257) {
        return _getResult.apply(this, arguments);
      }

      return getResult;
    }()
  }, {
    key: "createServerAttributes",
    value: function createServerAttributes(t, e, i, r, n, s, o, a) {
      return {
        serverId: t,
        serverType: e,
        cost: i,
        cpu: r,
        gpu: n,
        memory: s,
        disk: o,
        maxExecutionTime: a
      };
    }
  }, {
    key: "createContainerAttributes",
    value: function createContainerAttributes(t, e, i) {
      return {
        image: t,
        tag: e,
        checksum: i
      };
    }
  }, {
    key: "createClusterAttributes",
    value: function createClusterAttributes(t, e) {
      return {
        type: t,
        url: e
      };
    }
  }, {
    key: "createProviderAttributes",
    value: function createProviderAttributes(t, e, i, r, n) {
      return {
        type: t,
        description: e,
        environment: {
          cluster: i,
          supportedServers: n,
          supportedContainers: r
        }
      };
    }
  }, {
    key: "createComputeService",
    value: function createComputeService(t, e, i, r, n, s, o, a) {
      s || (s = 3600);
      var h = {
        type: "compute",
        index: 3,
        serviceEndpoint: o || this.ocean.provider.url,
        attributes: {
          main: {
            name: "dataAssetComputingService",
            creator: t.getId(),
            datePublished: i,
            cost: e,
            timeout: s,
            provider: r,
            privacy: {}
          }
        }
      };
      return n && (h.attributes.main.privacy = n), null != a && a.userCustomParameters && (h.attributes.userCustomParameters = a.userCustomParameters), null != a && a.algoCustomParameters && (h.attributes.algoCustomParameters = a.algoCustomParameters), h;
    }
  }, {
    key: "checkOutput",
    value: function checkOutput(t, e) {
      return e && (e.publishAlgorithmLog || e.publishOutput) ? {
        publishAlgorithmLog: e.publishAlgorithmLog,
        publishOutput: e.publishOutput,
        providerAddress: e.providerAddress || this.config.providerAddress,
        providerUri: e.providerUri || this.config.providerUri,
        metadataUri: e.metadataUri || this.config.metadataCacheUri,
        nodeUri: e.nodeUri || this.config.nodeUri,
        owner: e.owner || t.getId()
      } : {
        publishAlgorithmLog: !1,
        publishOutput: !1
      };
    }
  }, {
    key: "isOrderable",
    value: function () {
      var _isOrderable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(t, e, i, r) {
        var n, s, _t25, _e14, _i13, _t26, _iterator3, _step3, _e15;

        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return et(t, this.ocean);

              case 2:
                n = _context104.sent;
                s = n.ddo.findServiceById(e);

                if (s) {
                  _context104.next = 6;
                  break;
                }

                return _context104.abrupt("return", !1);

              case 6:
                if (!("compute" === s.type)) {
                  _context104.next = 59;
                  break;
                }

                if (!i.meta) {
                  _context104.next = 9;
                  break;
                }

                return _context104.abrupt("return", !(!s.attributes.main.privacy || !s.attributes.main.privacy.allowRawAlgorithm) || (this.logger.error("ERROR: This service does not allow raw algorithm"), !1));

              case 9:
                if (!i.did) {
                  _context104.next = 59;
                  break;
                }

                if (!i.serviceIndex) {
                  _context104.next = 32;
                  break;
                }

                _context104.t0 = !r;

                if (!_context104.t0) {
                  _context104.next = 16;
                  break;
                }

                _context104.next = 15;
                return this.ocean.assets.resolve(i.did);

              case 15:
                _context104.t0 = !(r = _context104.sent);

              case 16:
                if (!_context104.t0) {
                  _context104.next = 18;
                  break;
                }

                throw new Error("Couldn't resolve the did ".concat(i.did));

              case 18:
                _t25 = r.findServiceById(i.serviceIndex);

                if (!(_t25 && "compute" === _t25.type)) {
                  _context104.next = 32;
                  break;
                }

                _context104.next = 22;
                return mt.getInstance(this.instanceConfig);

              case 22:
                _e14 = _context104.sent;
                _context104.next = 25;
                return _e14.setBaseUrl(_t25.serviceEndpoint);

              case 25:
                _context104.next = 27;
                return mt.getInstance(this.instanceConfig);

              case 27:
                _i13 = _context104.sent;
                _context104.next = 30;
                return _i13.setBaseUrl(s.serviceEndpoint);

              case 30:
                if (!(_e14.providerAddress !== _i13.providerAddress)) {
                  _context104.next = 32;
                  break;
                }

                return _context104.abrupt("return", (this.logger.error("ERROR: Both assets with compute service are not served by the same provider"), !1));

              case 32:
                if (!s.attributes.main.privacy) {
                  _context104.next = 58;
                  break;
                }

                if (!s.attributes.main.privacy.allowAllPublishedAlgorithms) {
                  _context104.next = 35;
                  break;
                }

                return _context104.abrupt("return", !0);

              case 35:
                if (s.attributes.main.privacy.publisherTrustedAlgorithms) {
                  _context104.next = 37;
                  break;
                }

                return _context104.abrupt("return", !1);

              case 37:
                _iterator3 = _createForOfIteratorHelper(s.attributes.main.privacy.publisherTrustedAlgorithms);
                _context104.prev = 38;

                _iterator3.s();

              case 40:
                if ((_step3 = _iterator3.n()).done) {
                  _context104.next = 49;
                  break;
                }

                _t26 = _step3.value;

                if (!(_t26.did === i.did)) {
                  _context104.next = 47;
                  break;
                }

                _context104.next = 45;
                return this.createPublisherTrustedAlgorithmfromDID(i.did);

              case 45:
                _e15 = _context104.sent;
                return _context104.abrupt("return", _t26.containerSectionChecksum && _t26.containerSectionChecksum !== _e15.containerSectionChecksum ? (this.logger.error("ERROR: Algorithm container section was altered since it was added as trusted by " + n.did), !1) : !_t26.filesChecksum || _t26.filesChecksum === _e15.filesChecksum || (this.logger.error("ERROR: Algorithm files section was altered since it was added as trusted by " + n.ddo), !1));

              case 47:
                _context104.next = 40;
                break;

              case 49:
                _context104.next = 54;
                break;

              case 51:
                _context104.prev = 51;
                _context104.t1 = _context104["catch"](38);

                _iterator3.e(_context104.t1);

              case 54:
                _context104.prev = 54;

                _iterator3.f();

                return _context104.finish(54);

              case 57:
                return _context104.abrupt("return", (this.logger.error("ERROR: Algorithm " + i.did + " is not allowed by " + n.did), !1));

              case 58:
                console.error("Algo Index:" + i.serviceIndex);

              case 59:
                return _context104.abrupt("return", !0);

              case 60:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this, [[38, 51, 54, 57]]);
      }));

      function isOrderable(_x258, _x259, _x260, _x261) {
        return _isOrderable.apply(this, arguments);
      }

      return isOrderable;
    }()
  }, {
    key: "orderAsset",
    value: function orderAsset(t, e, i, r, n, s, o) {
      var _this15 = this;

      var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "json";
      var h = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : !0;
      return new P( /*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(u) {
          var _yield$et11, l, c;

          return _regeneratorRuntime.wrap(function _callee105$(_context105) {
            while (1) {
              switch (_context105.prev = _context105.next) {
                case 0:
                  _context105.next = 2;
                  return et(e, _this15.ocean);

                case 2:
                  _yield$et11 = _context105.sent;
                  l = _yield$et11.ddo;
                  _context105.next = 6;
                  return _this15.isOrderable(l, i, r);

                case 6:
                  if (_context105.sent) {
                    _context105.next = 8;
                    break;
                  }

                  throw new Error("Dataset order failed, dataset is not orderable with the specified algorithm");

                case 8:
                  c = l.findServiceById(i);

                  if (c) {
                    _context105.next = 11;
                    break;
                  }

                  throw new Error("Dataset order failed, Could not find service for the DDO");

                case 11:
                  _context105.prev = 11;
                  _context105.next = 14;
                  return _this15.ocean.assets.order(l, c.type, t, -1, n, s, o, a, h);

                case 14:
                  return _context105.abrupt("return", _context105.sent);

                case 17:
                  _context105.prev = 17;
                  _context105.t0 = _context105["catch"](11);
                  throw _this15.logger.error("ERROR: Failed to order: ".concat(_context105.t0.message)), new Error("Failed to order dataset: ".concat(_context105.t0.message));

                case 20:
                case "end":
                  return _context105.stop();
              }
            }
          }, _callee105, null, [[11, 17]]);
        }));

        return function (_x262) {
          return _ref12.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "orderAlgorithm",
    value: function () {
      var _orderAlgorithm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(t, e, i) {
        var r,
            n,
            s,
            o,
            a,
            h,
            _args106 = arguments;
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                r = _args106.length > 3 && _args106[3] !== undefined ? _args106[3] : -1;
                n = _args106.length > 4 ? _args106[4] : undefined;
                s = _args106.length > 5 ? _args106[5] : undefined;
                o = _args106.length > 6 ? _args106[6] : undefined;
                a = _args106.length > 7 && _args106[7] !== undefined ? _args106[7] : "json";
                h = _args106.length > 8 && _args106[8] !== undefined ? _args106[8] : !0;
                _context106.prev = 6;
                _context106.next = 9;
                return this.ocean.assets.order(t, e, i, r, n, s, o, a, h);

              case 9:
                return _context106.abrupt("return", _context106.sent);

              case 12:
                _context106.prev = 12;
                _context106.t0 = _context106["catch"](6);
                throw this.logger.error("ERROR: Failed to orderAlgorithm: ".concat(_context106.t0.message)), new Error("Failed to order algorithm: ".concat(_context106.t0.message));

              case 15:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this, [[6, 12]]);
      }));

      function orderAlgorithm(_x263, _x264, _x265) {
        return _orderAlgorithm.apply(this, arguments);
      }

      return orderAlgorithm;
    }()
  }, {
    key: "editComputePrivacy",
    value: function () {
      var _editComputePrivacy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(t, e, i) {
        var _i14;

        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                if (t) {
                  _context107.next = 2;
                  break;
                }

                return _context107.abrupt("return", null);

              case 2:
                if (!(-1 === e)) {
                  _context107.next = 7;
                  break;
                }

                _i14 = t.findServiceByType("compute");

                if (_i14) {
                  _context107.next = 6;
                  break;
                }

                return _context107.abrupt("return", null);

              case 6:
                e = _i14.index;

              case 7:
                return _context107.abrupt("return", void 0 === t.service[e] || "compute" !== t.service[e].type ? null : (t.service[e].attributes.main.privacy.allowRawAlgorithm = i.allowRawAlgorithm, t.service[e].attributes.main.privacy.allowAllPublishedAlgorithms = i.allowAllPublishedAlgorithms, t.service[e].attributes.main.privacy.allowNetworkAccess = i.allowNetworkAccess, t.service[e].attributes.main.privacy.publisherTrustedAlgorithms = i.publisherTrustedAlgorithms, t));

              case 8:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107);
      }));

      function editComputePrivacy(_x266, _x267, _x268) {
        return _editComputePrivacy.apply(this, arguments);
      }

      return editComputePrivacy;
    }()
  }, {
    key: "toggleAllowAllPublishedAlgorithms",
    value: function () {
      var _toggleAllowAllPublishedAlgorithms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(t, e, i) {
        var _i15;

        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                if (t) {
                  _context108.next = 2;
                  break;
                }

                return _context108.abrupt("return", null);

              case 2:
                if (!(-1 === e)) {
                  _context108.next = 7;
                  break;
                }

                _i15 = t.findServiceByType("compute");

                if (_i15) {
                  _context108.next = 6;
                  break;
                }

                return _context108.abrupt("return", null);

              case 6:
                e = _i15.index;

              case 7:
                return _context108.abrupt("return", void 0 === t.service[e] || "compute" !== t.service[e].type ? null : (t.service[e].attributes.main.privacy.allowAllPublishedAlgorithms = i, t));

              case 8:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108);
      }));

      function toggleAllowAllPublishedAlgorithms(_x269, _x270, _x271) {
        return _toggleAllowAllPublishedAlgorithms.apply(this, arguments);
      }

      return toggleAllowAllPublishedAlgorithms;
    }()
  }, {
    key: "createPublisherTrustedAlgorithmfromDID",
    value: function () {
      var _createPublisherTrustedAlgorithmfromDID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                _context109.t0 = !e;

                if (!_context109.t0) {
                  _context109.next = 5;
                  break;
                }

                _context109.next = 4;
                return this.ocean.assets.resolve(t);

              case 4:
                _context109.t0 = !(e = _context109.sent);

              case 5:
                if (!_context109.t0) {
                  _context109.next = 7;
                  break;
                }

                return _context109.abrupt("return", null);

              case 7:
                i = e.findServiceByType("metadata");
                return _context109.abrupt("return", i && i.attributes.main.algorithm && i.attributes.encryptedFiles && i.attributes.main.files ? {
                  did: t,
                  containerSectionChecksum: m(JSON.stringify(i.attributes.main.algorithm.container)).toString(),
                  filesChecksum: m(i.attributes.encryptedFiles + JSON.stringify(i.attributes.main.files)).toString()
                } : null);

              case 9:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function createPublisherTrustedAlgorithmfromDID(_x272, _x273) {
        return _createPublisherTrustedAlgorithmfromDID.apply(this, arguments);
      }

      return createPublisherTrustedAlgorithmfromDID;
    }()
  }, {
    key: "addTrustedAlgorithmtoAsset",
    value: function () {
      var _addTrustedAlgorithmtoAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(t, e, i) {
        var _i16, r;

        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                if (t) {
                  _context110.next = 2;
                  break;
                }

                return _context110.abrupt("return", null);

              case 2:
                if (!(-1 === e)) {
                  _context110.next = 7;
                  break;
                }

                _i16 = t.findServiceByType("compute");

                if (_i16) {
                  _context110.next = 6;
                  break;
                }

                return _context110.abrupt("return", null);

              case 6:
                e = _i16.index;

              case 7:
                if (!(void 0 === t.service[e])) {
                  _context110.next = 9;
                  break;
                }

                return _context110.abrupt("return", null);

              case 9:
                if (!("compute" !== t.service[e].type)) {
                  _context110.next = 11;
                  break;
                }

                return _context110.abrupt("return", null);

              case 11:
                t.service[e].attributes.main.privacy.publisherTrustedAlgorithms || (t.service[e].attributes.main.privacy.publisherTrustedAlgorithms = []);
                _context110.next = 14;
                return this.createPublisherTrustedAlgorithmfromDID(i);

              case 14:
                r = _context110.sent;
                return _context110.abrupt("return", (r && t.service[e].attributes.main.privacy.publisherTrustedAlgorithms.push(r), t));

              case 16:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function addTrustedAlgorithmtoAsset(_x274, _x275, _x276) {
        return _addTrustedAlgorithmtoAsset.apply(this, arguments);
      }

      return addTrustedAlgorithmtoAsset;
    }()
  }, {
    key: "isAlgorithmTrusted",
    value: function () {
      var _isAlgorithmTrusted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(t, e, i) {
        var _i17, r, _iterator4, _step4;

        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                if (t) {
                  _context111.next = 2;
                  break;
                }

                return _context111.abrupt("return", !1);

              case 2:
                if (!(-1 === e)) {
                  _context111.next = 7;
                  break;
                }

                _i17 = t.findServiceByType("compute");

                if (_i17) {
                  _context111.next = 6;
                  break;
                }

                return _context111.abrupt("return", !1);

              case 6:
                e = _i17.index;

              case 7:
                if (!(void 0 === t.service[e])) {
                  _context111.next = 9;
                  break;
                }

                return _context111.abrupt("return", !1);

              case 9:
                if (!("compute" !== t.service[e].type)) {
                  _context111.next = 11;
                  break;
                }

                return _context111.abrupt("return", !1);

              case 11:
                if (!t.service[e].attributes.main.privacy.allowAllPublishedAlgorithms) {
                  _context111.next = 13;
                  break;
                }

                return _context111.abrupt("return", !0);

              case 13:
                _iterator4 = _createForOfIteratorHelper(t.service[e].attributes.main.privacy.publisherTrustedAlgorithms);
                _context111.prev = 14;

                _iterator4.s();

              case 16:
                if ((_step4 = _iterator4.n()).done) {
                  _context111.next = 22;
                  break;
                }

                r = _step4.value;

                if (!(r.did === i)) {
                  _context111.next = 20;
                  break;
                }

                return _context111.abrupt("return", !0);

              case 20:
                _context111.next = 16;
                break;

              case 22:
                _context111.next = 27;
                break;

              case 24:
                _context111.prev = 24;
                _context111.t0 = _context111["catch"](14);

                _iterator4.e(_context111.t0);

              case 27:
                _context111.prev = 27;

                _iterator4.f();

                return _context111.finish(27);

              case 30:
                return _context111.abrupt("return", !1);

              case 31:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, null, [[14, 24, 27, 30]]);
      }));

      function isAlgorithmTrusted(_x277, _x278, _x279) {
        return _isAlgorithmTrusted.apply(this, arguments);
      }

      return isAlgorithmTrusted;
    }()
  }, {
    key: "removeTrustedAlgorithmFromAsset",
    value: function () {
      var _removeTrustedAlgorithmFromAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(t, e, i) {
        var _i18;

        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                if (t) {
                  _context112.next = 2;
                  break;
                }

                return _context112.abrupt("return", null);

              case 2:
                if (!(-1 === e)) {
                  _context112.next = 7;
                  break;
                }

                _i18 = t.findServiceByType("compute");

                if (_i18) {
                  _context112.next = 6;
                  break;
                }

                return _context112.abrupt("return", t);

              case 6:
                e = _i18.index;

              case 7:
                return _context112.abrupt("return", void 0 === t.service[e] || "compute" !== t.service[e].type ? t : t.service[e].attributes.main.privacy.publisherTrustedAlgorithms ? (t.service[e].attributes.main.privacy.publisherTrustedAlgorithms = t.service[e].attributes.main.privacy.publisherTrustedAlgorithms.filter(function (t) {
                  return t.did !== i;
                }), t) : t);

              case 8:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112);
      }));

      function removeTrustedAlgorithmFromAsset(_x280, _x281, _x282) {
        return _removeTrustedAlgorithmFromAsset.apply(this, arguments);
      }

      return removeTrustedAlgorithmFromAsset;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                e = new Ne();
                return _context113.abrupt("return", (e.setInstanceConfig(t), e));

              case 2:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113);
      }));

      function getInstance(_x283) {
        return _getInstance8.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return Ne;
}(st);

var Le = "115792089237316195423570985008687907853269984665640564039457584007913129639934";
var We, Fe, Ue, $e;
!function (t) {
  t[t.CreatingPool = 0] = "CreatingPool", t[t.ApprovingDatatoken = 1] = "ApprovingDatatoken", t[t.ApprovingOcean = 2] = "ApprovingOcean", t[t.SetupPool = 3] = "SetupPool";
}(We || (We = {}));

var je = /*#__PURE__*/function (_ref13) {
  _inherits(je, _ref13);

  var _super10 = _createSuper(je);

  function je(t, e) {
    var _this16;

    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var o = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, je);

    _this16 = _super10.call(this, t, e, i, r, n, o), _this16.oceanAddress = null, _this16.dtAddress = null, _this16.startBlock = void 0, s && (_this16.oceanAddress = s), _this16.startBlock = o && o.startBlock || 0;
    return _this16;
  }

  _createClass(je, [{
    key: "create",
    value: function create(t, e, i, r, n, s) {
      var _this17 = this;

      if (null == this.oceanAddress) throw this.logger.error("ERROR: oceanAddress is not defined"), new Error("ERROR: oceanAddress is not defined");
      if (parseFloat(s) > .1) throw this.logger.error("ERROR: Swap fee too high. The maximum allowed swapFee is 10%"), new Error("ERROR: Swap fee too high. The maximum allowed swapFee is 10%");
      if (parseFloat(i) < 2) throw this.logger.error("ERROR: Amount of DT is too low"), new Error("ERROR: Amount of DT is too low");
      if (parseFloat(r) > 9 || parseFloat(r) < 1) throw this.logger.error("ERROR: Weight out of bounds (min 1, max9)"), new Error("ERROR: Weight out of bounds (min 1, max9)");
      return new P( /*#__PURE__*/function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(o) {
          var a, h, u, l;
          return _regeneratorRuntime.wrap(function _callee114$(_context114) {
            while (1) {
              switch (_context114.prev = _context114.next) {
                case 0:
                  o.next(We.CreatingPool);
                  _context114.next = 3;
                  return _get2(_getPrototypeOf(je.prototype), "createPool", _this17).call(_this17, t);

                case 3:
                  a = _context114.sent;

                  if (a) {
                    _context114.next = 6;
                    break;
                  }

                  throw _this17.logger.error("ERROR: Failed to call create pool"), new Error("ERROR: Failed to call create pool");

                case 6:
                  h = a.events.BPoolRegistered.returnValues[0], u = 10 - parseFloat(r);
                  _this17.dtAddress = e;
                  o.next(We.ApprovingDatatoken);
                  _context114.next = 11;
                  return _this17.approve(t, e, h, _this17.web3.utils.toWei(String(i)));

                case 11:
                  l = _context114.sent;

                  if (l) {
                    _context114.next = 14;
                    break;
                  }

                  throw _this17.logger.error("ERROR: Failed to call approve DT token"), new Error("ERROR: Failed to call approve DT token");

                case 14:
                  o.next(We.ApprovingOcean);
                  _context114.next = 17;
                  return _this17.approve(t, _this17.oceanAddress, h, _this17.web3.utils.toWei(String(n)));

                case 17:
                  l = _context114.sent;

                  if (l) {
                    _context114.next = 20;
                    break;
                  }

                  throw _this17.logger.error("ERROR: Failed to call approve OCEAN token"), new Error("ERROR: Failed to call approve OCEAN token");

                case 20:
                  o.next(We.SetupPool);
                  _context114.next = 23;
                  return _get2(_getPrototypeOf(je.prototype), "setup", _this17).call(_this17, t, h, e, _this17.web3.utils.toWei(String(i)), _this17.web3.utils.toWei(String(r)), _this17.oceanAddress, _this17.web3.utils.toWei(String(n)), _this17.web3.utils.toWei(String(u)), _this17.web3.utils.toWei(s));

                case 23:
                  l = _context114.sent;

                  if (l) {
                    _context114.next = 26;
                    break;
                  }

                  throw _this17.logger.error("ERROR: Failed to create a new pool"), new Error("ERROR: Failed to create a new pool");

                case 26:
                  return _context114.abrupt("return", a);

                case 27:
                case "end":
                  return _context114.stop();
              }
            }
          }, _callee114);
        }));

        return function (_x284) {
          return _ref14.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getDTAddress",
    value: function () {
      var _getDTAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(t) {
        var e, i, _iterator5, _step5;

        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                this.dtAddress = null;
                _context115.next = 3;
                return this.getCurrentTokens(t);

              case 3:
                e = _context115.sent;

                if (null != e) {
                  _iterator5 = _createForOfIteratorHelper(e);

                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      i = _step5.value;
                      i.toLowerCase() !== this.oceanAddress.toLowerCase() && (this.dtAddress = i);
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }

                return _context115.abrupt("return", this.dtAddress);

              case 6:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));

      function getDTAddress(_x285) {
        return _getDTAddress.apply(this, arguments);
      }

      return getDTAddress;
    }()
  }, {
    key: "getOceanReserve",
    value: function () {
      var _getOceanReserve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(t) {
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                return _context116.abrupt("return", null == this.oceanAddress ? (this.logger.error("ERROR: oceanAddress is not defined"), null) : _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, this.oceanAddress));

              case 1:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));

      function getOceanReserve(_x286) {
        return _getOceanReserve.apply(this, arguments);
      }

      return getOceanReserve;
    }()
  }, {
    key: "getDTReserve",
    value: function () {
      var _getDTReserve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                _context117.next = 2;
                return this.getDTAddress(t);

              case 2:
                e = _context117.sent;
                return _context117.abrupt("return", _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e));

              case 4:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));

      function getDTReserve(_x287) {
        return _getDTReserve.apply(this, arguments);
      }

      return getDTReserve;
    }()
  }, {
    key: "getMaxBuyQuantity",
    value: function () {
      var _getMaxBuyQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                _context118.next = 2;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 2:
                r = _context118.sent;
                return _context118.abrupt("return", new e(r).div(3).toString());

              case 4:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this);
      }));

      function getMaxBuyQuantity(_x288, _x289) {
        return _getMaxBuyQuantity.apply(this, arguments);
      }

      return getMaxBuyQuantity;
    }()
  }, {
    key: "getOceanMaxBuyQuantity",
    value: function () {
      var _getOceanMaxBuyQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(t) {
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                return _context119.abrupt("return", this.getMaxBuyQuantity(t, this.oceanAddress));

              case 1:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, this);
      }));

      function getOceanMaxBuyQuantity(_x290) {
        return _getOceanMaxBuyQuantity.apply(this, arguments);
      }

      return getOceanMaxBuyQuantity;
    }()
  }, {
    key: "getDTMaxBuyQuantity",
    value: function () {
      var _getDTMaxBuyQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(t) {
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.t0 = this;
                _context120.t1 = t;
                _context120.next = 4;
                return this.getDTAddress(t);

              case 4:
                _context120.t2 = _context120.sent;
                return _context120.abrupt("return", _context120.t0.getMaxBuyQuantity.call(_context120.t0, _context120.t1, _context120.t2));

              case 6:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));

      function getDTMaxBuyQuantity(_x291) {
        return _getDTMaxBuyQuantity.apply(this, arguments);
      }

      return getDTMaxBuyQuantity;
    }()
  }, {
    key: "calcInGivenOut",
    value: function () {
      var _calcInGivenOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(t, e, i, r) {
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                _context121.t0 = _get2(_getPrototypeOf(je.prototype), "calcInGivenOut", this);
                _context121.t1 = this;
                _context121.t2 = t;
                _context121.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context121.t3 = _context121.sent;
                _context121.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context121.t4 = _context121.sent;
                _context121.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 11:
                _context121.t5 = _context121.sent;
                _context121.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, i);

              case 14:
                _context121.t6 = _context121.sent;
                _context121.t7 = r;
                _context121.next = 18;
                return this.getSwapFee(t);

              case 18:
                _context121.t8 = _context121.sent;
                _context121.next = 21;
                return _context121.t0.call.call(_context121.t0, _context121.t1, _context121.t2, _context121.t3, _context121.t4, _context121.t5, _context121.t6, _context121.t7, _context121.t8);

              case 21:
                return _context121.abrupt("return", _context121.sent);

              case 22:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));

      function calcInGivenOut(_x292, _x293, _x294, _x295) {
        return _calcInGivenOut.apply(this, arguments);
      }

      return calcInGivenOut;
    }()
  }, {
    key: "calcOutGivenIn",
    value: function () {
      var _calcOutGivenIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(t, e, i, r) {
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                _context122.t0 = _get2(_getPrototypeOf(je.prototype), "calcOutGivenIn", this);
                _context122.t1 = this;
                _context122.t2 = t;
                _context122.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context122.t3 = _context122.sent;
                _context122.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context122.t4 = _context122.sent;
                _context122.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 11:
                _context122.t5 = _context122.sent;
                _context122.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, i);

              case 14:
                _context122.t6 = _context122.sent;
                _context122.t7 = r;
                _context122.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 18:
                _context122.t8 = _context122.sent;
                _context122.next = 21;
                return _context122.t0.call.call(_context122.t0, _context122.t1, _context122.t2, _context122.t3, _context122.t4, _context122.t5, _context122.t6, _context122.t7, _context122.t8);

              case 21:
                return _context122.abrupt("return", _context122.sent);

              case 22:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, this);
      }));

      function calcOutGivenIn(_x296, _x297, _x298, _x299) {
        return _calcOutGivenIn.apply(this, arguments);
      }

      return calcOutGivenIn;
    }()
  }, {
    key: "calcPoolOutGivenSingleIn",
    value: function () {
      var _calcPoolOutGivenSingleIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                _context123.t0 = _get2(_getPrototypeOf(je.prototype), "calcPoolOutGivenSingleIn", this);
                _context123.t1 = this;
                _context123.t2 = t;
                _context123.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context123.t3 = _context123.sent;
                _context123.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context123.t4 = _context123.sent;
                _context123.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getPoolSharesTotalSupply", this).call(this, t);

              case 11:
                _context123.t5 = _context123.sent;
                _context123.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getTotalDenormalizedWeight", this).call(this, t);

              case 14:
                _context123.t6 = _context123.sent;
                _context123.t7 = i;
                _context123.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 18:
                _context123.t8 = _context123.sent;
                return _context123.abrupt("return", _context123.t0.call.call(_context123.t0, _context123.t1, _context123.t2, _context123.t3, _context123.t4, _context123.t5, _context123.t6, _context123.t7, _context123.t8));

              case 20:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));

      function calcPoolOutGivenSingleIn(_x300, _x301, _x302) {
        return _calcPoolOutGivenSingleIn.apply(this, arguments);
      }

      return calcPoolOutGivenSingleIn;
    }()
  }, {
    key: "calcSingleInGivenPoolOut",
    value: function () {
      var _calcSingleInGivenPoolOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                _context124.t0 = _get2(_getPrototypeOf(je.prototype), "calcSingleInGivenPoolOut", this);
                _context124.t1 = this;
                _context124.t2 = t;
                _context124.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context124.t3 = _context124.sent;
                _context124.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context124.t4 = _context124.sent;
                _context124.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getPoolSharesTotalSupply", this).call(this, t);

              case 11:
                _context124.t5 = _context124.sent;
                _context124.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getTotalDenormalizedWeight", this).call(this, t);

              case 14:
                _context124.t6 = _context124.sent;
                _context124.t7 = i;
                _context124.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 18:
                _context124.t8 = _context124.sent;
                return _context124.abrupt("return", _context124.t0.call.call(_context124.t0, _context124.t1, _context124.t2, _context124.t3, _context124.t4, _context124.t5, _context124.t6, _context124.t7, _context124.t8));

              case 20:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, this);
      }));

      function calcSingleInGivenPoolOut(_x303, _x304, _x305) {
        return _calcSingleInGivenPoolOut.apply(this, arguments);
      }

      return calcSingleInGivenPoolOut;
    }()
  }, {
    key: "calcSingleOutGivenPoolIn",
    value: function () {
      var _calcSingleOutGivenPoolIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                _context125.t0 = _get2(_getPrototypeOf(je.prototype), "calcSingleOutGivenPoolIn", this);
                _context125.t1 = this;
                _context125.t2 = t;
                _context125.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context125.t3 = _context125.sent;
                _context125.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context125.t4 = _context125.sent;
                _context125.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getPoolSharesTotalSupply", this).call(this, t);

              case 11:
                _context125.t5 = _context125.sent;
                _context125.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getTotalDenormalizedWeight", this).call(this, t);

              case 14:
                _context125.t6 = _context125.sent;
                _context125.t7 = i;
                _context125.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 18:
                _context125.t8 = _context125.sent;
                return _context125.abrupt("return", _context125.t0.call.call(_context125.t0, _context125.t1, _context125.t2, _context125.t3, _context125.t4, _context125.t5, _context125.t6, _context125.t7, _context125.t8));

              case 20:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, this);
      }));

      function calcSingleOutGivenPoolIn(_x306, _x307, _x308) {
        return _calcSingleOutGivenPoolIn.apply(this, arguments);
      }

      return calcSingleOutGivenPoolIn;
    }()
  }, {
    key: "calcPoolInGivenSingleOut",
    value: function () {
      var _calcPoolInGivenSingleOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                _context126.t0 = _get2(_getPrototypeOf(je.prototype), "calcPoolInGivenSingleOut", this);
                _context126.t1 = this;
                _context126.t2 = t;
                _context126.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, e);

              case 5:
                _context126.t3 = _context126.sent;
                _context126.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, e);

              case 8:
                _context126.t4 = _context126.sent;
                _context126.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getPoolSharesTotalSupply", this).call(this, t);

              case 11:
                _context126.t5 = _context126.sent;
                _context126.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getTotalDenormalizedWeight", this).call(this, t);

              case 14:
                _context126.t6 = _context126.sent;
                _context126.t7 = i;
                _context126.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 18:
                _context126.t8 = _context126.sent;
                return _context126.abrupt("return", _context126.t0.call.call(_context126.t0, _context126.t1, _context126.t2, _context126.t3, _context126.t4, _context126.t5, _context126.t6, _context126.t7, _context126.t8));

              case 20:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, this);
      }));

      function calcPoolInGivenSingleOut(_x309, _x310, _x311) {
        return _calcPoolInGivenSingleOut.apply(this, arguments);
      }

      return calcPoolInGivenSingleOut;
    }()
  }, {
    key: "getPoolSharesRequiredToRemoveDT",
    value: function () {
      var _getPoolSharesRequiredToRemoveDT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context127.sent;
                return _context127.abrupt("return", this.calcPoolInGivenSingleOut(t, i, e));

              case 4:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));

      function getPoolSharesRequiredToRemoveDT(_x312, _x313) {
        return _getPoolSharesRequiredToRemoveDT.apply(this, arguments);
      }

      return getPoolSharesRequiredToRemoveDT;
    }()
  }, {
    key: "getDTRemovedforPoolShares",
    value: function () {
      var _getDTRemovedforPoolShares = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context128.sent;
                return _context128.abrupt("return", this.calcSingleOutGivenPoolIn(t, i, e));

              case 4:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));

      function getDTRemovedforPoolShares(_x314, _x315) {
        return _getDTRemovedforPoolShares.apply(this, arguments);
      }

      return getDTRemovedforPoolShares;
    }()
  }, {
    key: "getPoolSharesRequiredToRemoveOcean",
    value: function () {
      var _getPoolSharesRequiredToRemoveOcean = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(t, e) {
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                return _context129.abrupt("return", this.calcPoolInGivenSingleOut(t, this.oceanAddress, e));

              case 1:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129, this);
      }));

      function getPoolSharesRequiredToRemoveOcean(_x316, _x317) {
        return _getPoolSharesRequiredToRemoveOcean.apply(this, arguments);
      }

      return getPoolSharesRequiredToRemoveOcean;
    }()
  }, {
    key: "getOceanRemovedforPoolShares",
    value: function () {
      var _getOceanRemovedforPoolShares = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130(t, e) {
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                return _context130.abrupt("return", this.calcSingleOutGivenPoolIn(t, this.oceanAddress, e));

              case 1:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130, this);
      }));

      function getOceanRemovedforPoolShares(_x318, _x319) {
        return _getOceanRemovedforPoolShares.apply(this, arguments);
      }

      return getOceanRemovedforPoolShares;
    }()
  }, {
    key: "getTokensRemovedforPoolShares",
    value: function () {
      var _getTokensRemovedforPoolShares = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131(t, i) {
        var r, n, s;
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                _context131.prev = 0;
                _context131.next = 3;
                return this.getPoolSharesTotalSupply(t);

              case 3:
                r = _context131.sent;
                _context131.next = 6;
                return this.getDTReserve(t);

              case 6:
                n = _context131.sent;
                _context131.next = 9;
                return this.getOceanReserve(t);

              case 9:
                s = _context131.sent;
                return _context131.abrupt("return", {
                  dtAmount: new e(i).div(r).mul(n).toString(),
                  oceanAmount: new e(i).div(r).mul(s).toString()
                });

              case 13:
                _context131.prev = 13;
                _context131.t0 = _context131["catch"](0);
                this.logger.error("ERROR: Unable to get token info. ".concat(_context131.t0.message));

              case 16:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this, [[0, 13]]);
      }));

      function getTokensRemovedforPoolShares(_x320, _x321) {
        return _getTokensRemovedforPoolShares.apply(this, arguments);
      }

      return getTokensRemovedforPoolShares;
    }()
  }, {
    key: "getDTMaxAddLiquidity",
    value: function () {
      var _getDTMaxAddLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                _context132.next = 2;
                return this.getDTAddress(t);

              case 2:
                e = _context132.sent;
                return _context132.abrupt("return", this.getMaxAddLiquidity(t, e));

              case 4:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132, this);
      }));

      function getDTMaxAddLiquidity(_x322) {
        return _getDTMaxAddLiquidity.apply(this, arguments);
      }

      return getDTMaxAddLiquidity;
    }()
  }, {
    key: "getOceanMaxAddLiquidity",
    value: function () {
      var _getOceanMaxAddLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133(t) {
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                return _context133.abrupt("return", this.getMaxAddLiquidity(t, this.oceanAddress));

              case 1:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, this);
      }));

      function getOceanMaxAddLiquidity(_x323) {
        return _getOceanMaxAddLiquidity.apply(this, arguments);
      }

      return getOceanMaxAddLiquidity;
    }()
  }, {
    key: "getMaxAddLiquidity",
    value: function () {
      var _getMaxAddLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee134(t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                _context134.next = 2;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 2:
                r = _context134.sent;
                return _context134.abrupt("return", parseFloat(r) > 0 ? new e(r).mul(.25).toString() : "0");

              case 4:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134, this);
      }));

      function getMaxAddLiquidity(_x324, _x325) {
        return _getMaxAddLiquidity.apply(this, arguments);
      }

      return getMaxAddLiquidity;
    }()
  }, {
    key: "getMaxRemoveLiquidity",
    value: function () {
      var _getMaxRemoveLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee135(t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                _context135.next = 2;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 2:
                r = _context135.sent;
                return _context135.abrupt("return", parseFloat(r) > 0 ? new e(r).mul(.25).toString() : "0");

              case 4:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135, this);
      }));

      function getMaxRemoveLiquidity(_x326, _x327) {
        return _getMaxRemoveLiquidity.apply(this, arguments);
      }

      return getMaxRemoveLiquidity;
    }()
  }, {
    key: "getDTMaxRemoveLiquidity",
    value: function () {
      var _getDTMaxRemoveLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee136(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee136$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                _context136.next = 2;
                return this.getDTAddress(t);

              case 2:
                e = _context136.sent;
                return _context136.abrupt("return", this.getMaxRemoveLiquidity(t, e));

              case 4:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee136, this);
      }));

      function getDTMaxRemoveLiquidity(_x328) {
        return _getDTMaxRemoveLiquidity.apply(this, arguments);
      }

      return getDTMaxRemoveLiquidity;
    }()
  }, {
    key: "getOceanMaxRemoveLiquidity",
    value: function () {
      var _getOceanMaxRemoveLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee137(t) {
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                return _context137.abrupt("return", this.getMaxRemoveLiquidity(t, this.oceanAddress));

              case 1:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));

      function getOceanMaxRemoveLiquidity(_x329) {
        return _getOceanMaxRemoveLiquidity.apply(this, arguments);
      }

      return getOceanMaxRemoveLiquidity;
    }()
  }, {
    key: "buyDT",
    value: function () {
      var _buyDT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee138(t, i, r, n, s) {
        var o, a;
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context138.next = 2;
                  break;
                }

                return _context138.abrupt("return", (this.logger.error("ERROR: undefined ocean token contract address"), null));

              case 2:
                _context138.next = 4;
                return this.getDTAddress(i);

              case 4:
                o = _context138.sent;
                _context138.t0 = new e(r);
                _context138.next = 8;
                return this.getDTMaxBuyQuantity(i);

              case 8:
                _context138.t1 = _context138.sent;

                if (!_context138.t0.greaterThan.call(_context138.t0, _context138.t1)) {
                  _context138.next = 11;
                  break;
                }

                return _context138.abrupt("return", (this.logger.error("ERROR: Buy quantity exceeds quantity allowed"), null));

              case 11:
                _context138.next = 13;
                return this.getOceanNeeded(i, r);

              case 13:
                a = _context138.sent;

                if (!new e(a).greaterThan(n)) {
                  _context138.next = 16;
                  break;
                }

                return _context138.abrupt("return", (this.logger.error("ERROR: Not enough Ocean Tokens"), null));

              case 16:
                _context138.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "approve", this).call(this, t, this.oceanAddress, i, this.web3.utils.toWei(n));

              case 18:
                if (_context138.sent) {
                  _context138.next = 20;
                  break;
                }

                throw this.logger.error("ERROR: Failed to call approve OCEAN token"), new Error("ERROR: Failed to call approve OCEAN token");

              case 20:
                _context138.next = 22;
                return _get2(_getPrototypeOf(je.prototype), "swapExactAmountOut", this).call(this, t, i, this.oceanAddress, n, o, r, s);

              case 22:
                return _context138.abrupt("return", _context138.sent);

              case 23:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138, this);
      }));

      function buyDT(_x330, _x331, _x332, _x333, _x334) {
        return _buyDT.apply(this, arguments);
      }

      return buyDT;
    }()
  }, {
    key: "buyDTWithExactOcean",
    value: function () {
      var _buyDTWithExactOcean = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee139(t, i, r, n, s) {
        var o, a;
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context139.next = 2;
                  break;
                }

                return _context139.abrupt("return", (this.logger.error("ERROR: undefined ocean token contract address"), null));

              case 2:
                _context139.next = 4;
                return this.getDTAddress(i);

              case 4:
                o = _context139.sent;
                _context139.t0 = new e(r);
                _context139.next = 8;
                return this.getDTMaxBuyQuantity(i);

              case 8:
                _context139.t1 = _context139.sent;

                if (!_context139.t0.greaterThan.call(_context139.t0, _context139.t1)) {
                  _context139.next = 11;
                  break;
                }

                return _context139.abrupt("return", (this.logger.error("ERROR: Buy quantity exceeds quantity allowed"), null));

              case 11:
                _context139.next = 13;
                return this.getOceanNeeded(i, r);

              case 13:
                a = _context139.sent;

                if (!new e(a).greaterThan(n)) {
                  _context139.next = 16;
                  break;
                }

                return _context139.abrupt("return", (this.logger.error("ERROR: Not enough Ocean Tokens"), null));

              case 16:
                _context139.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "approve", this).call(this, t, this.oceanAddress, i, this.web3.utils.toWei(n));

              case 18:
                if (_context139.sent) {
                  _context139.next = 20;
                  break;
                }

                throw this.logger.error("ERROR: Failed to call approve OCEAN token"), new Error("ERROR: Failed to call approve OCEAN token");

              case 20:
                _context139.next = 22;
                return _get2(_getPrototypeOf(je.prototype), "swapExactAmountIn", this).call(this, t, i, this.oceanAddress, n, o, r, s);

              case 22:
                return _context139.abrupt("return", _context139.sent);

              case 23:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));

      function buyDTWithExactOcean(_x335, _x336, _x337, _x338, _x339) {
        return _buyDTWithExactOcean.apply(this, arguments);
      }

      return buyDTWithExactOcean;
    }()
  }, {
    key: "sellDT",
    value: function () {
      var _sellDT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee140(t, i, r, n, s) {
        var o, a;
        return _regeneratorRuntime.wrap(function _callee140$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context140.next = 2;
                  break;
                }

                return _context140.abrupt("return", (this.logger.error("ERROR: oceanAddress is not defined"), null));

              case 2:
                _context140.next = 4;
                return this.getDTAddress(i);

              case 4:
                o = _context140.sent;
                _context140.t0 = new e(n);
                _context140.next = 8;
                return this.getOceanMaxBuyQuantity(i);

              case 8:
                _context140.t1 = _context140.sent;

                if (!_context140.t0.greaterThan.call(_context140.t0, _context140.t1)) {
                  _context140.next = 11;
                  break;
                }

                return _context140.abrupt("return", (this.logger.error("ERROR: Buy quantity exceeds quantity allowed"), null));

              case 11:
                _context140.next = 13;
                return this.getOceanReceived(i, r);

              case 13:
                a = _context140.sent;

                if (!new e(a).lessThan(n)) {
                  _context140.next = 16;
                  break;
                }

                return _context140.abrupt("return", (this.logger.error("ERROR: Not enough datatokens"), null));

              case 16:
                _context140.next = 18;
                return _get2(_getPrototypeOf(je.prototype), "approve", this).call(this, t, o, i, this.web3.utils.toWei(r));

              case 18:
                if (_context140.sent) {
                  _context140.next = 20;
                  break;
                }

                throw this.logger.error("ERROR: Failed to call approve DT token"), new Error("ERROR: Failed to call approve DT token");

              case 20:
                _context140.next = 22;
                return _get2(_getPrototypeOf(je.prototype), "swapExactAmountIn", this).call(this, t, i, o, r, this.oceanAddress, n, s);

              case 22:
                return _context140.abrupt("return", _context140.sent);

              case 23:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee140, this);
      }));

      function sellDT(_x340, _x341, _x342, _x343, _x344) {
        return _sellDT.apply(this, arguments);
      }

      return sellDT;
    }()
  }, {
    key: "addDTLiquidity",
    value: function () {
      var _addDTLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee141(t, i, r) {
        var n, s;
        return _regeneratorRuntime.wrap(function _callee141$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                _context141.next = 2;
                return this.getDTAddress(i);

              case 2:
                n = _context141.sent;
                _context141.next = 5;
                return this.getMaxAddLiquidity(i, n);

              case 5:
                s = _context141.sent;

                if (!new e(r).greaterThan(s)) {
                  _context141.next = 8;
                  break;
                }

                return _context141.abrupt("return", (this.logger.error("ERROR: Too much reserve to add"), null));

              case 8:
                _context141.next = 10;
                return _get2(_getPrototypeOf(je.prototype), "approve", this).call(this, t, n, i, this.web3.utils.toWei(r));

              case 10:
                if (_context141.sent) {
                  _context141.next = 12;
                  break;
                }

                throw this.logger.error("ERROR: Failed to call approve DT token"), new Error("ERROR: Failed to call approve DT token");

              case 12:
                _context141.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "joinswapExternAmountIn", this).call(this, t, i, n, r, "0");

              case 14:
                return _context141.abrupt("return", _context141.sent);

              case 15:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee141, this);
      }));

      function addDTLiquidity(_x345, _x346, _x347) {
        return _addDTLiquidity.apply(this, arguments);
      }

      return addDTLiquidity;
    }()
  }, {
    key: "removeDTLiquidity",
    value: function () {
      var _removeDTLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee142(t, i, r, n) {
        var s, o, a, h;
        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                _context142.next = 2;
                return this.getDTAddress(i);

              case 2:
                s = _context142.sent;
                _context142.next = 5;
                return this.getDTMaxRemoveLiquidity(i);

              case 5:
                o = _context142.sent;

                if (!new e(r).greaterThan(o)) {
                  _context142.next = 8;
                  break;
                }

                return _context142.abrupt("return", (this.logger.error("ERROR: Too much reserve to remove"), null));

              case 8:
                _context142.next = 10;
                return this.sharesBalance(t, i);

              case 10:
                a = _context142.sent;

                if (!new e(a).lessThan(n)) {
                  _context142.next = 13;
                  break;
                }

                return _context142.abrupt("return", (this.logger.error("ERROR: Not enough poolShares"), null));

              case 13:
                _context142.next = 15;
                return this.getPoolSharesRequiredToRemoveDT(i, r);

              case 15:
                h = _context142.sent;
                return _context142.abrupt("return", new e(n).lessThan(h) ? (this.logger.error("ERROR: Not enough poolShares"), null) : (new e(n).lessThan(h) && (n = new e(n).mul(.9999).toString()), this.exitswapExternAmountOut(t, i, s, r, n)));

              case 17:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142, this);
      }));

      function removeDTLiquidity(_x348, _x349, _x350, _x351) {
        return _removeDTLiquidity.apply(this, arguments);
      }

      return removeDTLiquidity;
    }()
  }, {
    key: "addOceanLiquidity",
    value: function () {
      var _addOceanLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee143(t, i, r) {
        var n;
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context143.next = 2;
                  break;
                }

                return _context143.abrupt("return", (this.logger.error("ERROR: oceanAddress is not defined"), null));

              case 2:
                _context143.next = 4;
                return this.getOceanMaxAddLiquidity(i);

              case 4:
                n = _context143.sent;

                if (!new e(r).greaterThan(n)) {
                  _context143.next = 7;
                  break;
                }

                return _context143.abrupt("return", (this.logger.error("ERROR: Too much reserve to add"), null));

              case 7:
                _context143.next = 9;
                return _get2(_getPrototypeOf(je.prototype), "approve", this).call(this, t, this.oceanAddress, i, this.web3.utils.toWei(r));

              case 9:
                if (_context143.sent) {
                  _context143.next = 11;
                  break;
                }

                throw this.logger.error("ERROR: Failed to call approve OCEAN token"), new Error("ERROR: Failed to call approve OCEAN token");

              case 11:
                _context143.next = 13;
                return _get2(_getPrototypeOf(je.prototype), "joinswapExternAmountIn", this).call(this, t, i, this.oceanAddress, r, "0");

              case 13:
                return _context143.abrupt("return", _context143.sent);

              case 14:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, this);
      }));

      function addOceanLiquidity(_x352, _x353, _x354) {
        return _addOceanLiquidity.apply(this, arguments);
      }

      return addOceanLiquidity;
    }()
  }, {
    key: "removeOceanLiquidityWithMinimum",
    value: function () {
      var _removeOceanLiquidityWithMinimum = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee144(t, i, r, n) {
        var s;
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context144.next = 2;
                  break;
                }

                return _context144.abrupt("return", (this.logger.error("ERROR: oceanAddress is not defined"), null));

              case 2:
                _context144.next = 4;
                return this.sharesBalance(t, i);

              case 4:
                s = _context144.sent;
                return _context144.abrupt("return", new e(s).lessThan(r) ? (this.logger.error("ERROR: Not enough poolShares"), null) : _get2(_getPrototypeOf(je.prototype), "exitswapPoolAmountIn", this).call(this, t, i, this.oceanAddress, r, n));

              case 6:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, this);
      }));

      function removeOceanLiquidityWithMinimum(_x355, _x356, _x357, _x358) {
        return _removeOceanLiquidityWithMinimum.apply(this, arguments);
      }

      return removeOceanLiquidityWithMinimum;
    }()
  }, {
    key: "removeOceanLiquidity",
    value: function () {
      var _removeOceanLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee145(t, i, r, n) {
        var s, o, a;
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                if (!(null == this.oceanAddress)) {
                  _context145.next = 2;
                  break;
                }

                return _context145.abrupt("return", (this.logger.error("ERROR: oceanAddress is not defined"), null));

              case 2:
                _context145.next = 4;
                return this.getOceanMaxRemoveLiquidity(i);

              case 4:
                s = _context145.sent;

                if (!new e(r).greaterThan(s)) {
                  _context145.next = 7;
                  break;
                }

                return _context145.abrupt("return", (this.logger.error("ERROR: Too much reserve to remove"), null));

              case 7:
                _context145.next = 9;
                return this.sharesBalance(t, i);

              case 9:
                o = _context145.sent;

                if (!new e(o).lessThan(n)) {
                  _context145.next = 12;
                  break;
                }

                return _context145.abrupt("return", (this.logger.error("ERROR: Not enough poolShares"), null));

              case 12:
                _context145.next = 14;
                return this.getPoolSharesRequiredToRemoveOcean(i, r);

              case 14:
                a = _context145.sent;
                return _context145.abrupt("return", new e(n).lessThan(a) ? (this.logger.error("ERROR: Not enough poolShares"), null) : (new e(n).lessThan(a) && (n = new e(n).mul(.9999).toString()), _get2(_getPrototypeOf(je.prototype), "exitswapExternAmountOut", this).call(this, t, i, this.oceanAddress, r, n)));

              case 16:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, this);
      }));

      function removeOceanLiquidity(_x359, _x360, _x361, _x362) {
        return _removeOceanLiquidity.apply(this, arguments);
      }

      return removeOceanLiquidity;
    }()
  }, {
    key: "removePoolLiquidity",
    value: function () {
      var _removePoolLiquidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee146(t, i, r) {
        var n,
            s,
            o,
            _args146 = arguments;
        return _regeneratorRuntime.wrap(function _callee146$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                n = _args146.length > 3 && _args146[3] !== undefined ? _args146[3] : "0";
                s = _args146.length > 4 && _args146[4] !== undefined ? _args146[4] : "0";
                _context146.next = 4;
                return this.sharesBalance(t, i);

              case 4:
                o = _context146.sent;
                return _context146.abrupt("return", new e(o).lessThan(r) ? (this.logger.error("ERROR: Not enough poolShares"), null) : (new e(o).equals(r) && (r = new e(r).mul(.9999).toString()), this.exitPool(t, i, r, [n, s])));

              case 6:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee146, this);
      }));

      function removePoolLiquidity(_x363, _x364, _x365) {
        return _removePoolLiquidity.apply(this, arguments);
      }

      return removePoolLiquidity;
    }()
  }, {
    key: "getDTPrice",
    value: function () {
      var _getDTPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee147(t) {
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                return _context147.abrupt("return", null == this.oceanAddress ? (this.logger.error("ERROR: oceanAddress is not defined"), "0") : this.getOceanNeeded(t, "1"));

              case 1:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147, this);
      }));

      function getDTPrice(_x366) {
        return _getDTPrice.apply(this, arguments);
      }

      return getDTPrice;
    }()
  }, {
    key: "searchPoolforDT",
    value: function () {
      var _searchPoolforDT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee148(t) {
        var e, i, r, _i19;

        return _regeneratorRuntime.wrap(function _callee148$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                e = [];
                i = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress), this.config);
                _context148.next = 4;
                return i.getPastEvents("BPoolRegistered", {
                  filter: {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 4:
                r = _context148.sent;
                r.sort(function (t, e) {
                  return t.blockNumber > e.blockNumber ? 1 : -1;
                });
                _i19 = 0;

              case 7:
                if (!(_i19 < r.length)) {
                  _context148.next = 16;
                  break;
                }

                _context148.next = 10;
                return _get2(_getPrototypeOf(je.prototype), "getCurrentTokens", this).call(this, r[_i19].returnValues[0]);

              case 10:
                _context148.t0 = _context148.sent.includes(t);

                if (!_context148.t0) {
                  _context148.next = 13;
                  break;
                }

                e.push(r[_i19].returnValues[0]);

              case 13:
                _i19++;
                _context148.next = 7;
                break;

              case 16:
                return _context148.abrupt("return", e);

              case 17:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee148, this);
      }));

      function searchPoolforDT(_x367) {
        return _searchPoolforDT.apply(this, arguments);
      }

      return searchPoolforDT;
    }()
  }, {
    key: "getOceanNeeded",
    value: function () {
      var _getOceanNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee149(t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee149$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                _context149.next = 2;
                return this.getDTAddress(t);

              case 2:
                r = _context149.sent;
                _context149.t0 = new e(i);
                _context149.next = 6;
                return this.getDTMaxBuyQuantity(t);

              case 6:
                _context149.t1 = _context149.sent;

                if (!_context149.t0.greaterThan.call(_context149.t0, _context149.t1)) {
                  _context149.next = 11;
                  break;
                }

                _context149.t2 = "0";
                _context149.next = 12;
                break;

              case 11:
                _context149.t2 = this.calcInGivenOut(t, this.oceanAddress, r, i);

              case 12:
                return _context149.abrupt("return", _context149.t2);

              case 13:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee149, this);
      }));

      function getOceanNeeded(_x368, _x369) {
        return _getOceanNeeded.apply(this, arguments);
      }

      return getOceanNeeded;
    }()
  }, {
    key: "getOceanReceived",
    value: function () {
      var _getOceanReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee150(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee150$(_context150) {
          while (1) {
            switch (_context150.prev = _context150.next) {
              case 0:
                _context150.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context150.sent;
                return _context150.abrupt("return", this.calcOutGivenIn(t, i, this.oceanAddress, e));

              case 4:
              case "end":
                return _context150.stop();
            }
          }
        }, _callee150, this);
      }));

      function getOceanReceived(_x370, _x371) {
        return _getOceanReceived.apply(this, arguments);
      }

      return getOceanReceived;
    }()
  }, {
    key: "getDTReceived",
    value: function () {
      var _getDTReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee151(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                _context151.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context151.sent;
                return _context151.abrupt("return", this.calcOutGivenIn(t, this.oceanAddress, i, e));

              case 4:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151, this);
      }));

      function getDTReceived(_x372, _x373) {
        return _getDTReceived.apply(this, arguments);
      }

      return getDTReceived;
    }()
  }, {
    key: "getDTNeeded",
    value: function () {
      var _getDTNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee152(t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                _context152.next = 2;
                return this.getDTAddress(t);

              case 2:
                r = _context152.sent;
                _context152.t0 = new e(i);
                _context152.next = 6;
                return this.getOceanMaxBuyQuantity(t);

              case 6:
                _context152.t1 = _context152.sent;

                if (!_context152.t0.greaterThan.call(_context152.t0, _context152.t1)) {
                  _context152.next = 11;
                  break;
                }

                _context152.t2 = "0";
                _context152.next = 12;
                break;

              case 11:
                _context152.t2 = this.calcInGivenOut(t, r, this.oceanAddress, i);

              case 12:
                return _context152.abrupt("return", _context152.t2);

              case 13:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, this);
      }));

      function getDTNeeded(_x374, _x375) {
        return _getDTNeeded.apply(this, arguments);
      }

      return getDTNeeded;
    }()
  }, {
    key: "getPoolsbyCreator",
    value: function () {
      var _getPoolsbyCreator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee153(t) {
        var e, i, r, _i20;

        return _regeneratorRuntime.wrap(function _callee153$(_context153) {
          while (1) {
            switch (_context153.prev = _context153.next) {
              case 0:
                e = [];
                i = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress), this.config);
                _context153.next = 4;
                return i.getPastEvents("BPoolRegistered", {
                  filter: t ? {
                    registeredBy: t
                  } : {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 4:
                r = _context153.sent;
                _i20 = 0;

              case 6:
                if (!(_i20 < r.length)) {
                  _context153.next = 17;
                  break;
                }

                _context153.t0 = t && r[_i20].returnValues[1].toLowerCase() !== t.toLowerCase();

                if (_context153.t0) {
                  _context153.next = 14;
                  break;
                }

                _context153.t1 = e;
                _context153.next = 12;
                return this.getPoolDetails(r[_i20].returnValues[0]);

              case 12:
                _context153.t2 = _context153.sent;

                _context153.t1.push.call(_context153.t1, _context153.t2);

              case 14:
                _i20++;
                _context153.next = 6;
                break;

              case 17:
                return _context153.abrupt("return", e);

              case 18:
              case "end":
                return _context153.stop();
            }
          }
        }, _callee153, this);
      }));

      function getPoolsbyCreator(_x376) {
        return _getPoolsbyCreator.apply(this, arguments);
      }

      return getPoolsbyCreator;
    }()
  }, {
    key: "getResult",
    value: function () {
      var _getResult2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee154(t, e) {
        var i, _t27;

        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                _context154.next = 2;
                return _get2(_getPrototypeOf(je.prototype), "sharesBalance", this).call(this, t, e.returnValues[0]);

              case 2:
                i = _context154.sent;

                if (!(parseFloat(i) > 0)) {
                  _context154.next = 9;
                  break;
                }

                _context154.next = 6;
                return this.getDTAddress(e.returnValues[0]);

              case 6:
                _t27 = _context154.sent;

                if (!_t27) {
                  _context154.next = 9;
                  break;
                }

                return _context154.abrupt("return", {
                  shares: i,
                  poolAddress: e.returnValues[0],
                  did: T(C(_t27))
                });

              case 9:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154, this);
      }));

      function getResult(_x377, _x378) {
        return _getResult2.apply(this, arguments);
      }

      return getResult;
    }()
  }, {
    key: "getPoolSharesByAddress",
    value: function () {
      var _getPoolSharesByAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee155(t) {
        var e, i, r, n, _i21, _t28, _i22, _t29, _i23;

        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                e = [];
                i = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress), this.config);
                _context155.next = 4;
                return i.getPastEvents("BPoolRegistered", {
                  filter: {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 4:
                r = _context155.sent;
                n = [];
                _i21 = 0;

              case 7:
                if (!(_i21 < r.length)) {
                  _context155.next = 17;
                  break;
                }

                if (!(n.push(this.getResult(t, r[_i21])), n.length > 10)) {
                  _context155.next = 14;
                  break;
                }

                _context155.next = 11;
                return Promise.all(n);

              case 11:
                _t28 = _context155.sent;

                for (_i22 = 0; _i22 < _t28.length; _i22++) {
                  e.push(_t28[_i22]);
                }

                n = [];

              case 14:
                _i21++;
                _context155.next = 7;
                break;

              case 17:
                if (!(n.length > 0)) {
                  _context155.next = 23;
                  break;
                }

                _context155.next = 20;
                return Promise.all(n);

              case 20:
                _t29 = _context155.sent;

                for (_i23 = 0; _i23 < _t29.length; _i23++) {
                  e.push(_t29[_i23]);
                }

                n = [];

              case 23:
                return _context155.abrupt("return", e.filter(function (t) {
                  return void 0 !== t;
                }));

              case 24:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155, this);
      }));

      function getPoolSharesByAddress(_x379) {
        return _getPoolSharesByAddress.apply(this, arguments);
      }

      return getPoolSharesByAddress;
    }()
  }, {
    key: "getPoolDetails",
    value: function () {
      var _getPoolDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee156(t) {
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                _context156.t0 = t;
                _context156.next = 3;
                return _get2(_getPrototypeOf(je.prototype), "getFinalTokens", this).call(this, t);

              case 3:
                _context156.t1 = _context156.sent;
                return _context156.abrupt("return", {
                  poolAddress: _context156.t0,
                  tokens: _context156.t1
                });

              case 5:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, this);
      }));

      function getPoolDetails(_x380) {
        return _getPoolDetails.apply(this, arguments);
      }

      return getPoolDetails;
    }()
  }, {
    key: "getPoolLogs",
    value: function () {
      var _getPoolLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee157(t) {
        var e,
            i,
            r,
            n,
            s,
            o,
            a,
            h,
            u,
            l,
            _e16,
            _t30,
            _e17,
            _t31,
            _e18,
            _args157 = arguments;

        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                e = _args157.length > 1 && _args157[1] !== undefined ? _args157[1] : 0;
                i = _args157.length > 2 ? _args157[2] : undefined;
                r = [];
                _context157.next = 5;
                return this.getDTAddress(t);

              case 5:
                n = _context157.sent;
                0 === e && (e = this.startBlock);
                s = _get2(_getPrototypeOf(je.prototype), "getSwapEventSignature", this).call(this), o = _get2(_getPrototypeOf(je.prototype), "getJoinEventSignature", this).call(this), a = _get2(_getPrototypeOf(je.prototype), "getExitEventSignature", this).call(this);
                h = i ? "0x000000000000000000000000" + i.substring(2).toLowerCase() : null;
                _context157.next = 11;
                return this.web3.eth.getPastLogs({
                  address: t,
                  topics: [[s, o, a], h],
                  fromBlock: e,
                  toBlock: "latest"
                });

              case 11:
                u = _context157.sent;
                l = [];
                _e16 = 0;

              case 14:
                if (!(_e16 < u.length)) {
                  _context157.next = 24;
                  break;
                }

                if (!(l.push(this.getEventData(t, n, u[_e16])), l.length > 10)) {
                  _context157.next = 21;
                  break;
                }

                _context157.next = 18;
                return Promise.all(l);

              case 18:
                _t30 = _context157.sent;

                for (_e17 = 0; _e17 < _t30.length; _e17++) {
                  r.push(_t30[_e17]);
                }

                l = [];

              case 21:
                _e16++;
                _context157.next = 14;
                break;

              case 24:
                if (!(l.length > 0)) {
                  _context157.next = 30;
                  break;
                }

                _context157.next = 27;
                return Promise.all(l);

              case 27:
                _t31 = _context157.sent;

                for (_e18 = 0; _e18 < _t31.length; _e18++) {
                  r.push(_t31[_e18]);
                }

                l = [];

              case 30:
                return _context157.abrupt("return", r.filter(function (t) {
                  return void 0 !== t;
                }));

              case 31:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, this);
      }));

      function getPoolLogs(_x381) {
        return _getPoolLogs.apply(this, arguments);
      }

      return getPoolLogs;
    }()
  }, {
    key: "getAllPoolLogs",
    value: function () {
      var _getAllPoolLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee158(t) {
        var e, i, r, n, _i24, _t32, _i25, _t33, _i26;

        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                e = [];
                i = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress), this.config);
                _context158.next = 4;
                return i.getPastEvents("BPoolRegistered", {
                  filter: {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 4:
                r = _context158.sent;
                n = [];
                _i24 = 0;

              case 7:
                if (!(_i24 < r.length)) {
                  _context158.next = 17;
                  break;
                }

                if (!(n.push(this.getPoolLogs(r[_i24].returnValues[0], r[_i24].blockNumber, t)), n.length > 10)) {
                  _context158.next = 14;
                  break;
                }

                _context158.next = 11;
                return Promise.all(n);

              case 11:
                _t32 = _context158.sent;

                for (_i25 = 0; _i25 < _t32.length; _i25++) {
                  e.push(_t32[_i25]);
                }

                n = [];

              case 14:
                _i24++;
                _context158.next = 7;
                break;

              case 17:
                if (!(n.length > 0)) {
                  _context158.next = 23;
                  break;
                }

                _context158.next = 20;
                return Promise.all(n);

              case 20:
                _t33 = _context158.sent;

                for (_i26 = 0; _i26 < _t33.length; _i26++) {
                  e.push(_t33[_i26]);
                }

                n = [];

              case 23:
                return _context158.abrupt("return", e.reduce(function (t, e) {
                  return t.concat(e);
                }));

              case 24:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, this);
      }));

      function getAllPoolLogs(_x382) {
        return _getAllPoolLogs.apply(this, arguments);
      }

      return getAllPoolLogs;
    }()
  }, {
    key: "getEventData",
    value: function () {
      var _getEventData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee159(t, e, i) {
        var r, n, s, o, a, h, u;
        return _regeneratorRuntime.wrap(function _callee159$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                _context159.next = 2;
                return this.web3.eth.getBlock(i.blockNumber);

              case 2:
                r = _context159.sent;
                n = _get2(_getPrototypeOf(je.prototype), "getSwapEventSignature", this).call(this);
                s = _get2(_getPrototypeOf(je.prototype), "getJoinEventSignature", this).call(this);
                o = _get2(_getPrototypeOf(je.prototype), "getExitEventSignature", this).call(this);
                _context159.t0 = i.topics[0];
                _context159.next = _context159.t0 === n ? 9 : _context159.t0 === s ? 11 : _context159.t0 === o ? 13 : 14;
                break;

              case 9:
                a = "swap";
                return _context159.abrupt("break", 14);

              case 11:
                a = "join";
                return _context159.abrupt("break", 14);

              case 13:
                a = "exit";

              case 14:
                u = {
                  poolAddress: t,
                  dtAddress: e,
                  caller: i.topics[1],
                  transactionHash: i.transactionHash,
                  blockNumber: i.blockNumber,
                  timestamp: parseInt(String(r.timestamp)),
                  type: a
                };
                _context159.t1 = a;
                _context159.next = _context159.t1 === "swap" ? 18 : _context159.t1 === "join" ? 20 : _context159.t1 === "exit" ? 22 : 23;
                break;

              case 18:
                h = this.web3.eth.abi.decodeParameters(["uint256", "uint256"], i.data), u = A({}, u, {
                  tokenIn: "0x" + i.topics[2].substring(i.topics[2].length - 40),
                  tokenOut: "0x" + i.topics[3].substring(i.topics[3].length - 40),
                  tokenAmountIn: this.web3.utils.fromWei(h[0]),
                  tokenAmountOut: this.web3.utils.fromWei(h[1])
                });
                return _context159.abrupt("break", 23);

              case 20:
                h = this.web3.eth.abi.decodeParameters(["uint256"], i.data), u = A({}, u, {
                  tokenIn: "0x" + i.topics[2].substring(i.topics[2].length - 40),
                  tokenAmountIn: this.web3.utils.fromWei(h[0])
                });
                return _context159.abrupt("break", 23);

              case 22:
                h = this.web3.eth.abi.decodeParameters(["uint256"], i.data), u = A({}, u, {
                  tokenOut: "0x" + i.topics[2].substring(i.topics[2].length - 40),
                  tokenAmountOut: this.web3.utils.fromWei(h[0])
                });

              case 23:
                return _context159.abrupt("return", u);

              case 24:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee159, this);
      }));

      function getEventData(_x383, _x384, _x385) {
        return _getEventData.apply(this, arguments);
      }

      return getEventData;
    }()
  }, {
    key: "computeSlippage",
    value: function () {
      var _computeSlippage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee160(t, i, r, n, s, o, a, h) {
        var u, l;
        return _regeneratorRuntime.wrap(function _callee160$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                _context160.next = 2;
                return _get2(_getPrototypeOf(je.prototype), "calcSpotPrice", this).call(this, t, i, r, n, s, h);

              case 2:
                u = _context160.sent;
                _context160.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "calcSpotPrice", this).call(this, t, o, r, a, s, h);

              case 5:
                l = _context160.sent;
                return _context160.abrupt("return", new e(l).mul(100).div(u).minus(100).toString());

              case 7:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee160, this);
      }));

      function computeSlippage(_x386, _x387, _x388, _x389, _x390, _x391, _x392, _x393) {
        return _computeSlippage.apply(this, arguments);
      }

      return computeSlippage;
    }()
  }, {
    key: "computeBuySlippage",
    value: function () {
      var _computeBuySlippage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee161(t, e) {
        var i, r, n, s, o, a, h, u, l;
        return _regeneratorRuntime.wrap(function _callee161$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                _context161.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context161.sent;
                _context161.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, i);

              case 5:
                r = _context161.sent;
                _context161.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, this.oceanAddress);

              case 8:
                n = _context161.sent;
                _context161.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 11:
                s = _context161.sent;
                _context161.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 14:
                o = _context161.sent;
                _context161.next = 17;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 17:
                a = _context161.sent;
                _context161.next = 20;
                return _get2(_getPrototypeOf(je.prototype), "calcOutGivenIn", this).call(this, t, o, n, s, r, e, a);

              case 20:
                h = _context161.sent;
                u = new X(this.web3.utils.toWei(s)).minus(this.web3.utils.toWei(h));
                l = new X(this.web3.utils.toWei(o)).plus(this.web3.utils.toWei(e));
                _context161.next = 25;
                return this.computeSlippage(t, o, n, s, r, this.web3.utils.fromWei(l.toString()), this.web3.utils.fromWei(u.toString()), a);

              case 25:
                return _context161.abrupt("return", _context161.sent);

              case 26:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee161, this);
      }));

      function computeBuySlippage(_x394, _x395) {
        return _computeBuySlippage.apply(this, arguments);
      }

      return computeBuySlippage;
    }()
  }, {
    key: "computeSellSlippage",
    value: function () {
      var _computeSellSlippage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee162(t, e) {
        var i, r, n, s, o, a, h, u, l;
        return _regeneratorRuntime.wrap(function _callee162$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                _context162.next = 2;
                return this.getDTAddress(t);

              case 2:
                i = _context162.sent;
                _context162.next = 5;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, i);

              case 5:
                r = _context162.sent;
                _context162.next = 8;
                return _get2(_getPrototypeOf(je.prototype), "getDenormalizedWeight", this).call(this, t, this.oceanAddress);

              case 8:
                n = _context162.sent;
                _context162.next = 11;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 11:
                s = _context162.sent;
                _context162.next = 14;
                return _get2(_getPrototypeOf(je.prototype), "getReserve", this).call(this, t, i);

              case 14:
                o = _context162.sent;
                _context162.next = 17;
                return _get2(_getPrototypeOf(je.prototype), "getSwapFee", this).call(this, t);

              case 17:
                a = _context162.sent;
                _context162.next = 20;
                return _get2(_getPrototypeOf(je.prototype), "calcOutGivenIn", this).call(this, t, s, r, o, n, e, a);

              case 20:
                h = _context162.sent;
                u = new X(this.web3.utils.toWei(s)).plus(this.web3.utils.toWei(e));
                l = new X(this.web3.utils.toWei(o)).minus(this.web3.utils.toWei(h));
                _context162.next = 25;
                return this.computeSlippage(t, s, r, o, n, this.web3.utils.fromWei(u.toString()), this.web3.utils.fromWei(l.toString()), a);

              case 25:
                return _context162.abrupt("return", _context162.sent);

              case 26:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee162, this);
      }));

      function computeSellSlippage(_x396, _x397) {
        return _computeSellSlippage.apply(this, arguments);
      }

      return computeSellSlippage;
    }()
  }]);

  return je;
}( /*#__PURE__*/function (_ref15) {
  _inherits(_class, _ref15);

  var _super11 = _createSuper(_class);

  function _class(t, e) {
    var _this18;

    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var s = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, _class);

    _this18 = _super11.call(this, t, e, i, n, s), _this18.poolABI = void 0, _this18.poolABI = r || g.abi;
    return _this18;
  }

  _createClass(_class, [{
    key: "createPool",
    value: function () {
      var _createPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee163(t) {
        return _regeneratorRuntime.wrap(function _callee163$(_context163) {
          while (1) {
            switch (_context163.prev = _context163.next) {
              case 0:
                _context163.next = 2;
                return _get2(_getPrototypeOf(_class.prototype), "createPool", this).call(this, t);

              case 2:
                return _context163.abrupt("return", _context163.sent);

              case 3:
              case "end":
                return _context163.stop();
            }
          }
        }, _callee163, this);
      }));

      function createPool(_x398) {
        return _createPool.apply(this, arguments);
      }

      return createPool;
    }()
  }, {
    key: "setup",
    value: function () {
      var _setup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee164(t, e, i, r, n, s, o, a, h) {
        var u, l, c, d;
        return _regeneratorRuntime.wrap(function _callee164$(_context164) {
          while (1) {
            switch (_context164.prev = _context164.next) {
              case 0:
                u = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                l = null;
                c = this.GASLIMIT_DEFAULT;
                _context164.prev = 3;
                _context164.next = 6;
                return u.methods.setup(i, r, n, s, o, a, h).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? c : e;
                });

              case 6:
                d = _context164.sent;
                _context164.next = 12;
                break;

              case 9:
                _context164.prev = 9;
                _context164.t0 = _context164["catch"](3);
                d = c;

              case 12:
                _context164.prev = 12;
                _context164.t1 = u.methods.setup(i, r, n, s, o, a, h);
                _context164.t2 = t;
                _context164.t3 = d;
                _context164.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context164.t4 = _context164.sent;
                _context164.t5 = {
                  from: _context164.t2,
                  gas: _context164.t3,
                  gasPrice: _context164.t4
                };
                _context164.next = 22;
                return _context164.t1.send.call(_context164.t1, _context164.t5);

              case 22:
                l = _context164.sent;
                _context164.next = 28;
                break;

              case 25:
                _context164.prev = 25;
                _context164.t6 = _context164["catch"](12);
                this.logger.error("ERROR: Failed to setup a pool: ".concat(_context164.t6.message));

              case 28:
                return _context164.abrupt("return", l);

              case 29:
              case "end":
                return _context164.stop();
            }
          }
        }, _callee164, this, [[3, 9], [12, 25]]);
      }));

      function setup(_x399, _x400, _x401, _x402, _x403, _x404, _x405, _x406, _x407) {
        return _setup.apply(this, arguments);
      }

      return setup;
    }()
  }, {
    key: "allowance",
    value: function () {
      var _allowance2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee165(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee165$(_context165) {
          while (1) {
            switch (_context165.prev = _context165.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(d.abi, t, {
                  from: i
                }), this.config);
                _context165.next = 3;
                return r.methods.allowance(e, i).call();

              case 3:
                n = _context165.sent;
                return _context165.abrupt("return", this.web3.utils.fromWei(n));

              case 5:
              case "end":
                return _context165.stop();
            }
          }
        }, _callee165, this);
      }));

      function allowance(_x408, _x409, _x410) {
        return _allowance2.apply(this, arguments);
      }

      return allowance;
    }()
  }, {
    key: "approve",
    value: function () {
      var _approve2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee166(t, i, r, n) {
        var s,
            o,
            _s3,
            a,
            h,
            u,
            _args166 = arguments;

        return _regeneratorRuntime.wrap(function _callee166$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                s = _args166.length > 4 && _args166[4] !== undefined ? _args166[4] : !1;
                o = Y(new this.web3.eth.Contract([{
                  constant: !1,
                  inputs: [{
                    name: "_spender",
                    type: "address"
                  }, {
                    name: "_value",
                    type: "uint256"
                  }],
                  name: "approve",
                  outputs: [{
                    name: "",
                    type: "bool"
                  }],
                  payable: !1,
                  stateMutability: "nonpayable",
                  type: "function"
                }], i, {
                  from: t
                }), this.config);

                if (s) {
                  _context166.next = 8;
                  break;
                }

                _context166.next = 5;
                return this.allowance(i, t, r);

              case 5:
                _s3 = _context166.sent;

                if (!new e(this.web3.utils.toWei(_s3)).greaterThanOrEqualTo(n)) {
                  _context166.next = 8;
                  break;
                }

                return _context166.abrupt("return", _s3);

              case 8:
                a = null;
                h = this.GASLIMIT_DEFAULT;
                _context166.prev = 10;
                _context166.next = 13;
                return o.methods.approve(r, n).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? h : e;
                });

              case 13:
                u = _context166.sent;
                _context166.next = 19;
                break;

              case 16:
                _context166.prev = 16;
                _context166.t0 = _context166["catch"](10);
                u = h;

              case 19:
                _context166.prev = 19;
                _context166.t1 = o.methods.approve(r, n);
                _context166.t2 = t;
                _context166.t3 = u + 1;
                _context166.next = 25;
                return Q(this.web3, this.config);

              case 25:
                _context166.t4 = _context166.sent;
                _context166.t5 = {
                  from: _context166.t2,
                  gas: _context166.t3,
                  gasPrice: _context166.t4
                };
                _context166.next = 29;
                return _context166.t1.send.call(_context166.t1, _context166.t5);

              case 29:
                a = _context166.sent;
                _context166.next = 35;
                break;

              case 32:
                _context166.prev = 32;
                _context166.t6 = _context166["catch"](19);
                this.logger.error("ERRPR: Failed to approve spender to spend tokens : ".concat(_context166.t6.message));

              case 35:
                return _context166.abrupt("return", a);

              case 36:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee166, this, [[10, 16], [19, 32]]);
      }));

      function approve(_x411, _x412, _x413, _x414) {
        return _approve2.apply(this, arguments);
      }

      return approve;
    }()
  }, {
    key: "sharesBalance",
    value: function () {
      var _sharesBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee167(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee167$(_context167) {
          while (1) {
            switch (_context167.prev = _context167.next) {
              case 0:
                i = null;
                _context167.prev = 1;
                r = Y(new this.web3.eth.Contract(this.poolABI, e), this.config);
                _context167.next = 5;
                return r.methods.balanceOf(t).call();

              case 5:
                n = _context167.sent;
                i = this.web3.utils.fromWei(n);
                _context167.next = 12;
                break;

              case 9:
                _context167.prev = 9;
                _context167.t0 = _context167["catch"](1);
                this.logger.error("ERROR: Failed to get shares of pool : ".concat(_context167.t0.message));

              case 12:
                return _context167.abrupt("return", i);

              case 13:
              case "end":
                return _context167.stop();
            }
          }
        }, _callee167, this, [[1, 9]]);
      }));

      function sharesBalance(_x415, _x416) {
        return _sharesBalance.apply(this, arguments);
      }

      return sharesBalance;
    }()
  }, {
    key: "addToPool",
    value: function () {
      var _addToPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee168(t, e, i) {
        var r, n, _iterator6, _step6;

        return _regeneratorRuntime.wrap(function _callee168$(_context168) {
          while (1) {
            switch (_context168.prev = _context168.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                _iterator6 = _createForOfIteratorHelper(i);
                _context168.prev = 2;

                _iterator6.s();

              case 4:
                if ((_step6 = _iterator6.n()).done) {
                  _context168.next = 25;
                  break;
                }

                n = _step6.value;
                _context168.prev = 6;
                _context168.next = 9;
                return this.approve(t, n.address, e, this.web3.utils.toWei("".concat(n.amount)));

              case 9:
                _context168.t0 = r.methods.bind(n.address, this.web3.utils.toWei(n.amount), this.web3.utils.toWei(n.weight));
                _context168.t1 = t;
                _context168.t2 = this.GASLIMIT_DEFAULT;
                _context168.next = 14;
                return Q(this.web3, this.config);

              case 14:
                _context168.t3 = _context168.sent;
                _context168.t4 = {
                  from: _context168.t1,
                  gas: _context168.t2,
                  gasPrice: _context168.t3
                };
                _context168.next = 18;
                return _context168.t0.send.call(_context168.t0, _context168.t4);

              case 18:
                _context168.next = 23;
                break;

              case 20:
                _context168.prev = 20;
                _context168.t5 = _context168["catch"](6);
                this.logger.error("ERROR: Failed to add tokens to pool: ".concat(_context168.t5.message));

              case 23:
                _context168.next = 4;
                break;

              case 25:
                _context168.next = 30;
                break;

              case 27:
                _context168.prev = 27;
                _context168.t6 = _context168["catch"](2);

                _iterator6.e(_context168.t6);

              case 30:
                _context168.prev = 30;

                _iterator6.f();

                return _context168.finish(30);

              case 33:
              case "end":
                return _context168.stop();
            }
          }
        }, _callee168, this, [[2, 27, 30, 33], [6, 20]]);
      }));

      function addToPool(_x417, _x418, _x419) {
        return _addToPool.apply(this, arguments);
      }

      return addToPool;
    }()
  }, {
    key: "setSwapFee",
    value: function () {
      var _setSwapFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee169(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee169$(_context169) {
          while (1) {
            switch (_context169.prev = _context169.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                n = null;
                _context169.prev = 2;
                _context169.t0 = r.methods.setSwapFee(this.web3.utils.toWei(i));
                _context169.t1 = t;
                _context169.t2 = this.GASLIMIT_DEFAULT;
                _context169.next = 8;
                return Q(this.web3, this.config);

              case 8:
                _context169.t3 = _context169.sent;
                _context169.t4 = {
                  from: _context169.t1,
                  gas: _context169.t2,
                  gasPrice: _context169.t3
                };
                _context169.next = 12;
                return _context169.t0.send.call(_context169.t0, _context169.t4);

              case 12:
                n = _context169.sent;
                _context169.next = 18;
                break;

              case 15:
                _context169.prev = 15;
                _context169.t5 = _context169["catch"](2);
                this.logger.error("ERROR: Failed to set pool swap fee: ".concat(_context169.t5.message));

              case 18:
                return _context169.abrupt("return", n);

              case 19:
              case "end":
                return _context169.stop();
            }
          }
        }, _callee169, this, [[2, 15]]);
      }));

      function setSwapFee(_x420, _x421, _x422) {
        return _setSwapFee.apply(this, arguments);
      }

      return setSwapFee;
    }()
  }, {
    key: "finalize",
    value: function () {
      var _finalize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee170(t, e) {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee170$(_context170) {
          while (1) {
            switch (_context170.prev = _context170.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                r = null;
                _context170.prev = 2;
                _context170.t0 = i.methods.finalize();
                _context170.t1 = t;
                _context170.t2 = this.GASLIMIT_DEFAULT;
                _context170.next = 8;
                return Q(this.web3, this.config);

              case 8:
                _context170.t3 = _context170.sent;
                _context170.t4 = {
                  from: _context170.t1,
                  gas: _context170.t2,
                  gasPrice: _context170.t3
                };
                _context170.next = 12;
                return _context170.t0.send.call(_context170.t0, _context170.t4);

              case 12:
                r = _context170.sent;
                _context170.next = 18;
                break;

              case 15:
                _context170.prev = 15;
                _context170.t5 = _context170["catch"](2);
                this.logger.error("ERROR: Failed to finalize pool: ".concat(_context170.t5.message));

              case 18:
                return _context170.abrupt("return", r);

              case 19:
              case "end":
                return _context170.stop();
            }
          }
        }, _callee170, this, [[2, 15]]);
      }));

      function finalize(_x423, _x424) {
        return _finalize.apply(this, arguments);
      }

      return finalize;
    }()
  }, {
    key: "getNumTokens",
    value: function () {
      var _getNumTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee171(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee171$(_context171) {
          while (1) {
            switch (_context171.prev = _context171.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context171.prev = 2;
                _context171.next = 5;
                return e.methods.getNumTokens().call();

              case 5:
                i = _context171.sent;
                _context171.next = 11;
                break;

              case 8:
                _context171.prev = 8;
                _context171.t0 = _context171["catch"](2);
                this.logger.error("ERROR: Failed to get number of tokens: ".concat(_context171.t0.message));

              case 11:
                return _context171.abrupt("return", i);

              case 12:
              case "end":
                return _context171.stop();
            }
          }
        }, _callee171, this, [[2, 8]]);
      }));

      function getNumTokens(_x425) {
        return _getNumTokens.apply(this, arguments);
      }

      return getNumTokens;
    }()
  }, {
    key: "getPoolSharesTotalSupply",
    value: function () {
      var _getPoolSharesTotalSupply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee172(t) {
        var e, i, _t34;

        return _regeneratorRuntime.wrap(function _callee172$(_context172) {
          while (1) {
            switch (_context172.prev = _context172.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context172.prev = 2;
                _context172.next = 5;
                return e.methods.totalSupply().call();

              case 5:
                _t34 = _context172.sent;
                i = this.web3.utils.fromWei(_t34);
                _context172.next = 12;
                break;

              case 9:
                _context172.prev = 9;
                _context172.t0 = _context172["catch"](2);
                this.logger.error("ERROR: Failed to get total supply of pool shares: ".concat(_context172.t0.message));

              case 12:
                return _context172.abrupt("return", i);

              case 13:
              case "end":
                return _context172.stop();
            }
          }
        }, _callee172, this, [[2, 9]]);
      }));

      function getPoolSharesTotalSupply(_x426) {
        return _getPoolSharesTotalSupply.apply(this, arguments);
      }

      return getPoolSharesTotalSupply;
    }()
  }, {
    key: "getCurrentTokens",
    value: function () {
      var _getCurrentTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee173(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee173$(_context173) {
          while (1) {
            switch (_context173.prev = _context173.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context173.prev = 2;
                _context173.next = 5;
                return e.methods.getCurrentTokens().call();

              case 5:
                i = _context173.sent;
                _context173.next = 11;
                break;

              case 8:
                _context173.prev = 8;
                _context173.t0 = _context173["catch"](2);
                this.logger.error("ERROR: Failed to get tokens composing this pool: ".concat(_context173.t0.message));

              case 11:
                return _context173.abrupt("return", i);

              case 12:
              case "end":
                return _context173.stop();
            }
          }
        }, _callee173, this, [[2, 8]]);
      }));

      function getCurrentTokens(_x427) {
        return _getCurrentTokens.apply(this, arguments);
      }

      return getCurrentTokens;
    }()
  }, {
    key: "getFinalTokens",
    value: function () {
      var _getFinalTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee174(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee174$(_context174) {
          while (1) {
            switch (_context174.prev = _context174.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context174.prev = 2;
                _context174.next = 5;
                return e.methods.getFinalTokens().call();

              case 5:
                i = _context174.sent;
                _context174.next = 11;
                break;

              case 8:
                _context174.prev = 8;
                _context174.t0 = _context174["catch"](2);
                this.logger.error("ERROR: Failed to get the final tokens composing this pool");

              case 11:
                return _context174.abrupt("return", i);

              case 12:
              case "end":
                return _context174.stop();
            }
          }
        }, _callee174, this, [[2, 8]]);
      }));

      function getFinalTokens(_x428) {
        return _getFinalTokens.apply(this, arguments);
      }

      return getFinalTokens;
    }()
  }, {
    key: "getController",
    value: function () {
      var _getController = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee175(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee175$(_context175) {
          while (1) {
            switch (_context175.prev = _context175.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context175.prev = 2;
                _context175.next = 5;
                return e.methods.getController().call();

              case 5:
                i = _context175.sent;
                _context175.next = 11;
                break;

              case 8:
                _context175.prev = 8;
                _context175.t0 = _context175["catch"](2);
                this.logger.error("ERROR: Failed to get pool controller address: ".concat(_context175.t0.message));

              case 11:
                return _context175.abrupt("return", i);

              case 12:
              case "end":
                return _context175.stop();
            }
          }
        }, _callee175, this, [[2, 8]]);
      }));

      function getController(_x429) {
        return _getController.apply(this, arguments);
      }

      return getController;
    }()
  }, {
    key: "setController",
    value: function () {
      var _setController = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee176(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee176$(_context176) {
          while (1) {
            switch (_context176.prev = _context176.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                n = null;
                _context176.prev = 2;
                _context176.next = 5;
                return r.methods.setController(i).send({
                  from: t,
                  gas: this.GASLIMIT_DEFAULT
                });

              case 5:
                n = _context176.sent;
                _context176.next = 11;
                break;

              case 8:
                _context176.prev = 8;
                _context176.t0 = _context176["catch"](2);
                this.logger.error("ERROR: Failed to set pool controller: ".concat(_context176.t0.message));

              case 11:
                return _context176.abrupt("return", n);

              case 12:
              case "end":
                return _context176.stop();
            }
          }
        }, _callee176, this, [[2, 8]]);
      }));

      function setController(_x430, _x431, _x432) {
        return _setController.apply(this, arguments);
      }

      return setController;
    }()
  }, {
    key: "isBound",
    value: function () {
      var _isBound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee177(t, e) {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee177$(_context177) {
          while (1) {
            switch (_context177.prev = _context177.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                r = null;
                _context177.prev = 2;
                _context177.next = 5;
                return i.methods.isBound(e).call();

              case 5:
                r = _context177.sent;
                _context177.next = 11;
                break;

              case 8:
                _context177.prev = 8;
                _context177.t0 = _context177["catch"](2);
                this.logger.error("ERROR: Failed to check whether a token       bounded to a pool. ".concat(_context177.t0.message));

              case 11:
                return _context177.abrupt("return", r);

              case 12:
              case "end":
                return _context177.stop();
            }
          }
        }, _callee177, this, [[2, 8]]);
      }));

      function isBound(_x433, _x434) {
        return _isBound.apply(this, arguments);
      }

      return isBound;
    }()
  }, {
    key: "getReserve",
    value: function () {
      var _getReserve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee178(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee178$(_context178) {
          while (1) {
            switch (_context178.prev = _context178.next) {
              case 0:
                i = null;
                _context178.prev = 1;
                r = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                _context178.next = 5;
                return r.methods.getBalance(e).call();

              case 5:
                n = _context178.sent;
                i = this.web3.utils.fromWei(n);
                _context178.next = 12;
                break;

              case 9:
                _context178.prev = 9;
                _context178.t0 = _context178["catch"](1);
                this.logger.error("ERROR: Failed to get how many tokens       are in the pool: ".concat(_context178.t0.message));

              case 12:
                return _context178.abrupt("return", i);

              case 13:
              case "end":
                return _context178.stop();
            }
          }
        }, _callee178, this, [[1, 9]]);
      }));

      function getReserve(_x435, _x436) {
        return _getReserve.apply(this, arguments);
      }

      return getReserve;
    }()
  }, {
    key: "isFinalized",
    value: function () {
      var _isFinalized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee179(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee179$(_context179) {
          while (1) {
            switch (_context179.prev = _context179.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context179.prev = 2;
                _context179.next = 5;
                return e.methods.isFinalized().call();

              case 5:
                i = _context179.sent;
                _context179.next = 11;
                break;

              case 8:
                _context179.prev = 8;
                _context179.t0 = _context179["catch"](2);
                this.logger.error("ERROR: Failed to check whether pool is finalized: ".concat(_context179.t0.message));

              case 11:
                return _context179.abrupt("return", i);

              case 12:
              case "end":
                return _context179.stop();
            }
          }
        }, _callee179, this, [[2, 8]]);
      }));

      function isFinalized(_x437) {
        return _isFinalized.apply(this, arguments);
      }

      return isFinalized;
    }()
  }, {
    key: "getSwapFee",
    value: function () {
      var _getSwapFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee180(t) {
        var e, i, _t35;

        return _regeneratorRuntime.wrap(function _callee180$(_context180) {
          while (1) {
            switch (_context180.prev = _context180.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context180.prev = 2;
                _context180.next = 5;
                return e.methods.getSwapFee().call();

              case 5:
                _t35 = _context180.sent;
                i = this.web3.utils.fromWei(_t35);
                _context180.next = 12;
                break;

              case 9:
                _context180.prev = 9;
                _context180.t0 = _context180["catch"](2);
                this.logger.error("ERROR: Failed to get pool fee: ".concat(_context180.t0.message));

              case 12:
                return _context180.abrupt("return", i);

              case 13:
              case "end":
                return _context180.stop();
            }
          }
        }, _callee180, this, [[2, 9]]);
      }));

      function getSwapFee(_x438) {
        return _getSwapFee.apply(this, arguments);
      }

      return getSwapFee;
    }()
  }, {
    key: "getNormalizedWeight",
    value: function () {
      var _getNormalizedWeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee181(t, e) {
        var i, r, _t36;

        return _regeneratorRuntime.wrap(function _callee181$(_context181) {
          while (1) {
            switch (_context181.prev = _context181.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                r = null;
                _context181.prev = 2;
                _context181.next = 5;
                return i.methods.getNormalizedWeight(e).call();

              case 5:
                _t36 = _context181.sent;
                r = this.web3.utils.fromWei(_t36);
                _context181.next = 12;
                break;

              case 9:
                _context181.prev = 9;
                _context181.t0 = _context181["catch"](2);
                this.logger.error("ERROR: Failed to get normalized weight of a token: ".concat(_context181.t0.message));

              case 12:
                return _context181.abrupt("return", r);

              case 13:
              case "end":
                return _context181.stop();
            }
          }
        }, _callee181, this, [[2, 9]]);
      }));

      function getNormalizedWeight(_x439, _x440) {
        return _getNormalizedWeight.apply(this, arguments);
      }

      return getNormalizedWeight;
    }()
  }, {
    key: "getDenormalizedWeight",
    value: function () {
      var _getDenormalizedWeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee182(t, e) {
        var i, r, _t37;

        return _regeneratorRuntime.wrap(function _callee182$(_context182) {
          while (1) {
            switch (_context182.prev = _context182.next) {
              case 0:
                i = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                r = null;
                _context182.prev = 2;
                _context182.next = 5;
                return i.methods.getDenormalizedWeight(e).call();

              case 5:
                _t37 = _context182.sent;
                r = this.web3.utils.fromWei(_t37);
                _context182.next = 12;
                break;

              case 9:
                _context182.prev = 9;
                _context182.t0 = _context182["catch"](2);
                this.logger.error("ERROR: Failed to get denormalized weight of a token in pool");

              case 12:
                return _context182.abrupt("return", r);

              case 13:
              case "end":
                return _context182.stop();
            }
          }
        }, _callee182, this, [[2, 9]]);
      }));

      function getDenormalizedWeight(_x441, _x442) {
        return _getDenormalizedWeight.apply(this, arguments);
      }

      return getDenormalizedWeight;
    }()
  }, {
    key: "getTotalDenormalizedWeight",
    value: function () {
      var _getTotalDenormalizedWeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee183(t) {
        var e, i, _t38;

        return _regeneratorRuntime.wrap(function _callee183$(_context183) {
          while (1) {
            switch (_context183.prev = _context183.next) {
              case 0:
                e = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                i = null;
                _context183.prev = 2;
                _context183.next = 5;
                return e.methods.getTotalDenormalizedWeight().call();

              case 5:
                _t38 = _context183.sent;
                i = this.web3.utils.fromWei(_t38);
                _context183.next = 12;
                break;

              case 9:
                _context183.prev = 9;
                _context183.t0 = _context183["catch"](2);
                this.logger.error("ERROR: Failed to get total denormalized weight in pool");

              case 12:
                return _context183.abrupt("return", i);

              case 13:
              case "end":
                return _context183.stop();
            }
          }
        }, _callee183, this, [[2, 9]]);
      }));

      function getTotalDenormalizedWeight(_x443) {
        return _getTotalDenormalizedWeight.apply(this, arguments);
      }

      return getTotalDenormalizedWeight;
    }()
  }, {
    key: "swapExactAmountIn",
    value: function () {
      var _swapExactAmountIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee184(t, e, i, r, n, s, o) {
        var a, h, u, l;
        return _regeneratorRuntime.wrap(function _callee184$(_context184) {
          while (1) {
            switch (_context184.prev = _context184.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                h = null;
                u = this.GASLIMIT_DEFAULT;
                _context184.prev = 3;
                _context184.next = 6;
                return a.methods.swapExactAmountIn(i, this.web3.utils.toWei(r), n, this.web3.utils.toWei(s), o ? this.web3.utils.toWei(o) : Le).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? u : e;
                });

              case 6:
                l = _context184.sent;
                _context184.next = 12;
                break;

              case 9:
                _context184.prev = 9;
                _context184.t0 = _context184["catch"](3);
                this.logger.log("Error estimate gas swapExactAmountIn"), this.logger.log(_context184.t0), l = u;

              case 12:
                _context184.prev = 12;
                _context184.t1 = a.methods.swapExactAmountIn(i, this.web3.utils.toWei(r), n, this.web3.utils.toWei(s), o ? this.web3.utils.toWei(o) : Le);
                _context184.t2 = t;
                _context184.t3 = l + 1;
                _context184.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context184.t4 = _context184.sent;
                _context184.t5 = {
                  from: _context184.t2,
                  gas: _context184.t3,
                  gasPrice: _context184.t4
                };
                _context184.next = 22;
                return _context184.t1.send.call(_context184.t1, _context184.t5);

              case 22:
                h = _context184.sent;
                _context184.next = 28;
                break;

              case 25:
                _context184.prev = 25;
                _context184.t6 = _context184["catch"](12);
                this.logger.error("ERROR: Failed to swap exact amount in : ".concat(_context184.t6.message));

              case 28:
                return _context184.abrupt("return", h);

              case 29:
              case "end":
                return _context184.stop();
            }
          }
        }, _callee184, this, [[3, 9], [12, 25]]);
      }));

      function swapExactAmountIn(_x444, _x445, _x446, _x447, _x448, _x449, _x450) {
        return _swapExactAmountIn.apply(this, arguments);
      }

      return swapExactAmountIn;
    }()
  }, {
    key: "swapExactAmountOut",
    value: function () {
      var _swapExactAmountOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee185(t, e, i, r, n, s, o) {
        var a, h, u, l;
        return _regeneratorRuntime.wrap(function _callee185$(_context185) {
          while (1) {
            switch (_context185.prev = _context185.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                h = null;
                u = this.GASLIMIT_DEFAULT;
                _context185.prev = 3;
                _context185.next = 6;
                return a.methods.swapExactAmountOut(i, this.web3.utils.toWei(r), n, this.web3.utils.toWei(s), o ? this.web3.utils.toWei(o) : Le).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? u : e;
                });

              case 6:
                l = _context185.sent;
                _context185.next = 12;
                break;

              case 9:
                _context185.prev = 9;
                _context185.t0 = _context185["catch"](3);
                l = u, this.logger.log("Error estimate gas swapExactAmountIn"), this.logger.log(_context185.t0);

              case 12:
                _context185.prev = 12;
                _context185.t1 = a.methods.swapExactAmountOut(i, this.web3.utils.toWei(r), n, this.web3.utils.toWei(s), o ? this.web3.utils.toWei(o) : Le);
                _context185.t2 = t;
                _context185.t3 = l + 1;
                _context185.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context185.t4 = _context185.sent;
                _context185.t5 = {
                  from: _context185.t2,
                  gas: _context185.t3,
                  gasPrice: _context185.t4
                };
                _context185.next = 22;
                return _context185.t1.send.call(_context185.t1, _context185.t5);

              case 22:
                h = _context185.sent;
                _context185.next = 28;
                break;

              case 25:
                _context185.prev = 25;
                _context185.t6 = _context185["catch"](12);
                this.logger.error("ERROR: Failed to swap exact amount out: ".concat(_context185.t6.message));

              case 28:
                return _context185.abrupt("return", h);

              case 29:
              case "end":
                return _context185.stop();
            }
          }
        }, _callee185, this, [[3, 9], [12, 25]]);
      }));

      function swapExactAmountOut(_x451, _x452, _x453, _x454, _x455, _x456, _x457) {
        return _swapExactAmountOut.apply(this, arguments);
      }

      return swapExactAmountOut;
    }()
  }, {
    key: "joinPool",
    value: function () {
      var _joinPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee186(t, e, i, r) {
        var n, s, o, _iterator7, _step7, a, h, u;

        return _regeneratorRuntime.wrap(function _callee186$(_context186) {
          while (1) {
            switch (_context186.prev = _context186.next) {
              case 0:
                n = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config), s = [];
                _iterator7 = _createForOfIteratorHelper(r);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    o = _step7.value;
                    s.push(this.web3.utils.toWei(o));
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                a = null;
                h = this.GASLIMIT_DEFAULT;
                _context186.prev = 5;
                _context186.next = 8;
                return n.methods.joinPool(this.web3.utils.toWei(i), s).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? h : e;
                });

              case 8:
                u = _context186.sent;
                _context186.next = 14;
                break;

              case 11:
                _context186.prev = 11;
                _context186.t0 = _context186["catch"](5);
                u = h;

              case 14:
                _context186.prev = 14;
                _context186.t1 = n.methods.joinPool(this.web3.utils.toWei(i), s);
                _context186.t2 = t;
                _context186.t3 = u + 1;
                _context186.next = 20;
                return Q(this.web3, this.config);

              case 20:
                _context186.t4 = _context186.sent;
                _context186.t5 = {
                  from: _context186.t2,
                  gas: _context186.t3,
                  gasPrice: _context186.t4
                };
                _context186.next = 24;
                return _context186.t1.send.call(_context186.t1, _context186.t5);

              case 24:
                a = _context186.sent;
                _context186.next = 30;
                break;

              case 27:
                _context186.prev = 27;
                _context186.t6 = _context186["catch"](14);
                this.logger.error("ERROR: Failed to join pool: ".concat(_context186.t6.message));

              case 30:
                return _context186.abrupt("return", a);

              case 31:
              case "end":
                return _context186.stop();
            }
          }
        }, _callee186, this, [[5, 11], [14, 27]]);
      }));

      function joinPool(_x458, _x459, _x460, _x461) {
        return _joinPool.apply(this, arguments);
      }

      return joinPool;
    }()
  }, {
    key: "exitPool",
    value: function () {
      var _exitPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee187(t, e, i, r) {
        var n, s, o, _iterator8, _step8, a, h, u;

        return _regeneratorRuntime.wrap(function _callee187$(_context187) {
          while (1) {
            switch (_context187.prev = _context187.next) {
              case 0:
                n = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config), s = [];
                _iterator8 = _createForOfIteratorHelper(r);

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    o = _step8.value;
                    s.push(this.web3.utils.toWei(o));
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }

                a = null;
                h = this.GASLIMIT_DEFAULT;
                _context187.prev = 5;
                _context187.next = 8;
                return n.methods.exitPool(this.web3.utils.toWei(i), s).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? h : e;
                });

              case 8:
                u = _context187.sent;
                _context187.next = 14;
                break;

              case 11:
                _context187.prev = 11;
                _context187.t0 = _context187["catch"](5);
                u = h;

              case 14:
                _context187.prev = 14;
                _context187.t1 = n.methods.exitPool(this.web3.utils.toWei(i), s);
                _context187.t2 = t;
                _context187.t3 = u;
                _context187.next = 20;
                return Q(this.web3, this.config);

              case 20:
                _context187.t4 = _context187.sent;
                _context187.t5 = {
                  from: _context187.t2,
                  gas: _context187.t3,
                  gasPrice: _context187.t4
                };
                _context187.next = 24;
                return _context187.t1.send.call(_context187.t1, _context187.t5);

              case 24:
                a = _context187.sent;
                _context187.next = 30;
                break;

              case 27:
                _context187.prev = 27;
                _context187.t6 = _context187["catch"](14);
                this.logger.error("ERROR: Failed to exit pool: ".concat(_context187.t6.message));

              case 30:
                return _context187.abrupt("return", a);

              case 31:
              case "end":
                return _context187.stop();
            }
          }
        }, _callee187, this, [[5, 11], [14, 27]]);
      }));

      function exitPool(_x462, _x463, _x464, _x465) {
        return _exitPool.apply(this, arguments);
      }

      return exitPool;
    }()
  }, {
    key: "joinswapExternAmountIn",
    value: function () {
      var _joinswapExternAmountIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee188(t, e, i, r, n) {
        var s, o, a, h;
        return _regeneratorRuntime.wrap(function _callee188$(_context188) {
          while (1) {
            switch (_context188.prev = _context188.next) {
              case 0:
                s = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                o = null;
                a = this.GASLIMIT_DEFAULT;
                _context188.prev = 3;
                _context188.next = 6;
                return s.methods.joinswapExternAmountIn(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n)).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? a : e;
                });

              case 6:
                h = _context188.sent;
                _context188.next = 12;
                break;

              case 9:
                _context188.prev = 9;
                _context188.t0 = _context188["catch"](3);
                h = a;

              case 12:
                _context188.prev = 12;
                _context188.t1 = s.methods.joinswapExternAmountIn(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n));
                _context188.t2 = t;
                _context188.t3 = h + 1;
                _context188.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context188.t4 = _context188.sent;
                _context188.t5 = {
                  from: _context188.t2,
                  gas: _context188.t3,
                  gasPrice: _context188.t4
                };
                _context188.next = 22;
                return _context188.t1.send.call(_context188.t1, _context188.t5);

              case 22:
                o = _context188.sent;
                _context188.next = 28;
                break;

              case 25:
                _context188.prev = 25;
                _context188.t6 = _context188["catch"](12);
                this.logger.error("ERROR: Failed to pay tokens in order to       join the pool: ".concat(_context188.t6.message));

              case 28:
                return _context188.abrupt("return", o);

              case 29:
              case "end":
                return _context188.stop();
            }
          }
        }, _callee188, this, [[3, 9], [12, 25]]);
      }));

      function joinswapExternAmountIn(_x466, _x467, _x468, _x469, _x470) {
        return _joinswapExternAmountIn.apply(this, arguments);
      }

      return joinswapExternAmountIn;
    }()
  }, {
    key: "joinswapPoolAmountOut",
    value: function () {
      var _joinswapPoolAmountOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee189(t, e, i, r, n) {
        var s, o, a, h;
        return _regeneratorRuntime.wrap(function _callee189$(_context189) {
          while (1) {
            switch (_context189.prev = _context189.next) {
              case 0:
                s = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                o = null;
                a = this.GASLIMIT_DEFAULT;
                _context189.prev = 3;
                _context189.next = 6;
                return s.methods.joinswapPoolAmountOut(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n)).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? a : e;
                });

              case 6:
                h = _context189.sent;
                _context189.next = 12;
                break;

              case 9:
                _context189.prev = 9;
                _context189.t0 = _context189["catch"](3);
                h = a;

              case 12:
                _context189.prev = 12;
                _context189.t1 = s.methods.joinswapPoolAmountOut(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n));
                _context189.t2 = t;
                _context189.t3 = h + 1;
                _context189.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context189.t4 = _context189.sent;
                _context189.t5 = {
                  from: _context189.t2,
                  gas: _context189.t3,
                  gasPrice: _context189.t4
                };
                _context189.next = 22;
                return _context189.t1.send.call(_context189.t1, _context189.t5);

              case 22:
                o = _context189.sent;
                _context189.next = 28;
                break;

              case 25:
                _context189.prev = 25;
                _context189.t6 = _context189["catch"](12);
                this.logger.error("ERROR: Failed to join swap pool amount out");

              case 28:
                return _context189.abrupt("return", o);

              case 29:
              case "end":
                return _context189.stop();
            }
          }
        }, _callee189, this, [[3, 9], [12, 25]]);
      }));

      function joinswapPoolAmountOut(_x471, _x472, _x473, _x474, _x475) {
        return _joinswapPoolAmountOut.apply(this, arguments);
      }

      return joinswapPoolAmountOut;
    }()
  }, {
    key: "exitswapPoolAmountIn",
    value: function () {
      var _exitswapPoolAmountIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee190(t, e, i, r, n) {
        var s, o, a, h;
        return _regeneratorRuntime.wrap(function _callee190$(_context190) {
          while (1) {
            switch (_context190.prev = _context190.next) {
              case 0:
                s = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                o = null;
                a = this.GASLIMIT_DEFAULT;
                _context190.prev = 3;
                _context190.next = 6;
                return s.methods.exitswapPoolAmountIn(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n)).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? a : e;
                });

              case 6:
                h = _context190.sent;
                _context190.next = 12;
                break;

              case 9:
                _context190.prev = 9;
                _context190.t0 = _context190["catch"](3);
                h = a;

              case 12:
                _context190.prev = 12;
                _context190.t1 = s.methods.exitswapPoolAmountIn(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n));
                _context190.t2 = t;
                _context190.t3 = h + 1;
                _context190.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context190.t4 = _context190.sent;
                _context190.t5 = {
                  from: _context190.t2,
                  gas: _context190.t3,
                  gasPrice: _context190.t4
                };
                _context190.next = 22;
                return _context190.t1.send.call(_context190.t1, _context190.t5);

              case 22:
                o = _context190.sent;
                _context190.next = 28;
                break;

              case 25:
                _context190.prev = 25;
                _context190.t6 = _context190["catch"](12);
                this.logger.error("ERROR: Failed to pay pool shares into the pool: ".concat(_context190.t6.message));

              case 28:
                return _context190.abrupt("return", o);

              case 29:
              case "end":
                return _context190.stop();
            }
          }
        }, _callee190, this, [[3, 9], [12, 25]]);
      }));

      function exitswapPoolAmountIn(_x476, _x477, _x478, _x479, _x480) {
        return _exitswapPoolAmountIn.apply(this, arguments);
      }

      return exitswapPoolAmountIn;
    }()
  }, {
    key: "exitswapExternAmountOut",
    value: function () {
      var _exitswapExternAmountOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee191(t, e, i, r, n) {
        var s, o, a, h;
        return _regeneratorRuntime.wrap(function _callee191$(_context191) {
          while (1) {
            switch (_context191.prev = _context191.next) {
              case 0:
                s = this.GASLIMIT_DEFAULT, o = Y(new this.web3.eth.Contract(this.poolABI, e, {
                  from: t
                }), this.config);
                h = null;
                _context191.prev = 2;
                _context191.next = 5;
                return o.methods.exitswapExternAmountOut(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n)).estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? s : e;
                });

              case 5:
                a = _context191.sent;
                _context191.next = 11;
                break;

              case 8:
                _context191.prev = 8;
                _context191.t0 = _context191["catch"](2);
                a = s;

              case 11:
                _context191.prev = 11;
                _context191.t1 = o.methods.exitswapExternAmountOut(i, this.web3.utils.toWei(r), this.web3.utils.toWei(n));
                _context191.t2 = t;
                _context191.t3 = a + 1;
                _context191.next = 17;
                return Q(this.web3, this.config);

              case 17:
                _context191.t4 = _context191.sent;
                _context191.t5 = {
                  from: _context191.t2,
                  gas: _context191.t3,
                  gasPrice: _context191.t4
                };
                _context191.next = 21;
                return _context191.t1.send.call(_context191.t1, _context191.t5);

              case 21:
                h = _context191.sent;
                _context191.next = 27;
                break;

              case 24:
                _context191.prev = 24;
                _context191.t6 = _context191["catch"](11);
                this.logger.error("ERROR: Failed to exitswapExternAmountOut");

              case 27:
                return _context191.abrupt("return", h);

              case 28:
              case "end":
                return _context191.stop();
            }
          }
        }, _callee191, this, [[2, 8], [11, 24]]);
      }));

      function exitswapExternAmountOut(_x481, _x482, _x483, _x484, _x485) {
        return _exitswapExternAmountOut.apply(this, arguments);
      }

      return exitswapExternAmountOut;
    }()
  }, {
    key: "getSpotPrice",
    value: function () {
      var _getSpotPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee192(t, e, i) {
        var r, n, _t39;

        return _regeneratorRuntime.wrap(function _callee192$(_context192) {
          while (1) {
            switch (_context192.prev = _context192.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                n = null;
                _context192.prev = 2;
                _context192.next = 5;
                return r.methods.getSpotPrice(e, i).call();

              case 5:
                _t39 = _context192.sent;
                n = this.web3.utils.fromWei(_t39);
                _context192.next = 12;
                break;

              case 9:
                _context192.prev = 9;
                _context192.t0 = _context192["catch"](2);
                this.logger.error("ERROR: Failed to get spot price of swapping tokenIn to tokenOut");

              case 12:
                return _context192.abrupt("return", n);

              case 13:
              case "end":
                return _context192.stop();
            }
          }
        }, _callee192, this, [[2, 9]]);
      }));

      function getSpotPrice(_x486, _x487, _x488) {
        return _getSpotPrice.apply(this, arguments);
      }

      return getSpotPrice;
    }()
  }, {
    key: "getSpotPriceSansFee",
    value: function () {
      var _getSpotPriceSansFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee193(t, e, i) {
        var r, n, _t40;

        return _regeneratorRuntime.wrap(function _callee193$(_context193) {
          while (1) {
            switch (_context193.prev = _context193.next) {
              case 0:
                r = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                n = null;
                _context193.prev = 2;
                _context193.next = 5;
                return r.methods.getSpotPriceSansFee(e, i).call();

              case 5:
                _t40 = _context193.sent;
                n = this.web3.utils.fromWei(_t40);
                _context193.next = 12;
                break;

              case 9:
                _context193.prev = 9;
                _context193.t0 = _context193["catch"](2);
                this.logger.error("ERROR: Failed to getSpotPriceSansFee");

              case 12:
                return _context193.abrupt("return", n);

              case 13:
              case "end":
                return _context193.stop();
            }
          }
        }, _callee193, this, [[2, 9]]);
      }));

      function getSpotPriceSansFee(_x489, _x490, _x491) {
        return _getSpotPriceSansFee.apply(this, arguments);
      }

      return getSpotPriceSansFee;
    }()
  }, {
    key: "calcSpotPrice",
    value: function () {
      var _calcSpotPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee194(t, e, i, r, n, s) {
        var o, a, _t41;

        return _regeneratorRuntime.wrap(function _callee194$(_context194) {
          while (1) {
            switch (_context194.prev = _context194.next) {
              case 0:
                o = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                a = "0";
                _context194.prev = 2;
                _context194.next = 5;
                return o.methods.calcSpotPrice(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s)).call();

              case 5:
                _t41 = _context194.sent;
                a = this.web3.utils.fromWei(_t41);
                _context194.next = 12;
                break;

              case 9:
                _context194.prev = 9;
                _context194.t0 = _context194["catch"](2);
                this.logger.error("ERROR: Failed to call calcSpotPrice");

              case 12:
                return _context194.abrupt("return", a);

              case 13:
              case "end":
                return _context194.stop();
            }
          }
        }, _callee194, this, [[2, 9]]);
      }));

      function calcSpotPrice(_x492, _x493, _x494, _x495, _x496, _x497) {
        return _calcSpotPrice.apply(this, arguments);
      }

      return calcSpotPrice;
    }()
  }, {
    key: "calcInGivenOut",
    value: function () {
      var _calcInGivenOut2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee195(t, i, r, n, s, o, a) {
        var h, u, _t42;

        return _regeneratorRuntime.wrap(function _callee195$(_context195) {
          while (1) {
            switch (_context195.prev = _context195.next) {
              case 0:
                h = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                u = null;

                if (!new e(o).gte(n)) {
                  _context195.next = 4;
                  break;
                }

                return _context195.abrupt("return", null);

              case 4:
                _context195.prev = 4;
                _context195.next = 7;
                return h.methods.calcInGivenOut(this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o), this.web3.utils.toWei(a)).call();

              case 7:
                _t42 = _context195.sent;
                u = this.web3.utils.fromWei(_t42);
                _context195.next = 14;
                break;

              case 11:
                _context195.prev = 11;
                _context195.t0 = _context195["catch"](4);
                this.logger.error("ERROR: Failed to calcInGivenOut");

              case 14:
                return _context195.abrupt("return", u);

              case 15:
              case "end":
                return _context195.stop();
            }
          }
        }, _callee195, this, [[4, 11]]);
      }));

      function calcInGivenOut(_x498, _x499, _x500, _x501, _x502, _x503, _x504) {
        return _calcInGivenOut2.apply(this, arguments);
      }

      return calcInGivenOut;
    }()
  }, {
    key: "calcOutGivenIn",
    value: function () {
      var _calcOutGivenIn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee196(t, e, i, r, n, s, o) {
        var a, h, _t43;

        return _regeneratorRuntime.wrap(function _callee196$(_context196) {
          while (1) {
            switch (_context196.prev = _context196.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                h = null;
                _context196.prev = 2;
                _context196.next = 5;
                return a.methods.calcOutGivenIn(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o)).call();

              case 5:
                _t43 = _context196.sent;
                h = this.web3.utils.fromWei(_t43);
                _context196.next = 12;
                break;

              case 9:
                _context196.prev = 9;
                _context196.t0 = _context196["catch"](2);
                this.logger.error("ERROR: Failed to calcOutGivenIn");

              case 12:
                return _context196.abrupt("return", h);

              case 13:
              case "end":
                return _context196.stop();
            }
          }
        }, _callee196, this, [[2, 9]]);
      }));

      function calcOutGivenIn(_x505, _x506, _x507, _x508, _x509, _x510, _x511) {
        return _calcOutGivenIn2.apply(this, arguments);
      }

      return calcOutGivenIn;
    }()
  }, {
    key: "calcPoolOutGivenSingleIn",
    value: function () {
      var _calcPoolOutGivenSingleIn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee197(t, e, i, r, n, s, o) {
        var a, h, _t44;

        return _regeneratorRuntime.wrap(function _callee197$(_context197) {
          while (1) {
            switch (_context197.prev = _context197.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                h = null;
                _context197.prev = 2;
                _context197.next = 5;
                return a.methods.calcPoolOutGivenSingleIn(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o)).call();

              case 5:
                _t44 = _context197.sent;
                h = this.web3.utils.fromWei(_t44);
                _context197.next = 12;
                break;

              case 9:
                _context197.prev = 9;
                _context197.t0 = _context197["catch"](2);
                this.logger.error("ERROR: Failed to calculate PoolOutGivenSingleIn : ".concat(_context197.t0.message));

              case 12:
                return _context197.abrupt("return", h);

              case 13:
              case "end":
                return _context197.stop();
            }
          }
        }, _callee197, this, [[2, 9]]);
      }));

      function calcPoolOutGivenSingleIn(_x512, _x513, _x514, _x515, _x516, _x517, _x518) {
        return _calcPoolOutGivenSingleIn2.apply(this, arguments);
      }

      return calcPoolOutGivenSingleIn;
    }()
  }, {
    key: "calcSingleInGivenPoolOut",
    value: function () {
      var _calcSingleInGivenPoolOut2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee198(t, e, i, r, n, s, o) {
        var a, h, _t45;

        return _regeneratorRuntime.wrap(function _callee198$(_context198) {
          while (1) {
            switch (_context198.prev = _context198.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                h = null;
                _context198.prev = 2;
                _context198.next = 5;
                return a.methods.calcSingleInGivenPoolOut(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o)).call();

              case 5:
                _t45 = _context198.sent;
                h = this.web3.utils.fromWei(_t45);
                _context198.next = 12;
                break;

              case 9:
                _context198.prev = 9;
                _context198.t0 = _context198["catch"](2);
                this.logger.error("ERROR: Failed to calculate SingleInGivenPoolOut : ".concat(_context198.t0.message));

              case 12:
                return _context198.abrupt("return", h);

              case 13:
              case "end":
                return _context198.stop();
            }
          }
        }, _callee198, this, [[2, 9]]);
      }));

      function calcSingleInGivenPoolOut(_x519, _x520, _x521, _x522, _x523, _x524, _x525) {
        return _calcSingleInGivenPoolOut2.apply(this, arguments);
      }

      return calcSingleInGivenPoolOut;
    }()
  }, {
    key: "calcSingleOutGivenPoolIn",
    value: function () {
      var _calcSingleOutGivenPoolIn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee199(t, e, i, r, n, s, o) {
        var a, h, _t46;

        return _regeneratorRuntime.wrap(function _callee199$(_context199) {
          while (1) {
            switch (_context199.prev = _context199.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                h = null;
                _context199.prev = 2;
                _context199.next = 5;
                return a.methods.calcSingleOutGivenPoolIn(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o)).call();

              case 5:
                _t46 = _context199.sent;
                h = this.web3.utils.fromWei(_t46);
                _context199.next = 12;
                break;

              case 9:
                _context199.prev = 9;
                _context199.t0 = _context199["catch"](2);
                this.logger.error("ERROR: Failed to calculate SingleOutGivenPoolIn : ".concat(_context199.t0.message));

              case 12:
                return _context199.abrupt("return", h);

              case 13:
              case "end":
                return _context199.stop();
            }
          }
        }, _callee199, this, [[2, 9]]);
      }));

      function calcSingleOutGivenPoolIn(_x526, _x527, _x528, _x529, _x530, _x531, _x532) {
        return _calcSingleOutGivenPoolIn2.apply(this, arguments);
      }

      return calcSingleOutGivenPoolIn;
    }()
  }, {
    key: "calcPoolInGivenSingleOut",
    value: function () {
      var _calcPoolInGivenSingleOut2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee200(t, e, i, r, n, s, o) {
        var a, h, _t47;

        return _regeneratorRuntime.wrap(function _callee200$(_context200) {
          while (1) {
            switch (_context200.prev = _context200.next) {
              case 0:
                a = Y(new this.web3.eth.Contract(this.poolABI, t), this.config);
                h = null;
                _context200.prev = 2;
                _context200.next = 5;
                return a.methods.calcPoolInGivenSingleOut(this.web3.utils.toWei(e), this.web3.utils.toWei(i), this.web3.utils.toWei(r), this.web3.utils.toWei(n), this.web3.utils.toWei(s), this.web3.utils.toWei(o)).call();

              case 5:
                _t47 = _context200.sent;
                h = this.web3.utils.fromWei(_t47);
                _context200.next = 12;
                break;

              case 9:
                _context200.prev = 9;
                _context200.t0 = _context200["catch"](2);
                this.logger.error("ERROR: Failed to calculate PoolInGivenSingleOut : ".concat(_context200.t0.message));

              case 12:
                return _context200.abrupt("return", h);

              case 13:
              case "end":
                return _context200.stop();
            }
          }
        }, _callee200, this, [[2, 9]]);
      }));

      function calcPoolInGivenSingleOut(_x533, _x534, _x535, _x536, _x537, _x538, _x539) {
        return _calcPoolInGivenSingleOut2.apply(this, arguments);
      }

      return calcPoolInGivenSingleOut;
    }()
  }, {
    key: "getSwapEventSignature",
    value: function getSwapEventSignature() {
      var t = this.poolABI.find(function (t) {
        if ("LOG_SWAP" === t.name && "event" === t.type) return t;
      });
      return this.web3.eth.abi.encodeEventSignature(t);
    }
  }, {
    key: "getJoinEventSignature",
    value: function getJoinEventSignature() {
      var t = this.poolABI.find(function (t) {
        if ("LOG_JOIN" === t.name && "event" === t.type) return t;
      });
      return this.web3.eth.abi.encodeEventSignature(t);
    }
  }, {
    key: "getExitEventSignature",
    value: function getExitEventSignature() {
      var t = this.poolABI.find(function (t) {
        if ("LOG_EXIT" === t.name && "event" === t.type) return t;
      });
      return this.web3.eth.abi.encodeEventSignature(t);
    }
  }]);

  return _class;
}( /*#__PURE__*/function () {
  function _class2(t, e) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, _class2);

    this.GASLIMIT_DEFAULT = 1e6, this.web3 = null, this.factoryABI = void 0, this.factoryAddress = void 0, this.logger = void 0, this.config = void 0, this.web3 = t, this.factoryABI = i || p.abi, r && (this.factoryAddress = r), this.logger = e, this.config = n;
  }

  _createClass(_class2, [{
    key: "createPool",
    value: function () {
      var _createPool2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee201(t) {
        var e, i, r, n;
        return _regeneratorRuntime.wrap(function _callee201$(_context201) {
          while (1) {
            switch (_context201.prev = _context201.next) {
              case 0:
                if (!(null === this.web3)) {
                  _context201.next = 2;
                  break;
                }

                return _context201.abrupt("return", (this.logger.error("ERROR: Web3 object is null"), null));

              case 2:
                if (!(null === this.factoryAddress)) {
                  _context201.next = 4;
                  break;
                }

                return _context201.abrupt("return", (this.logger.error("ERROR: bfactoryAddress is null"), null));

              case 4:
                e = Y(new this.web3.eth.Contract(this.factoryABI, this.factoryAddress, {
                  from: t
                }), this.config);
                i = null;
                r = this.GASLIMIT_DEFAULT;
                _context201.prev = 7;
                _context201.next = 10;
                return e.methods.newBPool().estimateGas({
                  from: t
                }, function (t, e) {
                  return t ? r : e;
                });

              case 10:
                n = _context201.sent;
                _context201.next = 16;
                break;

              case 13:
                _context201.prev = 13;
                _context201.t0 = _context201["catch"](7);
                this.logger.log("Error estimate gas newBPool"), this.logger.log(_context201.t0), n = r;

              case 16:
                _context201.prev = 16;
                _context201.t1 = e.methods.newBPool();
                _context201.t2 = t;
                _context201.t3 = n + 1;
                _context201.next = 22;
                return Q(this.web3, this.config);

              case 22:
                _context201.t4 = _context201.sent;
                _context201.t5 = {
                  from: _context201.t2,
                  gas: _context201.t3,
                  gasPrice: _context201.t4
                };
                _context201.next = 26;
                return _context201.t1.send.call(_context201.t1, _context201.t5);

              case 26:
                i = _context201.sent;
                _context201.next = 32;
                break;

              case 29:
                _context201.prev = 29;
                _context201.t6 = _context201["catch"](16);
                this.logger.error("ERROR: Failed to create new pool: ".concat(_context201.t6.message));

              case 32:
                return _context201.abrupt("return", i);

              case 33:
              case "end":
                return _context201.stop();
            }
          }
        }, _callee201, this, [[7, 13], [16, 29]]);
      }));

      function createPool(_x540) {
        return _createPool2.apply(this, arguments);
      }

      return createPool;
    }()
  }]);

  return _class2;
}()));

!function (t) {
  t[t.CreatingExchange = 0] = "CreatingExchange", t[t.ApprovingDatatoken = 1] = "ApprovingDatatoken";
}(Fe || (Fe = {}));

var qe = /*#__PURE__*/function () {
  function qe(t, e) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var s = arguments.length > 5 ? arguments[5] : undefined;
    var o = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, qe);

    this.GASLIMIT_DEFAULT = 1e6, this.oceanAddress = null, this.fixedRateExchangeAddress = void 0, this.fixedRateExchangeABI = void 0, this.web3 = void 0, this.contract = null, this.logger = void 0, this.datatokens = void 0, this.startBlock = void 0, this.config = void 0, this.web3 = t, this.fixedRateExchangeAddress = i, this.config = o, this.startBlock = o && o.startBlock || 0, this.fixedRateExchangeABI = r || w.abi, this.oceanAddress = n, this.datatokens = s, t && (this.contract = Y(new this.web3.eth.Contract(this.fixedRateExchangeABI, this.fixedRateExchangeAddress), this.config)), this.logger = e;
  }

  _createClass(qe, [{
    key: "create",
    value: function create(t, e, i, r) {
      return this.createExchange(this.oceanAddress, t, e, i, r);
    }
  }, {
    key: "createExchange",
    value: function createExchange(t, e, i, r, n) {
      var _this19 = this;

      return new P( /*#__PURE__*/function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee202(s) {
          var o, a, h, u;
          return _regeneratorRuntime.wrap(function _callee202$(_context202) {
            while (1) {
              switch (_context202.prev = _context202.next) {
                case 0:
                  s.next(Fe.CreatingExchange);
                  a = _this19.GASLIMIT_DEFAULT;
                  _context202.prev = 2;
                  _context202.next = 5;
                  return _this19.contract.methods.create(t, e, _this19.web3.utils.toWei(i)).estimateGas({
                    from: r
                  }, function (t, e) {
                    return t ? a : e;
                  });

                case 5:
                  o = _context202.sent;
                  _context202.next = 11;
                  break;

                case 8:
                  _context202.prev = 8;
                  _context202.t0 = _context202["catch"](2);
                  o = a;

                case 11:
                  h = null, u = null;
                  _context202.prev = 12;
                  _context202.t1 = _this19.contract.methods.create(t, e, _this19.web3.utils.toWei(i));
                  _context202.t2 = r;
                  _context202.t3 = o + 1;
                  _context202.next = 18;
                  return Q(_this19.web3, _this19.config);

                case 18:
                  _context202.t4 = _context202.sent;
                  _context202.t5 = {
                    from: _context202.t2,
                    gas: _context202.t3,
                    gasPrice: _context202.t4
                  };
                  _context202.next = 22;
                  return _context202.t1.send.call(_context202.t1, _context202.t5);

                case 22:
                  u = _context202.sent;
                  h = u.events.ExchangeCreated.returnValues[0];
                  _context202.next = 29;
                  break;

                case 26:
                  _context202.prev = 26;
                  _context202.t6 = _context202["catch"](12);

                  _this19.logger.error("ERROR: Failed to create new exchange: ".concat(_context202.t6.message));

                case 29:
                  return _context202.abrupt("return", (n && h && (s.next(Fe.ApprovingDatatoken), _this19.datatokens.approve(e, _this19.fixedRateExchangeAddress, n, r)), u));

                case 30:
                case "end":
                  return _context202.stop();
              }
            }
          }, _callee202, null, [[2, 8], [12, 26]]);
        }));

        return function (_x541) {
          return _ref16.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "generateExchangeId",
    value: function () {
      var _generateExchangeId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee203(t, e) {
        return _regeneratorRuntime.wrap(function _callee203$(_context203) {
          while (1) {
            switch (_context203.prev = _context203.next) {
              case 0:
                _context203.next = 2;
                return this.contract.methods.generateExchangeId(this.oceanAddress, t, e).call();

              case 2:
                return _context203.abrupt("return", _context203.sent);

              case 3:
              case "end":
                return _context203.stop();
            }
          }
        }, _callee203, this);
      }));

      function generateExchangeId(_x542, _x543) {
        return _generateExchangeId.apply(this, arguments);
      }

      return generateExchangeId;
    }()
  }, {
    key: "buyDT",
    value: function () {
      var _buyDT2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee204(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee204$(_context204) {
          while (1) {
            switch (_context204.prev = _context204.next) {
              case 0:
                r = this.GASLIMIT_DEFAULT;
                _context204.prev = 1;
                _context204.next = 4;
                return this.contract.methods.swap(t, this.web3.utils.toWei(String(e))).estimateGas({
                  from: i
                }, function (t, e) {
                  return t ? r : e;
                });

              case 4:
                n = _context204.sent;
                _context204.next = 10;
                break;

              case 7:
                _context204.prev = 7;
                _context204.t0 = _context204["catch"](1);
                n = r;

              case 10:
                _context204.prev = 10;
                _context204.t1 = this.contract.methods.swap(t, this.web3.utils.toWei(String(e)));
                _context204.t2 = i;
                _context204.t3 = n + 1;
                _context204.next = 16;
                return Q(this.web3, this.config);

              case 16:
                _context204.t4 = _context204.sent;
                _context204.t5 = {
                  from: _context204.t2,
                  gas: _context204.t3,
                  gasPrice: _context204.t4
                };
                _context204.next = 20;
                return _context204.t1.send.call(_context204.t1, _context204.t5);

              case 20:
                return _context204.abrupt("return", _context204.sent);

              case 23:
                _context204.prev = 23;
                _context204.t6 = _context204["catch"](10);
                return _context204.abrupt("return", (this.logger.error("ERROR: Failed to buy datatokens: ".concat(_context204.t6.message)), null));

              case 26:
              case "end":
                return _context204.stop();
            }
          }
        }, _callee204, this, [[1, 7], [10, 23]]);
      }));

      function buyDT(_x544, _x545, _x546) {
        return _buyDT2.apply(this, arguments);
      }

      return buyDT;
    }()
  }, {
    key: "getNumberOfExchanges",
    value: function () {
      var _getNumberOfExchanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee205() {
        return _regeneratorRuntime.wrap(function _callee205$(_context205) {
          while (1) {
            switch (_context205.prev = _context205.next) {
              case 0:
                _context205.next = 2;
                return this.contract.methods.getNumberOfExchanges().call();

              case 2:
                return _context205.abrupt("return", _context205.sent);

              case 3:
              case "end":
                return _context205.stop();
            }
          }
        }, _callee205, this);
      }));

      function getNumberOfExchanges() {
        return _getNumberOfExchanges.apply(this, arguments);
      }

      return getNumberOfExchanges;
    }()
  }, {
    key: "setRate",
    value: function () {
      var _setRate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee206(t, e, i) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee206$(_context206) {
          while (1) {
            switch (_context206.prev = _context206.next) {
              case 0:
                r = this.GASLIMIT_DEFAULT;
                _context206.prev = 1;
                _context206.next = 4;
                return this.contract.methods.setRate(t, this.web3.utils.toWei(String(e))).estimateGas({
                  from: i
                }, function (t, e) {
                  return t ? r : e;
                });

              case 4:
                n = _context206.sent;
                _context206.next = 10;
                break;

              case 7:
                _context206.prev = 7;
                _context206.t0 = _context206["catch"](1);
                n = r;

              case 10:
                _context206.t1 = this.contract.methods.setRate(t, this.web3.utils.toWei(String(e)));
                _context206.t2 = i;
                _context206.t3 = n + 1;
                _context206.next = 15;
                return Q(this.web3, this.config);

              case 15:
                _context206.t4 = _context206.sent;
                _context206.t5 = {
                  from: _context206.t2,
                  gas: _context206.t3,
                  gasPrice: _context206.t4
                };
                _context206.next = 19;
                return _context206.t1.send.call(_context206.t1, _context206.t5);

              case 19:
                return _context206.abrupt("return", _context206.sent);

              case 20:
              case "end":
                return _context206.stop();
            }
          }
        }, _callee206, this, [[1, 7]]);
      }));

      function setRate(_x547, _x548, _x549) {
        return _setRate.apply(this, arguments);
      }

      return setRate;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee207(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee207$(_context207) {
          while (1) {
            switch (_context207.prev = _context207.next) {
              case 0:
                _context207.next = 2;
                return this.getExchange(t);

              case 2:
                i = _context207.sent;

                if (i) {
                  _context207.next = 5;
                  break;
                }

                return _context207.abrupt("return", null);

              case 5:
                if (!(!0 === i.active)) {
                  _context207.next = 7;
                  break;
                }

                return _context207.abrupt("return", null);

              case 7:
                r = this.GASLIMIT_DEFAULT;
                _context207.prev = 8;
                _context207.next = 11;
                return this.contract.methods.toggleExchangeState(t).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? r : e;
                });

              case 11:
                n = _context207.sent;
                _context207.next = 17;
                break;

              case 14:
                _context207.prev = 14;
                _context207.t0 = _context207["catch"](8);
                n = r;

              case 17:
                _context207.t1 = this.contract.methods.toggleExchangeState(t);
                _context207.t2 = e;
                _context207.t3 = n + 1;
                _context207.next = 22;
                return Q(this.web3, this.config);

              case 22:
                _context207.t4 = _context207.sent;
                _context207.t5 = {
                  from: _context207.t2,
                  gas: _context207.t3,
                  gasPrice: _context207.t4
                };
                _context207.next = 26;
                return _context207.t1.send.call(_context207.t1, _context207.t5);

              case 26:
                return _context207.abrupt("return", _context207.sent);

              case 27:
              case "end":
                return _context207.stop();
            }
          }
        }, _callee207, this, [[8, 14]]);
      }));

      function activate(_x550, _x551) {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: "deactivate",
    value: function () {
      var _deactivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee208(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee208$(_context208) {
          while (1) {
            switch (_context208.prev = _context208.next) {
              case 0:
                _context208.next = 2;
                return this.getExchange(t);

              case 2:
                i = _context208.sent;

                if (i) {
                  _context208.next = 5;
                  break;
                }

                return _context208.abrupt("return", null);

              case 5:
                if (!(!1 === i.active)) {
                  _context208.next = 7;
                  break;
                }

                return _context208.abrupt("return", null);

              case 7:
                r = this.GASLIMIT_DEFAULT;
                _context208.prev = 8;
                _context208.next = 11;
                return this.contract.methods.toggleExchangeState(t).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? r : e;
                });

              case 11:
                n = _context208.sent;
                _context208.next = 17;
                break;

              case 14:
                _context208.prev = 14;
                _context208.t0 = _context208["catch"](8);
                n = r;

              case 17:
                _context208.t1 = this.contract.methods.toggleExchangeState(t);
                _context208.t2 = e;
                _context208.t3 = n + 1;
                _context208.next = 22;
                return Q(this.web3, this.config);

              case 22:
                _context208.t4 = _context208.sent;
                _context208.t5 = {
                  from: _context208.t2,
                  gas: _context208.t3,
                  gasPrice: _context208.t4
                };
                _context208.next = 26;
                return _context208.t1.send.call(_context208.t1, _context208.t5);

              case 26:
                return _context208.abrupt("return", _context208.sent);

              case 27:
              case "end":
                return _context208.stop();
            }
          }
        }, _callee208, this, [[8, 14]]);
      }));

      function deactivate(_x552, _x553) {
        return _deactivate.apply(this, arguments);
      }

      return deactivate;
    }()
  }, {
    key: "getRate",
    value: function () {
      var _getRate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee209(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee209$(_context209) {
          while (1) {
            switch (_context209.prev = _context209.next) {
              case 0:
                _context209.next = 2;
                return this.contract.methods.getRate(t).call();

              case 2:
                e = _context209.sent;
                return _context209.abrupt("return", this.web3.utils.fromWei(e));

              case 4:
              case "end":
                return _context209.stop();
            }
          }
        }, _callee209, this);
      }));

      function getRate(_x554) {
        return _getRate.apply(this, arguments);
      }

      return getRate;
    }()
  }, {
    key: "getSupply",
    value: function () {
      var _getSupply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee210(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee210$(_context210) {
          while (1) {
            switch (_context210.prev = _context210.next) {
              case 0:
                _context210.next = 2;
                return this.contract.methods.getSupply(t).call();

              case 2:
                e = _context210.sent;
                return _context210.abrupt("return", this.web3.utils.fromWei(e));

              case 4:
              case "end":
                return _context210.stop();
            }
          }
        }, _callee210, this);
      }));

      function getSupply(_x555) {
        return _getSupply.apply(this, arguments);
      }

      return getSupply;
    }()
  }, {
    key: "getOceanNeeded",
    value: function () {
      var _getOceanNeeded2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee211(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee211$(_context211) {
          while (1) {
            switch (_context211.prev = _context211.next) {
              case 0:
                _context211.next = 2;
                return this.contract.methods.CalcInGivenOut(t, this.web3.utils.toWei(e)).call();

              case 2:
                i = _context211.sent;
                return _context211.abrupt("return", this.web3.utils.fromWei(i));

              case 4:
              case "end":
                return _context211.stop();
            }
          }
        }, _callee211, this);
      }));

      function getOceanNeeded(_x556, _x557) {
        return _getOceanNeeded2.apply(this, arguments);
      }

      return getOceanNeeded;
    }()
  }, {
    key: "getExchange",
    value: function () {
      var _getExchange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee212(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee212$(_context212) {
          while (1) {
            switch (_context212.prev = _context212.next) {
              case 0:
                _context212.next = 2;
                return this.contract.methods.getExchange(t).call();

              case 2:
                e = _context212.sent;
                return _context212.abrupt("return", (e.fixedRate = this.web3.utils.fromWei(e.fixedRate), e.supply = this.web3.utils.fromWei(e.supply), e.exchangeID = t, e));

              case 4:
              case "end":
                return _context212.stop();
            }
          }
        }, _callee212, this);
      }));

      function getExchange(_x558) {
        return _getExchange.apply(this, arguments);
      }

      return getExchange;
    }()
  }, {
    key: "getExchanges",
    value: function () {
      var _getExchanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee213() {
        return _regeneratorRuntime.wrap(function _callee213$(_context213) {
          while (1) {
            switch (_context213.prev = _context213.next) {
              case 0:
                _context213.next = 2;
                return this.contract.methods.getExchanges().call();

              case 2:
                return _context213.abrupt("return", _context213.sent);

              case 3:
              case "end":
                return _context213.stop();
            }
          }
        }, _callee213, this);
      }));

      function getExchanges() {
        return _getExchanges.apply(this, arguments);
      }

      return getExchanges;
    }()
  }, {
    key: "isActive",
    value: function () {
      var _isActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee214(t) {
        return _regeneratorRuntime.wrap(function _callee214$(_context214) {
          while (1) {
            switch (_context214.prev = _context214.next) {
              case 0:
                _context214.next = 2;
                return this.contract.methods.isActive(t).call();

              case 2:
                return _context214.abrupt("return", _context214.sent);

              case 3:
              case "end":
                return _context214.stop();
            }
          }
        }, _callee214, this);
      }));

      function isActive(_x559) {
        return _isActive.apply(this, arguments);
      }

      return isActive;
    }()
  }, {
    key: "CalcInGivenOut",
    value: function () {
      var _CalcInGivenOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee215(t, e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee215$(_context215) {
          while (1) {
            switch (_context215.prev = _context215.next) {
              case 0:
                _context215.next = 2;
                return this.contract.methods.CalcInGivenOut(t, this.web3.utils.toWei(e)).call();

              case 2:
                i = _context215.sent;
                return _context215.abrupt("return", this.web3.utils.fromWei(i));

              case 4:
              case "end":
                return _context215.stop();
            }
          }
        }, _callee215, this);
      }));

      function CalcInGivenOut(_x560, _x561) {
        return _CalcInGivenOut.apply(this, arguments);
      }

      return CalcInGivenOut;
    }()
  }, {
    key: "searchforDT",
    value: function () {
      var _searchforDT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee216(t, e) {
        var i, r, n, s, _r6, _n5, _s4, _t48, _r7;

        return _regeneratorRuntime.wrap(function _callee216$(_context216) {
          while (1) {
            switch (_context216.prev = _context216.next) {
              case 0:
                i = [];
                _context216.next = 3;
                return this.contract.getPastEvents("ExchangeCreated", {
                  filter: {
                    datatoken: t.toLowerCase()
                  },
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 3:
                r = _context216.sent;
                n = [];
                s = 0;

              case 6:
                if (!(s < r.length)) {
                  _context216.next = 16;
                  break;
                }

                if (!(n.push(this.getExchange(r[s].returnValues[0])), n.length > 10 || s === r.length - 1)) {
                  _context216.next = 13;
                  break;
                }

                _context216.next = 10;
                return Promise.all(n);

              case 10:
                _r6 = _context216.sent;

                for (_n5 = 0; _n5 < _r6.length; _n5++) {
                  _s4 = _r6[_n5];

                  if (!0 === _s4.active && _s4.dataToken.toLowerCase() === t.toLowerCase()) {
                    _t48 = new X(_s4.supply), _r7 = new X(e);
                    _t48.gte(_r7) && i.push(_s4);
                  }
                }

                n = [];

              case 13:
                s++;
                _context216.next = 6;
                break;

              case 16:
                return _context216.abrupt("return", i);

              case 17:
              case "end":
                return _context216.stop();
            }
          }
        }, _callee216, this);
      }));

      function searchforDT(_x562, _x563) {
        return _searchforDT.apply(this, arguments);
      }

      return searchforDT;
    }()
  }, {
    key: "getExchangesbyCreator",
    value: function () {
      var _getExchangesbyCreator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee217(t) {
        var e, i, r;
        return _regeneratorRuntime.wrap(function _callee217$(_context217) {
          while (1) {
            switch (_context217.prev = _context217.next) {
              case 0:
                e = [];
                _context217.next = 3;
                return this.contract.getPastEvents("ExchangeCreated", {
                  filter: {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 3:
                i = _context217.sent;
                r = 0;

              case 5:
                if (!(r < i.length)) {
                  _context217.next = 16;
                  break;
                }

                _context217.t0 = t && i[r].returnValues[3].toLowerCase() !== t.toLowerCase();

                if (_context217.t0) {
                  _context217.next = 13;
                  break;
                }

                _context217.t1 = e;
                _context217.next = 11;
                return this.getExchange(i[r].returnValues[0]);

              case 11:
                _context217.t2 = _context217.sent;

                _context217.t1.push.call(_context217.t1, _context217.t2);

              case 13:
                r++;
                _context217.next = 5;
                break;

              case 16:
                return _context217.abrupt("return", e);

              case 17:
              case "end":
                return _context217.stop();
            }
          }
        }, _callee217, this);
      }));

      function getExchangesbyCreator(_x564) {
        return _getExchangesbyCreator.apply(this, arguments);
      }

      return getExchangesbyCreator;
    }()
  }, {
    key: "getExchangeSwaps",
    value: function () {
      var _getExchangeSwaps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee218(t, e) {
        var i, r, _t49;

        return _regeneratorRuntime.wrap(function _callee218$(_context218) {
          while (1) {
            switch (_context218.prev = _context218.next) {
              case 0:
                i = [];
                _context218.next = 3;
                return this.contract.getPastEvents("Swapped", {
                  filter: {
                    exchangeId: t
                  },
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 3:
                r = _context218.sent;

                for (_t49 = 0; _t49 < r.length; _t49++) {
                  e && r[_t49].returnValues[1].toLowerCase() !== e.toLowerCase() || i.push(this.getEventData(r[_t49]));
                }

                return _context218.abrupt("return", i);

              case 6:
              case "end":
                return _context218.stop();
            }
          }
        }, _callee218, this);
      }));

      function getExchangeSwaps(_x565, _x566) {
        return _getExchangeSwaps.apply(this, arguments);
      }

      return getExchangeSwaps;
    }()
  }, {
    key: "getAllExchangesSwaps",
    value: function () {
      var _getAllExchangesSwaps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee219(t) {
        var e, i, r;
        return _regeneratorRuntime.wrap(function _callee219$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                e = [];
                _context219.next = 3;
                return this.contract.getPastEvents("ExchangeCreated", {
                  filter: {},
                  fromBlock: this.startBlock,
                  toBlock: "latest"
                });

              case 3:
                i = _context219.sent;
                r = 0;

              case 5:
                if (!(r < i.length)) {
                  _context219.next = 12;
                  break;
                }

                _context219.next = 8;
                return this.getExchangeSwaps(i[r].returnValues[0], t);

              case 8:
                _context219.sent.forEach(function (t) {
                  e.push(t);
                });

              case 9:
                r++;
                _context219.next = 5;
                break;

              case 12:
                return _context219.abrupt("return", e);

              case 13:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee219, this);
      }));

      function getAllExchangesSwaps(_x567) {
        return _getAllExchangesSwaps.apply(this, arguments);
      }

      return getAllExchangesSwaps;
    }()
  }, {
    key: "getEventData",
    value: function getEventData(t) {
      return {
        exchangeID: t.returnValues[0],
        caller: t.returnValues[1],
        baseTokenAmount: this.web3.utils.fromWei(t.returnValues[2]),
        dataTokenAmount: this.web3.utils.fromWei(t.returnValues[3])
      };
    }
  }]);

  return qe;
}();

!function (t) {
  t[t.MakeDispenserMinter = 0] = "MakeDispenserMinter", t[t.AcceptingNewMinter = 1] = "AcceptingNewMinter";
}(Ue || (Ue = {})), function (t) {
  t[t.MakeOwnerMinter = 0] = "MakeOwnerMinter", t[t.AcceptingNewMinter = 1] = "AcceptingNewMinter";
}($e || ($e = {}));

var Ge = /*#__PURE__*/function () {
  function Ge(t, e) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var n = arguments.length > 4 ? arguments[4] : undefined;
    var s = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, Ge);

    this.GASLIMIT_DEFAULT = 1e6, this.dispenserAddress = void 0, this.dispenserABI = void 0, this.web3 = void 0, this.contract = null, this.logger = void 0, this.datatokens = void 0, this.startBlock = void 0, this.config = void 0, this.web3 = t, this.config = s, this.dispenserAddress = i, this.startBlock = s && s.startBlock || 0, this.dispenserABI = r || v.abi, this.datatokens = n, t && (this.contract = Y(new this.web3.eth.Contract(this.dispenserABI, this.dispenserAddress), this.config)), this.logger = e;
  }

  _createClass(Ge, [{
    key: "status",
    value: function () {
      var _status2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee220(t) {
        var _e19;

        return _regeneratorRuntime.wrap(function _callee220$(_context220) {
          while (1) {
            switch (_context220.prev = _context220.next) {
              case 0:
                _context220.prev = 0;
                _context220.next = 3;
                return this.contract.methods.status(t).call();

              case 3:
                _e19 = _context220.sent;
                return _context220.abrupt("return", (_e19.maxTokens = this.web3.utils.fromWei(_e19.maxTokens), _e19.maxBalance = this.web3.utils.fromWei(_e19.maxBalance), _e19.balance = this.web3.utils.fromWei(_e19.balance), _e19));

              case 7:
                _context220.prev = 7;
                _context220.t0 = _context220["catch"](0);
                this.logger.warn("No dispenser available for data token: ".concat(t));

              case 10:
                return _context220.abrupt("return", null);

              case 11:
              case "end":
                return _context220.stop();
            }
          }
        }, _callee220, this, [[0, 7]]);
      }));

      function status(_x568) {
        return _status2.apply(this, arguments);
      }

      return status;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee221(t, e, i, r) {
        var n, s, o;
        return _regeneratorRuntime.wrap(function _callee221$(_context221) {
          while (1) {
            switch (_context221.prev = _context221.next) {
              case 0:
                s = this.GASLIMIT_DEFAULT;
                _context221.prev = 1;
                _context221.next = 4;
                return this.contract.methods.activate(t, this.web3.utils.toWei(e), this.web3.utils.toWei(i)).estimateGas({
                  from: r
                }, function (t, e) {
                  return t ? s : e;
                });

              case 4:
                n = _context221.sent;
                _context221.next = 10;
                break;

              case 7:
                _context221.prev = 7;
                _context221.t0 = _context221["catch"](1);
                n = s;

              case 10:
                o = null;
                _context221.prev = 11;
                _context221.t1 = this.contract.methods.activate(t, this.web3.utils.toWei(e), this.web3.utils.toWei(i));
                _context221.t2 = r;
                _context221.t3 = n + 1;
                _context221.next = 17;
                return Q(this.web3, this.config);

              case 17:
                _context221.t4 = _context221.sent;
                _context221.t5 = {
                  from: _context221.t2,
                  gas: _context221.t3,
                  gasPrice: _context221.t4
                };
                _context221.next = 21;
                return _context221.t1.send.call(_context221.t1, _context221.t5);

              case 21:
                o = _context221.sent;
                _context221.next = 27;
                break;

              case 24:
                _context221.prev = 24;
                _context221.t6 = _context221["catch"](11);
                this.logger.error("ERROR: Failed to activate dispenser: ".concat(_context221.t6.message));

              case 27:
                return _context221.abrupt("return", o);

              case 28:
              case "end":
                return _context221.stop();
            }
          }
        }, _callee221, this, [[1, 7], [11, 24]]);
      }));

      function activate(_x569, _x570, _x571, _x572) {
        return _activate2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: "deactivate",
    value: function () {
      var _deactivate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee222(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee222$(_context222) {
          while (1) {
            switch (_context222.prev = _context222.next) {
              case 0:
                r = this.GASLIMIT_DEFAULT;
                _context222.prev = 1;
                _context222.next = 4;
                return this.contract.methods.deactivate(t).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? r : e;
                });

              case 4:
                i = _context222.sent;
                _context222.next = 10;
                break;

              case 7:
                _context222.prev = 7;
                _context222.t0 = _context222["catch"](1);
                i = r;

              case 10:
                n = null;
                _context222.prev = 11;
                _context222.t1 = this.contract.methods.deactivate(t);
                _context222.t2 = e;
                _context222.t3 = i + 1;
                _context222.next = 17;
                return Q(this.web3, this.config);

              case 17:
                _context222.t4 = _context222.sent;
                _context222.t5 = {
                  from: _context222.t2,
                  gas: _context222.t3,
                  gasPrice: _context222.t4
                };
                _context222.next = 21;
                return _context222.t1.send.call(_context222.t1, _context222.t5);

              case 21:
                n = _context222.sent;
                _context222.next = 27;
                break;

              case 24:
                _context222.prev = 24;
                _context222.t6 = _context222["catch"](11);
                this.logger.error("ERROR: Failed to deactivate dispenser: ".concat(_context222.t6.message));

              case 27:
                return _context222.abrupt("return", n);

              case 28:
              case "end":
                return _context222.stop();
            }
          }
        }, _callee222, this, [[1, 7], [11, 24]]);
      }));

      function deactivate(_x573, _x574) {
        return _deactivate2.apply(this, arguments);
      }

      return deactivate;
    }()
  }, {
    key: "makeMinter",
    value: function makeMinter(t, e) {
      var _this20 = this;

      return new P( /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee223(i) {
          var r, n, s;
          return _regeneratorRuntime.wrap(function _callee223$(_context223) {
            while (1) {
              switch (_context223.prev = _context223.next) {
                case 0:
                  i.next(Ue.MakeDispenserMinter);
                  n = _this20.GASLIMIT_DEFAULT;
                  _context223.next = 4;
                  return _this20.datatokens.proposeMinter(t, _this20.dispenserAddress, e);

                case 4:
                  if (_context223.sent) {
                    _context223.next = 6;
                    break;
                  }

                  return _context223.abrupt("return", null);

                case 6:
                  i.next(Ue.AcceptingNewMinter);
                  _context223.prev = 7;
                  _context223.next = 10;
                  return _this20.contract.methods.acceptMinter(t).estimateGas({
                    from: e
                  }, function (t, e) {
                    return t ? n : e;
                  });

                case 10:
                  r = _context223.sent;
                  _context223.next = 16;
                  break;

                case 13:
                  _context223.prev = 13;
                  _context223.t0 = _context223["catch"](7);
                  r = n;

                case 16:
                  s = null;
                  _context223.prev = 17;
                  _context223.t1 = _this20.contract.methods.acceptMinter(t);
                  _context223.t2 = e;
                  _context223.t3 = r + 1;
                  _context223.next = 23;
                  return Q(_this20.web3, _this20.config);

                case 23:
                  _context223.t4 = _context223.sent;
                  _context223.t5 = {
                    from: _context223.t2,
                    gas: _context223.t3,
                    gasPrice: _context223.t4
                  };
                  _context223.next = 27;
                  return _context223.t1.send.call(_context223.t1, _context223.t5);

                case 27:
                  s = _context223.sent;
                  _context223.next = 33;
                  break;

                case 30:
                  _context223.prev = 30;
                  _context223.t6 = _context223["catch"](17);

                  _this20.logger.error("ERROR: Failed to accept minter role: ".concat(_context223.t6.message));

                case 33:
                  return _context223.abrupt("return", s);

                case 34:
                case "end":
                  return _context223.stop();
              }
            }
          }, _callee223, null, [[7, 13], [17, 30]]);
        }));

        return function (_x575) {
          return _ref17.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "cancelMinter",
    value: function cancelMinter(t, e) {
      var _this21 = this;

      return new P( /*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee224(i) {
          var r, n, s;
          return _regeneratorRuntime.wrap(function _callee224$(_context224) {
            while (1) {
              switch (_context224.prev = _context224.next) {
                case 0:
                  i.next($e.MakeOwnerMinter);
                  n = _this21.GASLIMIT_DEFAULT;
                  _context224.prev = 2;
                  _context224.next = 5;
                  return _this21.contract.methods.removeMinter(t).estimateGas({
                    from: e
                  }, function (t, e) {
                    return t ? n : e;
                  });

                case 5:
                  r = _context224.sent;
                  _context224.next = 11;
                  break;

                case 8:
                  _context224.prev = 8;
                  _context224.t0 = _context224["catch"](2);
                  r = n;

                case 11:
                  s = null;
                  _context224.prev = 12;
                  _context224.t1 = _this21.contract.methods.removeMinter(t);
                  _context224.t2 = e;
                  _context224.t3 = r + 1;
                  _context224.next = 18;
                  return Q(_this21.web3, _this21.config);

                case 18:
                  _context224.t4 = _context224.sent;
                  _context224.t5 = {
                    from: _context224.t2,
                    gas: _context224.t3,
                    gasPrice: _context224.t4
                  };
                  _context224.next = 22;
                  return _context224.t1.send.call(_context224.t1, _context224.t5);

                case 22:
                  s = _context224.sent;
                  _context224.next = 28;
                  break;

                case 25:
                  _context224.prev = 25;
                  _context224.t6 = _context224["catch"](12);

                  _this21.logger.error("ERROR: Failed to remove minter role: ".concat(_context224.t6.message));

                case 28:
                  if (!s) {
                    _context224.next = 35;
                    break;
                  }

                  i.next($e.AcceptingNewMinter);
                  _context224.next = 32;
                  return _this21.datatokens.approveMinter(t, e);

                case 32:
                  _context224.t7 = _context224.sent;
                  _context224.next = 36;
                  break;

                case 35:
                  _context224.t7 = null;

                case 36:
                  return _context224.abrupt("return", _context224.t7);

                case 37:
                case "end":
                  return _context224.stop();
              }
            }
          }, _callee224, null, [[2, 8], [12, 25]]);
        }));

        return function (_x576) {
          return _ref18.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "dispense",
    value: function () {
      var _dispense = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee225(t, e) {
        var i,
            r,
            n,
            s,
            _args225 = arguments;
        return _regeneratorRuntime.wrap(function _callee225$(_context225) {
          while (1) {
            switch (_context225.prev = _context225.next) {
              case 0:
                i = _args225.length > 2 && _args225[2] !== undefined ? _args225[2] : "1";
                n = this.GASLIMIT_DEFAULT;
                _context225.prev = 2;
                _context225.next = 5;
                return this.contract.methods.dispense(t, this.web3.utils.toWei(i)).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? n : e;
                });

              case 5:
                r = _context225.sent;
                _context225.next = 11;
                break;

              case 8:
                _context225.prev = 8;
                _context225.t0 = _context225["catch"](2);
                r = n;

              case 11:
                s = null;
                _context225.prev = 12;
                _context225.t1 = this.contract.methods.dispense(t, this.web3.utils.toWei(i));
                _context225.t2 = e;
                _context225.t3 = r + 1;
                _context225.next = 18;
                return Q(this.web3, this.config);

              case 18:
                _context225.t4 = _context225.sent;
                _context225.t5 = {
                  from: _context225.t2,
                  gas: _context225.t3,
                  gasPrice: _context225.t4
                };
                _context225.next = 22;
                return _context225.t1.send.call(_context225.t1, _context225.t5);

              case 22:
                s = _context225.sent;
                _context225.next = 28;
                break;

              case 25:
                _context225.prev = 25;
                _context225.t6 = _context225["catch"](12);
                this.logger.error("ERROR: Failed to dispense tokens: ".concat(_context225.t6.message));

              case 28:
                return _context225.abrupt("return", s);

              case 29:
              case "end":
                return _context225.stop();
            }
          }
        }, _callee225, this, [[2, 8], [12, 25]]);
      }));

      function dispense(_x577, _x578) {
        return _dispense.apply(this, arguments);
      }

      return dispense;
    }()
  }, {
    key: "ownerWithdraw",
    value: function () {
      var _ownerWithdraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee226(t, e) {
        var i, r, n;
        return _regeneratorRuntime.wrap(function _callee226$(_context226) {
          while (1) {
            switch (_context226.prev = _context226.next) {
              case 0:
                r = this.GASLIMIT_DEFAULT;
                _context226.prev = 1;
                _context226.next = 4;
                return this.contract.methods.ownerWithdraw(t).estimateGas({
                  from: e
                }, function (t, e) {
                  return t ? r : e;
                });

              case 4:
                i = _context226.sent;
                _context226.next = 10;
                break;

              case 7:
                _context226.prev = 7;
                _context226.t0 = _context226["catch"](1);
                i = r;

              case 10:
                n = null;
                _context226.prev = 11;
                _context226.t1 = this.contract.methods.ownerWithdraw(t);
                _context226.t2 = e;
                _context226.t3 = i + 1;
                _context226.next = 17;
                return Q(this.web3, this.config);

              case 17:
                _context226.t4 = _context226.sent;
                _context226.t5 = {
                  from: _context226.t2,
                  gas: _context226.t3,
                  gasPrice: _context226.t4
                };
                _context226.next = 21;
                return _context226.t1.send.call(_context226.t1, _context226.t5);

              case 21:
                n = _context226.sent;
                _context226.next = 27;
                break;

              case 24:
                _context226.prev = 24;
                _context226.t6 = _context226["catch"](11);
                this.logger.error("ERROR: Failed to withdraw tokens: ".concat(_context226.t6.message));

              case 27:
                return _context226.abrupt("return", n);

              case 28:
              case "end":
                return _context226.stop();
            }
          }
        }, _callee226, this, [[1, 7], [11, 24]]);
      }));

      function ownerWithdraw(_x579, _x580) {
        return _ownerWithdraw.apply(this, arguments);
      }

      return ownerWithdraw;
    }()
  }, {
    key: "isDispensable",
    value: function () {
      var _isDispensable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee227(t, i) {
        var r,
            n,
            _args227 = arguments;
        return _regeneratorRuntime.wrap(function _callee227$(_context227) {
          while (1) {
            switch (_context227.prev = _context227.next) {
              case 0:
                r = _args227.length > 2 && _args227[2] !== undefined ? _args227[2] : "1";
                _context227.next = 3;
                return this.status(t);

              case 3:
                n = _context227.sent;
                _context227.t2 = !n || !1 === n.active;

                if (_context227.t2) {
                  _context227.next = 11;
                  break;
                }

                _context227.t3 = e;
                _context227.next = 9;
                return this.datatokens.balance(t, i);

              case 9:
                _context227.t4 = _context227.sent;
                _context227.t2 = new _context227.t3(_context227.t4).greaterThanOrEqualTo(n.maxBalance);

              case 11:
                _context227.t1 = _context227.t2;

                if (_context227.t1) {
                  _context227.next = 14;
                  break;
                }

                _context227.t1 = new e(String(r)).greaterThan(n.maxTokens);

              case 14:
                _context227.t0 = _context227.t1;

                if (_context227.t0) {
                  _context227.next = 17;
                  break;
                }

                _context227.t0 = !new e(n.balance).greaterThanOrEqualTo(r) && !0 !== n.isTrueMinter;

              case 17:
                return _context227.abrupt("return", !_context227.t0);

              case 18:
              case "end":
                return _context227.stop();
            }
          }
        }, _callee227, this);
      }));

      function isDispensable(_x581, _x582) {
        return _isDispensable.apply(this, arguments);
      }

      return isDispensable;
    }()
  }]);

  return Ge;
}();

var ze = /*#__PURE__*/function (_st10) {
  _inherits(ze, _st10);

  var _super12 = _createSuper(ze);

  function ze() {
    var _this22;

    _classCallCheck(this, ze);

    for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      t[_key10] = arguments[_key10];
    }

    _this22 = _super12.call.apply(_super12, [this].concat(t)), _this22.network = void 0, _this22.provider = void 0, _this22.eventAccessControl = void 0, _this22.web3Provider = void 0, _this22.metadataCache = void 0, _this22.onChainMetadata = void 0, _this22.accounts = void 0, _this22.assets = void 0, _this22.compute = void 0, _this22.datatokens = void 0, _this22.pool = void 0, _this22.fixedRateExchange = void 0, _this22.OceanDispenser = void 0, _this22.versions = void 0, _this22.utils = void 0;
    return _this22;
  }

  _createClass(ze, null, [{
    key: "getInstance",
    value: function () {
      var _getInstance9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee228(t) {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee228$(_context228) {
          while (1) {
            switch (_context228.prev = _context228.next) {
              case 0:
                e = new ze(), i = A({}, function (t) {
                  return {
                    config: t,
                    web3: t.web3Provider,
                    logger: R
                  };
                }(t), {
                  ocean: e
                });
                e.setInstanceConfig(i);
                _context228.next = 4;
                return Te.getInstance(i);

              case 4:
                e.utils = _context228.sent;
                _context228.next = 7;
                return mt.getInstance(i);

              case 7:
                e.provider = _context228.sent;
                _context228.next = 10;
                return Re.getInstance(i);

              case 10:
                e.eventAccessControl = _context228.sent;
                e.metadataCache = new Be(i.config.metadataCacheUri, i.logger);
                _context228.next = 14;
                return ht.getInstance(i);

              case 14:
                e.accounts = _context228.sent;
                _context228.next = 17;
                return ke.getInstance(i);

              case 17:
                e.assets = _context228.sent;
                _context228.next = 20;
                return Ne.getInstance(i);

              case 20:
                e.compute = _context228.sent;
                e.datatokens = new _e(i.config.factoryAddress, i.config.factoryABI, i.config.datatokensABI, i.config.web3Provider, i.logger, i.config);
                e.pool = new je(i.config.web3Provider, i.logger, i.config.poolFactoryABI, i.config.poolABI, i.config.poolFactoryAddress, i.config.oceanTokenAddress, i.config);
                e.fixedRateExchange = new qe(i.config.web3Provider, i.logger, i.config.fixedRateExchangeAddress, i.config.fixedRateExchangeAddressABI, i.config.oceanTokenAddress, e.datatokens, i.config);
                e.OceanDispenser = new Ge(i.config.web3Provider, i.logger, i.config.dispenserAddress, i.config.dispenserABI, e.datatokens, i.config);
                e.onChainMetadata = new Ce(i.config.web3Provider, i.logger, i.config.metadataContractAddress, i.config.metadataContractABI, e.metadataCache, i.config);
                _context228.next = 28;
                return Se.getInstance(i);

              case 28:
                e.versions = _context228.sent;
                e.network = new De();
                return _context228.abrupt("return", e);

              case 31:
              case "end":
                return _context228.stop();
            }
          }
        }, _callee228);
      }));

      function getInstance(_x583) {
        return _getInstance9.apply(this, arguments);
      }

      return getInstance;
    }()
  }]);

  return ze;
}(st);

var He = {
  networkId: null,
  network: "unknown",
  metadataCacheUri: "https://aquarius.oceanprotocol.com",
  nodeUri: "http://localhost:8545",
  providerUri: "http://127.0.0.1:8030",
  subgraphUri: null,
  explorerUri: null,
  oceanTokenAddress: null,
  oceanTokenSymbol: "OCEAN",
  factoryAddress: "0x1234",
  poolFactoryAddress: null,
  fixedRateExchangeAddress: null,
  dispenserAddress: null,
  metadataContractAddress: null,
  startBlock: 0,
  transactionBlockTimeout: 50,
  transactionConfirmationBlocks: 1,
  transactionPollingTimeout: 750,
  gasFeeMultiplier: 1
},
    Ze = [A({}, He), A({}, He, {
  networkId: 8996,
  network: "development",
  metadataCacheUri: "http://127.0.0.1:5000",
  rbacUri: "http://127.0.0.1:3000"
}), A({}, He, {
  networkId: 3,
  network: "ropsten",
  nodeUri: "https://ropsten.infura.io/v3",
  providerUri: "https://provider.ropsten.oceanprotocol.com",
  subgraphUri: "https://subgraph.ropsten.oceanprotocol.com",
  explorerUri: "https://ropsten.etherscan.io",
  startBlock: 9227563
}), A({}, He, {
  networkId: 4,
  network: "rinkeby",
  nodeUri: "https://rinkeby.infura.io/v3",
  providerUri: "https://provider.rinkeby.oceanprotocol.com",
  subgraphUri: "https://subgraph.rinkeby.oceanprotocol.com",
  explorerUri: "https://rinkeby.etherscan.io",
  startBlock: 7294090
}), A({}, He, {
  networkId: 1,
  network: "mainnet",
  nodeUri: "https://mainnet.infura.io/v3",
  providerUri: "https://provider.mainnet.oceanprotocol.com",
  subgraphUri: "https://subgraph.mainnet.oceanprotocol.com",
  explorerUri: "https://etherscan.io",
  startBlock: 11105459,
  transactionBlockTimeout: 150,
  transactionConfirmationBlocks: 5,
  transactionPollingTimeout: 1750,
  gasFeeMultiplier: 1.05
}), A({}, He, {
  networkId: 137,
  network: "polygon",
  nodeUri: "https://polygon-mainnet.infura.io/v3",
  providerUri: "https://provider.polygon.oceanprotocol.com",
  subgraphUri: "https://subgraph.polygon.oceanprotocol.com",
  explorerUri: "https://polygonscan.com",
  oceanTokenSymbol: "mOCEAN",
  startBlock: 11005222,
  gasFeeMultiplier: 1.05
}), A({}, He, {
  networkId: 1287,
  network: "moonbeamalpha",
  nodeUri: "https://rpc.testnet.moonbeam.network",
  providerUri: "https://provider.moonbeamalpha.oceanprotocol.com",
  subgraphUri: "https://subgraph.moonbeamalpha.oceanprotocol.com",
  explorerUri: "https://moonbase-blockscout.testnet.moonbeam.network/",
  startBlock: 90707
}), A({}, He, {
  networkId: 2021e3,
  network: "gaiaxtestnet",
  nodeUri: "https://rpc.gaiaxtestnet.oceanprotocol.com",
  providerUri: "https://provider.gaiaxtestnet.oceanprotocol.com",
  subgraphUri: "https://subgraph.gaiaxtestnet.oceanprotocol.com",
  explorerUri: "https://blockscout.gaiaxtestnet.oceanprotocol.com"
}), A({}, He, {
  networkId: 2021001,
  network: "catenaxtestnet",
  nodeUri: "https://rpc.catenaxtestnet.oceanprotocol.com",
  providerUri: "https://provider.catenaxtestnet.oceanprotocol.com",
  subgraphUri: "https://subgraph.catenaxtestnet.oceanprotocol.com",
  explorerUri: "https://blockscout.catenaxtestnet.oceanprotocol.com",
  metadataCacheUri: "https://aquarius.catenaxtestnet.oceanprotocol.com"
}), A({}, He, {
  networkId: 80001,
  network: "mumbai",
  nodeUri: "https://polygon-mumbai.infura.io/v3",
  providerUri: "https://provider.mumbai.oceanprotocol.com",
  subgraphUri: "https://subgraph.mumbai.oceanprotocol.com",
  explorerUri: "https://mumbai.polygonscan.com"
}), A({}, He, {
  networkId: 56,
  network: "bsc",
  nodeUri: "https://bsc-dataseed.binance.org",
  providerUri: "https://provider.bsc.oceanprotocol.com",
  subgraphUri: "https://subgraph.bsc.oceanprotocol.com",
  explorerUri: "https://bscscan.com/",
  gasFeeMultiplier: 1.05
}), A({}, He, {
  networkId: 44787,
  network: "celoalfajores",
  nodeUri: "https://alfajores-forno.celo-testnet.org",
  providerUri: "https://provider.celoalfajores.oceanprotocol.com",
  subgraphUri: "https://subgraph.celoalfajores.oceanprotocol.com",
  explorerUri: "https://alfajores-blockscout.celo-testnet.org"
}), A({}, He, {
  networkId: 246,
  network: "energyweb",
  nodeUri: "https://rpc.energyweb.org",
  providerUri: "https://provider.energyweb.oceanprotocol.com",
  subgraphUri: "https://subgraph.energyweb.oceanprotocol.com",
  explorerUri: "https://explorer.energyweb.org",
  gasFeeMultiplier: 1.05
}), A({}, He, {
  networkId: 1285,
  network: "moonriver",
  nodeUri: "https://moonriver.api.onfinality.io/public",
  providerUri: "https://provider.moonriver.oceanprotocol.com",
  subgraphUri: "https://subgraph.moonriver.oceanprotocol.com",
  explorerUri: "https://blockscout.moonriver.moonbeam.network",
  gasFeeMultiplier: 1.05
})];

var Ve = /*#__PURE__*/function () {
  function Ve() {
    _classCallCheck(this, Ve);
  }

  _createClass(Ve, [{
    key: "getAddressesFromEnv",
    value: function getAddressesFromEnv(t) {
      var e;

      if (M[t]) {
        var _M$t = M[t],
            i = _M$t.DTFactory,
            _r8 = _M$t.BFactory,
            n = _M$t.FixedRateExchange,
            s = _M$t.Dispenser,
            o = _M$t.Metadata,
            a = _M$t.Ocean,
            h = _M$t.chainId,
            _u = _M$t.startBlock;
        e = A({
          factoryAddress: i,
          poolFactoryAddress: _r8,
          fixedRateExchangeAddress: n,
          dispenserAddress: s,
          metadataContractAddress: o,
          oceanTokenAddress: a,
          networkId: h,
          startBlock: _u
        }, process.env.AQUARIUS_URI && {
          metadataCacheUri: process.env.AQUARIUS_URI
        });
      }

      if (r && process.env.ADDRESS_FILE) try {
        var _i27 = JSON.parse(r.readFileSync(process.env.ADDRESS_FILE || "".concat(y, "/.ocean/ocean-contracts/artifacts/address.json"), "utf8")),
            _i27$t = _i27[t],
            _n6 = _i27$t.DTFactory,
            _s5 = _i27$t.BFactory,
            _o4 = _i27$t.FixedRateExchange,
            _a2 = _i27$t.Dispenser,
            _h = _i27$t.Metadata,
            _u2 = _i27$t.Ocean,
            l = _i27$t.chainId,
            _c2 = _i27$t.startBlock;

        e = A({
          factoryAddress: _n6,
          poolFactoryAddress: _s5,
          fixedRateExchangeAddress: _o4,
          dispenserAddress: _a2,
          metadataContractAddress: _h,
          oceanTokenAddress: _u2,
          networkId: l,
          startBlock: _c2
        }, process.env.AQUARIUS_URI && {
          metadataCacheUri: process.env.AQUARIUS_URI
        });
      } catch (t) {}
      return e;
    }
  }, {
    key: "getConfig",
    value: function getConfig(t, e) {
      var i = "string" == typeof t ? "network" : "networkId";
      var r = Ze.find(function (e) {
        return e[i] === t;
      });
      return r ? (r = A({}, r, this.getAddressesFromEnv(r.network)), A({}, r, {
        nodeUri: e ? "".concat(r.nodeUri, "/").concat(e) : r.nodeUri
      })) : (R.error("No config found for given network '".concat(t, "'")), null);
    }
  }]);

  return Ve;
}();

export { ot as Account, b as Config, Ve as ConfigHelper, ae as CreateProgressStep, lt as DDO, at as DID, _e as DataTokens, x as LogLevel, R as Logger, Be as MetadataCache, ze as Ocean, ue as OceanPlatformTechStatus, he as OrderProgressStep, mt as Provider, nt as utils };